var Om = Object.defineProperty;
var sm = (p, t, e) => t in p ? Om(p, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : p[t] = e;
var z = (p, t, e) => sm(p, typeof t != "symbol" ? t + "" : t, e);
import Am from "axios";
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var cu;
function L() {
  return cu.apply(null, arguments);
}
function um(p) {
  cu = p;
}
function rt(p) {
  return p instanceof Array || Object.prototype.toString.call(p) === "[object Array]";
}
function uo(p) {
  return p != null && Object.prototype.toString.call(p) === "[object Object]";
}
function K0(p, t) {
  return Object.prototype.hasOwnProperty.call(p, t);
}
function ta(p) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(p).length === 0;
  var t;
  for (t in p)
    if (K0(p, t))
      return !1;
  return !0;
}
function Je(p) {
  return p === void 0;
}
function bp(p) {
  return typeof p == "number" || Object.prototype.toString.call(p) === "[object Number]";
}
function Pb(p) {
  return p instanceof Date || Object.prototype.toString.call(p) === "[object Date]";
}
function iu(p, t) {
  var e = [], o, b = p.length;
  for (o = 0; o < b; ++o)
    e.push(t(p[o], o));
  return e;
}
function Pp(p, t) {
  for (var e in t)
    K0(t, e) && (p[e] = t[e]);
  return K0(t, "toString") && (p.toString = t.toString), K0(t, "valueOf") && (p.valueOf = t.valueOf), p;
}
function Bt(p, t, e, o) {
  return Su(p, t, e, o, !0).utc();
}
function dm() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function D0(p) {
  return p._pf == null && (p._pf = dm()), p._pf;
}
var vi;
Array.prototype.some ? vi = Array.prototype.some : vi = function(p) {
  var t = Object(this), e = t.length >>> 0, o;
  for (o = 0; o < e; o++)
    if (o in t && p.call(this, t[o], o, t))
      return !0;
  return !1;
};
function pa(p) {
  var t = null, e = !1, o = p._d && !isNaN(p._d.getTime());
  if (o && (t = D0(p), e = vi.call(t.parsedDateParts, function(b) {
    return b != null;
  }), o = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && e), p._strict && (o = o && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(p))
    p._isValid = o;
  else
    return o;
  return p._isValid;
}
function Dz(p) {
  var t = Bt(NaN);
  return p != null ? Pp(D0(t), p) : D0(t).userInvalidated = !0, t;
}
var X3 = L.momentProperties = [], yc = !1;
function oa(p, t) {
  var e, o, b, r = X3.length;
  if (Je(t._isAMomentObject) || (p._isAMomentObject = t._isAMomentObject), Je(t._i) || (p._i = t._i), Je(t._f) || (p._f = t._f), Je(t._l) || (p._l = t._l), Je(t._strict) || (p._strict = t._strict), Je(t._tzm) || (p._tzm = t._tzm), Je(t._isUTC) || (p._isUTC = t._isUTC), Je(t._offset) || (p._offset = t._offset), Je(t._pf) || (p._pf = D0(t)), Je(t._locale) || (p._locale = t._locale), r > 0)
    for (e = 0; e < r; e++)
      o = X3[e], b = t[o], Je(b) || (p[o] = b);
  return p;
}
function Eb(p) {
  oa(this, p), this._d = new Date(p._d != null ? p._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), yc === !1 && (yc = !0, L.updateOffset(this), yc = !1);
}
function ct(p) {
  return p instanceof Eb || p != null && p._isAMomentObject != null;
}
function au(p) {
  L.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + p);
}
function P2(p, t) {
  var e = !0;
  return Pp(function() {
    if (L.deprecationHandler != null && L.deprecationHandler(null, p), e) {
      var o = [], b, r, i, s = arguments.length;
      for (r = 0; r < s; r++) {
        if (b = "", typeof arguments[r] == "object") {
          b += `
[` + r + "] ";
          for (i in arguments[0])
            K0(arguments[0], i) && (b += i + ": " + arguments[0][i] + ", ");
          b = b.slice(0, -2);
        } else
          b = arguments[r];
        o.push(b);
      }
      au(
        p + `
Arguments: ` + Array.prototype.slice.call(o).join("") + `
` + new Error().stack
      ), e = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var C3 = {};
function Ou(p, t) {
  L.deprecationHandler != null && L.deprecationHandler(p, t), C3[p] || (au(t), C3[p] = !0);
}
L.suppressDeprecationWarnings = !1;
L.deprecationHandler = null;
function Tt(p) {
  return typeof Function < "u" && p instanceof Function || Object.prototype.toString.call(p) === "[object Function]";
}
function lm(p) {
  var t, e;
  for (e in p)
    K0(p, e) && (t = p[e], Tt(t) ? this[e] = t : this["_" + e] = t);
  this._config = p, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function _i(p, t) {
  var e = Pp({}, p), o;
  for (o in t)
    K0(t, o) && (uo(p[o]) && uo(t[o]) ? (e[o] = {}, Pp(e[o], p[o]), Pp(e[o], t[o])) : t[o] != null ? e[o] = t[o] : delete e[o]);
  for (o in p)
    K0(p, o) && !K0(t, o) && uo(p[o]) && (e[o] = Pp({}, e[o]));
  return e;
}
function Ma(p) {
  p != null && this.set(p);
}
var Ni;
Object.keys ? Ni = Object.keys : Ni = function(p) {
  var t, e = [];
  for (t in p)
    K0(p, t) && e.push(t);
  return e;
};
var qm = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function fm(p, t, e) {
  var o = this._calendar[p] || this._calendar.sameElse;
  return Tt(o) ? o.call(t, e) : o;
}
function Nt(p, t, e) {
  var o = "" + Math.abs(p), b = t - o.length, r = p >= 0;
  return (r ? e ? "+" : "" : "-") + Math.pow(10, Math.max(0, b)).toString().substr(1) + o;
}
var ba = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Qn = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, gc = {}, qM = {};
function A0(p, t, e, o) {
  var b = o;
  typeof o == "string" && (b = function() {
    return this[o]();
  }), p && (qM[p] = b), t && (qM[t[0]] = function() {
    return Nt(b.apply(this, arguments), t[1], t[2]);
  }), e && (qM[e] = function() {
    return this.localeData().ordinal(
      b.apply(this, arguments),
      p
    );
  });
}
function Wm(p) {
  return p.match(/\[[\s\S]/) ? p.replace(/^\[|\]$/g, "") : p.replace(/\\/g, "");
}
function hm(p) {
  var t = p.match(ba), e, o;
  for (e = 0, o = t.length; e < o; e++)
    qM[t[e]] ? t[e] = qM[t[e]] : t[e] = Wm(t[e]);
  return function(b) {
    var r = "", i;
    for (i = 0; i < o; i++)
      r += Tt(t[i]) ? t[i].call(b, p) : t[i];
    return r;
  };
}
function pz(p, t) {
  return p.isValid() ? (t = su(t, p.localeData()), gc[t] = gc[t] || hm(t), gc[t](p)) : p.localeData().invalidDate();
}
function su(p, t) {
  var e = 5;
  function o(b) {
    return t.longDateFormat(b) || b;
  }
  for (Qn.lastIndex = 0; e >= 0 && Qn.test(p); )
    p = p.replace(
      Qn,
      o
    ), Qn.lastIndex = 0, e -= 1;
  return p;
}
var mm = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Rm(p) {
  var t = this._longDateFormat[p], e = this._longDateFormat[p.toUpperCase()];
  return t || !e ? t : (this._longDateFormat[p] = e.match(ba).map(function(o) {
    return o === "MMMM" || o === "MM" || o === "DD" || o === "dddd" ? o.slice(1) : o;
  }).join(""), this._longDateFormat[p]);
}
var ym = "Invalid date";
function gm() {
  return this._invalidDate;
}
var Lm = "%d", vm = /\d{1,2}/;
function _m(p) {
  return this._ordinal.replace("%d", p);
}
var Nm = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Bm(p, t, e, o) {
  var b = this._relativeTime[e];
  return Tt(b) ? b(p, t, e, o) : b.replace(/%d/i, p);
}
function Tm(p, t) {
  var e = this._relativeTime[p > 0 ? "future" : "past"];
  return Tt(e) ? e(t) : e.replace(/%s/i, t);
}
var I3 = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function E2(p) {
  return typeof p == "string" ? I3[p] || I3[p.toLowerCase()] : void 0;
}
function na(p) {
  var t = {}, e, o;
  for (o in p)
    K0(p, o) && (e = E2(o), e && (t[e] = p[o]));
  return t;
}
var wm = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Sm(p) {
  var t = [], e;
  for (e in p)
    K0(p, e) && t.push({ unit: e, priority: wm[e] });
  return t.sort(function(o, b) {
    return o.priority - b.priority;
  }), t;
}
var Au = /\d/, a2 = /\d\d/, uu = /\d{3}/, za = /\d{4}/, Xz = /[+-]?\d{6}/, W1 = /\d\d?/, du = /\d\d\d\d?/, lu = /\d\d\d\d\d\d?/, Cz = /\d{1,3}/, ra = /\d{1,4}/, Iz = /[+-]?\d{1,6}/, vM = /\d+/, Pz = /[+-]?\d+/, Dm = /Z|[+-]\d\d:?\d\d/gi, Ez = /Z|[+-]\d\d(?::?\d\d)?/gi, Xm = /[+-]?\d+(\.\d{1,3})?/, kb = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, _M = /^[1-9]\d?/, ca = /^([1-9]\d|\d)/, dz;
dz = {};
function c0(p, t, e) {
  dz[p] = Tt(t) ? t : function(o, b) {
    return o && e ? e : t;
  };
}
function Cm(p, t) {
  return K0(dz, p) ? dz[p](t._strict, t._locale) : new RegExp(Im(p));
}
function Im(p) {
  return pp(
    p.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, e, o, b, r) {
        return e || o || b || r;
      }
    )
  );
}
function pp(p) {
  return p.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function T2(p) {
  return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
}
function U0(p) {
  var t = +p, e = 0;
  return t !== 0 && isFinite(t) && (e = T2(t)), e;
}
var Bi = {};
function b1(p, t) {
  var e, o = t, b;
  for (typeof p == "string" && (p = [p]), bp(t) && (o = function(r, i) {
    i[t] = U0(r);
  }), b = p.length, e = 0; e < b; e++)
    Bi[p[e]] = o;
}
function xb(p, t) {
  b1(p, function(e, o, b, r) {
    b._w = b._w || {}, t(e, b._w, b, r);
  });
}
function Pm(p, t, e) {
  t != null && K0(Bi, p) && Bi[p](t, e._a, e, p);
}
function kz(p) {
  return p % 4 === 0 && p % 100 !== 0 || p % 400 === 0;
}
var Re = 0, ep = 1, gt = 2, be = 3, pt = 4, tp = 5, Ao = 6, Em = 7, km = 8;
A0("Y", 0, 0, function() {
  var p = this.year();
  return p <= 9999 ? Nt(p, 4) : "+" + p;
});
A0(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
A0(0, ["YYYY", 4], 0, "year");
A0(0, ["YYYYY", 5], 0, "year");
A0(0, ["YYYYYY", 6, !0], 0, "year");
c0("Y", Pz);
c0("YY", W1, a2);
c0("YYYY", ra, za);
c0("YYYYY", Iz, Xz);
c0("YYYYYY", Iz, Xz);
b1(["YYYYY", "YYYYYY"], Re);
b1("YYYY", function(p, t) {
  t[Re] = p.length === 2 ? L.parseTwoDigitYear(p) : U0(p);
});
b1("YY", function(p, t) {
  t[Re] = L.parseTwoDigitYear(p);
});
b1("Y", function(p, t) {
  t[Re] = parseInt(p, 10);
});
function hb(p) {
  return kz(p) ? 366 : 365;
}
L.parseTwoDigitYear = function(p) {
  return U0(p) + (U0(p) > 68 ? 1900 : 2e3);
};
var qu = NM("FullYear", !0);
function xm() {
  return kz(this.year());
}
function NM(p, t) {
  return function(e) {
    return e != null ? (fu(this, p, e), L.updateOffset(this, t), this) : gb(this, p);
  };
}
function gb(p, t) {
  if (!p.isValid())
    return NaN;
  var e = p._d, o = p._isUTC;
  switch (t) {
    case "Milliseconds":
      return o ? e.getUTCMilliseconds() : e.getMilliseconds();
    case "Seconds":
      return o ? e.getUTCSeconds() : e.getSeconds();
    case "Minutes":
      return o ? e.getUTCMinutes() : e.getMinutes();
    case "Hours":
      return o ? e.getUTCHours() : e.getHours();
    case "Date":
      return o ? e.getUTCDate() : e.getDate();
    case "Day":
      return o ? e.getUTCDay() : e.getDay();
    case "Month":
      return o ? e.getUTCMonth() : e.getMonth();
    case "FullYear":
      return o ? e.getUTCFullYear() : e.getFullYear();
    default:
      return NaN;
  }
}
function fu(p, t, e) {
  var o, b, r, i, s;
  if (!(!p.isValid() || isNaN(e))) {
    switch (o = p._d, b = p._isUTC, t) {
      case "Milliseconds":
        return void (b ? o.setUTCMilliseconds(e) : o.setMilliseconds(e));
      case "Seconds":
        return void (b ? o.setUTCSeconds(e) : o.setSeconds(e));
      case "Minutes":
        return void (b ? o.setUTCMinutes(e) : o.setMinutes(e));
      case "Hours":
        return void (b ? o.setUTCHours(e) : o.setHours(e));
      case "Date":
        return void (b ? o.setUTCDate(e) : o.setDate(e));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    r = e, i = p.month(), s = p.date(), s = s === 29 && i === 1 && !kz(r) ? 28 : s, b ? o.setUTCFullYear(r, i, s) : o.setFullYear(r, i, s);
  }
}
function Fm(p) {
  return p = E2(p), Tt(this[p]) ? this[p]() : this;
}
function Um(p, t) {
  if (typeof p == "object") {
    p = na(p);
    var e = Sm(p), o, b = e.length;
    for (o = 0; o < b; o++)
      this[e[o].unit](p[e[o].unit]);
  } else if (p = E2(p), Tt(this[p]))
    return this[p](t);
  return this;
}
function Hm(p, t) {
  return (p % t + t) % t;
}
var H1;
Array.prototype.indexOf ? H1 = Array.prototype.indexOf : H1 = function(p) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === p)
      return t;
  return -1;
};
function ia(p, t) {
  if (isNaN(p) || isNaN(t))
    return NaN;
  var e = Hm(t, 12);
  return p += (t - e) / 12, e === 1 ? kz(p) ? 29 : 28 : 31 - e % 7 % 2;
}
A0("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
A0("MMM", 0, 0, function(p) {
  return this.localeData().monthsShort(this, p);
});
A0("MMMM", 0, 0, function(p) {
  return this.localeData().months(this, p);
});
c0("M", W1, _M);
c0("MM", W1, a2);
c0("MMM", function(p, t) {
  return t.monthsShortRegex(p);
});
c0("MMMM", function(p, t) {
  return t.monthsRegex(p);
});
b1(["M", "MM"], function(p, t) {
  t[ep] = U0(p) - 1;
});
b1(["MMM", "MMMM"], function(p, t, e, o) {
  var b = e._locale.monthsParse(p, o, e._strict);
  b != null ? t[ep] = b : D0(e).invalidMonth = p;
});
var Jm = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Wu = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), hu = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, $m = kb, Vm = kb;
function Ym(p, t) {
  return p ? rt(this._months) ? this._months[p.month()] : this._months[(this._months.isFormat || hu).test(t) ? "format" : "standalone"][p.month()] : rt(this._months) ? this._months : this._months.standalone;
}
function Gm(p, t) {
  return p ? rt(this._monthsShort) ? this._monthsShort[p.month()] : this._monthsShort[hu.test(t) ? "format" : "standalone"][p.month()] : rt(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Km(p, t, e) {
  var o, b, r, i = p.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], o = 0; o < 12; ++o)
      r = Bt([2e3, o]), this._shortMonthsParse[o] = this.monthsShort(
        r,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[o] = this.months(r, "").toLocaleLowerCase();
  return e ? t === "MMM" ? (b = H1.call(this._shortMonthsParse, i), b !== -1 ? b : null) : (b = H1.call(this._longMonthsParse, i), b !== -1 ? b : null) : t === "MMM" ? (b = H1.call(this._shortMonthsParse, i), b !== -1 ? b : (b = H1.call(this._longMonthsParse, i), b !== -1 ? b : null)) : (b = H1.call(this._longMonthsParse, i), b !== -1 ? b : (b = H1.call(this._shortMonthsParse, i), b !== -1 ? b : null));
}
function Qm(p, t, e) {
  var o, b, r;
  if (this._monthsParseExact)
    return Km.call(this, p, t, e);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), o = 0; o < 12; o++) {
    if (b = Bt([2e3, o]), e && !this._longMonthsParse[o] && (this._longMonthsParse[o] = new RegExp(
      "^" + this.months(b, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[o] = new RegExp(
      "^" + this.monthsShort(b, "").replace(".", "") + "$",
      "i"
    )), !e && !this._monthsParse[o] && (r = "^" + this.months(b, "") + "|^" + this.monthsShort(b, ""), this._monthsParse[o] = new RegExp(r.replace(".", ""), "i")), e && t === "MMMM" && this._longMonthsParse[o].test(p))
      return o;
    if (e && t === "MMM" && this._shortMonthsParse[o].test(p))
      return o;
    if (!e && this._monthsParse[o].test(p))
      return o;
  }
}
function mu(p, t) {
  if (!p.isValid())
    return p;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = U0(t);
    else if (t = p.localeData().monthsParse(t), !bp(t))
      return p;
  }
  var e = t, o = p.date();
  return o = o < 29 ? o : Math.min(o, ia(p.year(), e)), p._isUTC ? p._d.setUTCMonth(e, o) : p._d.setMonth(e, o), p;
}
function Ru(p) {
  return p != null ? (mu(this, p), L.updateOffset(this, !0), this) : gb(this, "Month");
}
function Zm() {
  return ia(this.year(), this.month());
}
function jm(p) {
  return this._monthsParseExact ? (K0(this, "_monthsRegex") || yu.call(this), p ? this._monthsShortStrictRegex : this._monthsShortRegex) : (K0(this, "_monthsShortRegex") || (this._monthsShortRegex = $m), this._monthsShortStrictRegex && p ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function eR(p) {
  return this._monthsParseExact ? (K0(this, "_monthsRegex") || yu.call(this), p ? this._monthsStrictRegex : this._monthsRegex) : (K0(this, "_monthsRegex") || (this._monthsRegex = Vm), this._monthsStrictRegex && p ? this._monthsStrictRegex : this._monthsRegex);
}
function yu() {
  function p(d, q) {
    return q.length - d.length;
  }
  var t = [], e = [], o = [], b, r, i, s;
  for (b = 0; b < 12; b++)
    r = Bt([2e3, b]), i = pp(this.monthsShort(r, "")), s = pp(this.months(r, "")), t.push(i), e.push(s), o.push(s), o.push(i);
  t.sort(p), e.sort(p), o.sort(p), this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function tR(p, t, e, o, b, r, i) {
  var s;
  return p < 100 && p >= 0 ? (s = new Date(p + 400, t, e, o, b, r, i), isFinite(s.getFullYear()) && s.setFullYear(p)) : s = new Date(p, t, e, o, b, r, i), s;
}
function Lb(p) {
  var t, e;
  return p < 100 && p >= 0 ? (e = Array.prototype.slice.call(arguments), e[0] = p + 400, t = new Date(Date.UTC.apply(null, e)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(p)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function lz(p, t, e) {
  var o = 7 + t - e, b = (7 + Lb(p, 0, o).getUTCDay() - t) % 7;
  return -b + o - 1;
}
function gu(p, t, e, o, b) {
  var r = (7 + e - o) % 7, i = lz(p, o, b), s = 1 + 7 * (t - 1) + r + i, d, q;
  return s <= 0 ? (d = p - 1, q = hb(d) + s) : s > hb(p) ? (d = p + 1, q = s - hb(p)) : (d = p, q = s), {
    year: d,
    dayOfYear: q
  };
}
function vb(p, t, e) {
  var o = lz(p.year(), t, e), b = Math.floor((p.dayOfYear() - o - 1) / 7) + 1, r, i;
  return b < 1 ? (i = p.year() - 1, r = b + op(i, t, e)) : b > op(p.year(), t, e) ? (r = b - op(p.year(), t, e), i = p.year() + 1) : (i = p.year(), r = b), {
    week: r,
    year: i
  };
}
function op(p, t, e) {
  var o = lz(p, t, e), b = lz(p + 1, t, e);
  return (hb(p) - o + b) / 7;
}
A0("w", ["ww", 2], "wo", "week");
A0("W", ["WW", 2], "Wo", "isoWeek");
c0("w", W1, _M);
c0("ww", W1, a2);
c0("W", W1, _M);
c0("WW", W1, a2);
xb(
  ["w", "ww", "W", "WW"],
  function(p, t, e, o) {
    t[o.substr(0, 1)] = U0(p);
  }
);
function pR(p) {
  return vb(p, this._week.dow, this._week.doy).week;
}
var oR = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function MR() {
  return this._week.dow;
}
function bR() {
  return this._week.doy;
}
function nR(p) {
  var t = this.localeData().week(this);
  return p == null ? t : this.add((p - t) * 7, "d");
}
function zR(p) {
  var t = vb(this, 1, 4).week;
  return p == null ? t : this.add((p - t) * 7, "d");
}
A0("d", 0, "do", "day");
A0("dd", 0, 0, function(p) {
  return this.localeData().weekdaysMin(this, p);
});
A0("ddd", 0, 0, function(p) {
  return this.localeData().weekdaysShort(this, p);
});
A0("dddd", 0, 0, function(p) {
  return this.localeData().weekdays(this, p);
});
A0("e", 0, 0, "weekday");
A0("E", 0, 0, "isoWeekday");
c0("d", W1);
c0("e", W1);
c0("E", W1);
c0("dd", function(p, t) {
  return t.weekdaysMinRegex(p);
});
c0("ddd", function(p, t) {
  return t.weekdaysShortRegex(p);
});
c0("dddd", function(p, t) {
  return t.weekdaysRegex(p);
});
xb(["dd", "ddd", "dddd"], function(p, t, e, o) {
  var b = e._locale.weekdaysParse(p, o, e._strict);
  b != null ? t.d = b : D0(e).invalidWeekday = p;
});
xb(["d", "e", "E"], function(p, t, e, o) {
  t[o] = U0(p);
});
function rR(p, t) {
  return typeof p != "string" ? p : isNaN(p) ? (p = t.weekdaysParse(p), typeof p == "number" ? p : null) : parseInt(p, 10);
}
function cR(p, t) {
  return typeof p == "string" ? t.weekdaysParse(p) % 7 || 7 : isNaN(p) ? null : p;
}
function aa(p, t) {
  return p.slice(t, 7).concat(p.slice(0, t));
}
var iR = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Lu = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), aR = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), OR = kb, sR = kb, AR = kb;
function uR(p, t) {
  var e = rt(this._weekdays) ? this._weekdays : this._weekdays[p && p !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return p === !0 ? aa(e, this._week.dow) : p ? e[p.day()] : e;
}
function dR(p) {
  return p === !0 ? aa(this._weekdaysShort, this._week.dow) : p ? this._weekdaysShort[p.day()] : this._weekdaysShort;
}
function lR(p) {
  return p === !0 ? aa(this._weekdaysMin, this._week.dow) : p ? this._weekdaysMin[p.day()] : this._weekdaysMin;
}
function qR(p, t, e) {
  var o, b, r, i = p.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], o = 0; o < 7; ++o)
      r = Bt([2e3, 1]).day(o), this._minWeekdaysParse[o] = this.weekdaysMin(
        r,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[o] = this.weekdaysShort(
        r,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[o] = this.weekdays(r, "").toLocaleLowerCase();
  return e ? t === "dddd" ? (b = H1.call(this._weekdaysParse, i), b !== -1 ? b : null) : t === "ddd" ? (b = H1.call(this._shortWeekdaysParse, i), b !== -1 ? b : null) : (b = H1.call(this._minWeekdaysParse, i), b !== -1 ? b : null) : t === "dddd" ? (b = H1.call(this._weekdaysParse, i), b !== -1 || (b = H1.call(this._shortWeekdaysParse, i), b !== -1) ? b : (b = H1.call(this._minWeekdaysParse, i), b !== -1 ? b : null)) : t === "ddd" ? (b = H1.call(this._shortWeekdaysParse, i), b !== -1 || (b = H1.call(this._weekdaysParse, i), b !== -1) ? b : (b = H1.call(this._minWeekdaysParse, i), b !== -1 ? b : null)) : (b = H1.call(this._minWeekdaysParse, i), b !== -1 || (b = H1.call(this._weekdaysParse, i), b !== -1) ? b : (b = H1.call(this._shortWeekdaysParse, i), b !== -1 ? b : null));
}
function fR(p, t, e) {
  var o, b, r;
  if (this._weekdaysParseExact)
    return qR.call(this, p, t, e);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), o = 0; o < 7; o++) {
    if (b = Bt([2e3, 1]).day(o), e && !this._fullWeekdaysParse[o] && (this._fullWeekdaysParse[o] = new RegExp(
      "^" + this.weekdays(b, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysShort(b, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysMin(b, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[o] || (r = "^" + this.weekdays(b, "") + "|^" + this.weekdaysShort(b, "") + "|^" + this.weekdaysMin(b, ""), this._weekdaysParse[o] = new RegExp(r.replace(".", ""), "i")), e && t === "dddd" && this._fullWeekdaysParse[o].test(p))
      return o;
    if (e && t === "ddd" && this._shortWeekdaysParse[o].test(p))
      return o;
    if (e && t === "dd" && this._minWeekdaysParse[o].test(p))
      return o;
    if (!e && this._weekdaysParse[o].test(p))
      return o;
  }
}
function WR(p) {
  if (!this.isValid())
    return p != null ? this : NaN;
  var t = gb(this, "Day");
  return p != null ? (p = rR(p, this.localeData()), this.add(p - t, "d")) : t;
}
function hR(p) {
  if (!this.isValid())
    return p != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return p == null ? t : this.add(p - t, "d");
}
function mR(p) {
  if (!this.isValid())
    return p != null ? this : NaN;
  if (p != null) {
    var t = cR(p, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function RR(p) {
  return this._weekdaysParseExact ? (K0(this, "_weekdaysRegex") || Oa.call(this), p ? this._weekdaysStrictRegex : this._weekdaysRegex) : (K0(this, "_weekdaysRegex") || (this._weekdaysRegex = OR), this._weekdaysStrictRegex && p ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function yR(p) {
  return this._weekdaysParseExact ? (K0(this, "_weekdaysRegex") || Oa.call(this), p ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (K0(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = sR), this._weekdaysShortStrictRegex && p ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function gR(p) {
  return this._weekdaysParseExact ? (K0(this, "_weekdaysRegex") || Oa.call(this), p ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (K0(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = AR), this._weekdaysMinStrictRegex && p ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Oa() {
  function p(f, h) {
    return h.length - f.length;
  }
  var t = [], e = [], o = [], b = [], r, i, s, d, q;
  for (r = 0; r < 7; r++)
    i = Bt([2e3, 1]).day(r), s = pp(this.weekdaysMin(i, "")), d = pp(this.weekdaysShort(i, "")), q = pp(this.weekdays(i, "")), t.push(s), e.push(d), o.push(q), b.push(s), b.push(d), b.push(q);
  t.sort(p), e.sort(p), o.sort(p), b.sort(p), this._weekdaysRegex = new RegExp("^(" + b.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + o.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function sa() {
  return this.hours() % 12 || 12;
}
function LR() {
  return this.hours() || 24;
}
A0("H", ["HH", 2], 0, "hour");
A0("h", ["hh", 2], 0, sa);
A0("k", ["kk", 2], 0, LR);
A0("hmm", 0, 0, function() {
  return "" + sa.apply(this) + Nt(this.minutes(), 2);
});
A0("hmmss", 0, 0, function() {
  return "" + sa.apply(this) + Nt(this.minutes(), 2) + Nt(this.seconds(), 2);
});
A0("Hmm", 0, 0, function() {
  return "" + this.hours() + Nt(this.minutes(), 2);
});
A0("Hmmss", 0, 0, function() {
  return "" + this.hours() + Nt(this.minutes(), 2) + Nt(this.seconds(), 2);
});
function vu(p, t) {
  A0(p, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
vu("a", !0);
vu("A", !1);
function _u(p, t) {
  return t._meridiemParse;
}
c0("a", _u);
c0("A", _u);
c0("H", W1, ca);
c0("h", W1, _M);
c0("k", W1, _M);
c0("HH", W1, a2);
c0("hh", W1, a2);
c0("kk", W1, a2);
c0("hmm", du);
c0("hmmss", lu);
c0("Hmm", du);
c0("Hmmss", lu);
b1(["H", "HH"], be);
b1(["k", "kk"], function(p, t, e) {
  var o = U0(p);
  t[be] = o === 24 ? 0 : o;
});
b1(["a", "A"], function(p, t, e) {
  e._isPm = e._locale.isPM(p), e._meridiem = p;
});
b1(["h", "hh"], function(p, t, e) {
  t[be] = U0(p), D0(e).bigHour = !0;
});
b1("hmm", function(p, t, e) {
  var o = p.length - 2;
  t[be] = U0(p.substr(0, o)), t[pt] = U0(p.substr(o)), D0(e).bigHour = !0;
});
b1("hmmss", function(p, t, e) {
  var o = p.length - 4, b = p.length - 2;
  t[be] = U0(p.substr(0, o)), t[pt] = U0(p.substr(o, 2)), t[tp] = U0(p.substr(b)), D0(e).bigHour = !0;
});
b1("Hmm", function(p, t, e) {
  var o = p.length - 2;
  t[be] = U0(p.substr(0, o)), t[pt] = U0(p.substr(o));
});
b1("Hmmss", function(p, t, e) {
  var o = p.length - 4, b = p.length - 2;
  t[be] = U0(p.substr(0, o)), t[pt] = U0(p.substr(o, 2)), t[tp] = U0(p.substr(b));
});
function vR(p) {
  return (p + "").toLowerCase().charAt(0) === "p";
}
var _R = /[ap]\.?m?\.?/i, NR = NM("Hours", !0);
function BR(p, t, e) {
  return p > 11 ? e ? "pm" : "PM" : e ? "am" : "AM";
}
var Nu = {
  calendar: qm,
  longDateFormat: mm,
  invalidDate: ym,
  ordinal: Lm,
  dayOfMonthOrdinalParse: vm,
  relativeTime: Nm,
  months: Jm,
  monthsShort: Wu,
  week: oR,
  weekdays: iR,
  weekdaysMin: aR,
  weekdaysShort: Lu,
  meridiemParse: _R
}, g1 = {}, Ob = {}, _b;
function TR(p, t) {
  var e, o = Math.min(p.length, t.length);
  for (e = 0; e < o; e += 1)
    if (p[e] !== t[e])
      return e;
  return o;
}
function P3(p) {
  return p && p.toLowerCase().replace("_", "-");
}
function wR(p) {
  for (var t = 0, e, o, b, r; t < p.length; ) {
    for (r = P3(p[t]).split("-"), e = r.length, o = P3(p[t + 1]), o = o ? o.split("-") : null; e > 0; ) {
      if (b = xz(r.slice(0, e).join("-")), b)
        return b;
      if (o && o.length >= e && TR(r, o) >= e - 1)
        break;
      e--;
    }
    t++;
  }
  return _b;
}
function SR(p) {
  return !!(p && p.match("^[^/\\\\]*$"));
}
function xz(p) {
  var t = null, e;
  if (g1[p] === void 0 && typeof module < "u" && module && module.exports && SR(p))
    try {
      t = _b._abbr, e = require, e("./locale/" + p), xp(t);
    } catch {
      g1[p] = null;
    }
  return g1[p];
}
function xp(p, t) {
  var e;
  return p && (Je(t) ? e = zp(p) : e = Aa(p, t), e ? _b = e : typeof console < "u" && console.warn && console.warn(
    "Locale " + p + " not found. Did you forget to load it?"
  )), _b._abbr;
}
function Aa(p, t) {
  if (t !== null) {
    var e, o = Nu;
    if (t.abbr = p, g1[p] != null)
      Ou(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), o = g1[p]._config;
    else if (t.parentLocale != null)
      if (g1[t.parentLocale] != null)
        o = g1[t.parentLocale]._config;
      else if (e = xz(t.parentLocale), e != null)
        o = e._config;
      else
        return Ob[t.parentLocale] || (Ob[t.parentLocale] = []), Ob[t.parentLocale].push({
          name: p,
          config: t
        }), null;
    return g1[p] = new Ma(_i(o, t)), Ob[p] && Ob[p].forEach(function(b) {
      Aa(b.name, b.config);
    }), xp(p), g1[p];
  } else
    return delete g1[p], null;
}
function DR(p, t) {
  if (t != null) {
    var e, o, b = Nu;
    g1[p] != null && g1[p].parentLocale != null ? g1[p].set(_i(g1[p]._config, t)) : (o = xz(p), o != null && (b = o._config), t = _i(b, t), o == null && (t.abbr = p), e = new Ma(t), e.parentLocale = g1[p], g1[p] = e), xp(p);
  } else
    g1[p] != null && (g1[p].parentLocale != null ? (g1[p] = g1[p].parentLocale, p === xp() && xp(p)) : g1[p] != null && delete g1[p]);
  return g1[p];
}
function zp(p) {
  var t;
  if (p && p._locale && p._locale._abbr && (p = p._locale._abbr), !p)
    return _b;
  if (!rt(p)) {
    if (t = xz(p), t)
      return t;
    p = [p];
  }
  return wR(p);
}
function XR() {
  return Ni(g1);
}
function ua(p) {
  var t, e = p._a;
  return e && D0(p).overflow === -2 && (t = e[ep] < 0 || e[ep] > 11 ? ep : e[gt] < 1 || e[gt] > ia(e[Re], e[ep]) ? gt : e[be] < 0 || e[be] > 24 || e[be] === 24 && (e[pt] !== 0 || e[tp] !== 0 || e[Ao] !== 0) ? be : e[pt] < 0 || e[pt] > 59 ? pt : e[tp] < 0 || e[tp] > 59 ? tp : e[Ao] < 0 || e[Ao] > 999 ? Ao : -1, D0(p)._overflowDayOfYear && (t < Re || t > gt) && (t = gt), D0(p)._overflowWeeks && t === -1 && (t = Em), D0(p)._overflowWeekday && t === -1 && (t = km), D0(p).overflow = t), p;
}
var CR = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, IR = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, PR = /Z|[+-]\d\d(?::?\d\d)?/, Zn = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Lc = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], ER = /^\/?Date\((-?\d+)/i, kR = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, xR = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function Bu(p) {
  var t, e, o = p._i, b = CR.exec(o) || IR.exec(o), r, i, s, d, q = Zn.length, f = Lc.length;
  if (b) {
    for (D0(p).iso = !0, t = 0, e = q; t < e; t++)
      if (Zn[t][1].exec(b[1])) {
        i = Zn[t][0], r = Zn[t][2] !== !1;
        break;
      }
    if (i == null) {
      p._isValid = !1;
      return;
    }
    if (b[3]) {
      for (t = 0, e = f; t < e; t++)
        if (Lc[t][1].exec(b[3])) {
          s = (b[2] || " ") + Lc[t][0];
          break;
        }
      if (s == null) {
        p._isValid = !1;
        return;
      }
    }
    if (!r && s != null) {
      p._isValid = !1;
      return;
    }
    if (b[4])
      if (PR.exec(b[4]))
        d = "Z";
      else {
        p._isValid = !1;
        return;
      }
    p._f = i + (s || "") + (d || ""), la(p);
  } else
    p._isValid = !1;
}
function FR(p, t, e, o, b, r) {
  var i = [
    UR(p),
    Wu.indexOf(t),
    parseInt(e, 10),
    parseInt(o, 10),
    parseInt(b, 10)
  ];
  return r && i.push(parseInt(r, 10)), i;
}
function UR(p) {
  var t = parseInt(p, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function HR(p) {
  return p.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function JR(p, t, e) {
  if (p) {
    var o = Lu.indexOf(p), b = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (o !== b)
      return D0(e).weekdayMismatch = !0, e._isValid = !1, !1;
  }
  return !0;
}
function $R(p, t, e) {
  if (p)
    return xR[p];
  if (t)
    return 0;
  var o = parseInt(e, 10), b = o % 100, r = (o - b) / 100;
  return r * 60 + b;
}
function Tu(p) {
  var t = kR.exec(HR(p._i)), e;
  if (t) {
    if (e = FR(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !JR(t[1], e, p))
      return;
    p._a = e, p._tzm = $R(t[8], t[9], t[10]), p._d = Lb.apply(null, p._a), p._d.setUTCMinutes(p._d.getUTCMinutes() - p._tzm), D0(p).rfc2822 = !0;
  } else
    p._isValid = !1;
}
function VR(p) {
  var t = ER.exec(p._i);
  if (t !== null) {
    p._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Bu(p), p._isValid === !1)
    delete p._isValid;
  else
    return;
  if (Tu(p), p._isValid === !1)
    delete p._isValid;
  else
    return;
  p._strict ? p._isValid = !1 : L.createFromInputFallback(p);
}
L.createFromInputFallback = P2(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(p) {
    p._d = /* @__PURE__ */ new Date(p._i + (p._useUTC ? " UTC" : ""));
  }
);
function aM(p, t, e) {
  return p ?? t ?? e;
}
function YR(p) {
  var t = new Date(L.now());
  return p._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function da(p) {
  var t, e, o = [], b, r, i;
  if (!p._d) {
    for (b = YR(p), p._w && p._a[gt] == null && p._a[ep] == null && GR(p), p._dayOfYear != null && (i = aM(p._a[Re], b[Re]), (p._dayOfYear > hb(i) || p._dayOfYear === 0) && (D0(p)._overflowDayOfYear = !0), e = Lb(i, 0, p._dayOfYear), p._a[ep] = e.getUTCMonth(), p._a[gt] = e.getUTCDate()), t = 0; t < 3 && p._a[t] == null; ++t)
      p._a[t] = o[t] = b[t];
    for (; t < 7; t++)
      p._a[t] = o[t] = p._a[t] == null ? t === 2 ? 1 : 0 : p._a[t];
    p._a[be] === 24 && p._a[pt] === 0 && p._a[tp] === 0 && p._a[Ao] === 0 && (p._nextDay = !0, p._a[be] = 0), p._d = (p._useUTC ? Lb : tR).apply(
      null,
      o
    ), r = p._useUTC ? p._d.getUTCDay() : p._d.getDay(), p._tzm != null && p._d.setUTCMinutes(p._d.getUTCMinutes() - p._tzm), p._nextDay && (p._a[be] = 24), p._w && typeof p._w.d < "u" && p._w.d !== r && (D0(p).weekdayMismatch = !0);
  }
}
function GR(p) {
  var t, e, o, b, r, i, s, d, q;
  t = p._w, t.GG != null || t.W != null || t.E != null ? (r = 1, i = 4, e = aM(
    t.GG,
    p._a[Re],
    vb(f1(), 1, 4).year
  ), o = aM(t.W, 1), b = aM(t.E, 1), (b < 1 || b > 7) && (d = !0)) : (r = p._locale._week.dow, i = p._locale._week.doy, q = vb(f1(), r, i), e = aM(t.gg, p._a[Re], q.year), o = aM(t.w, q.week), t.d != null ? (b = t.d, (b < 0 || b > 6) && (d = !0)) : t.e != null ? (b = t.e + r, (t.e < 0 || t.e > 6) && (d = !0)) : b = r), o < 1 || o > op(e, r, i) ? D0(p)._overflowWeeks = !0 : d != null ? D0(p)._overflowWeekday = !0 : (s = gu(e, o, b, r, i), p._a[Re] = s.year, p._dayOfYear = s.dayOfYear);
}
L.ISO_8601 = function() {
};
L.RFC_2822 = function() {
};
function la(p) {
  if (p._f === L.ISO_8601) {
    Bu(p);
    return;
  }
  if (p._f === L.RFC_2822) {
    Tu(p);
    return;
  }
  p._a = [], D0(p).empty = !0;
  var t = "" + p._i, e, o, b, r, i, s = t.length, d = 0, q, f;
  for (b = su(p._f, p._locale).match(ba) || [], f = b.length, e = 0; e < f; e++)
    r = b[e], o = (t.match(Cm(r, p)) || [])[0], o && (i = t.substr(0, t.indexOf(o)), i.length > 0 && D0(p).unusedInput.push(i), t = t.slice(
      t.indexOf(o) + o.length
    ), d += o.length), qM[r] ? (o ? D0(p).empty = !1 : D0(p).unusedTokens.push(r), Pm(r, o, p)) : p._strict && !o && D0(p).unusedTokens.push(r);
  D0(p).charsLeftOver = s - d, t.length > 0 && D0(p).unusedInput.push(t), p._a[be] <= 12 && D0(p).bigHour === !0 && p._a[be] > 0 && (D0(p).bigHour = void 0), D0(p).parsedDateParts = p._a.slice(0), D0(p).meridiem = p._meridiem, p._a[be] = KR(
    p._locale,
    p._a[be],
    p._meridiem
  ), q = D0(p).era, q !== null && (p._a[Re] = p._locale.erasConvertYear(q, p._a[Re])), da(p), ua(p);
}
function KR(p, t, e) {
  var o;
  return e == null ? t : p.meridiemHour != null ? p.meridiemHour(t, e) : (p.isPM != null && (o = p.isPM(e), o && t < 12 && (t += 12), !o && t === 12 && (t = 0)), t);
}
function QR(p) {
  var t, e, o, b, r, i, s = !1, d = p._f.length;
  if (d === 0) {
    D0(p).invalidFormat = !0, p._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (b = 0; b < d; b++)
    r = 0, i = !1, t = oa({}, p), p._useUTC != null && (t._useUTC = p._useUTC), t._f = p._f[b], la(t), pa(t) && (i = !0), r += D0(t).charsLeftOver, r += D0(t).unusedTokens.length * 10, D0(t).score = r, s ? r < o && (o = r, e = t) : (o == null || r < o || i) && (o = r, e = t, i && (s = !0));
  Pp(p, e || t);
}
function ZR(p) {
  if (!p._d) {
    var t = na(p._i), e = t.day === void 0 ? t.date : t.day;
    p._a = iu(
      [t.year, t.month, e, t.hour, t.minute, t.second, t.millisecond],
      function(o) {
        return o && parseInt(o, 10);
      }
    ), da(p);
  }
}
function jR(p) {
  var t = new Eb(ua(wu(p)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function wu(p) {
  var t = p._i, e = p._f;
  return p._locale = p._locale || zp(p._l), t === null || e === void 0 && t === "" ? Dz({ nullInput: !0 }) : (typeof t == "string" && (p._i = t = p._locale.preparse(t)), ct(t) ? new Eb(ua(t)) : (Pb(t) ? p._d = t : rt(e) ? QR(p) : e ? la(p) : ey(p), pa(p) || (p._d = null), p));
}
function ey(p) {
  var t = p._i;
  Je(t) ? p._d = new Date(L.now()) : Pb(t) ? p._d = new Date(t.valueOf()) : typeof t == "string" ? VR(p) : rt(t) ? (p._a = iu(t.slice(0), function(e) {
    return parseInt(e, 10);
  }), da(p)) : uo(t) ? ZR(p) : bp(t) ? p._d = new Date(t) : L.createFromInputFallback(p);
}
function Su(p, t, e, o, b) {
  var r = {};
  return (t === !0 || t === !1) && (o = t, t = void 0), (e === !0 || e === !1) && (o = e, e = void 0), (uo(p) && ta(p) || rt(p) && p.length === 0) && (p = void 0), r._isAMomentObject = !0, r._useUTC = r._isUTC = b, r._l = e, r._i = p, r._f = t, r._strict = o, jR(r);
}
function f1(p, t, e, o) {
  return Su(p, t, e, o, !1);
}
var ty = P2(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var p = f1.apply(null, arguments);
    return this.isValid() && p.isValid() ? p < this ? this : p : Dz();
  }
), py = P2(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var p = f1.apply(null, arguments);
    return this.isValid() && p.isValid() ? p > this ? this : p : Dz();
  }
);
function Du(p, t) {
  var e, o;
  if (t.length === 1 && rt(t[0]) && (t = t[0]), !t.length)
    return f1();
  for (e = t[0], o = 1; o < t.length; ++o)
    (!t[o].isValid() || t[o][p](e)) && (e = t[o]);
  return e;
}
function oy() {
  var p = [].slice.call(arguments, 0);
  return Du("isBefore", p);
}
function My() {
  var p = [].slice.call(arguments, 0);
  return Du("isAfter", p);
}
var by = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, sb = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function ny(p) {
  var t, e = !1, o, b = sb.length;
  for (t in p)
    if (K0(p, t) && !(H1.call(sb, t) !== -1 && (p[t] == null || !isNaN(p[t]))))
      return !1;
  for (o = 0; o < b; ++o)
    if (p[sb[o]]) {
      if (e)
        return !1;
      parseFloat(p[sb[o]]) !== U0(p[sb[o]]) && (e = !0);
    }
  return !0;
}
function zy() {
  return this._isValid;
}
function ry() {
  return Ot(NaN);
}
function Fz(p) {
  var t = na(p), e = t.year || 0, o = t.quarter || 0, b = t.month || 0, r = t.week || t.isoWeek || 0, i = t.day || 0, s = t.hour || 0, d = t.minute || 0, q = t.second || 0, f = t.millisecond || 0;
  this._isValid = ny(t), this._milliseconds = +f + q * 1e3 + // 1000
  d * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + r * 7, this._months = +b + o * 3 + e * 12, this._data = {}, this._locale = zp(), this._bubble();
}
function oz(p) {
  return p instanceof Fz;
}
function Ti(p) {
  return p < 0 ? Math.round(-1 * p) * -1 : Math.round(p);
}
function cy(p, t, e) {
  var o = Math.min(p.length, t.length), b = Math.abs(p.length - t.length), r = 0, i;
  for (i = 0; i < o; i++)
    U0(p[i]) !== U0(t[i]) && r++;
  return r + b;
}
function Xu(p, t) {
  A0(p, 0, 0, function() {
    var e = this.utcOffset(), o = "+";
    return e < 0 && (e = -e, o = "-"), o + Nt(~~(e / 60), 2) + t + Nt(~~e % 60, 2);
  });
}
Xu("Z", ":");
Xu("ZZ", "");
c0("Z", Ez);
c0("ZZ", Ez);
b1(["Z", "ZZ"], function(p, t, e) {
  e._useUTC = !0, e._tzm = qa(Ez, p);
});
var iy = /([\+\-]|\d\d)/gi;
function qa(p, t) {
  var e = (t || "").match(p), o, b, r;
  return e === null ? null : (o = e[e.length - 1] || [], b = (o + "").match(iy) || ["-", 0, 0], r = +(b[1] * 60) + U0(b[2]), r === 0 ? 0 : b[0] === "+" ? r : -r);
}
function fa(p, t) {
  var e, o;
  return t._isUTC ? (e = t.clone(), o = (ct(p) || Pb(p) ? p.valueOf() : f1(p).valueOf()) - e.valueOf(), e._d.setTime(e._d.valueOf() + o), L.updateOffset(e, !1), e) : f1(p).local();
}
function wi(p) {
  return -Math.round(p._d.getTimezoneOffset());
}
L.updateOffset = function() {
};
function ay(p, t, e) {
  var o = this._offset || 0, b;
  if (!this.isValid())
    return p != null ? this : NaN;
  if (p != null) {
    if (typeof p == "string") {
      if (p = qa(Ez, p), p === null)
        return this;
    } else Math.abs(p) < 16 && !e && (p = p * 60);
    return !this._isUTC && t && (b = wi(this)), this._offset = p, this._isUTC = !0, b != null && this.add(b, "m"), o !== p && (!t || this._changeInProgress ? Pu(
      this,
      Ot(p - o, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, L.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? o : wi(this);
}
function Oy(p, t) {
  return p != null ? (typeof p != "string" && (p = -p), this.utcOffset(p, t), this) : -this.utcOffset();
}
function sy(p) {
  return this.utcOffset(0, p);
}
function Ay(p) {
  return this._isUTC && (this.utcOffset(0, p), this._isUTC = !1, p && this.subtract(wi(this), "m")), this;
}
function uy() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var p = qa(Dm, this._i);
    p != null ? this.utcOffset(p) : this.utcOffset(0, !0);
  }
  return this;
}
function dy(p) {
  return this.isValid() ? (p = p ? f1(p).utcOffset() : 0, (this.utcOffset() - p) % 60 === 0) : !1;
}
function ly() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function qy() {
  if (!Je(this._isDSTShifted))
    return this._isDSTShifted;
  var p = {}, t;
  return oa(p, this), p = wu(p), p._a ? (t = p._isUTC ? Bt(p._a) : f1(p._a), this._isDSTShifted = this.isValid() && cy(p._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function fy() {
  return this.isValid() ? !this._isUTC : !1;
}
function Wy() {
  return this.isValid() ? this._isUTC : !1;
}
function Cu() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var hy = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, my = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Ot(p, t) {
  var e = p, o = null, b, r, i;
  return oz(p) ? e = {
    ms: p._milliseconds,
    d: p._days,
    M: p._months
  } : bp(p) || !isNaN(+p) ? (e = {}, t ? e[t] = +p : e.milliseconds = +p) : (o = hy.exec(p)) ? (b = o[1] === "-" ? -1 : 1, e = {
    y: 0,
    d: U0(o[gt]) * b,
    h: U0(o[be]) * b,
    m: U0(o[pt]) * b,
    s: U0(o[tp]) * b,
    ms: U0(Ti(o[Ao] * 1e3)) * b
    // the millisecond decimal point is included in the match
  }) : (o = my.exec(p)) ? (b = o[1] === "-" ? -1 : 1, e = {
    y: ao(o[2], b),
    M: ao(o[3], b),
    w: ao(o[4], b),
    d: ao(o[5], b),
    h: ao(o[6], b),
    m: ao(o[7], b),
    s: ao(o[8], b)
  }) : e == null ? e = {} : typeof e == "object" && ("from" in e || "to" in e) && (i = Ry(
    f1(e.from),
    f1(e.to)
  ), e = {}, e.ms = i.milliseconds, e.M = i.months), r = new Fz(e), oz(p) && K0(p, "_locale") && (r._locale = p._locale), oz(p) && K0(p, "_isValid") && (r._isValid = p._isValid), r;
}
Ot.fn = Fz.prototype;
Ot.invalid = ry;
function ao(p, t) {
  var e = p && parseFloat(p.replace(",", "."));
  return (isNaN(e) ? 0 : e) * t;
}
function E3(p, t) {
  var e = {};
  return e.months = t.month() - p.month() + (t.year() - p.year()) * 12, p.clone().add(e.months, "M").isAfter(t) && --e.months, e.milliseconds = +t - +p.clone().add(e.months, "M"), e;
}
function Ry(p, t) {
  var e;
  return p.isValid() && t.isValid() ? (t = fa(t, p), p.isBefore(t) ? e = E3(p, t) : (e = E3(t, p), e.milliseconds = -e.milliseconds, e.months = -e.months), e) : { milliseconds: 0, months: 0 };
}
function Iu(p, t) {
  return function(e, o) {
    var b, r;
    return o !== null && !isNaN(+o) && (Ou(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), r = e, e = o, o = r), b = Ot(e, o), Pu(this, b, p), this;
  };
}
function Pu(p, t, e, o) {
  var b = t._milliseconds, r = Ti(t._days), i = Ti(t._months);
  p.isValid() && (o = o ?? !0, i && mu(p, gb(p, "Month") + i * e), r && fu(p, "Date", gb(p, "Date") + r * e), b && p._d.setTime(p._d.valueOf() + b * e), o && L.updateOffset(p, r || i));
}
var yy = Iu(1, "add"), gy = Iu(-1, "subtract");
function Eu(p) {
  return typeof p == "string" || p instanceof String;
}
function Ly(p) {
  return ct(p) || Pb(p) || Eu(p) || bp(p) || _y(p) || vy(p) || p === null || p === void 0;
}
function vy(p) {
  var t = uo(p) && !ta(p), e = !1, o = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], b, r, i = o.length;
  for (b = 0; b < i; b += 1)
    r = o[b], e = e || K0(p, r);
  return t && e;
}
function _y(p) {
  var t = rt(p), e = !1;
  return t && (e = p.filter(function(o) {
    return !bp(o) && Eu(p);
  }).length === 0), t && e;
}
function Ny(p) {
  var t = uo(p) && !ta(p), e = !1, o = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], b, r;
  for (b = 0; b < o.length; b += 1)
    r = o[b], e = e || K0(p, r);
  return t && e;
}
function By(p, t) {
  var e = p.diff(t, "days", !0);
  return e < -6 ? "sameElse" : e < -1 ? "lastWeek" : e < 0 ? "lastDay" : e < 1 ? "sameDay" : e < 2 ? "nextDay" : e < 7 ? "nextWeek" : "sameElse";
}
function Ty(p, t) {
  arguments.length === 1 && (arguments[0] ? Ly(arguments[0]) ? (p = arguments[0], t = void 0) : Ny(arguments[0]) && (t = arguments[0], p = void 0) : (p = void 0, t = void 0));
  var e = p || f1(), o = fa(e, this).startOf("day"), b = L.calendarFormat(this, o) || "sameElse", r = t && (Tt(t[b]) ? t[b].call(this, e) : t[b]);
  return this.format(
    r || this.localeData().calendar(b, this, f1(e))
  );
}
function wy() {
  return new Eb(this);
}
function Sy(p, t) {
  var e = ct(p) ? p : f1(p);
  return this.isValid() && e.isValid() ? (t = E2(t) || "millisecond", t === "millisecond" ? this.valueOf() > e.valueOf() : e.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function Dy(p, t) {
  var e = ct(p) ? p : f1(p);
  return this.isValid() && e.isValid() ? (t = E2(t) || "millisecond", t === "millisecond" ? this.valueOf() < e.valueOf() : this.clone().endOf(t).valueOf() < e.valueOf()) : !1;
}
function Xy(p, t, e, o) {
  var b = ct(p) ? p : f1(p), r = ct(t) ? t : f1(t);
  return this.isValid() && b.isValid() && r.isValid() ? (o = o || "()", (o[0] === "(" ? this.isAfter(b, e) : !this.isBefore(b, e)) && (o[1] === ")" ? this.isBefore(r, e) : !this.isAfter(r, e))) : !1;
}
function Cy(p, t) {
  var e = ct(p) ? p : f1(p), o;
  return this.isValid() && e.isValid() ? (t = E2(t) || "millisecond", t === "millisecond" ? this.valueOf() === e.valueOf() : (o = e.valueOf(), this.clone().startOf(t).valueOf() <= o && o <= this.clone().endOf(t).valueOf())) : !1;
}
function Iy(p, t) {
  return this.isSame(p, t) || this.isAfter(p, t);
}
function Py(p, t) {
  return this.isSame(p, t) || this.isBefore(p, t);
}
function Ey(p, t, e) {
  var o, b, r;
  if (!this.isValid())
    return NaN;
  if (o = fa(p, this), !o.isValid())
    return NaN;
  switch (b = (o.utcOffset() - this.utcOffset()) * 6e4, t = E2(t), t) {
    case "year":
      r = Mz(this, o) / 12;
      break;
    case "month":
      r = Mz(this, o);
      break;
    case "quarter":
      r = Mz(this, o) / 3;
      break;
    case "second":
      r = (this - o) / 1e3;
      break;
    // 1000
    case "minute":
      r = (this - o) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      r = (this - o) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      r = (this - o - b) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      r = (this - o - b) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      r = this - o;
  }
  return e ? r : T2(r);
}
function Mz(p, t) {
  if (p.date() < t.date())
    return -Mz(t, p);
  var e = (t.year() - p.year()) * 12 + (t.month() - p.month()), o = p.clone().add(e, "months"), b, r;
  return t - o < 0 ? (b = p.clone().add(e - 1, "months"), r = (t - o) / (o - b)) : (b = p.clone().add(e + 1, "months"), r = (t - o) / (b - o)), -(e + r) || 0;
}
L.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
L.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function ky() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function xy(p) {
  if (!this.isValid())
    return null;
  var t = p !== !0, e = t ? this.clone().utc() : this;
  return e.year() < 0 || e.year() > 9999 ? pz(
    e,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Tt(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", pz(e, "Z")) : pz(
    e,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Fy() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var p = "moment", t = "", e, o, b, r;
  return this.isLocal() || (p = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), e = "[" + p + '("]', o = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", b = "-MM-DD[T]HH:mm:ss.SSS", r = t + '[")]', this.format(e + o + b + r);
}
function Uy(p) {
  p || (p = this.isUtc() ? L.defaultFormatUtc : L.defaultFormat);
  var t = pz(this, p);
  return this.localeData().postformat(t);
}
function Hy(p, t) {
  return this.isValid() && (ct(p) && p.isValid() || f1(p).isValid()) ? Ot({ to: this, from: p }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Jy(p) {
  return this.from(f1(), p);
}
function $y(p, t) {
  return this.isValid() && (ct(p) && p.isValid() || f1(p).isValid()) ? Ot({ from: this, to: p }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Vy(p) {
  return this.to(f1(), p);
}
function ku(p) {
  var t;
  return p === void 0 ? this._locale._abbr : (t = zp(p), t != null && (this._locale = t), this);
}
var xu = P2(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(p) {
    return p === void 0 ? this.localeData() : this.locale(p);
  }
);
function Fu() {
  return this._locale;
}
var qz = 1e3, fM = 60 * qz, fz = 60 * fM, Uu = (365 * 400 + 97) * 24 * fz;
function WM(p, t) {
  return (p % t + t) % t;
}
function Hu(p, t, e) {
  return p < 100 && p >= 0 ? new Date(p + 400, t, e) - Uu : new Date(p, t, e).valueOf();
}
function Ju(p, t, e) {
  return p < 100 && p >= 0 ? Date.UTC(p + 400, t, e) - Uu : Date.UTC(p, t, e);
}
function Yy(p) {
  var t, e;
  if (p = E2(p), p === void 0 || p === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? Ju : Hu, p) {
    case "year":
      t = e(this.year(), 0, 1);
      break;
    case "quarter":
      t = e(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = e(this.year(), this.month(), 1);
      break;
    case "week":
      t = e(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = e(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= WM(
        t + (this._isUTC ? 0 : this.utcOffset() * fM),
        fz
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= WM(t, fM);
      break;
    case "second":
      t = this._d.valueOf(), t -= WM(t, qz);
      break;
  }
  return this._d.setTime(t), L.updateOffset(this, !0), this;
}
function Gy(p) {
  var t, e;
  if (p = E2(p), p === void 0 || p === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? Ju : Hu, p) {
    case "year":
      t = e(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = e(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = e(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = e(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = e(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += fz - WM(
        t + (this._isUTC ? 0 : this.utcOffset() * fM),
        fz
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += fM - WM(t, fM) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += qz - WM(t, qz) - 1;
      break;
  }
  return this._d.setTime(t), L.updateOffset(this, !0), this;
}
function Ky() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Qy() {
  return Math.floor(this.valueOf() / 1e3);
}
function Zy() {
  return new Date(this.valueOf());
}
function jy() {
  var p = this;
  return [
    p.year(),
    p.month(),
    p.date(),
    p.hour(),
    p.minute(),
    p.second(),
    p.millisecond()
  ];
}
function eg() {
  var p = this;
  return {
    years: p.year(),
    months: p.month(),
    date: p.date(),
    hours: p.hours(),
    minutes: p.minutes(),
    seconds: p.seconds(),
    milliseconds: p.milliseconds()
  };
}
function tg() {
  return this.isValid() ? this.toISOString() : null;
}
function pg() {
  return pa(this);
}
function og() {
  return Pp({}, D0(this));
}
function Mg() {
  return D0(this).overflow;
}
function bg() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
A0("N", 0, 0, "eraAbbr");
A0("NN", 0, 0, "eraAbbr");
A0("NNN", 0, 0, "eraAbbr");
A0("NNNN", 0, 0, "eraName");
A0("NNNNN", 0, 0, "eraNarrow");
A0("y", ["y", 1], "yo", "eraYear");
A0("y", ["yy", 2], 0, "eraYear");
A0("y", ["yyy", 3], 0, "eraYear");
A0("y", ["yyyy", 4], 0, "eraYear");
c0("N", Wa);
c0("NN", Wa);
c0("NNN", Wa);
c0("NNNN", dg);
c0("NNNNN", lg);
b1(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(p, t, e, o) {
    var b = e._locale.erasParse(p, o, e._strict);
    b ? D0(e).era = b : D0(e).invalidEra = p;
  }
);
c0("y", vM);
c0("yy", vM);
c0("yyy", vM);
c0("yyyy", vM);
c0("yo", qg);
b1(["y", "yy", "yyy", "yyyy"], Re);
b1(["yo"], function(p, t, e, o) {
  var b;
  e._locale._eraYearOrdinalRegex && (b = p.match(e._locale._eraYearOrdinalRegex)), e._locale.eraYearOrdinalParse ? t[Re] = e._locale.eraYearOrdinalParse(p, b) : t[Re] = parseInt(p, 10);
});
function ng(p, t) {
  var e, o, b, r = this._eras || zp("en")._eras;
  for (e = 0, o = r.length; e < o; ++e) {
    switch (typeof r[e].since) {
      case "string":
        b = L(r[e].since).startOf("day"), r[e].since = b.valueOf();
        break;
    }
    switch (typeof r[e].until) {
      case "undefined":
        r[e].until = 1 / 0;
        break;
      case "string":
        b = L(r[e].until).startOf("day").valueOf(), r[e].until = b.valueOf();
        break;
    }
  }
  return r;
}
function zg(p, t, e) {
  var o, b, r = this.eras(), i, s, d;
  for (p = p.toUpperCase(), o = 0, b = r.length; o < b; ++o)
    if (i = r[o].name.toUpperCase(), s = r[o].abbr.toUpperCase(), d = r[o].narrow.toUpperCase(), e)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === p)
            return r[o];
          break;
        case "NNNN":
          if (i === p)
            return r[o];
          break;
        case "NNNNN":
          if (d === p)
            return r[o];
          break;
      }
    else if ([i, s, d].indexOf(p) >= 0)
      return r[o];
}
function rg(p, t) {
  var e = p.since <= p.until ? 1 : -1;
  return t === void 0 ? L(p.since).year() : L(p.since).year() + (t - p.offset) * e;
}
function cg() {
  var p, t, e, o = this.localeData().eras();
  for (p = 0, t = o.length; p < t; ++p)
    if (e = this.clone().startOf("day").valueOf(), o[p].since <= e && e <= o[p].until || o[p].until <= e && e <= o[p].since)
      return o[p].name;
  return "";
}
function ig() {
  var p, t, e, o = this.localeData().eras();
  for (p = 0, t = o.length; p < t; ++p)
    if (e = this.clone().startOf("day").valueOf(), o[p].since <= e && e <= o[p].until || o[p].until <= e && e <= o[p].since)
      return o[p].narrow;
  return "";
}
function ag() {
  var p, t, e, o = this.localeData().eras();
  for (p = 0, t = o.length; p < t; ++p)
    if (e = this.clone().startOf("day").valueOf(), o[p].since <= e && e <= o[p].until || o[p].until <= e && e <= o[p].since)
      return o[p].abbr;
  return "";
}
function Og() {
  var p, t, e, o, b = this.localeData().eras();
  for (p = 0, t = b.length; p < t; ++p)
    if (e = b[p].since <= b[p].until ? 1 : -1, o = this.clone().startOf("day").valueOf(), b[p].since <= o && o <= b[p].until || b[p].until <= o && o <= b[p].since)
      return (this.year() - L(b[p].since).year()) * e + b[p].offset;
  return this.year();
}
function sg(p) {
  return K0(this, "_erasNameRegex") || ha.call(this), p ? this._erasNameRegex : this._erasRegex;
}
function Ag(p) {
  return K0(this, "_erasAbbrRegex") || ha.call(this), p ? this._erasAbbrRegex : this._erasRegex;
}
function ug(p) {
  return K0(this, "_erasNarrowRegex") || ha.call(this), p ? this._erasNarrowRegex : this._erasRegex;
}
function Wa(p, t) {
  return t.erasAbbrRegex(p);
}
function dg(p, t) {
  return t.erasNameRegex(p);
}
function lg(p, t) {
  return t.erasNarrowRegex(p);
}
function qg(p, t) {
  return t._eraYearOrdinalRegex || vM;
}
function ha() {
  var p = [], t = [], e = [], o = [], b, r, i, s, d, q = this.eras();
  for (b = 0, r = q.length; b < r; ++b)
    i = pp(q[b].name), s = pp(q[b].abbr), d = pp(q[b].narrow), t.push(i), p.push(s), e.push(d), o.push(i), o.push(s), o.push(d);
  this._erasRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + p.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
A0(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
A0(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Uz(p, t) {
  A0(0, [p, p.length], 0, t);
}
Uz("gggg", "weekYear");
Uz("ggggg", "weekYear");
Uz("GGGG", "isoWeekYear");
Uz("GGGGG", "isoWeekYear");
c0("G", Pz);
c0("g", Pz);
c0("GG", W1, a2);
c0("gg", W1, a2);
c0("GGGG", ra, za);
c0("gggg", ra, za);
c0("GGGGG", Iz, Xz);
c0("ggggg", Iz, Xz);
xb(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(p, t, e, o) {
    t[o.substr(0, 2)] = U0(p);
  }
);
xb(["gg", "GG"], function(p, t, e, o) {
  t[o] = L.parseTwoDigitYear(p);
});
function fg(p) {
  return $u.call(
    this,
    p,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Wg(p) {
  return $u.call(
    this,
    p,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function hg() {
  return op(this.year(), 1, 4);
}
function mg() {
  return op(this.isoWeekYear(), 1, 4);
}
function Rg() {
  var p = this.localeData()._week;
  return op(this.year(), p.dow, p.doy);
}
function yg() {
  var p = this.localeData()._week;
  return op(this.weekYear(), p.dow, p.doy);
}
function $u(p, t, e, o, b) {
  var r;
  return p == null ? vb(this, o, b).year : (r = op(p, o, b), t > r && (t = r), gg.call(this, p, t, e, o, b));
}
function gg(p, t, e, o, b) {
  var r = gu(p, t, e, o, b), i = Lb(r.year, 0, r.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
A0("Q", 0, "Qo", "quarter");
c0("Q", Au);
b1("Q", function(p, t) {
  t[ep] = (U0(p) - 1) * 3;
});
function Lg(p) {
  return p == null ? Math.ceil((this.month() + 1) / 3) : this.month((p - 1) * 3 + this.month() % 3);
}
A0("D", ["DD", 2], "Do", "date");
c0("D", W1, _M);
c0("DD", W1, a2);
c0("Do", function(p, t) {
  return p ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
b1(["D", "DD"], gt);
b1("Do", function(p, t) {
  t[gt] = U0(p.match(W1)[0]);
});
var Vu = NM("Date", !0);
A0("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
c0("DDD", Cz);
c0("DDDD", uu);
b1(["DDD", "DDDD"], function(p, t, e) {
  e._dayOfYear = U0(p);
});
function vg(p) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return p == null ? t : this.add(p - t, "d");
}
A0("m", ["mm", 2], 0, "minute");
c0("m", W1, ca);
c0("mm", W1, a2);
b1(["m", "mm"], pt);
var _g = NM("Minutes", !1);
A0("s", ["ss", 2], 0, "second");
c0("s", W1, ca);
c0("ss", W1, a2);
b1(["s", "ss"], tp);
var Ng = NM("Seconds", !1);
A0("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
A0(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
A0(0, ["SSS", 3], 0, "millisecond");
A0(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
A0(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
A0(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
A0(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
A0(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
A0(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
c0("S", Cz, Au);
c0("SS", Cz, a2);
c0("SSS", Cz, uu);
var Ep, Yu;
for (Ep = "SSSS"; Ep.length <= 9; Ep += "S")
  c0(Ep, vM);
function Bg(p, t) {
  t[Ao] = U0(("0." + p) * 1e3);
}
for (Ep = "S"; Ep.length <= 9; Ep += "S")
  b1(Ep, Bg);
Yu = NM("Milliseconds", !1);
A0("z", 0, 0, "zoneAbbr");
A0("zz", 0, 0, "zoneName");
function Tg() {
  return this._isUTC ? "UTC" : "";
}
function wg() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var K = Eb.prototype;
K.add = yy;
K.calendar = Ty;
K.clone = wy;
K.diff = Ey;
K.endOf = Gy;
K.format = Uy;
K.from = Hy;
K.fromNow = Jy;
K.to = $y;
K.toNow = Vy;
K.get = Fm;
K.invalidAt = Mg;
K.isAfter = Sy;
K.isBefore = Dy;
K.isBetween = Xy;
K.isSame = Cy;
K.isSameOrAfter = Iy;
K.isSameOrBefore = Py;
K.isValid = pg;
K.lang = xu;
K.locale = ku;
K.localeData = Fu;
K.max = py;
K.min = ty;
K.parsingFlags = og;
K.set = Um;
K.startOf = Yy;
K.subtract = gy;
K.toArray = jy;
K.toObject = eg;
K.toDate = Zy;
K.toISOString = xy;
K.inspect = Fy;
typeof Symbol < "u" && Symbol.for != null && (K[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
K.toJSON = tg;
K.toString = ky;
K.unix = Qy;
K.valueOf = Ky;
K.creationData = bg;
K.eraName = cg;
K.eraNarrow = ig;
K.eraAbbr = ag;
K.eraYear = Og;
K.year = qu;
K.isLeapYear = xm;
K.weekYear = fg;
K.isoWeekYear = Wg;
K.quarter = K.quarters = Lg;
K.month = Ru;
K.daysInMonth = Zm;
K.week = K.weeks = nR;
K.isoWeek = K.isoWeeks = zR;
K.weeksInYear = Rg;
K.weeksInWeekYear = yg;
K.isoWeeksInYear = hg;
K.isoWeeksInISOWeekYear = mg;
K.date = Vu;
K.day = K.days = WR;
K.weekday = hR;
K.isoWeekday = mR;
K.dayOfYear = vg;
K.hour = K.hours = NR;
K.minute = K.minutes = _g;
K.second = K.seconds = Ng;
K.millisecond = K.milliseconds = Yu;
K.utcOffset = ay;
K.utc = sy;
K.local = Ay;
K.parseZone = uy;
K.hasAlignedHourOffset = dy;
K.isDST = ly;
K.isLocal = fy;
K.isUtcOffset = Wy;
K.isUtc = Cu;
K.isUTC = Cu;
K.zoneAbbr = Tg;
K.zoneName = wg;
K.dates = P2(
  "dates accessor is deprecated. Use date instead.",
  Vu
);
K.months = P2(
  "months accessor is deprecated. Use month instead",
  Ru
);
K.years = P2(
  "years accessor is deprecated. Use year instead",
  qu
);
K.zone = P2(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Oy
);
K.isDSTShifted = P2(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  qy
);
function Sg(p) {
  return f1(p * 1e3);
}
function Dg() {
  return f1.apply(null, arguments).parseZone();
}
function Gu(p) {
  return p;
}
var Q0 = Ma.prototype;
Q0.calendar = fm;
Q0.longDateFormat = Rm;
Q0.invalidDate = gm;
Q0.ordinal = _m;
Q0.preparse = Gu;
Q0.postformat = Gu;
Q0.relativeTime = Bm;
Q0.pastFuture = Tm;
Q0.set = lm;
Q0.eras = ng;
Q0.erasParse = zg;
Q0.erasConvertYear = rg;
Q0.erasAbbrRegex = Ag;
Q0.erasNameRegex = sg;
Q0.erasNarrowRegex = ug;
Q0.months = Ym;
Q0.monthsShort = Gm;
Q0.monthsParse = Qm;
Q0.monthsRegex = eR;
Q0.monthsShortRegex = jm;
Q0.week = pR;
Q0.firstDayOfYear = bR;
Q0.firstDayOfWeek = MR;
Q0.weekdays = uR;
Q0.weekdaysMin = lR;
Q0.weekdaysShort = dR;
Q0.weekdaysParse = fR;
Q0.weekdaysRegex = RR;
Q0.weekdaysShortRegex = yR;
Q0.weekdaysMinRegex = gR;
Q0.isPM = vR;
Q0.meridiem = BR;
function Wz(p, t, e, o) {
  var b = zp(), r = Bt().set(o, t);
  return b[e](r, p);
}
function Ku(p, t, e) {
  if (bp(p) && (t = p, p = void 0), p = p || "", t != null)
    return Wz(p, t, e, "month");
  var o, b = [];
  for (o = 0; o < 12; o++)
    b[o] = Wz(p, o, e, "month");
  return b;
}
function ma(p, t, e, o) {
  typeof p == "boolean" ? (bp(t) && (e = t, t = void 0), t = t || "") : (t = p, e = t, p = !1, bp(t) && (e = t, t = void 0), t = t || "");
  var b = zp(), r = p ? b._week.dow : 0, i, s = [];
  if (e != null)
    return Wz(t, (e + r) % 7, o, "day");
  for (i = 0; i < 7; i++)
    s[i] = Wz(t, (i + r) % 7, o, "day");
  return s;
}
function Xg(p, t) {
  return Ku(p, t, "months");
}
function Cg(p, t) {
  return Ku(p, t, "monthsShort");
}
function Ig(p, t, e) {
  return ma(p, t, e, "weekdays");
}
function Pg(p, t, e) {
  return ma(p, t, e, "weekdaysShort");
}
function Eg(p, t, e) {
  return ma(p, t, e, "weekdaysMin");
}
xp("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(p) {
    var t = p % 10, e = U0(p % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return p + e;
  }
});
L.lang = P2(
  "moment.lang is deprecated. Use moment.locale instead.",
  xp
);
L.langData = P2(
  "moment.langData is deprecated. Use moment.localeData instead.",
  zp
);
var Qt = Math.abs;
function kg() {
  var p = this._data;
  return this._milliseconds = Qt(this._milliseconds), this._days = Qt(this._days), this._months = Qt(this._months), p.milliseconds = Qt(p.milliseconds), p.seconds = Qt(p.seconds), p.minutes = Qt(p.minutes), p.hours = Qt(p.hours), p.months = Qt(p.months), p.years = Qt(p.years), this;
}
function Qu(p, t, e, o) {
  var b = Ot(t, e);
  return p._milliseconds += o * b._milliseconds, p._days += o * b._days, p._months += o * b._months, p._bubble();
}
function xg(p, t) {
  return Qu(this, p, t, 1);
}
function Fg(p, t) {
  return Qu(this, p, t, -1);
}
function k3(p) {
  return p < 0 ? Math.floor(p) : Math.ceil(p);
}
function Ug() {
  var p = this._milliseconds, t = this._days, e = this._months, o = this._data, b, r, i, s, d;
  return p >= 0 && t >= 0 && e >= 0 || p <= 0 && t <= 0 && e <= 0 || (p += k3(Si(e) + t) * 864e5, t = 0, e = 0), o.milliseconds = p % 1e3, b = T2(p / 1e3), o.seconds = b % 60, r = T2(b / 60), o.minutes = r % 60, i = T2(r / 60), o.hours = i % 24, t += T2(i / 24), d = T2(Zu(t)), e += d, t -= k3(Si(d)), s = T2(e / 12), e %= 12, o.days = t, o.months = e, o.years = s, this;
}
function Zu(p) {
  return p * 4800 / 146097;
}
function Si(p) {
  return p * 146097 / 4800;
}
function Hg(p) {
  if (!this.isValid())
    return NaN;
  var t, e, o = this._milliseconds;
  if (p = E2(p), p === "month" || p === "quarter" || p === "year")
    switch (t = this._days + o / 864e5, e = this._months + Zu(t), p) {
      case "month":
        return e;
      case "quarter":
        return e / 3;
      case "year":
        return e / 12;
    }
  else
    switch (t = this._days + Math.round(Si(this._months)), p) {
      case "week":
        return t / 7 + o / 6048e5;
      case "day":
        return t + o / 864e5;
      case "hour":
        return t * 24 + o / 36e5;
      case "minute":
        return t * 1440 + o / 6e4;
      case "second":
        return t * 86400 + o / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + o;
      default:
        throw new Error("Unknown unit " + p);
    }
}
function rp(p) {
  return function() {
    return this.as(p);
  };
}
var ju = rp("ms"), Jg = rp("s"), $g = rp("m"), Vg = rp("h"), Yg = rp("d"), Gg = rp("w"), Kg = rp("M"), Qg = rp("Q"), Zg = rp("y"), jg = ju;
function eL() {
  return Ot(this);
}
function tL(p) {
  return p = E2(p), this.isValid() ? this[p + "s"]() : NaN;
}
function wo(p) {
  return function() {
    return this.isValid() ? this._data[p] : NaN;
  };
}
var pL = wo("milliseconds"), oL = wo("seconds"), ML = wo("minutes"), bL = wo("hours"), nL = wo("days"), zL = wo("months"), rL = wo("years");
function cL() {
  return T2(this.days() / 7);
}
var Zt = Math.round, AM = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function iL(p, t, e, o, b) {
  return b.relativeTime(t || 1, !!e, p, o);
}
function aL(p, t, e, o) {
  var b = Ot(p).abs(), r = Zt(b.as("s")), i = Zt(b.as("m")), s = Zt(b.as("h")), d = Zt(b.as("d")), q = Zt(b.as("M")), f = Zt(b.as("w")), h = Zt(b.as("y")), g = r <= e.ss && ["s", r] || r < e.s && ["ss", r] || i <= 1 && ["m"] || i < e.m && ["mm", i] || s <= 1 && ["h"] || s < e.h && ["hh", s] || d <= 1 && ["d"] || d < e.d && ["dd", d];
  return e.w != null && (g = g || f <= 1 && ["w"] || f < e.w && ["ww", f]), g = g || q <= 1 && ["M"] || q < e.M && ["MM", q] || h <= 1 && ["y"] || ["yy", h], g[2] = t, g[3] = +p > 0, g[4] = o, iL.apply(null, g);
}
function OL(p) {
  return p === void 0 ? Zt : typeof p == "function" ? (Zt = p, !0) : !1;
}
function sL(p, t) {
  return AM[p] === void 0 ? !1 : t === void 0 ? AM[p] : (AM[p] = t, p === "s" && (AM.ss = t - 1), !0);
}
function AL(p, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = !1, o = AM, b, r;
  return typeof p == "object" && (t = p, p = !1), typeof p == "boolean" && (e = p), typeof t == "object" && (o = Object.assign({}, AM, t), t.s != null && t.ss == null && (o.ss = t.s - 1)), b = this.localeData(), r = aL(this, !e, o, b), e && (r = b.pastFuture(+this, r)), b.postformat(r);
}
var vc = Math.abs;
function rM(p) {
  return (p > 0) - (p < 0) || +p;
}
function Hz() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var p = vc(this._milliseconds) / 1e3, t = vc(this._days), e = vc(this._months), o, b, r, i, s = this.asSeconds(), d, q, f, h;
  return s ? (o = T2(p / 60), b = T2(o / 60), p %= 60, o %= 60, r = T2(e / 12), e %= 12, i = p ? p.toFixed(3).replace(/\.?0+$/, "") : "", d = s < 0 ? "-" : "", q = rM(this._months) !== rM(s) ? "-" : "", f = rM(this._days) !== rM(s) ? "-" : "", h = rM(this._milliseconds) !== rM(s) ? "-" : "", d + "P" + (r ? q + r + "Y" : "") + (e ? q + e + "M" : "") + (t ? f + t + "D" : "") + (b || o || p ? "T" : "") + (b ? h + b + "H" : "") + (o ? h + o + "M" : "") + (p ? h + i + "S" : "")) : "P0D";
}
var $0 = Fz.prototype;
$0.isValid = zy;
$0.abs = kg;
$0.add = xg;
$0.subtract = Fg;
$0.as = Hg;
$0.asMilliseconds = ju;
$0.asSeconds = Jg;
$0.asMinutes = $g;
$0.asHours = Vg;
$0.asDays = Yg;
$0.asWeeks = Gg;
$0.asMonths = Kg;
$0.asQuarters = Qg;
$0.asYears = Zg;
$0.valueOf = jg;
$0._bubble = Ug;
$0.clone = eL;
$0.get = tL;
$0.milliseconds = pL;
$0.seconds = oL;
$0.minutes = ML;
$0.hours = bL;
$0.days = nL;
$0.weeks = cL;
$0.months = zL;
$0.years = rL;
$0.humanize = AL;
$0.toISOString = Hz;
$0.toString = Hz;
$0.toJSON = Hz;
$0.locale = ku;
$0.localeData = Fu;
$0.toIsoString = P2(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Hz
);
$0.lang = xu;
A0("X", 0, 0, "unix");
A0("x", 0, 0, "valueOf");
c0("x", Pz);
c0("X", Xm);
b1("X", function(p, t, e) {
  e._d = new Date(parseFloat(p) * 1e3);
});
b1("x", function(p, t, e) {
  e._d = new Date(U0(p));
});
//! moment.js
L.version = "2.30.1";
um(f1);
L.fn = K;
L.min = oy;
L.max = My;
L.now = by;
L.utc = Bt;
L.unix = Sg;
L.months = Xg;
L.isDate = Pb;
L.locale = xp;
L.invalid = Dz;
L.duration = Ot;
L.isMoment = ct;
L.weekdays = Ig;
L.parseZone = Dg;
L.localeData = zp;
L.isDuration = oz;
L.monthsShort = Cg;
L.weekdaysMin = Eg;
L.defineLocale = Aa;
L.updateLocale = DR;
L.locales = XR;
L.weekdaysShort = Pg;
L.normalizeUnits = E2;
L.relativeTimeRounding = OL;
L.relativeTimeThreshold = sL;
L.calendarFormat = By;
L.prototype = K;
L.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const uL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L
}, Symbol.toStringTag, { value: "Module" }));
class ye {
  update(t, e = !1) {
    if (t != null)
      for (const o in t)
        t.hasOwnProperty(o) && (e ? this[o] = t[o] : t[o] !== void 0 && (this[o] = t[o]));
  }
  clone() {
    throw new Error("Method not implemented.");
  }
}
class n0 extends ye {
  constructor() {
    super(...arguments);
    z(this, "id");
    z(this, "softDeleted");
    z(this, "softDeletedDate");
  }
}
class hM extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "offset");
    e && this.update(e);
  }
  get offsetAsText() {
    if (!this.offset) return "";
    const e = this.offset.asMilliseconds() < 0, o = Math.floor(Math.abs(this.offset.asHours())), b = Math.abs(this.offset.asMinutes()) - o * 60, r = o.toString().padStart(2, "0") + ":" + b.toString().padStart(2, "0");
    return e ? `-${r}` : `+${r}`;
  }
  update(e) {
    super.update(e);
  }
  clone() {
    return new hM({
      id: this.id,
      offset: this.offset,
      name: this.name
    });
  }
  static fromJson(e) {
    return new hM({
      id: e.id,
      offset: L.duration(e.offset ?? "00:00"),
      name: e.name
    });
  }
  static utc() {
    return new hM({
      id: "UTC",
      offset: L.duration("00:00")
    });
  }
}
var hz = /* @__PURE__ */ ((p) => (p.ru = "ru", p.en = "en", p.id = "id", p.uk = "uk", p.es = "es", p.zhtw = "zhtw", p.zhcn = "zhcn", p.lt = "lt", p))(hz || {});
class dL {
  constructor() {
    z(this, "listeners", {});
  }
  on(t, e) {
    this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push(e);
  }
  off(t, e) {
    this.listeners[t] && (this.listeners[t] = this.listeners[t].filter(
      (o) => o !== e
    ));
  }
  once(t, e) {
    const o = (b) => {
      e(b), this.off(t, o);
    };
    this.on(t, o);
  }
  emit(t, e) {
    this.listeners[t] && this.listeners[t].forEach((o) => o(e));
  }
}
var lL = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, e) {
    return "Cannot apply '" + t + "' to '" + e.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, e) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + e;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, e) {
    return "the entry '" + t + "' does not exist in the observable map '" + e + "'";
  },
  26: "please specify a property",
  27: function(t, e) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + e + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, e) {
    return "Cycle detected in computation " + t + ": " + e;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, qL = process.env.NODE_ENV !== "production" ? lL : {};
function o0(p) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
    e[o - 1] = arguments[o];
  if (process.env.NODE_ENV !== "production") {
    var b = typeof p == "string" ? p : qL[p];
    throw typeof b == "function" && (b = b.apply(null, e)), new Error("[MobX] " + b);
  }
  throw new Error(typeof p == "number" ? "[MobX] minified error nr: " + p + (e.length ? " " + e.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + p);
}
var fL = {};
function ed() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : fL;
}
var td = Object.assign, mz = Object.getOwnPropertyDescriptor, _t = Object.defineProperty, Jz = Object.prototype, Rz = [];
Object.freeze(Rz);
var Ra = {};
Object.freeze(Ra);
var WL = typeof Proxy < "u", hL = /* @__PURE__ */ Object.toString();
function pd() {
  WL || o0(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Ab(p) {
  process.env.NODE_ENV !== "production" && e0.verifyProxies && o0("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + p);
}
function k2() {
  return ++e0.mobxGuid;
}
function ya(p) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, p.apply(this, arguments);
  };
}
var uM = function() {
};
function J1(p) {
  return typeof p == "function";
}
function ho(p) {
  var t = typeof p;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function $z(p) {
  return p !== null && typeof p == "object";
}
function it(p) {
  if (!$z(p))
    return !1;
  var t = Object.getPrototypeOf(p);
  if (t == null)
    return !0;
  var e = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e.toString() === hL;
}
function od(p) {
  var t = p == null ? void 0 : p.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Vz(p, t, e) {
  _t(p, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: e
  });
}
function Md(p, t, e) {
  _t(p, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: e
  });
}
function So(p, t) {
  var e = "isMobX" + p;
  return t.prototype[e] = !0, function(o) {
    return $z(o) && o[e] === !0;
  };
}
function BM(p) {
  return p instanceof Map;
}
function Fb(p) {
  return p instanceof Set;
}
var bd = typeof Object.getOwnPropertySymbols < "u";
function mL(p) {
  var t = Object.keys(p);
  if (!bd)
    return t;
  var e = Object.getOwnPropertySymbols(p);
  return e.length ? [].concat(t, e.filter(function(o) {
    return Jz.propertyIsEnumerable.call(p, o);
  })) : t;
}
var Yz = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : bd ? function(p) {
  return Object.getOwnPropertyNames(p).concat(Object.getOwnPropertySymbols(p));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function Di(p) {
  return typeof p == "string" ? p : typeof p == "symbol" ? p.toString() : new String(p).toString();
}
function nd(p) {
  return p === null ? null : typeof p == "object" ? "" + p : p;
}
function r2(p, t) {
  return Jz.hasOwnProperty.call(p, t);
}
var RL = Object.getOwnPropertyDescriptors || function(t) {
  var e = {};
  return Yz(t).forEach(function(o) {
    e[o] = mz(t, o);
  }), e;
};
function yL(p, t) {
  for (var e = 0; e < t.length; e++) {
    var o = t[e];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(p, vL(o.key), o);
  }
}
function ga(p, t, e) {
  return t && yL(p.prototype, t), Object.defineProperty(p, "prototype", {
    writable: !1
  }), p;
}
function np() {
  return np = Object.assign ? Object.assign.bind() : function(p) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var o in e)
        Object.prototype.hasOwnProperty.call(e, o) && (p[o] = e[o]);
    }
    return p;
  }, np.apply(this, arguments);
}
function zd(p, t) {
  p.prototype = Object.create(t.prototype), p.prototype.constructor = p, Xi(p, t);
}
function Xi(p, t) {
  return Xi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, b) {
    return o.__proto__ = b, o;
  }, Xi(p, t);
}
function bz(p) {
  if (p === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return p;
}
function gL(p, t) {
  if (p) {
    if (typeof p == "string") return x3(p, t);
    var e = Object.prototype.toString.call(p).slice(8, -1);
    if (e === "Object" && p.constructor && (e = p.constructor.name), e === "Map" || e === "Set") return Array.from(p);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return x3(p, t);
  }
}
function x3(p, t) {
  (t == null || t > p.length) && (t = p.length);
  for (var e = 0, o = new Array(t); e < t; e++) o[e] = p[e];
  return o;
}
function dM(p, t) {
  var e = typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
  if (e) return (e = e.call(p)).next.bind(e);
  if (Array.isArray(p) || (e = gL(p)) || t) {
    e && (p = e);
    var o = 0;
    return function() {
      return o >= p.length ? {
        done: !0
      } : {
        done: !1,
        value: p[o++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LL(p, t) {
  if (typeof p != "object" || p === null) return p;
  var e = p[Symbol.toPrimitive];
  if (e !== void 0) {
    var o = e.call(p, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(p);
}
function vL(p) {
  var t = LL(p, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Ve = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function bt(p) {
  function t(e, o) {
    if (Ub(o))
      return p.decorate_20223_(e, o);
    TM(e, o, p);
  }
  return Object.assign(t, p);
}
function TM(p, t, e) {
  if (r2(p, Ve) || Vz(p, Ve, np({}, p[Ve])), process.env.NODE_ENV !== "production" && yz(e) && !r2(p[Ve], t)) {
    var o = p.constructor.name + ".prototype." + t.toString();
    o0("'" + o + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  _L(p, e, t), yz(e) || (p[Ve][t] = e);
}
function _L(p, t, e) {
  if (process.env.NODE_ENV !== "production" && !yz(t) && r2(p[Ve], e)) {
    var o = p.constructor.name + ".prototype." + e.toString(), b = p[Ve][e].annotationType_, r = t.annotationType_;
    o0("Cannot apply '@" + r + "' to '" + o + "':" + (`
The field is already decorated with '@` + b + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function NL(p) {
  return r2(p, Ve) || Vz(p, Ve, np({}, p[Ve])), p[Ve];
}
function Ub(p) {
  return typeof p == "object" && typeof p.kind == "string";
}
function Gz(p, t) {
  process.env.NODE_ENV !== "production" && !t.includes(p.kind) && o0("The decorator applied to '" + String(p.name) + "' cannot be used on a " + p.kind + " element");
}
var L0 = /* @__PURE__ */ Symbol("mobx administration"), Hb = /* @__PURE__ */ (function() {
  function p(e) {
    e === void 0 && (e = process.env.NODE_ENV !== "production" ? "Atom@" + k2() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = G0.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e;
  }
  var t = p.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(o) {
      return o();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(o) {
      return o();
    });
  }, t.reportObserved = function() {
    return Ld(this);
  }, t.reportChanged = function() {
    D2(), vd(this), X2();
  }, t.toString = function() {
    return this.name_;
  }, p;
})(), La = /* @__PURE__ */ So("Atom", Hb);
function rd(p, t, e) {
  t === void 0 && (t = uM), e === void 0 && (e = uM);
  var o = new Hb(p);
  return t !== uM && F8(o, t), e !== uM && Xd(o, e), o;
}
function BL(p, t) {
  return Kd(p, t);
}
function TL(p, t) {
  return Object.is ? Object.is(p, t) : p === t ? p !== 0 || 1 / p === 1 / t : p !== p && t !== t;
}
var mM = {
  structural: BL,
  default: TL
};
function mo(p, t, e) {
  return Tb(p) ? p : Array.isArray(p) ? a.array(p, {
    name: e
  }) : it(p) ? a.object(p, void 0, {
    name: e
  }) : BM(p) ? a.map(p, {
    name: e
  }) : Fb(p) ? a.set(p, {
    name: e
  }) : typeof p == "function" && !$b(p) && !Bb(p) ? od(p) ? RM(p) : Nb(e, p) : p;
}
function wL(p, t, e) {
  if (p == null || Gb(p) || tr(p) || Fp(p) || wM(p))
    return p;
  if (Array.isArray(p))
    return a.array(p, {
      name: e,
      deep: !1
    });
  if (it(p))
    return a.object(p, void 0, {
      name: e,
      deep: !1
    });
  if (BM(p))
    return a.map(p, {
      name: e,
      deep: !1
    });
  if (Fb(p))
    return a.set(p, {
      name: e,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && o0("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Kz(p) {
  return p;
}
function SL(p, t) {
  return process.env.NODE_ENV !== "production" && Tb(p) && o0("observable.struct should not be used with observable values"), Kd(p, t) ? t : p;
}
var cd = "override", DL = /* @__PURE__ */ bt({
  annotationType_: cd,
  make_: XL,
  extend_: CL,
  decorate_20223_: IL
});
function yz(p) {
  return p.annotationType_ === cd;
}
function XL(p, t) {
  return process.env.NODE_ENV !== "production" && p.isPlainObject_ && o0("Cannot apply '" + this.annotationType_ + "' to '" + p.name_ + "." + t.toString() + "':" + (`
'` + this.annotationType_ + "' cannot be used on plain objects.")), process.env.NODE_ENV !== "production" && !r2(p.appliedAnnotations_, t) && o0("'" + p.name_ + "." + t.toString() + "' is annotated with '" + this.annotationType_ + "', but no such annotated member was found on prototype."), 0;
}
function CL(p, t, e, o) {
  o0("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function IL(p, t) {
  console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function Jb(p, t) {
  return {
    annotationType_: p,
    options_: t,
    make_: PL,
    extend_: EL,
    decorate_20223_: kL
  };
}
function PL(p, t, e, o) {
  var b;
  if ((b = this.options_) != null && b.bound)
    return this.extend_(p, t, e, !1) === null ? 0 : 1;
  if (o === p.target_)
    return this.extend_(p, t, e, !1) === null ? 0 : 2;
  if ($b(e.value))
    return 1;
  var r = id(p, this, t, e, !1);
  return _t(o, t, r), 2;
}
function EL(p, t, e, o) {
  var b = id(p, this, t, e);
  return p.defineProperty_(t, b, o);
}
function kL(p, t) {
  process.env.NODE_ENV !== "production" && Gz(t, ["method", "field"]);
  var e = t.kind, o = t.name, b = t.addInitializer, r = this, i = function(q) {
    var f, h, g, y;
    return Ro((f = (h = r.options_) == null ? void 0 : h.name) != null ? f : o.toString(), q, (g = (y = r.options_) == null ? void 0 : y.autoAction) != null ? g : !1);
  };
  if (e == "field") {
    b(function() {
      TM(this, o, r);
    });
    return;
  }
  if (e == "method") {
    var s;
    return $b(p) || (p = i(p)), (s = this.options_) != null && s.bound && b(function() {
      var d = this, q = d[o].bind(d);
      q.isMobxAction = !0, d[o] = q;
    }), p;
  }
  o0("Cannot apply '" + r.annotationType_ + "' to '" + String(o) + "' (kind: " + e + "):" + (`
'` + r.annotationType_ + "' can only be used on properties with a function value."));
}
function xL(p, t, e, o) {
  var b = t.annotationType_, r = o.value;
  process.env.NODE_ENV !== "production" && !J1(r) && o0("Cannot apply '" + b + "' to '" + p.name_ + "." + e.toString() + "':" + (`
'` + b + "' can only be used on properties with a function value."));
}
function id(p, t, e, o, b) {
  var r, i, s, d, q, f, h;
  b === void 0 && (b = e0.safeDescriptors), xL(p, t, e, o);
  var g = o.value;
  if ((r = t.options_) != null && r.bound) {
    var y;
    g = g.bind((y = p.proxy_) != null ? y : p.target_);
  }
  return {
    value: Ro(
      (i = (s = t.options_) == null ? void 0 : s.name) != null ? i : e.toString(),
      g,
      (d = (q = t.options_) == null ? void 0 : q.autoAction) != null ? d : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (f = t.options_) != null && f.bound ? (h = p.proxy_) != null ? h : p.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: b ? p.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !b
  };
}
function ad(p, t) {
  return {
    annotationType_: p,
    options_: t,
    make_: FL,
    extend_: UL,
    decorate_20223_: HL
  };
}
function FL(p, t, e, o) {
  var b;
  if (o === p.target_)
    return this.extend_(p, t, e, !1) === null ? 0 : 2;
  if ((b = this.options_) != null && b.bound && (!r2(p.target_, t) || !Bb(p.target_[t])) && this.extend_(p, t, e, !1) === null)
    return 0;
  if (Bb(e.value))
    return 1;
  var r = Od(p, this, t, e, !1, !1);
  return _t(o, t, r), 2;
}
function UL(p, t, e, o) {
  var b, r = Od(p, this, t, e, (b = this.options_) == null ? void 0 : b.bound);
  return p.defineProperty_(t, r, o);
}
function HL(p, t) {
  var e;
  process.env.NODE_ENV !== "production" && Gz(t, ["method"]);
  var o = t.name, b = t.addInitializer;
  return Bb(p) || (p = RM(p)), (e = this.options_) != null && e.bound && b(function() {
    var r = this, i = r[o].bind(r);
    i.isMobXFlow = !0, r[o] = i;
  }), p;
}
function JL(p, t, e, o) {
  var b = t.annotationType_, r = o.value;
  process.env.NODE_ENV !== "production" && !J1(r) && o0("Cannot apply '" + b + "' to '" + p.name_ + "." + e.toString() + "':" + (`
'` + b + "' can only be used on properties with a generator function value."));
}
function Od(p, t, e, o, b, r) {
  r === void 0 && (r = e0.safeDescriptors), JL(p, t, e, o);
  var i = o.value;
  if (Bb(i) || (i = RM(i)), b) {
    var s;
    i = i.bind((s = p.proxy_) != null ? s : p.target_), i.isMobXFlow = !0;
  }
  return {
    value: i,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: r ? p.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !r
  };
}
function va(p, t) {
  return {
    annotationType_: p,
    options_: t,
    make_: $L,
    extend_: VL,
    decorate_20223_: YL
  };
}
function $L(p, t, e) {
  return this.extend_(p, t, e, !1) === null ? 0 : 1;
}
function VL(p, t, e, o) {
  return GL(p, this, t, e), p.defineComputedProperty_(t, np({}, this.options_, {
    get: e.get,
    set: e.set
  }), o);
}
function YL(p, t) {
  process.env.NODE_ENV !== "production" && Gz(t, ["getter"]);
  var e = this, o = t.name, b = t.addInitializer;
  return b(function() {
    var r = SM(this)[L0], i = np({}, e.options_, {
      get: p,
      context: this
    });
    i.name || (i.name = process.env.NODE_ENV !== "production" ? r.name_ + "." + o.toString() : "ObservableObject." + o.toString()), r.values_.set(o, new yo(i));
  }), function() {
    return this[L0].getObservablePropValue_(o);
  };
}
function GL(p, t, e, o) {
  var b = t.annotationType_, r = o.get;
  process.env.NODE_ENV !== "production" && !r && o0("Cannot apply '" + b + "' to '" + p.name_ + "." + e.toString() + "':" + (`
'` + b + "' can only be used on getter(+setter) properties."));
}
function Qz(p, t) {
  return {
    annotationType_: p,
    options_: t,
    make_: KL,
    extend_: QL,
    decorate_20223_: ZL
  };
}
function KL(p, t, e) {
  return this.extend_(p, t, e, !1) === null ? 0 : 1;
}
function QL(p, t, e, o) {
  var b, r;
  return jL(p, this, t, e), p.defineObservableProperty_(t, e.value, (b = (r = this.options_) == null ? void 0 : r.enhancer) != null ? b : mo, o);
}
function ZL(p, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw o0("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    Gz(t, ["accessor"]);
  }
  var e = this, o = t.kind, b = t.name, r = /* @__PURE__ */ new WeakSet();
  function i(s, d) {
    var q, f, h = SM(s)[L0], g = new lo(d, (q = (f = e.options_) == null ? void 0 : f.enhancer) != null ? q : mo, process.env.NODE_ENV !== "production" ? h.name_ + "." + b.toString() : "ObservableObject." + b.toString(), !1);
    h.values_.set(b, g), r.add(s);
  }
  if (o == "accessor")
    return {
      get: function() {
        return r.has(this) || i(this, p.get.call(this)), this[L0].getObservablePropValue_(b);
      },
      set: function(d) {
        return r.has(this) || i(this, d), this[L0].setObservablePropValue_(b, d);
      },
      init: function(d) {
        return r.has(this) || i(this, d), d;
      }
    };
}
function jL(p, t, e, o) {
  var b = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in o) && o0("Cannot apply '" + b + "' to '" + p.name_ + "." + e.toString() + "':" + (`
'` + b + "' cannot be used on getter/setter properties"));
}
var e8 = "true", t8 = /* @__PURE__ */ sd();
function sd(p) {
  return {
    annotationType_: e8,
    options_: p,
    make_: p8,
    extend_: o8,
    decorate_20223_: M8
  };
}
function p8(p, t, e, o) {
  var b, r;
  if (e.get)
    return $.make_(p, t, e, o);
  if (e.set) {
    var i = Ro(t.toString(), e.set);
    return o === p.target_ ? p.defineProperty_(t, {
      configurable: e0.safeDescriptors ? p.isPlainObject_ : !0,
      set: i
    }) === null ? 0 : 2 : (_t(o, t, {
      configurable: !0,
      set: i
    }), 2);
  }
  if (o !== p.target_ && typeof e.value == "function") {
    var s;
    if (od(e.value)) {
      var d, q = (d = this.options_) != null && d.autoBind ? RM.bound : RM;
      return q.make_(p, t, e, o);
    }
    var f = (s = this.options_) != null && s.autoBind ? Nb.bound : Nb;
    return f.make_(p, t, e, o);
  }
  var h = ((b = this.options_) == null ? void 0 : b.deep) === !1 ? a.ref : a;
  if (typeof e.value == "function" && (r = this.options_) != null && r.autoBind) {
    var g;
    e.value = e.value.bind((g = p.proxy_) != null ? g : p.target_);
  }
  return h.make_(p, t, e, o);
}
function o8(p, t, e, o) {
  var b, r;
  if (e.get)
    return $.extend_(p, t, e, o);
  if (e.set)
    return p.defineProperty_(t, {
      configurable: e0.safeDescriptors ? p.isPlainObject_ : !0,
      set: Ro(t.toString(), e.set)
    }, o);
  if (typeof e.value == "function" && (b = this.options_) != null && b.autoBind) {
    var i;
    e.value = e.value.bind((i = p.proxy_) != null ? i : p.target_);
  }
  var s = ((r = this.options_) == null ? void 0 : r.deep) === !1 ? a.ref : a;
  return s.extend_(p, t, e, o);
}
function M8(p, t) {
  o0("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var b8 = "observable", n8 = "observable.ref", z8 = "observable.shallow", r8 = "observable.struct", Ad = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(Ad);
function jn(p) {
  return p || Ad;
}
var Ci = /* @__PURE__ */ Qz(b8), c8 = /* @__PURE__ */ Qz(n8, {
  enhancer: Kz
}), i8 = /* @__PURE__ */ Qz(z8, {
  enhancer: wL
}), a8 = /* @__PURE__ */ Qz(r8, {
  enhancer: SL
}), ud = /* @__PURE__ */ bt(Ci);
function ez(p) {
  return p.deep === !0 ? mo : p.deep === !1 ? Kz : s8(p.defaultDecorator);
}
function O8(p) {
  var t;
  return p ? (t = p.defaultDecorator) != null ? t : sd(p) : void 0;
}
function s8(p) {
  var t, e;
  return p && (t = (e = p.options_) == null ? void 0 : e.enhancer) != null ? t : mo;
}
function dd(p, t, e) {
  if (Ub(t))
    return Ci.decorate_20223_(p, t);
  if (ho(t)) {
    TM(p, t, Ci);
    return;
  }
  return Tb(p) ? p : it(p) ? a.object(p, t, e) : Array.isArray(p) ? a.array(p, t) : BM(p) ? a.map(p, t) : Fb(p) ? a.set(p, t) : typeof p == "object" && p !== null ? p : a.box(p, t);
}
td(dd, ud);
var A8 = {
  box: function(t, e) {
    var o = jn(e);
    return new lo(t, ez(o), o.name, !0, o.equals);
  },
  array: function(t, e) {
    var o = jn(e);
    return (e0.useProxies === !1 || o.proxy === !1 ? av : tv)(t, ez(o), o.name);
  },
  map: function(t, e) {
    var o = jn(e);
    return new Fd(t, ez(o), o.name);
  },
  set: function(t, e) {
    var o = jn(e);
    return new Jd(t, ez(o), o.name);
  },
  object: function(t, e, o) {
    return Xo(function() {
      return U8(e0.useProxies === !1 || (o == null ? void 0 : o.proxy) === !1 ? SM({}, o) : Z8({}, o), t, e);
    });
  },
  ref: /* @__PURE__ */ bt(c8),
  shallow: /* @__PURE__ */ bt(i8),
  deep: ud,
  struct: /* @__PURE__ */ bt(a8)
}, a = /* @__PURE__ */ td(dd, A8), ld = "computed", u8 = "computed.struct", Ii = /* @__PURE__ */ va(ld), d8 = /* @__PURE__ */ va(u8, {
  equals: mM.structural
}), $ = function(t, e) {
  if (Ub(e))
    return Ii.decorate_20223_(t, e);
  if (ho(e))
    return TM(t, e, Ii);
  if (it(t))
    return bt(va(ld, t));
  process.env.NODE_ENV !== "production" && (J1(t) || o0("First argument to `computed` should be an expression."), J1(e) && o0("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var o = it(e) ? e : {};
  return o.get = t, o.name || (o.name = t.name || ""), new yo(o);
};
Object.assign($, Ii);
$.struct = /* @__PURE__ */ bt(d8);
var F3, U3, gz = 0, l8 = 1, q8 = (F3 = (U3 = /* @__PURE__ */ mz(function() {
}, "name")) == null ? void 0 : U3.configurable) != null ? F3 : !1, H3 = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Ro(p, t, e, o) {
  e === void 0 && (e = !1), process.env.NODE_ENV !== "production" && (J1(t) || o0("`action` can only be invoked on functions"), (typeof p != "string" || !p) && o0("actions should have valid names, got: '" + p + "'"));
  function b() {
    return qd(p, e, t, o || this, arguments);
  }
  return b.isMobxAction = !0, b.toString = function() {
    return t.toString();
  }, q8 && (H3.value = p, _t(b, "name", H3)), b;
}
function qd(p, t, e, o, b) {
  var r = f8(p, t, o, b);
  try {
    return e.apply(o, b);
  } catch (i) {
    throw r.error_ = i, i;
  } finally {
    W8(r);
  }
}
function f8(p, t, e, o) {
  var b = process.env.NODE_ENV !== "production" && se() && !!p, r = 0;
  if (process.env.NODE_ENV !== "production" && b) {
    r = Date.now();
    var i = o ? Array.from(o) : Rz;
    c2({
      type: Na,
      name: p,
      object: e,
      arguments: i
    });
  }
  var s = e0.trackingDerivation, d = !t || !s;
  D2();
  var q = e0.allowStateChanges;
  d && (Do(), q = Zz(!0));
  var f = _a(!0), h = {
    runAsAction_: d,
    prevDerivation_: s,
    prevAllowStateChanges_: q,
    prevAllowStateReads_: f,
    notifySpy_: b,
    startTime_: r,
    actionId_: l8++,
    parentActionId_: gz
  };
  return gz = h.actionId_, h;
}
function W8(p) {
  gz !== p.actionId_ && o0(30), gz = p.parentActionId_, p.error_ !== void 0 && (e0.suppressReactionErrors = !0), jz(p.prevAllowStateChanges_), mb(p.prevAllowStateReads_), X2(), p.runAsAction_ && Mp(p.prevDerivation_), process.env.NODE_ENV !== "production" && p.notifySpy_ && i2({
    time: Date.now() - p.startTime_
  }), e0.suppressReactionErrors = !1;
}
function h8(p, t) {
  var e = Zz(p);
  try {
    return t();
  } finally {
    jz(e);
  }
}
function Zz(p) {
  var t = e0.allowStateChanges;
  return e0.allowStateChanges = p, t;
}
function jz(p) {
  e0.allowStateChanges = p;
}
var fd, m8 = "create";
fd = Symbol.toPrimitive;
var lo = /* @__PURE__ */ (function(p) {
  zd(t, p);
  function t(o, b, r, i, s) {
    var d;
    return r === void 0 && (r = process.env.NODE_ENV !== "production" ? "ObservableValue@" + k2() : "ObservableValue"), i === void 0 && (i = !0), s === void 0 && (s = mM.default), d = p.call(this, r) || this, d.enhancer = void 0, d.name_ = void 0, d.equals = void 0, d.hasUnreportedChange_ = !1, d.interceptors_ = void 0, d.changeListeners_ = void 0, d.value_ = void 0, d.dehancer = void 0, d.enhancer = b, d.name_ = r, d.equals = s, d.value_ = b(o, void 0, r), process.env.NODE_ENV !== "production" && i && se() && go({
      type: m8,
      object: bz(d),
      observableKind: "value",
      debugObjectName: d.name_,
      newValue: "" + d.value_
    }), d;
  }
  var e = t.prototype;
  return e.dehanceValue = function(b) {
    return this.dehancer !== void 0 ? this.dehancer(b) : b;
  }, e.set = function(b) {
    var r = this.value_;
    if (b = this.prepareNewValue_(b), b !== e0.UNCHANGED) {
      var i = se();
      process.env.NODE_ENV !== "production" && i && c2({
        type: ot,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: b,
        oldValue: r
      }), this.setNewValue_(b), process.env.NODE_ENV !== "production" && i && i2();
    }
  }, e.prepareNewValue_ = function(b) {
    if (Lt(this), w2(this)) {
      var r = S2(this, {
        object: this,
        type: ot,
        newValue: b
      });
      if (!r)
        return e0.UNCHANGED;
      b = r.newValue;
    }
    return b = this.enhancer(b, this.value_, this.name_), this.equals(this.value_, b) ? e0.UNCHANGED : b;
  }, e.setNewValue_ = function(b) {
    var r = this.value_;
    this.value_ = b, this.reportChanged(), nt(this) && zt(this, {
      type: ot,
      object: this,
      newValue: b,
      oldValue: r
    });
  }, e.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, e.intercept_ = function(b) {
    return Vb(this, b);
  }, e.observe_ = function(b, r) {
    return r && b({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: ot,
      newValue: this.value_,
      oldValue: void 0
    }), Yb(this, b);
  }, e.raw = function() {
    return this.value_;
  }, e.toJSON = function() {
    return this.get();
  }, e.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, e.valueOf = function() {
    return nd(this.get());
  }, e[fd] = function() {
    return this.valueOf();
  }, t;
})(Hb), Wd;
Wd = Symbol.toPrimitive;
var yo = /* @__PURE__ */ (function() {
  function p(e) {
    this.dependenciesState_ = G0.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = G0.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Lz(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = I2.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e.get || o0(31), this.derivation = e.get, this.name_ = e.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + k2() : "ComputedValue"), e.set && (this.setter_ = Ro(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", e.set)), this.equals_ = e.equals || (e.compareStructural || e.struct ? mM.structural : mM.default), this.scope_ = e.context, this.requiresReaction_ = e.requiresReaction, this.keepAlive_ = !!e.keepAlive;
  }
  var t = p.prototype;
  return t.onBecomeStale_ = function() {
    _8(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(o) {
      return o();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(o) {
      return o();
    });
  }, t.get = function() {
    if (this.isComputing_ && o0(32, this.name_, this.derivation), e0.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      Pi(this) && (this.warnAboutUntrackedRead_(), D2(), this.value_ = this.computeValue_(!1), X2());
    else if (Ld(this), Pi(this)) {
      var o = e0.trackingContext;
      this.keepAlive_ && !o && (e0.trackingContext = this), this.trackAndCompute() && v8(this), e0.trackingContext = o;
    }
    var b = this.value_;
    if (nz(b))
      throw b.cause;
    return b;
  }, t.set = function(o) {
    if (this.setter_) {
      this.isRunningSetter_ && o0(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, o);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      o0(34, this.name_);
  }, t.trackAndCompute = function() {
    var o = this.value_, b = (
      /* see #1208 */
      this.dependenciesState_ === G0.NOT_TRACKING_
    ), r = this.computeValue_(!0), i = b || nz(o) || nz(r) || !this.equals_(o, r);
    return i && (this.value_ = r, process.env.NODE_ENV !== "production" && se() && go({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: o,
      newValue: r
    })), i;
  }, t.computeValue_ = function(o) {
    this.isComputing_ = !0;
    var b = Zz(!1), r;
    if (o)
      r = hd(this, this.derivation, this.scope_);
    else if (e0.disableErrorBoundaries === !0)
      r = this.derivation.call(this.scope_);
    else
      try {
        r = this.derivation.call(this.scope_);
      } catch (i) {
        r = new Lz(i);
      }
    return jz(b), this.isComputing_ = !1, r;
  }, t.suspend_ = function() {
    this.keepAlive_ || (Ei(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== I2.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(o, b) {
    var r = this, i = !0, s = void 0;
    return I8(function() {
      var d = r.get();
      if (!i || b) {
        var q = Do();
        o({
          observableKind: "computed",
          debugObjectName: r.name_,
          type: ot,
          object: r,
          newValue: d,
          oldValue: s
        }), Mp(q);
      }
      i = !1, s = d;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== I2.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : e0.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return nd(this.get());
  }, t[Wd] = function() {
    return this.valueOf();
  }, p;
})(), er = /* @__PURE__ */ So("ComputedValue", yo), G0;
(function(p) {
  p[p.NOT_TRACKING_ = -1] = "NOT_TRACKING_", p[p.UP_TO_DATE_ = 0] = "UP_TO_DATE_", p[p.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", p[p.STALE_ = 2] = "STALE_";
})(G0 || (G0 = {}));
var I2;
(function(p) {
  p[p.NONE = 0] = "NONE", p[p.LOG = 1] = "LOG", p[p.BREAK = 2] = "BREAK";
})(I2 || (I2 = {}));
var Lz = function(t) {
  this.cause = void 0, this.cause = t;
};
function nz(p) {
  return p instanceof Lz;
}
function Pi(p) {
  switch (p.dependenciesState_) {
    case G0.UP_TO_DATE_:
      return !1;
    case G0.NOT_TRACKING_:
    case G0.STALE_:
      return !0;
    case G0.POSSIBLY_STALE_: {
      for (var t = _a(!0), e = Do(), o = p.observing_, b = o.length, r = 0; r < b; r++) {
        var i = o[r];
        if (er(i)) {
          if (e0.disableErrorBoundaries)
            i.get();
          else
            try {
              i.get();
            } catch {
              return Mp(e), mb(t), !0;
            }
          if (p.dependenciesState_ === G0.STALE_)
            return Mp(e), mb(t), !0;
        }
      }
      return Rd(p), Mp(e), mb(t), !1;
    }
  }
}
function Lt(p) {
  if (process.env.NODE_ENV !== "production") {
    var t = p.observers_.size > 0;
    !e0.allowStateChanges && (t || e0.enforceActions === "always") && console.warn("[MobX] " + (e0.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + p.name_);
  }
}
function R8(p) {
  process.env.NODE_ENV !== "production" && !e0.allowStateReads && e0.observableRequiresReaction && console.warn("[mobx] Observable '" + p.name_ + "' being read outside a reactive context.");
}
function hd(p, t, e) {
  var o = _a(!0);
  Rd(p), p.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    p.runId_ === 0 ? 100 : p.observing_.length
  ), p.unboundDepsCount_ = 0, p.runId_ = ++e0.runId;
  var b = e0.trackingDerivation;
  e0.trackingDerivation = p, e0.inBatch++;
  var r;
  if (e0.disableErrorBoundaries === !0)
    r = t.call(e);
  else
    try {
      r = t.call(e);
    } catch (i) {
      r = new Lz(i);
    }
  return e0.inBatch--, e0.trackingDerivation = b, g8(p), y8(p), mb(o), r;
}
function y8(p) {
  process.env.NODE_ENV !== "production" && p.observing_.length === 0 && (typeof p.requiresObservable_ == "boolean" ? p.requiresObservable_ : e0.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + p.name_ + "' is created/updated without reading any observable value.");
}
function g8(p) {
  for (var t = p.observing_, e = p.observing_ = p.newObserving_, o = G0.UP_TO_DATE_, b = 0, r = p.unboundDepsCount_, i = 0; i < r; i++) {
    var s = e[i];
    s.diffValue_ === 0 && (s.diffValue_ = 1, b !== i && (e[b] = s), b++), s.dependenciesState_ > o && (o = s.dependenciesState_);
  }
  for (e.length = b, p.newObserving_ = null, r = t.length; r--; ) {
    var d = t[r];
    d.diffValue_ === 0 && yd(d, p), d.diffValue_ = 0;
  }
  for (; b--; ) {
    var q = e[b];
    q.diffValue_ === 1 && (q.diffValue_ = 0, L8(q, p));
  }
  o !== G0.UP_TO_DATE_ && (p.dependenciesState_ = o, p.onBecomeStale_());
}
function Ei(p) {
  var t = p.observing_;
  p.observing_ = [];
  for (var e = t.length; e--; )
    yd(t[e], p);
  p.dependenciesState_ = G0.NOT_TRACKING_;
}
function md(p) {
  var t = Do();
  try {
    return p();
  } finally {
    Mp(t);
  }
}
function Do() {
  var p = e0.trackingDerivation;
  return e0.trackingDerivation = null, p;
}
function Mp(p) {
  e0.trackingDerivation = p;
}
function _a(p) {
  var t = e0.allowStateReads;
  return e0.allowStateReads = p, t;
}
function mb(p) {
  e0.allowStateReads = p;
}
function Rd(p) {
  if (p.dependenciesState_ !== G0.UP_TO_DATE_) {
    p.dependenciesState_ = G0.UP_TO_DATE_;
    for (var t = p.observing_, e = t.length; e--; )
      t[e].lowestObserverState_ = G0.UP_TO_DATE_;
  }
}
var _c = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Nc = !0, e0 = /* @__PURE__ */ (function() {
  var p = /* @__PURE__ */ ed();
  return p.__mobxInstanceCount > 0 && !p.__mobxGlobals && (Nc = !1), p.__mobxGlobals && p.__mobxGlobals.version !== new _c().version && (Nc = !1), Nc ? p.__mobxGlobals ? (p.__mobxInstanceCount += 1, p.__mobxGlobals.UNCHANGED || (p.__mobxGlobals.UNCHANGED = {}), p.__mobxGlobals) : (p.__mobxInstanceCount = 1, p.__mobxGlobals = /* @__PURE__ */ new _c()) : (setTimeout(function() {
    o0(35);
  }, 1), new _c());
})();
function L8(p, t) {
  p.observers_.add(t), p.lowestObserverState_ > t.dependenciesState_ && (p.lowestObserverState_ = t.dependenciesState_);
}
function yd(p, t) {
  p.observers_.delete(t), p.observers_.size === 0 && gd(p);
}
function gd(p) {
  p.isPendingUnobservation_ === !1 && (p.isPendingUnobservation_ = !0, e0.pendingUnobservations.push(p));
}
function D2() {
  e0.inBatch++;
}
function X2() {
  if (--e0.inBatch === 0) {
    Bd();
    for (var p = e0.pendingUnobservations, t = 0; t < p.length; t++) {
      var e = p[t];
      e.isPendingUnobservation_ = !1, e.observers_.size === 0 && (e.isBeingObserved_ && (e.isBeingObserved_ = !1, e.onBUO()), e instanceof yo && e.suspend_());
    }
    e0.pendingUnobservations = [];
  }
}
function Ld(p) {
  R8(p);
  var t = e0.trackingDerivation;
  return t !== null ? (t.runId_ !== p.lastAccessedBy_ && (p.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = p, !p.isBeingObserved_ && e0.trackingContext && (p.isBeingObserved_ = !0, p.onBO())), p.isBeingObserved_) : (p.observers_.size === 0 && e0.inBatch > 0 && gd(p), !1);
}
function vd(p) {
  p.lowestObserverState_ !== G0.STALE_ && (p.lowestObserverState_ = G0.STALE_, p.observers_.forEach(function(t) {
    t.dependenciesState_ === G0.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== I2.NONE && _d(t, p), t.onBecomeStale_()), t.dependenciesState_ = G0.STALE_;
  }));
}
function v8(p) {
  p.lowestObserverState_ !== G0.STALE_ && (p.lowestObserverState_ = G0.STALE_, p.observers_.forEach(function(t) {
    t.dependenciesState_ === G0.POSSIBLY_STALE_ ? (t.dependenciesState_ = G0.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== I2.NONE && _d(t, p)) : t.dependenciesState_ === G0.UP_TO_DATE_ && (p.lowestObserverState_ = G0.UP_TO_DATE_);
  }));
}
function _8(p) {
  p.lowestObserverState_ === G0.UP_TO_DATE_ && (p.lowestObserverState_ = G0.POSSIBLY_STALE_, p.observers_.forEach(function(t) {
    t.dependenciesState_ === G0.UP_TO_DATE_ && (t.dependenciesState_ = G0.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function _d(p, t) {
  if (console.log("[mobx.trace] '" + p.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), p.isTracing_ === I2.BREAK) {
    var e = [];
    Nd(H8(p), e, 1), new Function(`debugger;
/*
Tracing '` + p.name_ + `'

You are entering this break point because derivation '` + p.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (p instanceof yo ? p.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + e.join(`
`) + `
*/
    `)();
  }
}
function Nd(p, t, e) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(e - 1) + p.name), p.dependencies && p.dependencies.forEach(function(o) {
    return Nd(o, t, e + 1);
  });
}
var vz = /* @__PURE__ */ (function() {
  function p(e, o, b, r) {
    e === void 0 && (e = process.env.NODE_ENV !== "production" ? "Reaction@" + k2() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = G0.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = I2.NONE, this.name_ = e, this.onInvalidate_ = o, this.errorHandler_ = b, this.requiresObservable_ = r;
  }
  var t = p.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, e0.pendingReactions.push(this), Bd());
  }, t.isScheduled = function() {
    return this.isScheduled_;
  }, t.runReaction_ = function() {
    if (!this.isDisposed_) {
      D2(), this.isScheduled_ = !1;
      var o = e0.trackingContext;
      if (e0.trackingContext = this, Pi(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && se() && go({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (b) {
          this.reportExceptionInDerivation_(b);
        }
      }
      e0.trackingContext = o, X2();
    }
  }, t.track = function(o) {
    if (!this.isDisposed_) {
      D2();
      var b = se(), r;
      process.env.NODE_ENV !== "production" && b && (r = Date.now(), c2({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var i = e0.trackingContext;
      e0.trackingContext = this;
      var s = hd(this, o, void 0);
      e0.trackingContext = i, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && Ei(this), nz(s) && this.reportExceptionInDerivation_(s.cause), process.env.NODE_ENV !== "production" && b && i2({
        time: Date.now() - r
      }), X2();
    }
  }, t.reportExceptionInDerivation_ = function(o) {
    var b = this;
    if (this.errorHandler_) {
      this.errorHandler_(o, this);
      return;
    }
    if (e0.disableErrorBoundaries)
      throw o;
    var r = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    e0.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(r, o), process.env.NODE_ENV !== "production" && se() && go({
      type: "error",
      name: this.name_,
      message: r,
      error: "" + o
    }), e0.globalReactionErrorHandlers.forEach(function(i) {
      return i(o, b);
    });
  }, t.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (D2(), Ei(this), X2()));
  }, t.getDisposer_ = function(o) {
    var b = this, r = function i() {
      b.dispose(), o == null || o.removeEventListener == null || o.removeEventListener("abort", i);
    };
    return o == null || o.addEventListener == null || o.addEventListener("abort", r), r[L0] = this, r;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(o) {
    o === void 0 && (o = !1), G8(this, o);
  }, p;
})(), J3 = 100, N8 = function(t) {
  return t();
};
function Bd() {
  e0.inBatch > 0 || e0.isRunningReactions || N8(B8);
}
function B8() {
  e0.isRunningReactions = !0;
  for (var p = e0.pendingReactions, t = 0; p.length > 0; ) {
    ++t === J3 && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + J3 + " iterations." + (" Probably there is a cycle in the reactive function: " + p[0]) : "[mobx] cycle in reaction: " + p[0]), p.splice(0));
    for (var e = p.splice(0), o = 0, b = e.length; o < b; o++)
      e[o].runReaction_();
  }
  e0.isRunningReactions = !1;
}
var _z = /* @__PURE__ */ So("Reaction", vz);
function se() {
  return process.env.NODE_ENV !== "production" && !!e0.spyListeners.length;
}
function go(p) {
  if (process.env.NODE_ENV !== "production" && e0.spyListeners.length)
    for (var t = e0.spyListeners, e = 0, o = t.length; e < o; e++)
      t[e](p);
}
function c2(p) {
  if (process.env.NODE_ENV !== "production") {
    var t = np({}, p, {
      spyReportStart: !0
    });
    go(t);
  }
}
var T8 = {
  type: "report-end",
  spyReportEnd: !0
};
function i2(p) {
  process.env.NODE_ENV !== "production" && go(p ? np({}, p, {
    type: "report-end",
    spyReportEnd: !0
  }) : T8);
}
function w8(p) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (e0.spyListeners.push(p), ya(function() {
    e0.spyListeners = e0.spyListeners.filter(function(t) {
      return t !== p;
    });
  }));
}
var Na = "action", S8 = "action.bound", Td = "autoAction", D8 = "autoAction.bound", wd = "<unnamed action>", ki = /* @__PURE__ */ Jb(Na), X8 = /* @__PURE__ */ Jb(S8, {
  bound: !0
}), xi = /* @__PURE__ */ Jb(Td, {
  autoAction: !0
}), C8 = /* @__PURE__ */ Jb(D8, {
  autoAction: !0,
  bound: !0
});
function Sd(p) {
  var t = function(o, b) {
    if (J1(o))
      return Ro(o.name || wd, o, p);
    if (J1(b))
      return Ro(o, b, p);
    if (Ub(b))
      return (p ? xi : ki).decorate_20223_(o, b);
    if (ho(b))
      return TM(o, b, p ? xi : ki);
    if (ho(o))
      return bt(Jb(p ? Td : Na, {
        name: o,
        autoAction: p
      }));
    process.env.NODE_ENV !== "production" && o0("Invalid arguments for `action`");
  };
  return t;
}
var C = /* @__PURE__ */ Sd(!1);
Object.assign(C, ki);
var Nb = /* @__PURE__ */ Sd(!0);
Object.assign(Nb, xi);
C.bound = /* @__PURE__ */ bt(X8);
Nb.bound = /* @__PURE__ */ bt(C8);
function s0(p) {
  return qd(p.name || wd, !1, p, this, void 0);
}
function $b(p) {
  return J1(p) && p.isMobxAction === !0;
}
function I8(p, t) {
  var e, o, b, r, i;
  t === void 0 && (t = Ra), process.env.NODE_ENV !== "production" && (J1(p) || o0("Autorun expects a function as first argument"), $b(p) && o0("Autorun does not accept actions since actions are untrackable"));
  var s = (e = (o = t) == null ? void 0 : o.name) != null ? e : process.env.NODE_ENV !== "production" ? p.name || "Autorun@" + k2() : "Autorun", d = !t.scheduler && !t.delay, q;
  if (d)
    q = new vz(s, function() {
      this.track(g);
    }, t.onError, t.requiresObservable);
  else {
    var f = Dd(t), h = !1;
    q = new vz(s, function() {
      h || (h = !0, f(function() {
        h = !1, q.isDisposed_ || q.track(g);
      }));
    }, t.onError, t.requiresObservable);
  }
  function g() {
    p(q);
  }
  return (b = t) != null && (r = b.signal) != null && r.aborted || q.schedule_(), q.getDisposer_((i = t) == null ? void 0 : i.signal);
}
var P8 = function(t) {
  return t();
};
function Dd(p) {
  return p.scheduler ? p.scheduler : p.delay ? function(t) {
    return setTimeout(t, p.delay);
  } : P8;
}
function $3(p, t, e) {
  var o, b, r, i;
  e === void 0 && (e = Ra), process.env.NODE_ENV !== "production" && ((!J1(p) || !J1(t)) && o0("First and second argument to reaction should be functions"), it(e) || o0("Third argument of reactions should be an object"));
  var s = (o = e.name) != null ? o : process.env.NODE_ENV !== "production" ? "Reaction@" + k2() : "Reaction", d = C(s, e.onError ? E8(e.onError, t) : t), q = !e.scheduler && !e.delay, f = Dd(e), h = !0, g = !1, y, w = e.compareStructural ? mM.structural : e.equals || mM.default, U = new vz(s, function() {
    h || q ? N() : g || (g = !0, f(N));
  }, e.onError, e.requiresObservable);
  function N() {
    if (g = !1, !U.isDisposed_) {
      var S = !1, D = y;
      U.track(function() {
        var V = h8(!1, function() {
          return p(U);
        });
        S = h || !w(y, V), y = V;
      }), (h && e.fireImmediately || !h && S) && d(y, D, U), h = !1;
    }
  }
  return (b = e) != null && (r = b.signal) != null && r.aborted || U.schedule_(), U.getDisposer_((i = e) == null ? void 0 : i.signal);
}
function E8(p, t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (e) {
      p.call(this, e);
    }
  };
}
var k8 = "onBO", x8 = "onBUO";
function F8(p, t, e) {
  return Cd(k8, p, t, e);
}
function Xd(p, t, e) {
  return Cd(x8, p, t, e);
}
function Cd(p, t, e, o) {
  var b = yM(t), r = J1(o) ? o : e, i = p + "L";
  return b[i] ? b[i].add(r) : b[i] = /* @__PURE__ */ new Set([r]), function() {
    var s = b[i];
    s && (s.delete(r), s.size === 0 && delete b[i]);
  };
}
function U8(p, t, e, o) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && o0("'extendObservable' expected 2-4 arguments"), typeof p != "object" && o0("'extendObservable' expects an object as first argument"), Fp(p) && o0("'extendObservable' should not be used on maps, use map.merge instead"), it(t) || o0("'extendObservable' only accepts plain objects as second argument"), (Tb(t) || Tb(e)) && o0("Extending an object with another observable (object) is not supported"));
  var b = RL(t);
  return Xo(function() {
    var r = SM(p, o)[L0];
    Yz(b).forEach(function(i) {
      r.extend_(
        i,
        b[i],
        // must pass "undefined" for { key: undefined }
        e && i in e ? e[i] : !0
      );
    });
  }), p;
}
function H8(p, t) {
  return Id(yM(p, t));
}
function Id(p) {
  var t = {
    name: p.name_
  };
  return p.observing_ && p.observing_.length > 0 && (t.dependencies = J8(p.observing_).map(Id)), t;
}
function J8(p) {
  return Array.from(new Set(p));
}
var $8 = 0;
function Pd() {
  this.message = "FLOW_CANCELLED";
}
Pd.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var Bc = /* @__PURE__ */ ad("flow"), V8 = /* @__PURE__ */ ad("flow.bound", {
  bound: !0
}), RM = /* @__PURE__ */ Object.assign(function(t, e) {
  if (Ub(e))
    return Bc.decorate_20223_(t, e);
  if (ho(e))
    return TM(t, e, Bc);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && o0("Flow expects single argument with generator function");
  var o = t, b = o.name || "<unnamed flow>", r = function() {
    var s = this, d = arguments, q = ++$8, f = C(b + " - runid: " + q + " - init", o).apply(s, d), h, g = void 0, y = new Promise(function(w, U) {
      var N = 0;
      h = U;
      function S(H) {
        g = void 0;
        var Y;
        try {
          Y = C(b + " - runid: " + q + " - yield " + N++, f.next).call(f, H);
        } catch (t0) {
          return U(t0);
        }
        V(Y);
      }
      function D(H) {
        g = void 0;
        var Y;
        try {
          Y = C(b + " - runid: " + q + " - yield " + N++, f.throw).call(f, H);
        } catch (t0) {
          return U(t0);
        }
        V(Y);
      }
      function V(H) {
        if (J1(H == null ? void 0 : H.then)) {
          H.then(V, U);
          return;
        }
        return H.done ? w(H.value) : (g = Promise.resolve(H.value), g.then(S, D));
      }
      S(void 0);
    });
    return y.cancel = C(b + " - runid: " + q + " - cancel", function() {
      try {
        g && V3(g);
        var w = f.return(void 0), U = Promise.resolve(w.value);
        U.then(uM, uM), V3(U), h(new Pd());
      } catch (N) {
        h(N);
      }
    }), y;
  };
  return r.isMobXFlow = !0, r;
}, Bc);
RM.bound = /* @__PURE__ */ bt(V8);
function V3(p) {
  J1(p.cancel) && p.cancel();
}
function Bb(p) {
  return (p == null ? void 0 : p.isMobXFlow) === !0;
}
function Y8(p, t) {
  return p ? Gb(p) || !!p[L0] || La(p) || _z(p) || er(p) : !1;
}
function Tb(p) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && o0("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), Y8(p);
}
function G8() {
  if (process.env.NODE_ENV !== "production") {
    for (var p = !1, t = arguments.length, e = new Array(t), o = 0; o < t; o++)
      e[o] = arguments[o];
    typeof e[e.length - 1] == "boolean" && (p = e.pop());
    var b = K8(e);
    if (!b)
      return o0("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    b.isTracing_ === I2.NONE && console.log("[mobx.trace] '" + b.name_ + "' tracing enabled"), b.isTracing_ = p ? I2.BREAK : I2.LOG;
  }
}
function K8(p) {
  switch (p.length) {
    case 0:
      return e0.trackingDerivation;
    case 1:
      return yM(p[0]);
    case 2:
      return yM(p[0], p[1]);
  }
}
function jt(p, t) {
  t === void 0 && (t = void 0), D2();
  try {
    return p.apply(t);
  } finally {
    X2();
  }
}
function Oo(p) {
  return p[L0];
}
var Q8 = {
  has: function(t, e) {
    return process.env.NODE_ENV !== "production" && e0.trackingDerivation && Ab("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Oo(t).has_(e);
  },
  get: function(t, e) {
    return Oo(t).get_(e);
  },
  set: function(t, e, o) {
    var b;
    return ho(e) ? (process.env.NODE_ENV !== "production" && !Oo(t).values_.has(e) && Ab("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (b = Oo(t).set_(e, o, !0)) != null ? b : !0) : !1;
  },
  deleteProperty: function(t, e) {
    var o;
    return process.env.NODE_ENV !== "production" && Ab("delete properties from an observable object. Use 'remove' from 'mobx' instead."), ho(e) ? (o = Oo(t).delete_(e, !0)) != null ? o : !0 : !1;
  },
  defineProperty: function(t, e, o) {
    var b;
    return process.env.NODE_ENV !== "production" && Ab("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (b = Oo(t).defineProperty_(e, o)) != null ? b : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && e0.trackingDerivation && Ab("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Oo(t).ownKeys_();
  },
  preventExtensions: function(t) {
    o0(13);
  }
};
function Z8(p, t) {
  var e, o;
  return pd(), p = SM(p, t), (o = (e = p[L0]).proxy_) != null ? o : e.proxy_ = new Proxy(p, Q8);
}
function w2(p) {
  return p.interceptors_ !== void 0 && p.interceptors_.length > 0;
}
function Vb(p, t) {
  var e = p.interceptors_ || (p.interceptors_ = []);
  return e.push(t), ya(function() {
    var o = e.indexOf(t);
    o !== -1 && e.splice(o, 1);
  });
}
function S2(p, t) {
  var e = Do();
  try {
    for (var o = [].concat(p.interceptors_ || []), b = 0, r = o.length; b < r && (t = o[b](t), t && !t.type && o0(14), !!t); b++)
      ;
    return t;
  } finally {
    Mp(e);
  }
}
function nt(p) {
  return p.changeListeners_ !== void 0 && p.changeListeners_.length > 0;
}
function Yb(p, t) {
  var e = p.changeListeners_ || (p.changeListeners_ = []);
  return e.push(t), ya(function() {
    var o = e.indexOf(t);
    o !== -1 && e.splice(o, 1);
  });
}
function zt(p, t) {
  var e = Do(), o = p.changeListeners_;
  if (o) {
    o = o.slice();
    for (var b = 0, r = o.length; b < r; b++)
      o[b](t);
    Mp(e);
  }
}
function i0(p, t, e) {
  return Xo(function() {
    var o, b = SM(p, e)[L0];
    process.env.NODE_ENV !== "production" && t && p[Ve] && o0("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (o = t) != null || (t = NL(p)), Yz(t).forEach(function(r) {
      return b.make_(r, t[r]);
    });
  }), p;
}
var Y3 = "splice", ot = "update", j8 = 1e4, ev = {
  get: function(t, e) {
    var o = t[L0];
    return e === L0 ? o : e === "length" ? o.getArrayLength_() : typeof e == "string" && !isNaN(e) ? o.get_(parseInt(e)) : r2(Nz, e) ? Nz[e] : t[e];
  },
  set: function(t, e, o) {
    var b = t[L0];
    return e === "length" && b.setArrayLength_(o), typeof e == "symbol" || isNaN(e) ? t[e] = o : b.set_(parseInt(e), o), !0;
  },
  preventExtensions: function() {
    o0(15);
  }
}, Ba = /* @__PURE__ */ (function() {
  function p(e, o, b, r) {
    e === void 0 && (e = process.env.NODE_ENV !== "production" ? "ObservableArray@" + k2() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = b, this.legacyMode_ = r, this.atom_ = new Hb(e), this.enhancer_ = function(i, s) {
      return o(i, s, process.env.NODE_ENV !== "production" ? e + "[..]" : "ObservableArray[..]");
    };
  }
  var t = p.prototype;
  return t.dehanceValue_ = function(o) {
    return this.dehancer !== void 0 ? this.dehancer(o) : o;
  }, t.dehanceValues_ = function(o) {
    return this.dehancer !== void 0 && o.length > 0 ? o.map(this.dehancer) : o;
  }, t.intercept_ = function(o) {
    return Vb(this, o);
  }, t.observe_ = function(o, b) {
    return b === void 0 && (b = !1), b && o({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Yb(this, o);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(o) {
    (typeof o != "number" || isNaN(o) || o < 0) && o0("Out of range: " + o);
    var b = this.values_.length;
    if (o !== b)
      if (o > b) {
        for (var r = new Array(o - b), i = 0; i < o - b; i++)
          r[i] = void 0;
        this.spliceWithArray_(b, 0, r);
      } else
        this.spliceWithArray_(o, b - o);
  }, t.updateArrayLength_ = function(o, b) {
    o !== this.lastKnownLength_ && o0(16), this.lastKnownLength_ += b, this.legacyMode_ && b > 0 && Yd(o + b + 1);
  }, t.spliceWithArray_ = function(o, b, r) {
    var i = this;
    Lt(this.atom_);
    var s = this.values_.length;
    if (o === void 0 ? o = 0 : o > s ? o = s : o < 0 && (o = Math.max(0, s + o)), arguments.length === 1 ? b = s - o : b == null ? b = 0 : b = Math.max(0, Math.min(b, s - o)), r === void 0 && (r = Rz), w2(this)) {
      var d = S2(this, {
        object: this.proxy_,
        type: Y3,
        index: o,
        removedCount: b,
        added: r
      });
      if (!d)
        return Rz;
      b = d.removedCount, r = d.added;
    }
    if (r = r.length === 0 ? r : r.map(function(h) {
      return i.enhancer_(h, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var q = r.length - b;
      this.updateArrayLength_(s, q);
    }
    var f = this.spliceItemsIntoValues_(o, b, r);
    return (b !== 0 || r.length !== 0) && this.notifyArraySplice_(o, r, f), this.dehanceValues_(f);
  }, t.spliceItemsIntoValues_ = function(o, b, r) {
    if (r.length < j8) {
      var i;
      return (i = this.values_).splice.apply(i, [o, b].concat(r));
    } else {
      var s = this.values_.slice(o, o + b), d = this.values_.slice(o + b);
      this.values_.length += r.length - b;
      for (var q = 0; q < r.length; q++)
        this.values_[o + q] = r[q];
      for (var f = 0; f < d.length; f++)
        this.values_[o + r.length + f] = d[f];
      return s;
    }
  }, t.notifyArrayChildUpdate_ = function(o, b, r) {
    var i = !this.owned_ && se(), s = nt(this), d = s || i ? {
      observableKind: "array",
      object: this.proxy_,
      type: ot,
      debugObjectName: this.atom_.name_,
      index: o,
      newValue: b,
      oldValue: r
    } : null;
    process.env.NODE_ENV !== "production" && i && c2(d), this.atom_.reportChanged(), s && zt(this, d), process.env.NODE_ENV !== "production" && i && i2();
  }, t.notifyArraySplice_ = function(o, b, r) {
    var i = !this.owned_ && se(), s = nt(this), d = s || i ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: Y3,
      index: o,
      removed: r,
      added: b,
      removedCount: r.length,
      addedCount: b.length
    } : null;
    process.env.NODE_ENV !== "production" && i && c2(d), this.atom_.reportChanged(), s && zt(this, d), process.env.NODE_ENV !== "production" && i && i2();
  }, t.get_ = function(o) {
    if (this.legacyMode_ && o >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + o + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + o);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[o]);
  }, t.set_ = function(o, b) {
    var r = this.values_;
    if (this.legacyMode_ && o > r.length && o0(17, o, r.length), o < r.length) {
      Lt(this.atom_);
      var i = r[o];
      if (w2(this)) {
        var s = S2(this, {
          type: ot,
          object: this.proxy_,
          index: o,
          newValue: b
        });
        if (!s)
          return;
        b = s.newValue;
      }
      b = this.enhancer_(b, i);
      var d = b !== i;
      d && (r[o] = b, this.notifyArrayChildUpdate_(o, b, i));
    } else {
      for (var q = new Array(o + 1 - r.length), f = 0; f < q.length - 1; f++)
        q[f] = void 0;
      q[q.length - 1] = b, this.spliceWithArray_(r.length, 0, q);
    }
  }, p;
})();
function tv(p, t, e, o) {
  return e === void 0 && (e = process.env.NODE_ENV !== "production" ? "ObservableArray@" + k2() : "ObservableArray"), o === void 0 && (o = !1), pd(), Xo(function() {
    var b = new Ba(e, t, o, !1);
    Md(b.values_, L0, b);
    var r = new Proxy(b.values_, ev);
    return b.proxy_ = r, p && p.length && b.spliceWithArray_(0, 0, p), r;
  });
}
var Nz = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var e = this[L0];
    return e.spliceWithArray_(0, e.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, e) {
    for (var o = arguments.length, b = new Array(o > 2 ? o - 2 : 0), r = 2; r < o; r++)
      b[r - 2] = arguments[r];
    var i = this[L0];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return i.spliceWithArray_(t);
      case 2:
        return i.spliceWithArray_(t, e);
    }
    return i.spliceWithArray_(t, e, b);
  },
  spliceWithArray: function(t, e, o) {
    return this[L0].spliceWithArray_(t, e, o);
  },
  push: function() {
    for (var t = this[L0], e = arguments.length, o = new Array(e), b = 0; b < e; b++)
      o[b] = arguments[b];
    return t.spliceWithArray_(t.values_.length, 0, o), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[L0].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[L0], e = arguments.length, o = new Array(e), b = 0; b < e; b++)
      o[b] = arguments[b];
    return t.spliceWithArray_(0, 0, o), t.values_.length;
  },
  reverse: function() {
    return e0.trackingDerivation && o0(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    e0.trackingDerivation && o0(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var e = this[L0], o = e.dehanceValues_(e.values_).indexOf(t);
    return o > -1 ? (this.splice(o, 1), !0) : !1;
  }
};
A1("at", O2);
A1("concat", O2);
A1("flat", O2);
A1("includes", O2);
A1("indexOf", O2);
A1("join", O2);
A1("lastIndexOf", O2);
A1("slice", O2);
A1("toString", O2);
A1("toLocaleString", O2);
A1("toSorted", O2);
A1("toSpliced", O2);
A1("with", O2);
A1("every", st);
A1("filter", st);
A1("find", st);
A1("findIndex", st);
A1("findLast", st);
A1("findLastIndex", st);
A1("flatMap", st);
A1("forEach", st);
A1("map", st);
A1("some", st);
A1("toReversed", st);
A1("reduce", Ed);
A1("reduceRight", Ed);
function A1(p, t) {
  typeof Array.prototype[p] == "function" && (Nz[p] = t(p));
}
function O2(p) {
  return function() {
    var t = this[L0];
    t.atom_.reportObserved();
    var e = t.dehanceValues_(t.values_);
    return e[p].apply(e, arguments);
  };
}
function st(p) {
  return function(t, e) {
    var o = this, b = this[L0];
    b.atom_.reportObserved();
    var r = b.dehanceValues_(b.values_);
    return r[p](function(i, s) {
      return t.call(e, i, s, o);
    });
  };
}
function Ed(p) {
  return function() {
    var t = this, e = this[L0];
    e.atom_.reportObserved();
    var o = e.dehanceValues_(e.values_), b = arguments[0];
    return arguments[0] = function(r, i, s) {
      return b(r, i, s, t);
    }, o[p].apply(o, arguments);
  };
}
var pv = /* @__PURE__ */ So("ObservableArrayAdministration", Ba);
function tr(p) {
  return $z(p) && pv(p[L0]);
}
var kd, xd, ov = {}, kp = "add", Bz = "delete";
kd = Symbol.iterator;
xd = Symbol.toStringTag;
var Fd = /* @__PURE__ */ (function() {
  function p(e, o, b) {
    var r = this;
    o === void 0 && (o = mo), b === void 0 && (b = process.env.NODE_ENV !== "production" ? "ObservableMap@" + k2() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[L0] = ov, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = o, this.name_ = b, J1(Map) || o0(18), Xo(function() {
      r.keysAtom_ = rd(process.env.NODE_ENV !== "production" ? r.name_ + ".keys()" : "ObservableMap.keys()"), r.data_ = /* @__PURE__ */ new Map(), r.hasMap_ = /* @__PURE__ */ new Map(), e && r.merge(e);
    });
  }
  var t = p.prototype;
  return t.has_ = function(o) {
    return this.data_.has(o);
  }, t.has = function(o) {
    var b = this;
    if (!e0.trackingDerivation)
      return this.has_(o);
    var r = this.hasMap_.get(o);
    if (!r) {
      var i = r = new lo(this.has_(o), Kz, process.env.NODE_ENV !== "production" ? this.name_ + "." + Di(o) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(o, i), Xd(i, function() {
        return b.hasMap_.delete(o);
      });
    }
    return r.get();
  }, t.set = function(o, b) {
    var r = this.has_(o);
    if (w2(this)) {
      var i = S2(this, {
        type: r ? ot : kp,
        object: this,
        newValue: b,
        name: o
      });
      if (!i)
        return this;
      b = i.newValue;
    }
    return r ? this.updateValue_(o, b) : this.addValue_(o, b), this;
  }, t.delete = function(o) {
    var b = this;
    if (Lt(this.keysAtom_), w2(this)) {
      var r = S2(this, {
        type: Bz,
        object: this,
        name: o
      });
      if (!r)
        return !1;
    }
    if (this.has_(o)) {
      var i = se(), s = nt(this), d = s || i ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Bz,
        object: this,
        oldValue: this.data_.get(o).value_,
        name: o
      } : null;
      return process.env.NODE_ENV !== "production" && i && c2(d), jt(function() {
        var q;
        b.keysAtom_.reportChanged(), (q = b.hasMap_.get(o)) == null || q.setNewValue_(!1);
        var f = b.data_.get(o);
        f.setNewValue_(void 0), b.data_.delete(o);
      }), s && zt(this, d), process.env.NODE_ENV !== "production" && i && i2(), !0;
    }
    return !1;
  }, t.updateValue_ = function(o, b) {
    var r = this.data_.get(o);
    if (b = r.prepareNewValue_(b), b !== e0.UNCHANGED) {
      var i = se(), s = nt(this), d = s || i ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: ot,
        object: this,
        oldValue: r.value_,
        name: o,
        newValue: b
      } : null;
      process.env.NODE_ENV !== "production" && i && c2(d), r.setNewValue_(b), s && zt(this, d), process.env.NODE_ENV !== "production" && i && i2();
    }
  }, t.addValue_ = function(o, b) {
    var r = this;
    Lt(this.keysAtom_), jt(function() {
      var q, f = new lo(b, r.enhancer_, process.env.NODE_ENV !== "production" ? r.name_ + "." + Di(o) : "ObservableMap.key", !1);
      r.data_.set(o, f), b = f.value_, (q = r.hasMap_.get(o)) == null || q.setNewValue_(!0), r.keysAtom_.reportChanged();
    });
    var i = se(), s = nt(this), d = s || i ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: kp,
      object: this,
      name: o,
      newValue: b
    } : null;
    process.env.NODE_ENV !== "production" && i && c2(d), s && zt(this, d), process.env.NODE_ENV !== "production" && i && i2();
  }, t.get = function(o) {
    return this.has(o) ? this.dehanceValue_(this.data_.get(o).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(o) {
    return this.dehancer !== void 0 ? this.dehancer(o) : o;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var o = this, b = this.keys();
    return wb({
      next: function() {
        var i = b.next(), s = i.done, d = i.value;
        return {
          done: s,
          value: s ? void 0 : o.get(d)
        };
      }
    });
  }, t.entries = function() {
    var o = this, b = this.keys();
    return wb({
      next: function() {
        var i = b.next(), s = i.done, d = i.value;
        return {
          done: s,
          value: s ? void 0 : [d, o.get(d)]
        };
      }
    });
  }, t[kd] = function() {
    return this.entries();
  }, t.forEach = function(o, b) {
    for (var r = dM(this), i; !(i = r()).done; ) {
      var s = i.value, d = s[0], q = s[1];
      o.call(b, q, d, this);
    }
  }, t.merge = function(o) {
    var b = this;
    return Fp(o) && (o = new Map(o)), jt(function() {
      it(o) ? mL(o).forEach(function(r) {
        return b.set(r, o[r]);
      }) : Array.isArray(o) ? o.forEach(function(r) {
        var i = r[0], s = r[1];
        return b.set(i, s);
      }) : BM(o) ? (o.constructor !== Map && o0(19, o), o.forEach(function(r, i) {
        return b.set(i, r);
      })) : o != null && o0(20, o);
    }), this;
  }, t.clear = function() {
    var o = this;
    jt(function() {
      md(function() {
        for (var b = dM(o.keys()), r; !(r = b()).done; ) {
          var i = r.value;
          o.delete(i);
        }
      });
    });
  }, t.replace = function(o) {
    var b = this;
    return jt(function() {
      for (var r = Mv(o), i = /* @__PURE__ */ new Map(), s = !1, d = dM(b.data_.keys()), q; !(q = d()).done; ) {
        var f = q.value;
        if (!r.has(f)) {
          var h = b.delete(f);
          if (h)
            s = !0;
          else {
            var g = b.data_.get(f);
            i.set(f, g);
          }
        }
      }
      for (var y = dM(r.entries()), w; !(w = y()).done; ) {
        var U = w.value, N = U[0], S = U[1], D = b.data_.has(N);
        if (b.set(N, S), b.data_.has(N)) {
          var V = b.data_.get(N);
          i.set(N, V), D || (s = !0);
        }
      }
      if (!s)
        if (b.data_.size !== i.size)
          b.keysAtom_.reportChanged();
        else
          for (var H = b.data_.keys(), Y = i.keys(), t0 = H.next(), j = Y.next(); !t0.done; ) {
            if (t0.value !== j.value) {
              b.keysAtom_.reportChanged();
              break;
            }
            t0 = H.next(), j = Y.next();
          }
      b.data_ = i;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(o, b) {
    return process.env.NODE_ENV !== "production" && b === !0 && o0("`observe` doesn't support fireImmediately=true in combination with maps."), Yb(this, o);
  }, t.intercept_ = function(o) {
    return Vb(this, o);
  }, ga(p, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: xd,
    get: function() {
      return "Map";
    }
  }]), p;
})(), Fp = /* @__PURE__ */ So("ObservableMap", Fd);
function Mv(p) {
  if (BM(p) || Fp(p))
    return p;
  if (Array.isArray(p))
    return new Map(p);
  if (it(p)) {
    var t = /* @__PURE__ */ new Map();
    for (var e in p)
      t.set(e, p[e]);
    return t;
  } else
    return o0(21, p);
}
var Ud, Hd, bv = {};
Ud = Symbol.iterator;
Hd = Symbol.toStringTag;
var Jd = /* @__PURE__ */ (function() {
  function p(e, o, b) {
    var r = this;
    o === void 0 && (o = mo), b === void 0 && (b = process.env.NODE_ENV !== "production" ? "ObservableSet@" + k2() : "ObservableSet"), this.name_ = void 0, this[L0] = bv, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = b, J1(Set) || o0(22), this.enhancer_ = function(i, s) {
      return o(i, s, b);
    }, Xo(function() {
      r.atom_ = rd(r.name_), e && r.replace(e);
    });
  }
  var t = p.prototype;
  return t.dehanceValue_ = function(o) {
    return this.dehancer !== void 0 ? this.dehancer(o) : o;
  }, t.clear = function() {
    var o = this;
    jt(function() {
      md(function() {
        for (var b = dM(o.data_.values()), r; !(r = b()).done; ) {
          var i = r.value;
          o.delete(i);
        }
      });
    });
  }, t.forEach = function(o, b) {
    for (var r = dM(this), i; !(i = r()).done; ) {
      var s = i.value;
      o.call(b, s, s, this);
    }
  }, t.add = function(o) {
    var b = this;
    if (Lt(this.atom_), w2(this)) {
      var r = S2(this, {
        type: kp,
        object: this,
        newValue: o
      });
      if (!r)
        return this;
    }
    if (!this.has(o)) {
      jt(function() {
        b.data_.add(b.enhancer_(o, void 0)), b.atom_.reportChanged();
      });
      var i = process.env.NODE_ENV !== "production" && se(), s = nt(this), d = s || i ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: kp,
        object: this,
        newValue: o
      } : null;
      i && process.env.NODE_ENV !== "production" && c2(d), s && zt(this, d), i && process.env.NODE_ENV !== "production" && i2();
    }
    return this;
  }, t.delete = function(o) {
    var b = this;
    if (w2(this)) {
      var r = S2(this, {
        type: Bz,
        object: this,
        oldValue: o
      });
      if (!r)
        return !1;
    }
    if (this.has(o)) {
      var i = process.env.NODE_ENV !== "production" && se(), s = nt(this), d = s || i ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Bz,
        object: this,
        oldValue: o
      } : null;
      return i && process.env.NODE_ENV !== "production" && c2(d), jt(function() {
        b.atom_.reportChanged(), b.data_.delete(o);
      }), s && zt(this, d), i && process.env.NODE_ENV !== "production" && i2(), !0;
    }
    return !1;
  }, t.has = function(o) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(o));
  }, t.entries = function() {
    var o = 0, b = Array.from(this.keys()), r = Array.from(this.values());
    return wb({
      next: function() {
        var s = o;
        return o += 1, s < r.length ? {
          value: [b[s], r[s]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var o = this, b = 0, r = Array.from(this.data_.values());
    return wb({
      next: function() {
        return b < r.length ? {
          value: o.dehanceValue_(r[b++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, t.replace = function(o) {
    var b = this;
    return wM(o) && (o = new Set(o)), jt(function() {
      Array.isArray(o) ? (b.clear(), o.forEach(function(r) {
        return b.add(r);
      })) : Fb(o) ? (b.clear(), o.forEach(function(r) {
        return b.add(r);
      })) : o != null && o0("Cannot initialize set from " + o);
    }), this;
  }, t.observe_ = function(o, b) {
    return process.env.NODE_ENV !== "production" && b === !0 && o0("`observe` doesn't support fireImmediately=true in combination with sets."), Yb(this, o);
  }, t.intercept_ = function(o) {
    return Vb(this, o);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Ud] = function() {
    return this.values();
  }, ga(p, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Hd,
    get: function() {
      return "Set";
    }
  }]), p;
})(), wM = /* @__PURE__ */ So("ObservableSet", Jd), G3 = /* @__PURE__ */ Object.create(null), K3 = "remove", Fi = /* @__PURE__ */ (function() {
  function p(e, o, b, r) {
    o === void 0 && (o = /* @__PURE__ */ new Map()), r === void 0 && (r = t8), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = e, this.values_ = o, this.name_ = b, this.defaultAnnotation_ = r, this.keysAtom_ = new Hb(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = it(this.target_), process.env.NODE_ENV !== "production" && !Qd(this.defaultAnnotation_) && o0("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = p.prototype;
  return t.getObservablePropValue_ = function(o) {
    return this.values_.get(o).get();
  }, t.setObservablePropValue_ = function(o, b) {
    var r = this.values_.get(o);
    if (r instanceof yo)
      return r.set(b), !0;
    if (w2(this)) {
      var i = S2(this, {
        type: ot,
        object: this.proxy_ || this.target_,
        name: o,
        newValue: b
      });
      if (!i)
        return null;
      b = i.newValue;
    }
    if (b = r.prepareNewValue_(b), b !== e0.UNCHANGED) {
      var s = nt(this), d = process.env.NODE_ENV !== "production" && se(), q = s || d ? {
        type: ot,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: r.value_,
        name: o,
        newValue: b
      } : null;
      process.env.NODE_ENV !== "production" && d && c2(q), r.setNewValue_(b), s && zt(this, q), process.env.NODE_ENV !== "production" && d && i2();
    }
    return !0;
  }, t.get_ = function(o) {
    return e0.trackingDerivation && !r2(this.target_, o) && this.has_(o), this.target_[o];
  }, t.set_ = function(o, b, r) {
    return r === void 0 && (r = !1), r2(this.target_, o) ? this.values_.has(o) ? this.setObservablePropValue_(o, b) : r ? Reflect.set(this.target_, o, b) : (this.target_[o] = b, !0) : this.extend_(o, {
      value: b,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, r);
  }, t.has_ = function(o) {
    if (!e0.trackingDerivation)
      return o in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var b = this.pendingKeys_.get(o);
    return b || (b = new lo(o in this.target_, Kz, process.env.NODE_ENV !== "production" ? this.name_ + "." + Di(o) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(o, b)), b.get();
  }, t.make_ = function(o, b) {
    if (b === !0 && (b = this.defaultAnnotation_), b !== !1) {
      if (j3(this, b, o), !(o in this.target_)) {
        var r;
        if ((r = this.target_[Ve]) != null && r[o])
          return;
        o0(1, b.annotationType_, this.name_ + "." + o.toString());
      }
      for (var i = this.target_; i && i !== Jz; ) {
        var s = mz(i, o);
        if (s) {
          var d = b.make_(this, o, s, i);
          if (d === 0)
            return;
          if (d === 1)
            break;
        }
        i = Object.getPrototypeOf(i);
      }
      Z3(this, b, o);
    }
  }, t.extend_ = function(o, b, r, i) {
    if (i === void 0 && (i = !1), r === !0 && (r = this.defaultAnnotation_), r === !1)
      return this.defineProperty_(o, b, i);
    j3(this, r, o);
    var s = r.extend_(this, o, b, i);
    return s && Z3(this, r, o), s;
  }, t.defineProperty_ = function(o, b, r) {
    r === void 0 && (r = !1), Lt(this.keysAtom_);
    try {
      D2();
      var i = this.delete_(o);
      if (!i)
        return i;
      if (w2(this)) {
        var s = S2(this, {
          object: this.proxy_ || this.target_,
          name: o,
          type: kp,
          newValue: b.value
        });
        if (!s)
          return null;
        var d = s.newValue;
        b.value !== d && (b = np({}, b, {
          value: d
        }));
      }
      if (r) {
        if (!Reflect.defineProperty(this.target_, o, b))
          return !1;
      } else
        _t(this.target_, o, b);
      this.notifyPropertyAddition_(o, b.value);
    } finally {
      X2();
    }
    return !0;
  }, t.defineObservableProperty_ = function(o, b, r, i) {
    i === void 0 && (i = !1), Lt(this.keysAtom_);
    try {
      D2();
      var s = this.delete_(o);
      if (!s)
        return s;
      if (w2(this)) {
        var d = S2(this, {
          object: this.proxy_ || this.target_,
          name: o,
          type: kp,
          newValue: b
        });
        if (!d)
          return null;
        b = d.newValue;
      }
      var q = Q3(o), f = {
        configurable: e0.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: q.get,
        set: q.set
      };
      if (i) {
        if (!Reflect.defineProperty(this.target_, o, f))
          return !1;
      } else
        _t(this.target_, o, f);
      var h = new lo(b, r, process.env.NODE_ENV !== "production" ? this.name_ + "." + o.toString() : "ObservableObject.key", !1);
      this.values_.set(o, h), this.notifyPropertyAddition_(o, h.value_);
    } finally {
      X2();
    }
    return !0;
  }, t.defineComputedProperty_ = function(o, b, r) {
    r === void 0 && (r = !1), Lt(this.keysAtom_);
    try {
      D2();
      var i = this.delete_(o);
      if (!i)
        return i;
      if (w2(this)) {
        var s = S2(this, {
          object: this.proxy_ || this.target_,
          name: o,
          type: kp,
          newValue: void 0
        });
        if (!s)
          return null;
      }
      b.name || (b.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + o.toString() : "ObservableObject.key"), b.context = this.proxy_ || this.target_;
      var d = Q3(o), q = {
        configurable: e0.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: d.get,
        set: d.set
      };
      if (r) {
        if (!Reflect.defineProperty(this.target_, o, q))
          return !1;
      } else
        _t(this.target_, o, q);
      this.values_.set(o, new yo(b)), this.notifyPropertyAddition_(o, void 0);
    } finally {
      X2();
    }
    return !0;
  }, t.delete_ = function(o, b) {
    if (b === void 0 && (b = !1), Lt(this.keysAtom_), !r2(this.target_, o))
      return !0;
    if (w2(this)) {
      var r = S2(this, {
        object: this.proxy_ || this.target_,
        name: o,
        type: K3
      });
      if (!r)
        return null;
    }
    try {
      var i, s;
      D2();
      var d = nt(this), q = process.env.NODE_ENV !== "production" && se(), f = this.values_.get(o), h = void 0;
      if (!f && (d || q)) {
        var g;
        h = (g = mz(this.target_, o)) == null ? void 0 : g.value;
      }
      if (b) {
        if (!Reflect.deleteProperty(this.target_, o))
          return !1;
      } else
        delete this.target_[o];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[o], f && (this.values_.delete(o), f instanceof lo && (h = f.value_), vd(f)), this.keysAtom_.reportChanged(), (i = this.pendingKeys_) == null || (s = i.get(o)) == null || s.set(o in this.target_), d || q) {
        var y = {
          type: K3,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: h,
          name: o
        };
        process.env.NODE_ENV !== "production" && q && c2(y), d && zt(this, y), process.env.NODE_ENV !== "production" && q && i2();
      }
    } finally {
      X2();
    }
    return !0;
  }, t.observe_ = function(o, b) {
    return process.env.NODE_ENV !== "production" && b === !0 && o0("`observe` doesn't support the fire immediately property for observable objects."), Yb(this, o);
  }, t.intercept_ = function(o) {
    return Vb(this, o);
  }, t.notifyPropertyAddition_ = function(o, b) {
    var r, i, s = nt(this), d = process.env.NODE_ENV !== "production" && se();
    if (s || d) {
      var q = s || d ? {
        type: kp,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: o,
        newValue: b
      } : null;
      process.env.NODE_ENV !== "production" && d && c2(q), s && zt(this, q), process.env.NODE_ENV !== "production" && d && i2();
    }
    (r = this.pendingKeys_) == null || (i = r.get(o)) == null || i.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Yz(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, p;
})();
function SM(p, t) {
  var e;
  if (process.env.NODE_ENV !== "production" && t && Gb(p) && o0("Options can't be provided for already observable objects."), r2(p, L0))
    return process.env.NODE_ENV !== "production" && !(Gd(p) instanceof Fi) && o0("Cannot convert '" + Tz(p) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), p;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(p) && o0("Cannot make the designated object observable; it is not extensible");
  var o = (e = t == null ? void 0 : t.name) != null ? e : process.env.NODE_ENV !== "production" ? (it(p) ? "ObservableObject" : p.constructor.name) + "@" + k2() : "ObservableObject", b = new Fi(p, /* @__PURE__ */ new Map(), String(o), O8(t));
  return Vz(p, L0, b), p;
}
var nv = /* @__PURE__ */ So("ObservableObjectAdministration", Fi);
function Q3(p) {
  return G3[p] || (G3[p] = {
    get: function() {
      return this[L0].getObservablePropValue_(p);
    },
    set: function(e) {
      return this[L0].setObservablePropValue_(p, e);
    }
  });
}
function Gb(p) {
  return $z(p) ? nv(p[L0]) : !1;
}
function Z3(p, t, e) {
  var o;
  process.env.NODE_ENV !== "production" && (p.appliedAnnotations_[e] = t), (o = p.target_[Ve]) == null || delete o[e];
}
function j3(p, t, e) {
  if (process.env.NODE_ENV !== "production" && !Qd(t) && o0("Cannot annotate '" + p.name_ + "." + e.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !yz(t) && r2(p.appliedAnnotations_, e)) {
    var o = p.name_ + "." + e.toString(), b = p.appliedAnnotations_[e].annotationType_, r = t.annotationType_;
    o0("Cannot apply '" + r + "' to '" + o + "':" + (`
The field is already annotated with '` + b + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var zv = /* @__PURE__ */ Vd(0), rv = /* @__PURE__ */ (function() {
  var p = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      p = !0;
    }
  }), Object.create(t)[0] = 1, p === !1;
})(), Tc = 0, $d = function() {
};
function cv(p, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(p.prototype, t) : p.prototype.__proto__ !== void 0 ? p.prototype.__proto__ = t : p.prototype = t;
}
cv($d, Array.prototype);
var Ta = /* @__PURE__ */ (function(p, t, e) {
  zd(o, p);
  function o(r, i, s, d) {
    var q;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableArray@" + k2() : "ObservableArray"), d === void 0 && (d = !1), q = p.call(this) || this, Xo(function() {
      var f = new Ba(s, i, d, !0);
      f.proxy_ = bz(q), Md(bz(q), L0, f), r && r.length && q.spliceWithArray(0, 0, r), rv && Object.defineProperty(bz(q), "0", zv);
    }), q;
  }
  var b = o.prototype;
  return b.concat = function() {
    this[L0].atom_.reportObserved();
    for (var i = arguments.length, s = new Array(i), d = 0; d < i; d++)
      s[d] = arguments[d];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      s.map(function(q) {
        return tr(q) ? q.slice() : q;
      })
    );
  }, b[e] = function() {
    var r = this, i = 0;
    return wb({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, ga(o, [{
    key: "length",
    get: function() {
      return this[L0].getArrayLength_();
    },
    set: function(i) {
      this[L0].setArrayLength_(i);
    }
  }, {
    key: t,
    get: function() {
      return "Array";
    }
  }]), o;
})($d, Symbol.toStringTag, Symbol.iterator);
Object.entries(Nz).forEach(function(p) {
  var t = p[0], e = p[1];
  t !== "concat" && Vz(Ta.prototype, t, e);
});
function Vd(p) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[L0].get_(p);
    },
    set: function(e) {
      this[L0].set_(p, e);
    }
  };
}
function iv(p) {
  _t(Ta.prototype, "" + p, Vd(p));
}
function Yd(p) {
  if (p > Tc) {
    for (var t = Tc; t < p + 100; t++)
      iv(t);
    Tc = p;
  }
}
Yd(1e3);
function av(p, t, e) {
  return new Ta(p, t, e);
}
function yM(p, t) {
  if (typeof p == "object" && p !== null) {
    if (tr(p))
      return t !== void 0 && o0(23), p[L0].atom_;
    if (wM(p))
      return p.atom_;
    if (Fp(p)) {
      if (t === void 0)
        return p.keysAtom_;
      var e = p.data_.get(t) || p.hasMap_.get(t);
      return e || o0(25, t, Tz(p)), e;
    }
    if (Gb(p)) {
      if (!t)
        return o0(26);
      var o = p[L0].values_.get(t);
      return o || o0(27, t, Tz(p)), o;
    }
    if (La(p) || er(p) || _z(p))
      return p;
  } else if (J1(p) && _z(p[L0]))
    return p[L0];
  o0(28);
}
function Gd(p, t) {
  if (p || o0(29), La(p) || er(p) || _z(p) || Fp(p) || wM(p))
    return p;
  if (p[L0])
    return p[L0];
  o0(24, p);
}
function Tz(p, t) {
  var e;
  if (t !== void 0)
    e = yM(p, t);
  else {
    if ($b(p))
      return p.name;
    Gb(p) || Fp(p) || wM(p) ? e = Gd(p) : e = yM(p);
  }
  return e.name_;
}
function Xo(p) {
  var t = Do(), e = Zz(!0);
  D2();
  try {
    return p();
  } finally {
    X2(), jz(e), Mp(t);
  }
}
var eA = Jz.toString;
function Kd(p, t, e) {
  return e === void 0 && (e = -1), Ui(p, t, e);
}
function Ui(p, t, e, o, b) {
  if (p === t)
    return p !== 0 || 1 / p === 1 / t;
  if (p == null || t == null)
    return !1;
  if (p !== p)
    return t !== t;
  var r = typeof p;
  if (r !== "function" && r !== "object" && typeof t != "object")
    return !1;
  var i = eA.call(p);
  if (i !== eA.call(t))
    return !1;
  switch (i) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + p == "" + t;
    case "[object Number]":
      return +p != +p ? +t != +t : +p == 0 ? 1 / +p === 1 / t : +p == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +p == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(p) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      e >= 0 && e++;
      break;
  }
  p = tA(p), t = tA(t);
  var s = i === "[object Array]";
  if (!s) {
    if (typeof p != "object" || typeof t != "object")
      return !1;
    var d = p.constructor, q = t.constructor;
    if (d !== q && !(J1(d) && d instanceof d && J1(q) && q instanceof q) && "constructor" in p && "constructor" in t)
      return !1;
  }
  if (e === 0)
    return !1;
  e < 0 && (e = -1), o = o || [], b = b || [];
  for (var f = o.length; f--; )
    if (o[f] === p)
      return b[f] === t;
  if (o.push(p), b.push(t), s) {
    if (f = p.length, f !== t.length)
      return !1;
    for (; f--; )
      if (!Ui(p[f], t[f], e - 1, o, b))
        return !1;
  } else {
    var h = Object.keys(p), g;
    if (f = h.length, Object.keys(t).length !== f)
      return !1;
    for (; f--; )
      if (g = h[f], !(r2(t, g) && Ui(p[g], t[g], e - 1, o, b)))
        return !1;
  }
  return o.pop(), b.pop(), !0;
}
function tA(p) {
  return tr(p) ? p.slice() : BM(p) || Fp(p) || Fb(p) || wM(p) ? Array.from(p.entries()) : p;
}
function wb(p) {
  return p[Symbol.iterator] = Ov, p;
}
function Ov() {
  return this;
}
function Qd(p) {
  return (
    // Can be function
    p instanceof Object && typeof p.annotationType_ == "string" && J1(p.make_) && J1(p.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(p) {
  var t = ed();
  typeof t[p] > "u" && o0("MobX requires global '" + p + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: w8,
  extras: {
    getDebugName: Tz
  },
  $mobx: L0
});
var sv = Object.defineProperty, Av = Object.getOwnPropertyDescriptor, n1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Av(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && sv(t, e, b), b;
};
class J0 {
  constructor(t) {
    z(this, "skip", 0);
    z(this, "take", 25);
    z(this, "itemsTotal", 0);
    z(this, "search");
    z(this, "sortName");
    z(this, "sortType");
    z(this, "filters");
    z(this, "softDeleted", !1);
    z(this, "useSort", !0);
    z(this, "useBaseFilter", !0);
    z(this, "useItemsTotal", !0);
    z(this, "ids");
    z(this, "extendedFilterId");
    z(this, "extendedFilter");
    z(this, "fields");
    t && this.update(t);
  }
  get page() {
    return this.skip / Math.max(1, this.take) + 1;
  }
  set page(t) {
    this.skip = (t - 1) * Math.max(1, this.take);
  }
  get pageTotal() {
    return Math.ceil(this.itemsTotal / Math.max(1, this.take));
  }
  update(t) {
    for (const e in t)
      t.hasOwnProperty(e) && (this[e] = t[e] === null ? void 0 : t[e]);
    t.softDeleted === null && (this.softDeleted = null);
  }
}
class S1 {
  constructor(t = "paging") {
    z(this, "inited", !1);
    z(this, "hasError", !1);
    z(this, "fetching", !1);
    z(this, "items", []);
    z(this, "filter");
    z(this, "mode", "paging");
    i0(this), this.filter = this.createFilter({}), this.mode = t;
  }
  get isEmpty() {
    return this.inited && this.filter.itemsTotal == 0;
  }
  get hasMore() {
    if (this.filter.itemsTotal === void 0) return !0;
    switch (this.mode) {
      case "paging":
        return this.filter.page * this.filter.take < this.filter.itemsTotal;
      case "infinity":
        return this.filter.itemsTotal > this.items.length;
    }
  }
  get moreCount() {
    switch (this.mode) {
      case "paging":
        return Math.max(this.filter.itemsTotal - this.filter.page * this.filter.take, 0);
      case "infinity":
        return this.filter.itemsTotal - this.items.length;
    }
  }
  setItems(t) {
    this.items = t;
  }
  async fetch(t) {
    s0(() => {
      this.fetching = !0;
    });
    const e = await this.fetchItems(t ?? this.filter);
    if (e.success) {
      const o = e.body.items ?? [], b = e.body.filter;
      this.processResponse(o, b);
    }
    return s0(() => {
      this.inited = !0, this.hasError = !e.success, this.fetching = !1;
    }), e;
  }
  /**
   * fetch with no pagination
   * @param fields 
   * @returns 
   */
  async fetchAll(t = !1) {
    const e = this.createFilter({
      useBaseFilter: !1,
      softDeleted: t ? null : this.filter.softDeleted
    });
    return await this.fetch(e);
  }
  processResponse(t, e) {
    switch (this.mode) {
      case "paging": {
        this.items = t;
        break;
      }
      case "infinity": {
        const o = this.items.slice();
        let b = e.skip;
        for (const r of t)
          o[b] || (o[b] = r), b++;
        this.items = o;
        break;
      }
    }
    if (!e) {
      console.warn("[ListStore] No filter in response");
      return;
    }
    this.filter = this.createFilter({ ...this.filter, itemsTotal: e.itemsTotal });
  }
  updateFilter(t, e = !0) {
    e && (this.filter.page = 1), this.filter = this.createFilter(t);
  }
  setFilter(t) {
    this.filter = t;
  }
  createFilter(t) {
    return new J0({ ...this.filter, ...t });
  }
  reset() {
    this.items = [], this.hasError = !1, this.filter = this.createFilter({}), this.inited = !1;
  }
  insertItems(...t) {
    this.items = [...t, ...this.items], this.updateFilter({ itemsTotal: Math.max(this.filter.itemsTotal + t.length, 0) });
  }
  updateItems(...t) {
    for (const e of t) {
      const o = this.items.findIndex((b) => b.id === e.id);
      o !== -1 && this.items[o].update(e);
    }
  }
  replaceItems(...t) {
    for (const e of t) {
      const o = this.items.findIndex((b) => b.id === e.id);
      o !== -1 && (this.items[o] = e);
    }
  }
  removeItems(...t) {
    this.items = this.items.filter((e) => !t.some((o) => o.id === e.id)), this.updateFilter({ itemsTotal: Math.max(this.filter.itemsTotal - t.length, 0) });
  }
}
n1([
  a
], S1.prototype, "inited", 2);
n1([
  a
], S1.prototype, "hasError", 2);
n1([
  a
], S1.prototype, "fetching", 2);
n1([
  a
], S1.prototype, "items", 2);
n1([
  a
], S1.prototype, "filter", 2);
n1([
  a
], S1.prototype, "mode", 2);
n1([
  $
], S1.prototype, "isEmpty", 1);
n1([
  $
], S1.prototype, "hasMore", 1);
n1([
  $
], S1.prototype, "moreCount", 1);
n1([
  C
], S1.prototype, "setItems", 1);
n1([
  C
], S1.prototype, "processResponse", 1);
n1([
  C
], S1.prototype, "updateFilter", 1);
n1([
  C
], S1.prototype, "setFilter", 1);
n1([
  C
], S1.prototype, "reset", 1);
n1([
  C
], S1.prototype, "insertItems", 1);
n1([
  C
], S1.prototype, "updateItems", 1);
n1([
  C
], S1.prototype, "replaceItems", 1);
n1([
  C
], S1.prototype, "removeItems", 1);
class v1 extends S1 {
  constructor(e = "paging") {
    super(e);
    z(this, "creating", !1);
    z(this, "saving", !1);
    z(this, "deleting", !1);
    i0(this);
  }
  async create(e) {
    this.creating = !0;
    const o = await this.crudApi.create(e);
    return o.success && (typeof o.body == "string" ? e.update({ id: o.body }) : e.update(o.body)), s0(() => {
      this.creating = !1;
    }), o;
  }
  async save(e) {
    this.saving = !0;
    const o = await this.crudApi.save(e.toJson());
    return s0(() => {
      this.saving = !1;
    }), o;
  }
  async savePartial(e, o) {
    this.saving = !0;
    const b = await this.crudApi.save({ id: o.id, ...e });
    return b.success && o.update(e), s0(() => {
      this.saving = !1;
    }), b;
  }
  async saveCustom(e) {
    this.saving = !0;
    const o = await this.crudApi.save(e);
    return s0(() => {
      this.saving = !1;
    }), o;
  }
  async delete(e, o = !0) {
    this.deleting = !0;
    const b = await this.crudApi.delete(e);
    return b.success && o && await this.fetch(), s0(() => {
      this.deleting = !1;
    }), b;
  }
  async fetchItem(e, o) {
    this.fetching = !0;
    const b = await this.crudApi.fetchItem(e, o);
    return s0(() => {
      this.fetching = !1;
    }), b;
  }
  async fetchItems(e, o) {
    return this.crudApi.fetch(o, e ?? this.filter);
  }
  updateFilter(e, o = !0) {
    o && (this.filter.page = 1), this.filter = { ...this.filter, ...e };
  }
}
n1([
  a
], v1.prototype, "creating", 2);
n1([
  a
], v1.prototype, "saving", 2);
n1([
  a
], v1.prototype, "deleting", 2);
n1([
  C
], v1.prototype, "create", 1);
n1([
  C
], v1.prototype, "save", 1);
n1([
  C
], v1.prototype, "savePartial", 1);
n1([
  C
], v1.prototype, "saveCustom", 1);
n1([
  C
], v1.prototype, "delete", 1);
n1([
  C
], v1.prototype, "fetchItem", 1);
n1([
  DL
], v1.prototype, "updateFilter", 1);
class uv {
  constructor() {
    z(this, "stack", []);
  }
  get length() {
    return this.stack.length;
  }
  push(t) {
    if (t == null) throw new Error("[DisposableStack] func is null");
    if (t.dispose != null) {
      this.stack.push(t.dispose.bind(t));
      return;
    }
    if (typeof t != "function") throw new Error("[DisposableStack] func is not a function");
    this.stack.push(t);
  }
  dispose() {
    for (; this.stack.length > 0; )
      this.stack.pop()();
  }
}
class Kb {
  constructor() {
    z(this, "stack");
    this.stack = new uv();
  }
  toDispose(t) {
    this.stack.push(t);
  }
  dispose() {
    this.stack.dispose();
  }
}
var dv = /* @__PURE__ */ ((p) => (p[p.Day = 24] = "Day", p))(dv || {}), lv = /* @__PURE__ */ ((p) => (p[p.Hour = 60] = "Hour", p[p.Day = 1440] = "Day", p))(lv || {}), qv = /* @__PURE__ */ ((p) => (p[p.Minute = 60] = "Minute", p[p.Hour = 3600] = "Hour", p[p.Day = 86400] = "Day", p))(qv || {}), fv = /* @__PURE__ */ ((p) => (p[p.Second = 1e3] = "Second", p[p.Minute = 6e4] = "Minute", p[p.Hour = 36e5] = "Hour", p[p.Day = 864e5] = "Day", p))(fv || {}), Wv = /* @__PURE__ */ ((p) => (p[p.Millisecond = 1e4] = "Millisecond", p[p.Second = 1e7] = "Second", p[p.Minute = 6e8] = "Minute", p[p.Hour = 36e9] = "Hour", p[p.Day = 864e9] = "Day", p))(Wv || {}), hv = /* @__PURE__ */ ((p) => (p[p.Ticks = 0] = "Ticks", p[p.Milliseconds = 1] = "Milliseconds", p[p.Seconds = 2] = "Seconds", p[p.Minutes = 3] = "Minutes", p[p.Hours = 4] = "Hours", p[p.Days = 5] = "Days", p))(hv || {});
class mv {
  static toMilliseconds(t, e = 1) {
    switch (e) {
      //@ts-ignore
      case 5:
        t *= 24;
      //@ts-ignore
      case 4:
        t *= 60;
      //@ts-ignore
      case 3:
        t *= 60;
      //@ts-ignore
      case 2:
        t *= 1e3;
      case 1:
        return t;
      case 0:
        return t / 1e4;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
  static fromMilliseconds(t, e) {
    switch (e) {
      case 5:
        return t / 864e5;
      case 4:
        return t / 36e5;
      case 3:
        return t / 6e4;
      case 2:
        return t / 1e3;
      case 1:
        return t;
      case 0:
        return t * 1e4;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
}
class s1 {
  constructor(t, e = 1) {
    z(this, "ticks");
    z(this, "milliseconds");
    z(this, "seconds");
    z(this, "minutes");
    z(this, "hours");
    z(this, "days");
    const o = mv.toMilliseconds(t, e);
    this.ticks = o * 1e4, this.milliseconds = o, this.seconds = o / 1e3, this.minutes = o / 6e4, this.hours = o / 36e5, this.days = o / 864e5;
  }
  add(t) {
    return s1.fromMilliseconds(this.milliseconds + t.milliseconds);
  }
  substract(t) {
    return s1.fromMilliseconds(this.milliseconds - t.milliseconds);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.ticks == 0;
  }
  static from(t, e) {
    return new s1(t, e);
  }
  static fromDays(t) {
    return new s1(
      t,
      5
      /* Days */
    );
  }
  static fromHours(t) {
    return new s1(
      t,
      4
      /* Hours */
    );
  }
  static fromMinutes(t) {
    return new s1(
      t,
      3
      /* Minutes */
    );
  }
  static fromSeconds(t) {
    return new s1(
      t,
      2
      /* Seconds */
    );
  }
  static fromMilliseconds(t) {
    return new s1(
      t,
      1
      /* Milliseconds */
    );
  }
  static fromMs(t) {
    return new s1(
      t,
      1
      /* Milliseconds */
    );
  }
  static fromTicks(t) {
    return new s1(
      t,
      0
      /* Ticks */
    );
  }
  static fromTimeMeasure(t, e) {
    switch (e) {
      case "seconds":
        return s1.fromSeconds(t);
      case "minutes":
        return s1.fromMinutes(t);
      case "hours":
        return s1.fromHours(t);
      case "days":
        return s1.fromDays(t);
      case "weeks":
        return s1.fromDays(t * 7);
      case "months":
        return s1.fromDays(t * 30);
      default:
        throw new Error("Invalid TimeMeasure.");
    }
  }
  static get zero() {
    return new s1(0);
  }
}
s1.prototype.toString = function() {
  return this.milliseconds.toString();
};
s1.prototype.valueOf = function() {
  return this.milliseconds;
};
var lM = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function wa(p) {
  return p && p.__esModule && Object.prototype.hasOwnProperty.call(p, "default") ? p.default : p;
}
function Zd(p) {
  if (Object.prototype.hasOwnProperty.call(p, "__esModule")) return p;
  var t = p.default;
  if (typeof t == "function") {
    var e = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(p).forEach(function(o) {
    var b = Object.getOwnPropertyDescriptor(p, o);
    Object.defineProperty(e, o, b.get ? b : {
      enumerable: !0,
      get: function() {
        return p[o];
      }
    });
  }), e;
}
var ub = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var Rv = ub.exports, pA;
function yv() {
  return pA || (pA = 1, (function(p, t) {
    (function() {
      var e, o = "4.17.21", b = 200, r = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", i = "Expected a function", s = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", q = 500, f = "__lodash_placeholder__", h = 1, g = 2, y = 4, w = 1, U = 2, N = 1, S = 2, D = 4, V = 8, H = 16, Y = 32, t0 = 64, j = 128, b0 = 256, y0 = 512, m0 = 30, V0 = "...", O0 = 800, m1 = 16, Z0 = 1, ze = 2, I1 = 3, pe = 1 / 0, W0 = 9007199254740991, re = 17976931348623157e292, fe = NaN, G1 = 4294967295, W2 = G1 - 1, h2 = G1 >>> 1, ke = [
        ["ary", j],
        ["bind", N],
        ["bindKey", S],
        ["curry", V],
        ["curryRight", H],
        ["flip", y0],
        ["partial", Y],
        ["partialRight", t0],
        ["rearg", b0]
      ], K1 = "[object Arguments]", d1 = "[object Array]", x0 = "[object AsyncFunction]", i1 = "[object Boolean]", a1 = "[object Date]", P0 = "[object DOMException]", o1 = "[object Error]", E0 = "[object Function]", m = "[object GeneratorFunction]", I = "[object Map]", E = "[object Number]", G = "[object Null]", z0 = "[object Object]", h0 = "[object Promise]", t1 = "[object Proxy]", _0 = "[object RegExp]", g0 = "[object Set]", je = "[object String]", K2 = "[object Symbol]", fp = "[object Undefined]", Qp = "[object WeakMap]", ar = "[object WeakSet]", Wp = "[object ArrayBuffer]", hp = "[object DataView]", Et = "[object Float32Array]", Zp = "[object Float64Array]", Ho = "[object Int8Array]", FM = "[object Int16Array]", UM = "[object Int32Array]", jp = "[object Uint8Array]", mp = "[object Uint8ClampedArray]", B = "[object Uint16Array]", T = "[object Uint32Array]", Y0 = /\b__p \+= '';/g, M1 = /\b(__p \+=) '' \+/g, z1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, w0 = /&(?:amp|lt|gt|quot|#39);/g, Q2 = /[&<>"']/g, kt = RegExp(w0.source), Ne = RegExp(Q2.source), ft = /<%-([\s\S]+?)%>/g, HM = /<%([\s\S]+?)%>/g, xt = /<%=([\s\S]+?)%>/g, e2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pn = /^\w*$/, on = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Jo = /[\\^$.*+?()[\]{}|]/g, eo = RegExp(Jo.source), to = /^\s+/, $o = /\s/, JM = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, $M = /\{\n\/\* \[wrapped with (.+)\] \*/, Mn = /,? & /, bn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, VM = /[()=,{}\[\]\/\s]/, nn = /\\(\\)?/g, YM = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, GM = /\w*$/, Or = /^[-+]0x[0-9a-f]+$/i, KM = /^0b[01]+$/i, Rp = /^\[object .+?Constructor\]$/, Vo = /^0o[0-7]+$/i, sr = /^(?:0|[1-9]\d*)$/, zn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, rn = /($^)/, o4 = /['\n\r\u2028\u2029\\]/g, cn = "\\ud800-\\udfff", M4 = "\\u0300-\\u036f", b4 = "\\ufe20-\\ufe2f", n4 = "\\u20d0-\\u20ff", iO = M4 + b4 + n4, aO = "\\u2700-\\u27bf", OO = "a-z\\xdf-\\xf6\\xf8-\\xff", z4 = "\\xac\\xb1\\xd7\\xf7", r4 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", c4 = "\\u2000-\\u206f", i4 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", sO = "A-Z\\xc0-\\xd6\\xd8-\\xde", AO = "\\ufe0e\\ufe0f", uO = z4 + r4 + c4 + i4, Ar = "['’]", a4 = "[" + cn + "]", dO = "[" + uO + "]", an = "[" + iO + "]", lO = "\\d+", O4 = "[" + aO + "]", qO = "[" + OO + "]", fO = "[^" + cn + uO + lO + aO + OO + sO + "]", ur = "\\ud83c[\\udffb-\\udfff]", s4 = "(?:" + an + "|" + ur + ")", WO = "[^" + cn + "]", dr = "(?:\\ud83c[\\udde6-\\uddff]){2}", lr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Yo = "[" + sO + "]", hO = "\\u200d", mO = "(?:" + qO + "|" + fO + ")", A4 = "(?:" + Yo + "|" + fO + ")", RO = "(?:" + Ar + "(?:d|ll|m|re|s|t|ve))?", yO = "(?:" + Ar + "(?:D|LL|M|RE|S|T|VE))?", gO = s4 + "?", LO = "[" + AO + "]?", u4 = "(?:" + hO + "(?:" + [WO, dr, lr].join("|") + ")" + LO + gO + ")*", d4 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", l4 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", vO = LO + gO + u4, q4 = "(?:" + [O4, dr, lr].join("|") + ")" + vO, f4 = "(?:" + [WO + an + "?", an, dr, lr, a4].join("|") + ")", W4 = RegExp(Ar, "g"), h4 = RegExp(an, "g"), qr = RegExp(ur + "(?=" + ur + ")|" + f4 + vO, "g"), m4 = RegExp([
        Yo + "?" + qO + "+" + RO + "(?=" + [dO, Yo, "$"].join("|") + ")",
        A4 + "+" + yO + "(?=" + [dO, Yo + mO, "$"].join("|") + ")",
        Yo + "?" + mO + "+" + RO,
        Yo + "+" + yO,
        l4,
        d4,
        lO,
        q4
      ].join("|"), "g"), R4 = RegExp("[" + hO + cn + iO + AO + "]"), y4 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, g4 = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], L4 = -1, l1 = {};
      l1[Et] = l1[Zp] = l1[Ho] = l1[FM] = l1[UM] = l1[jp] = l1[mp] = l1[B] = l1[T] = !0, l1[K1] = l1[d1] = l1[Wp] = l1[i1] = l1[hp] = l1[a1] = l1[o1] = l1[E0] = l1[I] = l1[E] = l1[z0] = l1[_0] = l1[g0] = l1[je] = l1[Qp] = !1;
      var O1 = {};
      O1[K1] = O1[d1] = O1[Wp] = O1[hp] = O1[i1] = O1[a1] = O1[Et] = O1[Zp] = O1[Ho] = O1[FM] = O1[UM] = O1[I] = O1[E] = O1[z0] = O1[_0] = O1[g0] = O1[je] = O1[K2] = O1[jp] = O1[mp] = O1[B] = O1[T] = !0, O1[o1] = O1[E0] = O1[Qp] = !1;
      var v4 = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, _4 = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, N4 = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, B4 = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, T4 = parseFloat, w4 = parseInt, _O = typeof lM == "object" && lM && lM.Object === Object && lM, S4 = typeof self == "object" && self && self.Object === Object && self, ae = _O || S4 || Function("return this")(), fr = t && !t.nodeType && t, po = fr && !0 && p && !p.nodeType && p, NO = po && po.exports === fr, Wr = NO && _O.process, m2 = (function() {
        try {
          var v = po && po.require && po.require("util").types;
          return v || Wr && Wr.binding && Wr.binding("util");
        } catch {
        }
      })(), BO = m2 && m2.isArrayBuffer, TO = m2 && m2.isDate, wO = m2 && m2.isMap, SO = m2 && m2.isRegExp, DO = m2 && m2.isSet, XO = m2 && m2.isTypedArray;
      function t2(v, P, X) {
        switch (X.length) {
          case 0:
            return v.call(P);
          case 1:
            return v.call(P, X[0]);
          case 2:
            return v.call(P, X[0], X[1]);
          case 3:
            return v.call(P, X[0], X[1], X[2]);
        }
        return v.apply(P, X);
      }
      function D4(v, P, X, r0) {
        for (var N0 = -1, j0 = v == null ? 0 : v.length; ++N0 < j0; ) {
          var oe = v[N0];
          P(r0, oe, X(oe), v);
        }
        return r0;
      }
      function R2(v, P) {
        for (var X = -1, r0 = v == null ? 0 : v.length; ++X < r0 && P(v[X], X, v) !== !1; )
          ;
        return v;
      }
      function X4(v, P) {
        for (var X = v == null ? 0 : v.length; X-- && P(v[X], X, v) !== !1; )
          ;
        return v;
      }
      function CO(v, P) {
        for (var X = -1, r0 = v == null ? 0 : v.length; ++X < r0; )
          if (!P(v[X], X, v))
            return !1;
        return !0;
      }
      function yp(v, P) {
        for (var X = -1, r0 = v == null ? 0 : v.length, N0 = 0, j0 = []; ++X < r0; ) {
          var oe = v[X];
          P(oe, X, v) && (j0[N0++] = oe);
        }
        return j0;
      }
      function On(v, P) {
        var X = v == null ? 0 : v.length;
        return !!X && Go(v, P, 0) > -1;
      }
      function hr(v, P, X) {
        for (var r0 = -1, N0 = v == null ? 0 : v.length; ++r0 < N0; )
          if (X(P, v[r0]))
            return !0;
        return !1;
      }
      function R1(v, P) {
        for (var X = -1, r0 = v == null ? 0 : v.length, N0 = Array(r0); ++X < r0; )
          N0[X] = P(v[X], X, v);
        return N0;
      }
      function gp(v, P) {
        for (var X = -1, r0 = P.length, N0 = v.length; ++X < r0; )
          v[N0 + X] = P[X];
        return v;
      }
      function mr(v, P, X, r0) {
        var N0 = -1, j0 = v == null ? 0 : v.length;
        for (r0 && j0 && (X = v[++N0]); ++N0 < j0; )
          X = P(X, v[N0], N0, v);
        return X;
      }
      function C4(v, P, X, r0) {
        var N0 = v == null ? 0 : v.length;
        for (r0 && N0 && (X = v[--N0]); N0--; )
          X = P(X, v[N0], N0, v);
        return X;
      }
      function Rr(v, P) {
        for (var X = -1, r0 = v == null ? 0 : v.length; ++X < r0; )
          if (P(v[X], X, v))
            return !0;
        return !1;
      }
      var I4 = yr("length");
      function P4(v) {
        return v.split("");
      }
      function E4(v) {
        return v.match(bn) || [];
      }
      function IO(v, P, X) {
        var r0;
        return X(v, function(N0, j0, oe) {
          if (P(N0, j0, oe))
            return r0 = j0, !1;
        }), r0;
      }
      function sn(v, P, X, r0) {
        for (var N0 = v.length, j0 = X + (r0 ? 1 : -1); r0 ? j0-- : ++j0 < N0; )
          if (P(v[j0], j0, v))
            return j0;
        return -1;
      }
      function Go(v, P, X) {
        return P === P ? Q4(v, P, X) : sn(v, PO, X);
      }
      function k4(v, P, X, r0) {
        for (var N0 = X - 1, j0 = v.length; ++N0 < j0; )
          if (r0(v[N0], P))
            return N0;
        return -1;
      }
      function PO(v) {
        return v !== v;
      }
      function EO(v, P) {
        var X = v == null ? 0 : v.length;
        return X ? Lr(v, P) / X : fe;
      }
      function yr(v) {
        return function(P) {
          return P == null ? e : P[v];
        };
      }
      function gr(v) {
        return function(P) {
          return v == null ? e : v[P];
        };
      }
      function kO(v, P, X, r0, N0) {
        return N0(v, function(j0, oe, r1) {
          X = r0 ? (r0 = !1, j0) : P(X, j0, oe, r1);
        }), X;
      }
      function x4(v, P) {
        var X = v.length;
        for (v.sort(P); X--; )
          v[X] = v[X].value;
        return v;
      }
      function Lr(v, P) {
        for (var X, r0 = -1, N0 = v.length; ++r0 < N0; ) {
          var j0 = P(v[r0]);
          j0 !== e && (X = X === e ? j0 : X + j0);
        }
        return X;
      }
      function vr(v, P) {
        for (var X = -1, r0 = Array(v); ++X < v; )
          r0[X] = P(X);
        return r0;
      }
      function F4(v, P) {
        return R1(P, function(X) {
          return [X, v[X]];
        });
      }
      function xO(v) {
        return v && v.slice(0, JO(v) + 1).replace(to, "");
      }
      function p2(v) {
        return function(P) {
          return v(P);
        };
      }
      function _r(v, P) {
        return R1(P, function(X) {
          return v[X];
        });
      }
      function QM(v, P) {
        return v.has(P);
      }
      function FO(v, P) {
        for (var X = -1, r0 = v.length; ++X < r0 && Go(P, v[X], 0) > -1; )
          ;
        return X;
      }
      function UO(v, P) {
        for (var X = v.length; X-- && Go(P, v[X], 0) > -1; )
          ;
        return X;
      }
      function U4(v, P) {
        for (var X = v.length, r0 = 0; X--; )
          v[X] === P && ++r0;
        return r0;
      }
      var H4 = gr(v4), J4 = gr(_4);
      function $4(v) {
        return "\\" + B4[v];
      }
      function V4(v, P) {
        return v == null ? e : v[P];
      }
      function Ko(v) {
        return R4.test(v);
      }
      function Y4(v) {
        return y4.test(v);
      }
      function G4(v) {
        for (var P, X = []; !(P = v.next()).done; )
          X.push(P.value);
        return X;
      }
      function Nr(v) {
        var P = -1, X = Array(v.size);
        return v.forEach(function(r0, N0) {
          X[++P] = [N0, r0];
        }), X;
      }
      function HO(v, P) {
        return function(X) {
          return v(P(X));
        };
      }
      function Lp(v, P) {
        for (var X = -1, r0 = v.length, N0 = 0, j0 = []; ++X < r0; ) {
          var oe = v[X];
          (oe === P || oe === f) && (v[X] = f, j0[N0++] = X);
        }
        return j0;
      }
      function An(v) {
        var P = -1, X = Array(v.size);
        return v.forEach(function(r0) {
          X[++P] = r0;
        }), X;
      }
      function K4(v) {
        var P = -1, X = Array(v.size);
        return v.forEach(function(r0) {
          X[++P] = [r0, r0];
        }), X;
      }
      function Q4(v, P, X) {
        for (var r0 = X - 1, N0 = v.length; ++r0 < N0; )
          if (v[r0] === P)
            return r0;
        return -1;
      }
      function Z4(v, P, X) {
        for (var r0 = X + 1; r0--; )
          if (v[r0] === P)
            return r0;
        return r0;
      }
      function Qo(v) {
        return Ko(v) ? eq(v) : I4(v);
      }
      function Z2(v) {
        return Ko(v) ? tq(v) : P4(v);
      }
      function JO(v) {
        for (var P = v.length; P-- && $o.test(v.charAt(P)); )
          ;
        return P;
      }
      var j4 = gr(N4);
      function eq(v) {
        for (var P = qr.lastIndex = 0; qr.test(v); )
          ++P;
        return P;
      }
      function tq(v) {
        return v.match(qr) || [];
      }
      function pq(v) {
        return v.match(m4) || [];
      }
      var oq = (function v(P) {
        P = P == null ? ae : Zo.defaults(ae.Object(), P, Zo.pick(ae, g4));
        var X = P.Array, r0 = P.Date, N0 = P.Error, j0 = P.Function, oe = P.Math, r1 = P.Object, Br = P.RegExp, Mq = P.String, y2 = P.TypeError, un = X.prototype, bq = j0.prototype, jo = r1.prototype, dn = P["__core-js_shared__"], ln = bq.toString, p1 = jo.hasOwnProperty, nq = 0, $O = (function() {
          var M = /[^.]+$/.exec(dn && dn.keys && dn.keys.IE_PROTO || "");
          return M ? "Symbol(src)_1." + M : "";
        })(), qn = jo.toString, zq = ln.call(r1), rq = ae._, cq = Br(
          "^" + ln.call(p1).replace(Jo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), fn = NO ? P.Buffer : e, vp = P.Symbol, Wn = P.Uint8Array, VO = fn ? fn.allocUnsafe : e, hn = HO(r1.getPrototypeOf, r1), YO = r1.create, GO = jo.propertyIsEnumerable, mn = un.splice, KO = vp ? vp.isConcatSpreadable : e, ZM = vp ? vp.iterator : e, oo = vp ? vp.toStringTag : e, Rn = (function() {
          try {
            var M = ro(r1, "defineProperty");
            return M({}, "", {}), M;
          } catch {
          }
        })(), iq = P.clearTimeout !== ae.clearTimeout && P.clearTimeout, aq = r0 && r0.now !== ae.Date.now && r0.now, Oq = P.setTimeout !== ae.setTimeout && P.setTimeout, yn = oe.ceil, gn = oe.floor, Tr = r1.getOwnPropertySymbols, sq = fn ? fn.isBuffer : e, QO = P.isFinite, Aq = un.join, uq = HO(r1.keys, r1), Me = oe.max, We = oe.min, dq = r0.now, lq = P.parseInt, ZO = oe.random, qq = un.reverse, wr = ro(P, "DataView"), jM = ro(P, "Map"), Sr = ro(P, "Promise"), eM = ro(P, "Set"), eb = ro(P, "WeakMap"), tb = ro(r1, "create"), Ln = eb && new eb(), tM = {}, fq = co(wr), Wq = co(jM), hq = co(Sr), mq = co(eM), Rq = co(eb), vn = vp ? vp.prototype : e, pb = vn ? vn.valueOf : e, jO = vn ? vn.toString : e;
        function u(M) {
          if (P1(M) && !B0(M) && !(M instanceof F0)) {
            if (M instanceof g2)
              return M;
            if (p1.call(M, "__wrapped__"))
              return e3(M);
          }
          return new g2(M);
        }
        var pM = /* @__PURE__ */ (function() {
          function M() {
          }
          return function(n) {
            if (!B1(n))
              return {};
            if (YO)
              return YO(n);
            M.prototype = n;
            var c = new M();
            return M.prototype = e, c;
          };
        })();
        function _n() {
        }
        function g2(M, n) {
          this.__wrapped__ = M, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = e;
        }
        u.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: ft,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: HM,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: xt,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: u
          }
        }, u.prototype = _n.prototype, u.prototype.constructor = u, g2.prototype = pM(_n.prototype), g2.prototype.constructor = g2;
        function F0(M) {
          this.__wrapped__ = M, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = G1, this.__views__ = [];
        }
        function yq() {
          var M = new F0(this.__wrapped__);
          return M.__actions__ = xe(this.__actions__), M.__dir__ = this.__dir__, M.__filtered__ = this.__filtered__, M.__iteratees__ = xe(this.__iteratees__), M.__takeCount__ = this.__takeCount__, M.__views__ = xe(this.__views__), M;
        }
        function gq() {
          if (this.__filtered__) {
            var M = new F0(this);
            M.__dir__ = -1, M.__filtered__ = !0;
          } else
            M = this.clone(), M.__dir__ *= -1;
          return M;
        }
        function Lq() {
          var M = this.__wrapped__.value(), n = this.__dir__, c = B0(M), O = n < 0, A = c ? M.length : 0, l = Ef(0, A, this.__views__), W = l.start, R = l.end, _ = R - W, x = O ? R : W - 1, F = this.__iteratees__, J = F.length, p0 = 0, a0 = We(_, this.__takeCount__);
          if (!c || !O && A == _ && a0 == _)
            return Rs(M, this.__actions__);
          var q0 = [];
          e:
            for (; _-- && p0 < a0; ) {
              x += n;
              for (var X0 = -1, f0 = M[x]; ++X0 < J; ) {
                var k0 = F[X0], H0 = k0.iteratee, b2 = k0.type, we = H0(f0);
                if (b2 == ze)
                  f0 = we;
                else if (!we) {
                  if (b2 == Z0)
                    continue e;
                  break e;
                }
              }
              q0[p0++] = f0;
            }
          return q0;
        }
        F0.prototype = pM(_n.prototype), F0.prototype.constructor = F0;
        function Mo(M) {
          var n = -1, c = M == null ? 0 : M.length;
          for (this.clear(); ++n < c; ) {
            var O = M[n];
            this.set(O[0], O[1]);
          }
        }
        function vq() {
          this.__data__ = tb ? tb(null) : {}, this.size = 0;
        }
        function _q(M) {
          var n = this.has(M) && delete this.__data__[M];
          return this.size -= n ? 1 : 0, n;
        }
        function Nq(M) {
          var n = this.__data__;
          if (tb) {
            var c = n[M];
            return c === d ? e : c;
          }
          return p1.call(n, M) ? n[M] : e;
        }
        function Bq(M) {
          var n = this.__data__;
          return tb ? n[M] !== e : p1.call(n, M);
        }
        function Tq(M, n) {
          var c = this.__data__;
          return this.size += this.has(M) ? 0 : 1, c[M] = tb && n === e ? d : n, this;
        }
        Mo.prototype.clear = vq, Mo.prototype.delete = _q, Mo.prototype.get = Nq, Mo.prototype.has = Bq, Mo.prototype.set = Tq;
        function Ft(M) {
          var n = -1, c = M == null ? 0 : M.length;
          for (this.clear(); ++n < c; ) {
            var O = M[n];
            this.set(O[0], O[1]);
          }
        }
        function wq() {
          this.__data__ = [], this.size = 0;
        }
        function Sq(M) {
          var n = this.__data__, c = Nn(n, M);
          if (c < 0)
            return !1;
          var O = n.length - 1;
          return c == O ? n.pop() : mn.call(n, c, 1), --this.size, !0;
        }
        function Dq(M) {
          var n = this.__data__, c = Nn(n, M);
          return c < 0 ? e : n[c][1];
        }
        function Xq(M) {
          return Nn(this.__data__, M) > -1;
        }
        function Cq(M, n) {
          var c = this.__data__, O = Nn(c, M);
          return O < 0 ? (++this.size, c.push([M, n])) : c[O][1] = n, this;
        }
        Ft.prototype.clear = wq, Ft.prototype.delete = Sq, Ft.prototype.get = Dq, Ft.prototype.has = Xq, Ft.prototype.set = Cq;
        function Ut(M) {
          var n = -1, c = M == null ? 0 : M.length;
          for (this.clear(); ++n < c; ) {
            var O = M[n];
            this.set(O[0], O[1]);
          }
        }
        function Iq() {
          this.size = 0, this.__data__ = {
            hash: new Mo(),
            map: new (jM || Ft)(),
            string: new Mo()
          };
        }
        function Pq(M) {
          var n = xn(this, M).delete(M);
          return this.size -= n ? 1 : 0, n;
        }
        function Eq(M) {
          return xn(this, M).get(M);
        }
        function kq(M) {
          return xn(this, M).has(M);
        }
        function xq(M, n) {
          var c = xn(this, M), O = c.size;
          return c.set(M, n), this.size += c.size == O ? 0 : 1, this;
        }
        Ut.prototype.clear = Iq, Ut.prototype.delete = Pq, Ut.prototype.get = Eq, Ut.prototype.has = kq, Ut.prototype.set = xq;
        function bo(M) {
          var n = -1, c = M == null ? 0 : M.length;
          for (this.__data__ = new Ut(); ++n < c; )
            this.add(M[n]);
        }
        function Fq(M) {
          return this.__data__.set(M, d), this;
        }
        function Uq(M) {
          return this.__data__.has(M);
        }
        bo.prototype.add = bo.prototype.push = Fq, bo.prototype.has = Uq;
        function j2(M) {
          var n = this.__data__ = new Ft(M);
          this.size = n.size;
        }
        function Hq() {
          this.__data__ = new Ft(), this.size = 0;
        }
        function Jq(M) {
          var n = this.__data__, c = n.delete(M);
          return this.size = n.size, c;
        }
        function $q(M) {
          return this.__data__.get(M);
        }
        function Vq(M) {
          return this.__data__.has(M);
        }
        function Yq(M, n) {
          var c = this.__data__;
          if (c instanceof Ft) {
            var O = c.__data__;
            if (!jM || O.length < b - 1)
              return O.push([M, n]), this.size = ++c.size, this;
            c = this.__data__ = new Ut(O);
          }
          return c.set(M, n), this.size = c.size, this;
        }
        j2.prototype.clear = Hq, j2.prototype.delete = Jq, j2.prototype.get = $q, j2.prototype.has = Vq, j2.prototype.set = Yq;
        function es(M, n) {
          var c = B0(M), O = !c && io(M), A = !c && !O && wp(M), l = !c && !O && !A && nM(M), W = c || O || A || l, R = W ? vr(M.length, Mq) : [], _ = R.length;
          for (var x in M)
            (n || p1.call(M, x)) && !(W && // Safari 9 has enumerable `arguments.length` in strict mode.
            (x == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            A && (x == "offset" || x == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            l && (x == "buffer" || x == "byteLength" || x == "byteOffset") || // Skip index properties.
            Vt(x, _))) && R.push(x);
          return R;
        }
        function ts(M) {
          var n = M.length;
          return n ? M[Hr(0, n - 1)] : e;
        }
        function Gq(M, n) {
          return Fn(xe(M), no(n, 0, M.length));
        }
        function Kq(M) {
          return Fn(xe(M));
        }
        function Dr(M, n, c) {
          (c !== e && !et(M[n], c) || c === e && !(n in M)) && Ht(M, n, c);
        }
        function ob(M, n, c) {
          var O = M[n];
          (!(p1.call(M, n) && et(O, c)) || c === e && !(n in M)) && Ht(M, n, c);
        }
        function Nn(M, n) {
          for (var c = M.length; c--; )
            if (et(M[c][0], n))
              return c;
          return -1;
        }
        function Qq(M, n, c, O) {
          return _p(M, function(A, l, W) {
            n(O, A, c(A), W);
          }), O;
        }
        function ps(M, n) {
          return M && ht(n, ce(n), M);
        }
        function Zq(M, n) {
          return M && ht(n, Ue(n), M);
        }
        function Ht(M, n, c) {
          n == "__proto__" && Rn ? Rn(M, n, {
            configurable: !0,
            enumerable: !0,
            value: c,
            writable: !0
          }) : M[n] = c;
        }
        function Xr(M, n) {
          for (var c = -1, O = n.length, A = X(O), l = M == null; ++c < O; )
            A[c] = l ? e : uc(M, n[c]);
          return A;
        }
        function no(M, n, c) {
          return M === M && (c !== e && (M = M <= c ? M : c), n !== e && (M = M >= n ? M : n)), M;
        }
        function L2(M, n, c, O, A, l) {
          var W, R = n & h, _ = n & g, x = n & y;
          if (c && (W = A ? c(M, O, A, l) : c(M)), W !== e)
            return W;
          if (!B1(M))
            return M;
          var F = B0(M);
          if (F) {
            if (W = xf(M), !R)
              return xe(M, W);
          } else {
            var J = he(M), p0 = J == E0 || J == m;
            if (wp(M))
              return Ls(M, R);
            if (J == z0 || J == K1 || p0 && !A) {
              if (W = _ || p0 ? {} : Js(M), !R)
                return _ ? Bf(M, Zq(W, M)) : Nf(M, ps(W, M));
            } else {
              if (!O1[J])
                return A ? M : {};
              W = Ff(M, J, R);
            }
          }
          l || (l = new j2());
          var a0 = l.get(M);
          if (a0)
            return a0;
          l.set(M, W), W3(M) ? M.forEach(function(f0) {
            W.add(L2(f0, n, c, f0, M, l));
          }) : q3(M) && M.forEach(function(f0, k0) {
            W.set(k0, L2(f0, n, c, k0, M, l));
          });
          var q0 = x ? _ ? tc : ec : _ ? Ue : ce, X0 = F ? e : q0(M);
          return R2(X0 || M, function(f0, k0) {
            X0 && (k0 = f0, f0 = M[k0]), ob(W, k0, L2(f0, n, c, k0, M, l));
          }), W;
        }
        function jq(M) {
          var n = ce(M);
          return function(c) {
            return os(c, M, n);
          };
        }
        function os(M, n, c) {
          var O = c.length;
          if (M == null)
            return !O;
          for (M = r1(M); O--; ) {
            var A = c[O], l = n[A], W = M[A];
            if (W === e && !(A in M) || !l(W))
              return !1;
          }
          return !0;
        }
        function Ms(M, n, c) {
          if (typeof M != "function")
            throw new y2(i);
          return ib(function() {
            M.apply(e, c);
          }, n);
        }
        function Mb(M, n, c, O) {
          var A = -1, l = On, W = !0, R = M.length, _ = [], x = n.length;
          if (!R)
            return _;
          c && (n = R1(n, p2(c))), O ? (l = hr, W = !1) : n.length >= b && (l = QM, W = !1, n = new bo(n));
          e:
            for (; ++A < R; ) {
              var F = M[A], J = c == null ? F : c(F);
              if (F = O || F !== 0 ? F : 0, W && J === J) {
                for (var p0 = x; p0--; )
                  if (n[p0] === J)
                    continue e;
                _.push(F);
              } else l(n, J, O) || _.push(F);
            }
          return _;
        }
        var _p = Ts(Wt), bs = Ts(Ir, !0);
        function ef(M, n) {
          var c = !0;
          return _p(M, function(O, A, l) {
            return c = !!n(O, A, l), c;
          }), c;
        }
        function Bn(M, n, c) {
          for (var O = -1, A = M.length; ++O < A; ) {
            var l = M[O], W = n(l);
            if (W != null && (R === e ? W === W && !M2(W) : c(W, R)))
              var R = W, _ = l;
          }
          return _;
        }
        function tf(M, n, c, O) {
          var A = M.length;
          for (c = S0(c), c < 0 && (c = -c > A ? 0 : A + c), O = O === e || O > A ? A : S0(O), O < 0 && (O += A), O = c > O ? 0 : m3(O); c < O; )
            M[c++] = n;
          return M;
        }
        function ns(M, n) {
          var c = [];
          return _p(M, function(O, A, l) {
            n(O, A, l) && c.push(O);
          }), c;
        }
        function Oe(M, n, c, O, A) {
          var l = -1, W = M.length;
          for (c || (c = Hf), A || (A = []); ++l < W; ) {
            var R = M[l];
            n > 0 && c(R) ? n > 1 ? Oe(R, n - 1, c, O, A) : gp(A, R) : O || (A[A.length] = R);
          }
          return A;
        }
        var Cr = ws(), zs = ws(!0);
        function Wt(M, n) {
          return M && Cr(M, n, ce);
        }
        function Ir(M, n) {
          return M && zs(M, n, ce);
        }
        function Tn(M, n) {
          return yp(n, function(c) {
            return Yt(M[c]);
          });
        }
        function zo(M, n) {
          n = Bp(n, M);
          for (var c = 0, O = n.length; M != null && c < O; )
            M = M[mt(n[c++])];
          return c && c == O ? M : e;
        }
        function rs(M, n, c) {
          var O = n(M);
          return B0(M) ? O : gp(O, c(M));
        }
        function Be(M) {
          return M == null ? M === e ? fp : G : oo && oo in r1(M) ? Pf(M) : Qf(M);
        }
        function Pr(M, n) {
          return M > n;
        }
        function pf(M, n) {
          return M != null && p1.call(M, n);
        }
        function of(M, n) {
          return M != null && n in r1(M);
        }
        function Mf(M, n, c) {
          return M >= We(n, c) && M < Me(n, c);
        }
        function Er(M, n, c) {
          for (var O = c ? hr : On, A = M[0].length, l = M.length, W = l, R = X(l), _ = 1 / 0, x = []; W--; ) {
            var F = M[W];
            W && n && (F = R1(F, p2(n))), _ = We(F.length, _), R[W] = !c && (n || A >= 120 && F.length >= 120) ? new bo(W && F) : e;
          }
          F = M[0];
          var J = -1, p0 = R[0];
          e:
            for (; ++J < A && x.length < _; ) {
              var a0 = F[J], q0 = n ? n(a0) : a0;
              if (a0 = c || a0 !== 0 ? a0 : 0, !(p0 ? QM(p0, q0) : O(x, q0, c))) {
                for (W = l; --W; ) {
                  var X0 = R[W];
                  if (!(X0 ? QM(X0, q0) : O(M[W], q0, c)))
                    continue e;
                }
                p0 && p0.push(q0), x.push(a0);
              }
            }
          return x;
        }
        function bf(M, n, c, O) {
          return Wt(M, function(A, l, W) {
            n(O, c(A), l, W);
          }), O;
        }
        function bb(M, n, c) {
          n = Bp(n, M), M = Gs(M, n);
          var O = M == null ? M : M[mt(_2(n))];
          return O == null ? e : t2(O, M, c);
        }
        function cs(M) {
          return P1(M) && Be(M) == K1;
        }
        function nf(M) {
          return P1(M) && Be(M) == Wp;
        }
        function zf(M) {
          return P1(M) && Be(M) == a1;
        }
        function nb(M, n, c, O, A) {
          return M === n ? !0 : M == null || n == null || !P1(M) && !P1(n) ? M !== M && n !== n : rf(M, n, c, O, nb, A);
        }
        function rf(M, n, c, O, A, l) {
          var W = B0(M), R = B0(n), _ = W ? d1 : he(M), x = R ? d1 : he(n);
          _ = _ == K1 ? z0 : _, x = x == K1 ? z0 : x;
          var F = _ == z0, J = x == z0, p0 = _ == x;
          if (p0 && wp(M)) {
            if (!wp(n))
              return !1;
            W = !0, F = !1;
          }
          if (p0 && !F)
            return l || (l = new j2()), W || nM(M) ? Fs(M, n, c, O, A, l) : Cf(M, n, _, c, O, A, l);
          if (!(c & w)) {
            var a0 = F && p1.call(M, "__wrapped__"), q0 = J && p1.call(n, "__wrapped__");
            if (a0 || q0) {
              var X0 = a0 ? M.value() : M, f0 = q0 ? n.value() : n;
              return l || (l = new j2()), A(X0, f0, c, O, l);
            }
          }
          return p0 ? (l || (l = new j2()), If(M, n, c, O, A, l)) : !1;
        }
        function cf(M) {
          return P1(M) && he(M) == I;
        }
        function kr(M, n, c, O) {
          var A = c.length, l = A, W = !O;
          if (M == null)
            return !l;
          for (M = r1(M); A--; ) {
            var R = c[A];
            if (W && R[2] ? R[1] !== M[R[0]] : !(R[0] in M))
              return !1;
          }
          for (; ++A < l; ) {
            R = c[A];
            var _ = R[0], x = M[_], F = R[1];
            if (W && R[2]) {
              if (x === e && !(_ in M))
                return !1;
            } else {
              var J = new j2();
              if (O)
                var p0 = O(x, F, _, M, n, J);
              if (!(p0 === e ? nb(F, x, w | U, O, J) : p0))
                return !1;
            }
          }
          return !0;
        }
        function is(M) {
          if (!B1(M) || $f(M))
            return !1;
          var n = Yt(M) ? cq : Rp;
          return n.test(co(M));
        }
        function af(M) {
          return P1(M) && Be(M) == _0;
        }
        function Of(M) {
          return P1(M) && he(M) == g0;
        }
        function sf(M) {
          return P1(M) && Yn(M.length) && !!l1[Be(M)];
        }
        function as(M) {
          return typeof M == "function" ? M : M == null ? He : typeof M == "object" ? B0(M) ? As(M[0], M[1]) : ss(M) : S3(M);
        }
        function xr(M) {
          if (!cb(M))
            return uq(M);
          var n = [];
          for (var c in r1(M))
            p1.call(M, c) && c != "constructor" && n.push(c);
          return n;
        }
        function Af(M) {
          if (!B1(M))
            return Kf(M);
          var n = cb(M), c = [];
          for (var O in M)
            O == "constructor" && (n || !p1.call(M, O)) || c.push(O);
          return c;
        }
        function Fr(M, n) {
          return M < n;
        }
        function Os(M, n) {
          var c = -1, O = Fe(M) ? X(M.length) : [];
          return _p(M, function(A, l, W) {
            O[++c] = n(A, l, W);
          }), O;
        }
        function ss(M) {
          var n = oc(M);
          return n.length == 1 && n[0][2] ? Vs(n[0][0], n[0][1]) : function(c) {
            return c === M || kr(c, M, n);
          };
        }
        function As(M, n) {
          return bc(M) && $s(n) ? Vs(mt(M), n) : function(c) {
            var O = uc(c, M);
            return O === e && O === n ? dc(c, M) : nb(n, O, w | U);
          };
        }
        function wn(M, n, c, O, A) {
          M !== n && Cr(n, function(l, W) {
            if (A || (A = new j2()), B1(l))
              uf(M, n, W, c, wn, O, A);
            else {
              var R = O ? O(zc(M, W), l, W + "", M, n, A) : e;
              R === e && (R = l), Dr(M, W, R);
            }
          }, Ue);
        }
        function uf(M, n, c, O, A, l, W) {
          var R = zc(M, c), _ = zc(n, c), x = W.get(_);
          if (x) {
            Dr(M, c, x);
            return;
          }
          var F = l ? l(R, _, c + "", M, n, W) : e, J = F === e;
          if (J) {
            var p0 = B0(_), a0 = !p0 && wp(_), q0 = !p0 && !a0 && nM(_);
            F = _, p0 || a0 || q0 ? B0(R) ? F = R : F1(R) ? F = xe(R) : a0 ? (J = !1, F = Ls(_, !0)) : q0 ? (J = !1, F = vs(_, !0)) : F = [] : ab(_) || io(_) ? (F = R, io(R) ? F = R3(R) : (!B1(R) || Yt(R)) && (F = Js(_))) : J = !1;
          }
          J && (W.set(_, F), A(F, _, O, l, W), W.delete(_)), Dr(M, c, F);
        }
        function us(M, n) {
          var c = M.length;
          if (c)
            return n += n < 0 ? c : 0, Vt(n, c) ? M[n] : e;
        }
        function ds(M, n, c) {
          n.length ? n = R1(n, function(l) {
            return B0(l) ? function(W) {
              return zo(W, l.length === 1 ? l[0] : l);
            } : l;
          }) : n = [He];
          var O = -1;
          n = R1(n, p2(l0()));
          var A = Os(M, function(l, W, R) {
            var _ = R1(n, function(x) {
              return x(l);
            });
            return { criteria: _, index: ++O, value: l };
          });
          return x4(A, function(l, W) {
            return _f(l, W, c);
          });
        }
        function df(M, n) {
          return ls(M, n, function(c, O) {
            return dc(M, O);
          });
        }
        function ls(M, n, c) {
          for (var O = -1, A = n.length, l = {}; ++O < A; ) {
            var W = n[O], R = zo(M, W);
            c(R, W) && zb(l, Bp(W, M), R);
          }
          return l;
        }
        function lf(M) {
          return function(n) {
            return zo(n, M);
          };
        }
        function Ur(M, n, c, O) {
          var A = O ? k4 : Go, l = -1, W = n.length, R = M;
          for (M === n && (n = xe(n)), c && (R = R1(M, p2(c))); ++l < W; )
            for (var _ = 0, x = n[l], F = c ? c(x) : x; (_ = A(R, F, _, O)) > -1; )
              R !== M && mn.call(R, _, 1), mn.call(M, _, 1);
          return M;
        }
        function qs(M, n) {
          for (var c = M ? n.length : 0, O = c - 1; c--; ) {
            var A = n[c];
            if (c == O || A !== l) {
              var l = A;
              Vt(A) ? mn.call(M, A, 1) : Vr(M, A);
            }
          }
          return M;
        }
        function Hr(M, n) {
          return M + gn(ZO() * (n - M + 1));
        }
        function qf(M, n, c, O) {
          for (var A = -1, l = Me(yn((n - M) / (c || 1)), 0), W = X(l); l--; )
            W[O ? l : ++A] = M, M += c;
          return W;
        }
        function Jr(M, n) {
          var c = "";
          if (!M || n < 1 || n > W0)
            return c;
          do
            n % 2 && (c += M), n = gn(n / 2), n && (M += M);
          while (n);
          return c;
        }
        function I0(M, n) {
          return rc(Ys(M, n, He), M + "");
        }
        function ff(M) {
          return ts(zM(M));
        }
        function Wf(M, n) {
          var c = zM(M);
          return Fn(c, no(n, 0, c.length));
        }
        function zb(M, n, c, O) {
          if (!B1(M))
            return M;
          n = Bp(n, M);
          for (var A = -1, l = n.length, W = l - 1, R = M; R != null && ++A < l; ) {
            var _ = mt(n[A]), x = c;
            if (_ === "__proto__" || _ === "constructor" || _ === "prototype")
              return M;
            if (A != W) {
              var F = R[_];
              x = O ? O(F, _, R) : e, x === e && (x = B1(F) ? F : Vt(n[A + 1]) ? [] : {});
            }
            ob(R, _, x), R = R[_];
          }
          return M;
        }
        var fs = Ln ? function(M, n) {
          return Ln.set(M, n), M;
        } : He, hf = Rn ? function(M, n) {
          return Rn(M, "toString", {
            configurable: !0,
            enumerable: !1,
            value: qc(n),
            writable: !0
          });
        } : He;
        function mf(M) {
          return Fn(zM(M));
        }
        function v2(M, n, c) {
          var O = -1, A = M.length;
          n < 0 && (n = -n > A ? 0 : A + n), c = c > A ? A : c, c < 0 && (c += A), A = n > c ? 0 : c - n >>> 0, n >>>= 0;
          for (var l = X(A); ++O < A; )
            l[O] = M[O + n];
          return l;
        }
        function Rf(M, n) {
          var c;
          return _p(M, function(O, A, l) {
            return c = n(O, A, l), !c;
          }), !!c;
        }
        function Sn(M, n, c) {
          var O = 0, A = M == null ? O : M.length;
          if (typeof n == "number" && n === n && A <= h2) {
            for (; O < A; ) {
              var l = O + A >>> 1, W = M[l];
              W !== null && !M2(W) && (c ? W <= n : W < n) ? O = l + 1 : A = l;
            }
            return A;
          }
          return $r(M, n, He, c);
        }
        function $r(M, n, c, O) {
          var A = 0, l = M == null ? 0 : M.length;
          if (l === 0)
            return 0;
          n = c(n);
          for (var W = n !== n, R = n === null, _ = M2(n), x = n === e; A < l; ) {
            var F = gn((A + l) / 2), J = c(M[F]), p0 = J !== e, a0 = J === null, q0 = J === J, X0 = M2(J);
            if (W)
              var f0 = O || q0;
            else x ? f0 = q0 && (O || p0) : R ? f0 = q0 && p0 && (O || !a0) : _ ? f0 = q0 && p0 && !a0 && (O || !X0) : a0 || X0 ? f0 = !1 : f0 = O ? J <= n : J < n;
            f0 ? A = F + 1 : l = F;
          }
          return We(l, W2);
        }
        function Ws(M, n) {
          for (var c = -1, O = M.length, A = 0, l = []; ++c < O; ) {
            var W = M[c], R = n ? n(W) : W;
            if (!c || !et(R, _)) {
              var _ = R;
              l[A++] = W === 0 ? 0 : W;
            }
          }
          return l;
        }
        function hs(M) {
          return typeof M == "number" ? M : M2(M) ? fe : +M;
        }
        function o2(M) {
          if (typeof M == "string")
            return M;
          if (B0(M))
            return R1(M, o2) + "";
          if (M2(M))
            return jO ? jO.call(M) : "";
          var n = M + "";
          return n == "0" && 1 / M == -pe ? "-0" : n;
        }
        function Np(M, n, c) {
          var O = -1, A = On, l = M.length, W = !0, R = [], _ = R;
          if (c)
            W = !1, A = hr;
          else if (l >= b) {
            var x = n ? null : Df(M);
            if (x)
              return An(x);
            W = !1, A = QM, _ = new bo();
          } else
            _ = n ? [] : R;
          e:
            for (; ++O < l; ) {
              var F = M[O], J = n ? n(F) : F;
              if (F = c || F !== 0 ? F : 0, W && J === J) {
                for (var p0 = _.length; p0--; )
                  if (_[p0] === J)
                    continue e;
                n && _.push(J), R.push(F);
              } else A(_, J, c) || (_ !== R && _.push(J), R.push(F));
            }
          return R;
        }
        function Vr(M, n) {
          return n = Bp(n, M), M = Gs(M, n), M == null || delete M[mt(_2(n))];
        }
        function ms(M, n, c, O) {
          return zb(M, n, c(zo(M, n)), O);
        }
        function Dn(M, n, c, O) {
          for (var A = M.length, l = O ? A : -1; (O ? l-- : ++l < A) && n(M[l], l, M); )
            ;
          return c ? v2(M, O ? 0 : l, O ? l + 1 : A) : v2(M, O ? l + 1 : 0, O ? A : l);
        }
        function Rs(M, n) {
          var c = M;
          return c instanceof F0 && (c = c.value()), mr(n, function(O, A) {
            return A.func.apply(A.thisArg, gp([O], A.args));
          }, c);
        }
        function Yr(M, n, c) {
          var O = M.length;
          if (O < 2)
            return O ? Np(M[0]) : [];
          for (var A = -1, l = X(O); ++A < O; )
            for (var W = M[A], R = -1; ++R < O; )
              R != A && (l[A] = Mb(l[A] || W, M[R], n, c));
          return Np(Oe(l, 1), n, c);
        }
        function ys(M, n, c) {
          for (var O = -1, A = M.length, l = n.length, W = {}; ++O < A; ) {
            var R = O < l ? n[O] : e;
            c(W, M[O], R);
          }
          return W;
        }
        function Gr(M) {
          return F1(M) ? M : [];
        }
        function Kr(M) {
          return typeof M == "function" ? M : He;
        }
        function Bp(M, n) {
          return B0(M) ? M : bc(M, n) ? [M] : js(e1(M));
        }
        var yf = I0;
        function Tp(M, n, c) {
          var O = M.length;
          return c = c === e ? O : c, !n && c >= O ? M : v2(M, n, c);
        }
        var gs = iq || function(M) {
          return ae.clearTimeout(M);
        };
        function Ls(M, n) {
          if (n)
            return M.slice();
          var c = M.length, O = VO ? VO(c) : new M.constructor(c);
          return M.copy(O), O;
        }
        function Qr(M) {
          var n = new M.constructor(M.byteLength);
          return new Wn(n).set(new Wn(M)), n;
        }
        function gf(M, n) {
          var c = n ? Qr(M.buffer) : M.buffer;
          return new M.constructor(c, M.byteOffset, M.byteLength);
        }
        function Lf(M) {
          var n = new M.constructor(M.source, GM.exec(M));
          return n.lastIndex = M.lastIndex, n;
        }
        function vf(M) {
          return pb ? r1(pb.call(M)) : {};
        }
        function vs(M, n) {
          var c = n ? Qr(M.buffer) : M.buffer;
          return new M.constructor(c, M.byteOffset, M.length);
        }
        function _s(M, n) {
          if (M !== n) {
            var c = M !== e, O = M === null, A = M === M, l = M2(M), W = n !== e, R = n === null, _ = n === n, x = M2(n);
            if (!R && !x && !l && M > n || l && W && _ && !R && !x || O && W && _ || !c && _ || !A)
              return 1;
            if (!O && !l && !x && M < n || x && c && A && !O && !l || R && c && A || !W && A || !_)
              return -1;
          }
          return 0;
        }
        function _f(M, n, c) {
          for (var O = -1, A = M.criteria, l = n.criteria, W = A.length, R = c.length; ++O < W; ) {
            var _ = _s(A[O], l[O]);
            if (_) {
              if (O >= R)
                return _;
              var x = c[O];
              return _ * (x == "desc" ? -1 : 1);
            }
          }
          return M.index - n.index;
        }
        function Ns(M, n, c, O) {
          for (var A = -1, l = M.length, W = c.length, R = -1, _ = n.length, x = Me(l - W, 0), F = X(_ + x), J = !O; ++R < _; )
            F[R] = n[R];
          for (; ++A < W; )
            (J || A < l) && (F[c[A]] = M[A]);
          for (; x--; )
            F[R++] = M[A++];
          return F;
        }
        function Bs(M, n, c, O) {
          for (var A = -1, l = M.length, W = -1, R = c.length, _ = -1, x = n.length, F = Me(l - R, 0), J = X(F + x), p0 = !O; ++A < F; )
            J[A] = M[A];
          for (var a0 = A; ++_ < x; )
            J[a0 + _] = n[_];
          for (; ++W < R; )
            (p0 || A < l) && (J[a0 + c[W]] = M[A++]);
          return J;
        }
        function xe(M, n) {
          var c = -1, O = M.length;
          for (n || (n = X(O)); ++c < O; )
            n[c] = M[c];
          return n;
        }
        function ht(M, n, c, O) {
          var A = !c;
          c || (c = {});
          for (var l = -1, W = n.length; ++l < W; ) {
            var R = n[l], _ = O ? O(c[R], M[R], R, c, M) : e;
            _ === e && (_ = M[R]), A ? Ht(c, R, _) : ob(c, R, _);
          }
          return c;
        }
        function Nf(M, n) {
          return ht(M, Mc(M), n);
        }
        function Bf(M, n) {
          return ht(M, Us(M), n);
        }
        function Xn(M, n) {
          return function(c, O) {
            var A = B0(c) ? D4 : Qq, l = n ? n() : {};
            return A(c, M, l0(O, 2), l);
          };
        }
        function oM(M) {
          return I0(function(n, c) {
            var O = -1, A = c.length, l = A > 1 ? c[A - 1] : e, W = A > 2 ? c[2] : e;
            for (l = M.length > 3 && typeof l == "function" ? (A--, l) : e, W && Te(c[0], c[1], W) && (l = A < 3 ? e : l, A = 1), n = r1(n); ++O < A; ) {
              var R = c[O];
              R && M(n, R, O, l);
            }
            return n;
          });
        }
        function Ts(M, n) {
          return function(c, O) {
            if (c == null)
              return c;
            if (!Fe(c))
              return M(c, O);
            for (var A = c.length, l = n ? A : -1, W = r1(c); (n ? l-- : ++l < A) && O(W[l], l, W) !== !1; )
              ;
            return c;
          };
        }
        function ws(M) {
          return function(n, c, O) {
            for (var A = -1, l = r1(n), W = O(n), R = W.length; R--; ) {
              var _ = W[M ? R : ++A];
              if (c(l[_], _, l) === !1)
                break;
            }
            return n;
          };
        }
        function Tf(M, n, c) {
          var O = n & N, A = rb(M);
          function l() {
            var W = this && this !== ae && this instanceof l ? A : M;
            return W.apply(O ? c : this, arguments);
          }
          return l;
        }
        function Ss(M) {
          return function(n) {
            n = e1(n);
            var c = Ko(n) ? Z2(n) : e, O = c ? c[0] : n.charAt(0), A = c ? Tp(c, 1).join("") : n.slice(1);
            return O[M]() + A;
          };
        }
        function MM(M) {
          return function(n) {
            return mr(T3(B3(n).replace(W4, "")), M, "");
          };
        }
        function rb(M) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new M();
              case 1:
                return new M(n[0]);
              case 2:
                return new M(n[0], n[1]);
              case 3:
                return new M(n[0], n[1], n[2]);
              case 4:
                return new M(n[0], n[1], n[2], n[3]);
              case 5:
                return new M(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new M(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new M(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var c = pM(M.prototype), O = M.apply(c, n);
            return B1(O) ? O : c;
          };
        }
        function wf(M, n, c) {
          var O = rb(M);
          function A() {
            for (var l = arguments.length, W = X(l), R = l, _ = bM(A); R--; )
              W[R] = arguments[R];
            var x = l < 3 && W[0] !== _ && W[l - 1] !== _ ? [] : Lp(W, _);
            if (l -= x.length, l < c)
              return Ps(
                M,
                n,
                Cn,
                A.placeholder,
                e,
                W,
                x,
                e,
                e,
                c - l
              );
            var F = this && this !== ae && this instanceof A ? O : M;
            return t2(F, this, W);
          }
          return A;
        }
        function Ds(M) {
          return function(n, c, O) {
            var A = r1(n);
            if (!Fe(n)) {
              var l = l0(c, 3);
              n = ce(n), c = function(R) {
                return l(A[R], R, A);
              };
            }
            var W = M(n, c, O);
            return W > -1 ? A[l ? n[W] : W] : e;
          };
        }
        function Xs(M) {
          return $t(function(n) {
            var c = n.length, O = c, A = g2.prototype.thru;
            for (M && n.reverse(); O--; ) {
              var l = n[O];
              if (typeof l != "function")
                throw new y2(i);
              if (A && !W && kn(l) == "wrapper")
                var W = new g2([], !0);
            }
            for (O = W ? O : c; ++O < c; ) {
              l = n[O];
              var R = kn(l), _ = R == "wrapper" ? pc(l) : e;
              _ && nc(_[0]) && _[1] == (j | V | Y | b0) && !_[4].length && _[9] == 1 ? W = W[kn(_[0])].apply(W, _[3]) : W = l.length == 1 && nc(l) ? W[R]() : W.thru(l);
            }
            return function() {
              var x = arguments, F = x[0];
              if (W && x.length == 1 && B0(F))
                return W.plant(F).value();
              for (var J = 0, p0 = c ? n[J].apply(this, x) : F; ++J < c; )
                p0 = n[J].call(this, p0);
              return p0;
            };
          });
        }
        function Cn(M, n, c, O, A, l, W, R, _, x) {
          var F = n & j, J = n & N, p0 = n & S, a0 = n & (V | H), q0 = n & y0, X0 = p0 ? e : rb(M);
          function f0() {
            for (var k0 = arguments.length, H0 = X(k0), b2 = k0; b2--; )
              H0[b2] = arguments[b2];
            if (a0)
              var we = bM(f0), n2 = U4(H0, we);
            if (O && (H0 = Ns(H0, O, A, a0)), l && (H0 = Bs(H0, l, W, a0)), k0 -= n2, a0 && k0 < x) {
              var U1 = Lp(H0, we);
              return Ps(
                M,
                n,
                Cn,
                f0.placeholder,
                c,
                H0,
                U1,
                R,
                _,
                x - k0
              );
            }
            var tt = J ? c : this, Kt = p0 ? tt[M] : M;
            return k0 = H0.length, R ? H0 = Zf(H0, R) : q0 && k0 > 1 && H0.reverse(), F && _ < k0 && (H0.length = _), this && this !== ae && this instanceof f0 && (Kt = X0 || rb(Kt)), Kt.apply(tt, H0);
          }
          return f0;
        }
        function Cs(M, n) {
          return function(c, O) {
            return bf(c, M, n(O), {});
          };
        }
        function In(M, n) {
          return function(c, O) {
            var A;
            if (c === e && O === e)
              return n;
            if (c !== e && (A = c), O !== e) {
              if (A === e)
                return O;
              typeof c == "string" || typeof O == "string" ? (c = o2(c), O = o2(O)) : (c = hs(c), O = hs(O)), A = M(c, O);
            }
            return A;
          };
        }
        function Zr(M) {
          return $t(function(n) {
            return n = R1(n, p2(l0())), I0(function(c) {
              var O = this;
              return M(n, function(A) {
                return t2(A, O, c);
              });
            });
          });
        }
        function Pn(M, n) {
          n = n === e ? " " : o2(n);
          var c = n.length;
          if (c < 2)
            return c ? Jr(n, M) : n;
          var O = Jr(n, yn(M / Qo(n)));
          return Ko(n) ? Tp(Z2(O), 0, M).join("") : O.slice(0, M);
        }
        function Sf(M, n, c, O) {
          var A = n & N, l = rb(M);
          function W() {
            for (var R = -1, _ = arguments.length, x = -1, F = O.length, J = X(F + _), p0 = this && this !== ae && this instanceof W ? l : M; ++x < F; )
              J[x] = O[x];
            for (; _--; )
              J[x++] = arguments[++R];
            return t2(p0, A ? c : this, J);
          }
          return W;
        }
        function Is(M) {
          return function(n, c, O) {
            return O && typeof O != "number" && Te(n, c, O) && (c = O = e), n = Gt(n), c === e ? (c = n, n = 0) : c = Gt(c), O = O === e ? n < c ? 1 : -1 : Gt(O), qf(n, c, O, M);
          };
        }
        function En(M) {
          return function(n, c) {
            return typeof n == "string" && typeof c == "string" || (n = N2(n), c = N2(c)), M(n, c);
          };
        }
        function Ps(M, n, c, O, A, l, W, R, _, x) {
          var F = n & V, J = F ? W : e, p0 = F ? e : W, a0 = F ? l : e, q0 = F ? e : l;
          n |= F ? Y : t0, n &= ~(F ? t0 : Y), n & D || (n &= -4);
          var X0 = [
            M,
            n,
            A,
            a0,
            J,
            q0,
            p0,
            R,
            _,
            x
          ], f0 = c.apply(e, X0);
          return nc(M) && Ks(f0, X0), f0.placeholder = O, Qs(f0, M, n);
        }
        function jr(M) {
          var n = oe[M];
          return function(c, O) {
            if (c = N2(c), O = O == null ? 0 : We(S0(O), 292), O && QO(c)) {
              var A = (e1(c) + "e").split("e"), l = n(A[0] + "e" + (+A[1] + O));
              return A = (e1(l) + "e").split("e"), +(A[0] + "e" + (+A[1] - O));
            }
            return n(c);
          };
        }
        var Df = eM && 1 / An(new eM([, -0]))[1] == pe ? function(M) {
          return new eM(M);
        } : hc;
        function Es(M) {
          return function(n) {
            var c = he(n);
            return c == I ? Nr(n) : c == g0 ? K4(n) : F4(n, M(n));
          };
        }
        function Jt(M, n, c, O, A, l, W, R) {
          var _ = n & S;
          if (!_ && typeof M != "function")
            throw new y2(i);
          var x = O ? O.length : 0;
          if (x || (n &= -97, O = A = e), W = W === e ? W : Me(S0(W), 0), R = R === e ? R : S0(R), x -= A ? A.length : 0, n & t0) {
            var F = O, J = A;
            O = A = e;
          }
          var p0 = _ ? e : pc(M), a0 = [
            M,
            n,
            c,
            O,
            A,
            F,
            J,
            l,
            W,
            R
          ];
          if (p0 && Gf(a0, p0), M = a0[0], n = a0[1], c = a0[2], O = a0[3], A = a0[4], R = a0[9] = a0[9] === e ? _ ? 0 : M.length : Me(a0[9] - x, 0), !R && n & (V | H) && (n &= -25), !n || n == N)
            var q0 = Tf(M, n, c);
          else n == V || n == H ? q0 = wf(M, n, R) : (n == Y || n == (N | Y)) && !A.length ? q0 = Sf(M, n, c, O) : q0 = Cn.apply(e, a0);
          var X0 = p0 ? fs : Ks;
          return Qs(X0(q0, a0), M, n);
        }
        function ks(M, n, c, O) {
          return M === e || et(M, jo[c]) && !p1.call(O, c) ? n : M;
        }
        function xs(M, n, c, O, A, l) {
          return B1(M) && B1(n) && (l.set(n, M), wn(M, n, e, xs, l), l.delete(n)), M;
        }
        function Xf(M) {
          return ab(M) ? e : M;
        }
        function Fs(M, n, c, O, A, l) {
          var W = c & w, R = M.length, _ = n.length;
          if (R != _ && !(W && _ > R))
            return !1;
          var x = l.get(M), F = l.get(n);
          if (x && F)
            return x == n && F == M;
          var J = -1, p0 = !0, a0 = c & U ? new bo() : e;
          for (l.set(M, n), l.set(n, M); ++J < R; ) {
            var q0 = M[J], X0 = n[J];
            if (O)
              var f0 = W ? O(X0, q0, J, n, M, l) : O(q0, X0, J, M, n, l);
            if (f0 !== e) {
              if (f0)
                continue;
              p0 = !1;
              break;
            }
            if (a0) {
              if (!Rr(n, function(k0, H0) {
                if (!QM(a0, H0) && (q0 === k0 || A(q0, k0, c, O, l)))
                  return a0.push(H0);
              })) {
                p0 = !1;
                break;
              }
            } else if (!(q0 === X0 || A(q0, X0, c, O, l))) {
              p0 = !1;
              break;
            }
          }
          return l.delete(M), l.delete(n), p0;
        }
        function Cf(M, n, c, O, A, l, W) {
          switch (c) {
            case hp:
              if (M.byteLength != n.byteLength || M.byteOffset != n.byteOffset)
                return !1;
              M = M.buffer, n = n.buffer;
            case Wp:
              return !(M.byteLength != n.byteLength || !l(new Wn(M), new Wn(n)));
            case i1:
            case a1:
            case E:
              return et(+M, +n);
            case o1:
              return M.name == n.name && M.message == n.message;
            case _0:
            case je:
              return M == n + "";
            case I:
              var R = Nr;
            case g0:
              var _ = O & w;
              if (R || (R = An), M.size != n.size && !_)
                return !1;
              var x = W.get(M);
              if (x)
                return x == n;
              O |= U, W.set(M, n);
              var F = Fs(R(M), R(n), O, A, l, W);
              return W.delete(M), F;
            case K2:
              if (pb)
                return pb.call(M) == pb.call(n);
          }
          return !1;
        }
        function If(M, n, c, O, A, l) {
          var W = c & w, R = ec(M), _ = R.length, x = ec(n), F = x.length;
          if (_ != F && !W)
            return !1;
          for (var J = _; J--; ) {
            var p0 = R[J];
            if (!(W ? p0 in n : p1.call(n, p0)))
              return !1;
          }
          var a0 = l.get(M), q0 = l.get(n);
          if (a0 && q0)
            return a0 == n && q0 == M;
          var X0 = !0;
          l.set(M, n), l.set(n, M);
          for (var f0 = W; ++J < _; ) {
            p0 = R[J];
            var k0 = M[p0], H0 = n[p0];
            if (O)
              var b2 = W ? O(H0, k0, p0, n, M, l) : O(k0, H0, p0, M, n, l);
            if (!(b2 === e ? k0 === H0 || A(k0, H0, c, O, l) : b2)) {
              X0 = !1;
              break;
            }
            f0 || (f0 = p0 == "constructor");
          }
          if (X0 && !f0) {
            var we = M.constructor, n2 = n.constructor;
            we != n2 && "constructor" in M && "constructor" in n && !(typeof we == "function" && we instanceof we && typeof n2 == "function" && n2 instanceof n2) && (X0 = !1);
          }
          return l.delete(M), l.delete(n), X0;
        }
        function $t(M) {
          return rc(Ys(M, e, o3), M + "");
        }
        function ec(M) {
          return rs(M, ce, Mc);
        }
        function tc(M) {
          return rs(M, Ue, Us);
        }
        var pc = Ln ? function(M) {
          return Ln.get(M);
        } : hc;
        function kn(M) {
          for (var n = M.name + "", c = tM[n], O = p1.call(tM, n) ? c.length : 0; O--; ) {
            var A = c[O], l = A.func;
            if (l == null || l == M)
              return A.name;
          }
          return n;
        }
        function bM(M) {
          var n = p1.call(u, "placeholder") ? u : M;
          return n.placeholder;
        }
        function l0() {
          var M = u.iteratee || fc;
          return M = M === fc ? as : M, arguments.length ? M(arguments[0], arguments[1]) : M;
        }
        function xn(M, n) {
          var c = M.__data__;
          return Jf(n) ? c[typeof n == "string" ? "string" : "hash"] : c.map;
        }
        function oc(M) {
          for (var n = ce(M), c = n.length; c--; ) {
            var O = n[c], A = M[O];
            n[c] = [O, A, $s(A)];
          }
          return n;
        }
        function ro(M, n) {
          var c = V4(M, n);
          return is(c) ? c : e;
        }
        function Pf(M) {
          var n = p1.call(M, oo), c = M[oo];
          try {
            M[oo] = e;
            var O = !0;
          } catch {
          }
          var A = qn.call(M);
          return O && (n ? M[oo] = c : delete M[oo]), A;
        }
        var Mc = Tr ? function(M) {
          return M == null ? [] : (M = r1(M), yp(Tr(M), function(n) {
            return GO.call(M, n);
          }));
        } : mc, Us = Tr ? function(M) {
          for (var n = []; M; )
            gp(n, Mc(M)), M = hn(M);
          return n;
        } : mc, he = Be;
        (wr && he(new wr(new ArrayBuffer(1))) != hp || jM && he(new jM()) != I || Sr && he(Sr.resolve()) != h0 || eM && he(new eM()) != g0 || eb && he(new eb()) != Qp) && (he = function(M) {
          var n = Be(M), c = n == z0 ? M.constructor : e, O = c ? co(c) : "";
          if (O)
            switch (O) {
              case fq:
                return hp;
              case Wq:
                return I;
              case hq:
                return h0;
              case mq:
                return g0;
              case Rq:
                return Qp;
            }
          return n;
        });
        function Ef(M, n, c) {
          for (var O = -1, A = c.length; ++O < A; ) {
            var l = c[O], W = l.size;
            switch (l.type) {
              case "drop":
                M += W;
                break;
              case "dropRight":
                n -= W;
                break;
              case "take":
                n = We(n, M + W);
                break;
              case "takeRight":
                M = Me(M, n - W);
                break;
            }
          }
          return { start: M, end: n };
        }
        function kf(M) {
          var n = M.match($M);
          return n ? n[1].split(Mn) : [];
        }
        function Hs(M, n, c) {
          n = Bp(n, M);
          for (var O = -1, A = n.length, l = !1; ++O < A; ) {
            var W = mt(n[O]);
            if (!(l = M != null && c(M, W)))
              break;
            M = M[W];
          }
          return l || ++O != A ? l : (A = M == null ? 0 : M.length, !!A && Yn(A) && Vt(W, A) && (B0(M) || io(M)));
        }
        function xf(M) {
          var n = M.length, c = new M.constructor(n);
          return n && typeof M[0] == "string" && p1.call(M, "index") && (c.index = M.index, c.input = M.input), c;
        }
        function Js(M) {
          return typeof M.constructor == "function" && !cb(M) ? pM(hn(M)) : {};
        }
        function Ff(M, n, c) {
          var O = M.constructor;
          switch (n) {
            case Wp:
              return Qr(M);
            case i1:
            case a1:
              return new O(+M);
            case hp:
              return gf(M, c);
            case Et:
            case Zp:
            case Ho:
            case FM:
            case UM:
            case jp:
            case mp:
            case B:
            case T:
              return vs(M, c);
            case I:
              return new O();
            case E:
            case je:
              return new O(M);
            case _0:
              return Lf(M);
            case g0:
              return new O();
            case K2:
              return vf(M);
          }
        }
        function Uf(M, n) {
          var c = n.length;
          if (!c)
            return M;
          var O = c - 1;
          return n[O] = (c > 1 ? "& " : "") + n[O], n = n.join(c > 2 ? ", " : " "), M.replace(JM, `{
/* [wrapped with ` + n + `] */
`);
        }
        function Hf(M) {
          return B0(M) || io(M) || !!(KO && M && M[KO]);
        }
        function Vt(M, n) {
          var c = typeof M;
          return n = n ?? W0, !!n && (c == "number" || c != "symbol" && sr.test(M)) && M > -1 && M % 1 == 0 && M < n;
        }
        function Te(M, n, c) {
          if (!B1(c))
            return !1;
          var O = typeof n;
          return (O == "number" ? Fe(c) && Vt(n, c.length) : O == "string" && n in c) ? et(c[n], M) : !1;
        }
        function bc(M, n) {
          if (B0(M))
            return !1;
          var c = typeof M;
          return c == "number" || c == "symbol" || c == "boolean" || M == null || M2(M) ? !0 : pn.test(M) || !e2.test(M) || n != null && M in r1(n);
        }
        function Jf(M) {
          var n = typeof M;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? M !== "__proto__" : M === null;
        }
        function nc(M) {
          var n = kn(M), c = u[n];
          if (typeof c != "function" || !(n in F0.prototype))
            return !1;
          if (M === c)
            return !0;
          var O = pc(c);
          return !!O && M === O[0];
        }
        function $f(M) {
          return !!$O && $O in M;
        }
        var Vf = dn ? Yt : Rc;
        function cb(M) {
          var n = M && M.constructor, c = typeof n == "function" && n.prototype || jo;
          return M === c;
        }
        function $s(M) {
          return M === M && !B1(M);
        }
        function Vs(M, n) {
          return function(c) {
            return c == null ? !1 : c[M] === n && (n !== e || M in r1(c));
          };
        }
        function Yf(M) {
          var n = $n(M, function(O) {
            return c.size === q && c.clear(), O;
          }), c = n.cache;
          return n;
        }
        function Gf(M, n) {
          var c = M[1], O = n[1], A = c | O, l = A < (N | S | j), W = O == j && c == V || O == j && c == b0 && M[7].length <= n[8] || O == (j | b0) && n[7].length <= n[8] && c == V;
          if (!(l || W))
            return M;
          O & N && (M[2] = n[2], A |= c & N ? 0 : D);
          var R = n[3];
          if (R) {
            var _ = M[3];
            M[3] = _ ? Ns(_, R, n[4]) : R, M[4] = _ ? Lp(M[3], f) : n[4];
          }
          return R = n[5], R && (_ = M[5], M[5] = _ ? Bs(_, R, n[6]) : R, M[6] = _ ? Lp(M[5], f) : n[6]), R = n[7], R && (M[7] = R), O & j && (M[8] = M[8] == null ? n[8] : We(M[8], n[8])), M[9] == null && (M[9] = n[9]), M[0] = n[0], M[1] = A, M;
        }
        function Kf(M) {
          var n = [];
          if (M != null)
            for (var c in r1(M))
              n.push(c);
          return n;
        }
        function Qf(M) {
          return qn.call(M);
        }
        function Ys(M, n, c) {
          return n = Me(n === e ? M.length - 1 : n, 0), function() {
            for (var O = arguments, A = -1, l = Me(O.length - n, 0), W = X(l); ++A < l; )
              W[A] = O[n + A];
            A = -1;
            for (var R = X(n + 1); ++A < n; )
              R[A] = O[A];
            return R[n] = c(W), t2(M, this, R);
          };
        }
        function Gs(M, n) {
          return n.length < 2 ? M : zo(M, v2(n, 0, -1));
        }
        function Zf(M, n) {
          for (var c = M.length, O = We(n.length, c), A = xe(M); O--; ) {
            var l = n[O];
            M[O] = Vt(l, c) ? A[l] : e;
          }
          return M;
        }
        function zc(M, n) {
          if (!(n === "constructor" && typeof M[n] == "function") && n != "__proto__")
            return M[n];
        }
        var Ks = Zs(fs), ib = Oq || function(M, n) {
          return ae.setTimeout(M, n);
        }, rc = Zs(hf);
        function Qs(M, n, c) {
          var O = n + "";
          return rc(M, Uf(O, jf(kf(O), c)));
        }
        function Zs(M) {
          var n = 0, c = 0;
          return function() {
            var O = dq(), A = m1 - (O - c);
            if (c = O, A > 0) {
              if (++n >= O0)
                return arguments[0];
            } else
              n = 0;
            return M.apply(e, arguments);
          };
        }
        function Fn(M, n) {
          var c = -1, O = M.length, A = O - 1;
          for (n = n === e ? O : n; ++c < n; ) {
            var l = Hr(c, A), W = M[l];
            M[l] = M[c], M[c] = W;
          }
          return M.length = n, M;
        }
        var js = Yf(function(M) {
          var n = [];
          return M.charCodeAt(0) === 46 && n.push(""), M.replace(on, function(c, O, A, l) {
            n.push(A ? l.replace(nn, "$1") : O || c);
          }), n;
        });
        function mt(M) {
          if (typeof M == "string" || M2(M))
            return M;
          var n = M + "";
          return n == "0" && 1 / M == -pe ? "-0" : n;
        }
        function co(M) {
          if (M != null) {
            try {
              return ln.call(M);
            } catch {
            }
            try {
              return M + "";
            } catch {
            }
          }
          return "";
        }
        function jf(M, n) {
          return R2(ke, function(c) {
            var O = "_." + c[0];
            n & c[1] && !On(M, O) && M.push(O);
          }), M.sort();
        }
        function e3(M) {
          if (M instanceof F0)
            return M.clone();
          var n = new g2(M.__wrapped__, M.__chain__);
          return n.__actions__ = xe(M.__actions__), n.__index__ = M.__index__, n.__values__ = M.__values__, n;
        }
        function e5(M, n, c) {
          (c ? Te(M, n, c) : n === e) ? n = 1 : n = Me(S0(n), 0);
          var O = M == null ? 0 : M.length;
          if (!O || n < 1)
            return [];
          for (var A = 0, l = 0, W = X(yn(O / n)); A < O; )
            W[l++] = v2(M, A, A += n);
          return W;
        }
        function t5(M) {
          for (var n = -1, c = M == null ? 0 : M.length, O = 0, A = []; ++n < c; ) {
            var l = M[n];
            l && (A[O++] = l);
          }
          return A;
        }
        function p5() {
          var M = arguments.length;
          if (!M)
            return [];
          for (var n = X(M - 1), c = arguments[0], O = M; O--; )
            n[O - 1] = arguments[O];
          return gp(B0(c) ? xe(c) : [c], Oe(n, 1));
        }
        var o5 = I0(function(M, n) {
          return F1(M) ? Mb(M, Oe(n, 1, F1, !0)) : [];
        }), M5 = I0(function(M, n) {
          var c = _2(n);
          return F1(c) && (c = e), F1(M) ? Mb(M, Oe(n, 1, F1, !0), l0(c, 2)) : [];
        }), b5 = I0(function(M, n) {
          var c = _2(n);
          return F1(c) && (c = e), F1(M) ? Mb(M, Oe(n, 1, F1, !0), e, c) : [];
        });
        function n5(M, n, c) {
          var O = M == null ? 0 : M.length;
          return O ? (n = c || n === e ? 1 : S0(n), v2(M, n < 0 ? 0 : n, O)) : [];
        }
        function z5(M, n, c) {
          var O = M == null ? 0 : M.length;
          return O ? (n = c || n === e ? 1 : S0(n), n = O - n, v2(M, 0, n < 0 ? 0 : n)) : [];
        }
        function r5(M, n) {
          return M && M.length ? Dn(M, l0(n, 3), !0, !0) : [];
        }
        function c5(M, n) {
          return M && M.length ? Dn(M, l0(n, 3), !0) : [];
        }
        function i5(M, n, c, O) {
          var A = M == null ? 0 : M.length;
          return A ? (c && typeof c != "number" && Te(M, n, c) && (c = 0, O = A), tf(M, n, c, O)) : [];
        }
        function t3(M, n, c) {
          var O = M == null ? 0 : M.length;
          if (!O)
            return -1;
          var A = c == null ? 0 : S0(c);
          return A < 0 && (A = Me(O + A, 0)), sn(M, l0(n, 3), A);
        }
        function p3(M, n, c) {
          var O = M == null ? 0 : M.length;
          if (!O)
            return -1;
          var A = O - 1;
          return c !== e && (A = S0(c), A = c < 0 ? Me(O + A, 0) : We(A, O - 1)), sn(M, l0(n, 3), A, !0);
        }
        function o3(M) {
          var n = M == null ? 0 : M.length;
          return n ? Oe(M, 1) : [];
        }
        function a5(M) {
          var n = M == null ? 0 : M.length;
          return n ? Oe(M, pe) : [];
        }
        function O5(M, n) {
          var c = M == null ? 0 : M.length;
          return c ? (n = n === e ? 1 : S0(n), Oe(M, n)) : [];
        }
        function s5(M) {
          for (var n = -1, c = M == null ? 0 : M.length, O = {}; ++n < c; ) {
            var A = M[n];
            O[A[0]] = A[1];
          }
          return O;
        }
        function M3(M) {
          return M && M.length ? M[0] : e;
        }
        function A5(M, n, c) {
          var O = M == null ? 0 : M.length;
          if (!O)
            return -1;
          var A = c == null ? 0 : S0(c);
          return A < 0 && (A = Me(O + A, 0)), Go(M, n, A);
        }
        function u5(M) {
          var n = M == null ? 0 : M.length;
          return n ? v2(M, 0, -1) : [];
        }
        var d5 = I0(function(M) {
          var n = R1(M, Gr);
          return n.length && n[0] === M[0] ? Er(n) : [];
        }), l5 = I0(function(M) {
          var n = _2(M), c = R1(M, Gr);
          return n === _2(c) ? n = e : c.pop(), c.length && c[0] === M[0] ? Er(c, l0(n, 2)) : [];
        }), q5 = I0(function(M) {
          var n = _2(M), c = R1(M, Gr);
          return n = typeof n == "function" ? n : e, n && c.pop(), c.length && c[0] === M[0] ? Er(c, e, n) : [];
        });
        function f5(M, n) {
          return M == null ? "" : Aq.call(M, n);
        }
        function _2(M) {
          var n = M == null ? 0 : M.length;
          return n ? M[n - 1] : e;
        }
        function W5(M, n, c) {
          var O = M == null ? 0 : M.length;
          if (!O)
            return -1;
          var A = O;
          return c !== e && (A = S0(c), A = A < 0 ? Me(O + A, 0) : We(A, O - 1)), n === n ? Z4(M, n, A) : sn(M, PO, A, !0);
        }
        function h5(M, n) {
          return M && M.length ? us(M, S0(n)) : e;
        }
        var m5 = I0(b3);
        function b3(M, n) {
          return M && M.length && n && n.length ? Ur(M, n) : M;
        }
        function R5(M, n, c) {
          return M && M.length && n && n.length ? Ur(M, n, l0(c, 2)) : M;
        }
        function y5(M, n, c) {
          return M && M.length && n && n.length ? Ur(M, n, e, c) : M;
        }
        var g5 = $t(function(M, n) {
          var c = M == null ? 0 : M.length, O = Xr(M, n);
          return qs(M, R1(n, function(A) {
            return Vt(A, c) ? +A : A;
          }).sort(_s)), O;
        });
        function L5(M, n) {
          var c = [];
          if (!(M && M.length))
            return c;
          var O = -1, A = [], l = M.length;
          for (n = l0(n, 3); ++O < l; ) {
            var W = M[O];
            n(W, O, M) && (c.push(W), A.push(O));
          }
          return qs(M, A), c;
        }
        function cc(M) {
          return M == null ? M : qq.call(M);
        }
        function v5(M, n, c) {
          var O = M == null ? 0 : M.length;
          return O ? (c && typeof c != "number" && Te(M, n, c) ? (n = 0, c = O) : (n = n == null ? 0 : S0(n), c = c === e ? O : S0(c)), v2(M, n, c)) : [];
        }
        function _5(M, n) {
          return Sn(M, n);
        }
        function N5(M, n, c) {
          return $r(M, n, l0(c, 2));
        }
        function B5(M, n) {
          var c = M == null ? 0 : M.length;
          if (c) {
            var O = Sn(M, n);
            if (O < c && et(M[O], n))
              return O;
          }
          return -1;
        }
        function T5(M, n) {
          return Sn(M, n, !0);
        }
        function w5(M, n, c) {
          return $r(M, n, l0(c, 2), !0);
        }
        function S5(M, n) {
          var c = M == null ? 0 : M.length;
          if (c) {
            var O = Sn(M, n, !0) - 1;
            if (et(M[O], n))
              return O;
          }
          return -1;
        }
        function D5(M) {
          return M && M.length ? Ws(M) : [];
        }
        function X5(M, n) {
          return M && M.length ? Ws(M, l0(n, 2)) : [];
        }
        function C5(M) {
          var n = M == null ? 0 : M.length;
          return n ? v2(M, 1, n) : [];
        }
        function I5(M, n, c) {
          return M && M.length ? (n = c || n === e ? 1 : S0(n), v2(M, 0, n < 0 ? 0 : n)) : [];
        }
        function P5(M, n, c) {
          var O = M == null ? 0 : M.length;
          return O ? (n = c || n === e ? 1 : S0(n), n = O - n, v2(M, n < 0 ? 0 : n, O)) : [];
        }
        function E5(M, n) {
          return M && M.length ? Dn(M, l0(n, 3), !1, !0) : [];
        }
        function k5(M, n) {
          return M && M.length ? Dn(M, l0(n, 3)) : [];
        }
        var x5 = I0(function(M) {
          return Np(Oe(M, 1, F1, !0));
        }), F5 = I0(function(M) {
          var n = _2(M);
          return F1(n) && (n = e), Np(Oe(M, 1, F1, !0), l0(n, 2));
        }), U5 = I0(function(M) {
          var n = _2(M);
          return n = typeof n == "function" ? n : e, Np(Oe(M, 1, F1, !0), e, n);
        });
        function H5(M) {
          return M && M.length ? Np(M) : [];
        }
        function J5(M, n) {
          return M && M.length ? Np(M, l0(n, 2)) : [];
        }
        function $5(M, n) {
          return n = typeof n == "function" ? n : e, M && M.length ? Np(M, e, n) : [];
        }
        function ic(M) {
          if (!(M && M.length))
            return [];
          var n = 0;
          return M = yp(M, function(c) {
            if (F1(c))
              return n = Me(c.length, n), !0;
          }), vr(n, function(c) {
            return R1(M, yr(c));
          });
        }
        function n3(M, n) {
          if (!(M && M.length))
            return [];
          var c = ic(M);
          return n == null ? c : R1(c, function(O) {
            return t2(n, e, O);
          });
        }
        var V5 = I0(function(M, n) {
          return F1(M) ? Mb(M, n) : [];
        }), Y5 = I0(function(M) {
          return Yr(yp(M, F1));
        }), G5 = I0(function(M) {
          var n = _2(M);
          return F1(n) && (n = e), Yr(yp(M, F1), l0(n, 2));
        }), K5 = I0(function(M) {
          var n = _2(M);
          return n = typeof n == "function" ? n : e, Yr(yp(M, F1), e, n);
        }), Q5 = I0(ic);
        function Z5(M, n) {
          return ys(M || [], n || [], ob);
        }
        function j5(M, n) {
          return ys(M || [], n || [], zb);
        }
        var eW = I0(function(M) {
          var n = M.length, c = n > 1 ? M[n - 1] : e;
          return c = typeof c == "function" ? (M.pop(), c) : e, n3(M, c);
        });
        function z3(M) {
          var n = u(M);
          return n.__chain__ = !0, n;
        }
        function tW(M, n) {
          return n(M), M;
        }
        function Un(M, n) {
          return n(M);
        }
        var pW = $t(function(M) {
          var n = M.length, c = n ? M[0] : 0, O = this.__wrapped__, A = function(l) {
            return Xr(l, M);
          };
          return n > 1 || this.__actions__.length || !(O instanceof F0) || !Vt(c) ? this.thru(A) : (O = O.slice(c, +c + (n ? 1 : 0)), O.__actions__.push({
            func: Un,
            args: [A],
            thisArg: e
          }), new g2(O, this.__chain__).thru(function(l) {
            return n && !l.length && l.push(e), l;
          }));
        });
        function oW() {
          return z3(this);
        }
        function MW() {
          return new g2(this.value(), this.__chain__);
        }
        function bW() {
          this.__values__ === e && (this.__values__ = h3(this.value()));
          var M = this.__index__ >= this.__values__.length, n = M ? e : this.__values__[this.__index__++];
          return { done: M, value: n };
        }
        function nW() {
          return this;
        }
        function zW(M) {
          for (var n, c = this; c instanceof _n; ) {
            var O = e3(c);
            O.__index__ = 0, O.__values__ = e, n ? A.__wrapped__ = O : n = O;
            var A = O;
            c = c.__wrapped__;
          }
          return A.__wrapped__ = M, n;
        }
        function rW() {
          var M = this.__wrapped__;
          if (M instanceof F0) {
            var n = M;
            return this.__actions__.length && (n = new F0(this)), n = n.reverse(), n.__actions__.push({
              func: Un,
              args: [cc],
              thisArg: e
            }), new g2(n, this.__chain__);
          }
          return this.thru(cc);
        }
        function cW() {
          return Rs(this.__wrapped__, this.__actions__);
        }
        var iW = Xn(function(M, n, c) {
          p1.call(M, c) ? ++M[c] : Ht(M, c, 1);
        });
        function aW(M, n, c) {
          var O = B0(M) ? CO : ef;
          return c && Te(M, n, c) && (n = e), O(M, l0(n, 3));
        }
        function OW(M, n) {
          var c = B0(M) ? yp : ns;
          return c(M, l0(n, 3));
        }
        var sW = Ds(t3), AW = Ds(p3);
        function uW(M, n) {
          return Oe(Hn(M, n), 1);
        }
        function dW(M, n) {
          return Oe(Hn(M, n), pe);
        }
        function lW(M, n, c) {
          return c = c === e ? 1 : S0(c), Oe(Hn(M, n), c);
        }
        function r3(M, n) {
          var c = B0(M) ? R2 : _p;
          return c(M, l0(n, 3));
        }
        function c3(M, n) {
          var c = B0(M) ? X4 : bs;
          return c(M, l0(n, 3));
        }
        var qW = Xn(function(M, n, c) {
          p1.call(M, c) ? M[c].push(n) : Ht(M, c, [n]);
        });
        function fW(M, n, c, O) {
          M = Fe(M) ? M : zM(M), c = c && !O ? S0(c) : 0;
          var A = M.length;
          return c < 0 && (c = Me(A + c, 0)), Gn(M) ? c <= A && M.indexOf(n, c) > -1 : !!A && Go(M, n, c) > -1;
        }
        var WW = I0(function(M, n, c) {
          var O = -1, A = typeof n == "function", l = Fe(M) ? X(M.length) : [];
          return _p(M, function(W) {
            l[++O] = A ? t2(n, W, c) : bb(W, n, c);
          }), l;
        }), hW = Xn(function(M, n, c) {
          Ht(M, c, n);
        });
        function Hn(M, n) {
          var c = B0(M) ? R1 : Os;
          return c(M, l0(n, 3));
        }
        function mW(M, n, c, O) {
          return M == null ? [] : (B0(n) || (n = n == null ? [] : [n]), c = O ? e : c, B0(c) || (c = c == null ? [] : [c]), ds(M, n, c));
        }
        var RW = Xn(function(M, n, c) {
          M[c ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function yW(M, n, c) {
          var O = B0(M) ? mr : kO, A = arguments.length < 3;
          return O(M, l0(n, 4), c, A, _p);
        }
        function gW(M, n, c) {
          var O = B0(M) ? C4 : kO, A = arguments.length < 3;
          return O(M, l0(n, 4), c, A, bs);
        }
        function LW(M, n) {
          var c = B0(M) ? yp : ns;
          return c(M, Vn(l0(n, 3)));
        }
        function vW(M) {
          var n = B0(M) ? ts : ff;
          return n(M);
        }
        function _W(M, n, c) {
          (c ? Te(M, n, c) : n === e) ? n = 1 : n = S0(n);
          var O = B0(M) ? Gq : Wf;
          return O(M, n);
        }
        function NW(M) {
          var n = B0(M) ? Kq : mf;
          return n(M);
        }
        function BW(M) {
          if (M == null)
            return 0;
          if (Fe(M))
            return Gn(M) ? Qo(M) : M.length;
          var n = he(M);
          return n == I || n == g0 ? M.size : xr(M).length;
        }
        function TW(M, n, c) {
          var O = B0(M) ? Rr : Rf;
          return c && Te(M, n, c) && (n = e), O(M, l0(n, 3));
        }
        var wW = I0(function(M, n) {
          if (M == null)
            return [];
          var c = n.length;
          return c > 1 && Te(M, n[0], n[1]) ? n = [] : c > 2 && Te(n[0], n[1], n[2]) && (n = [n[0]]), ds(M, Oe(n, 1), []);
        }), Jn = aq || function() {
          return ae.Date.now();
        };
        function SW(M, n) {
          if (typeof n != "function")
            throw new y2(i);
          return M = S0(M), function() {
            if (--M < 1)
              return n.apply(this, arguments);
          };
        }
        function i3(M, n, c) {
          return n = c ? e : n, n = M && n == null ? M.length : n, Jt(M, j, e, e, e, e, n);
        }
        function a3(M, n) {
          var c;
          if (typeof n != "function")
            throw new y2(i);
          return M = S0(M), function() {
            return --M > 0 && (c = n.apply(this, arguments)), M <= 1 && (n = e), c;
          };
        }
        var ac = I0(function(M, n, c) {
          var O = N;
          if (c.length) {
            var A = Lp(c, bM(ac));
            O |= Y;
          }
          return Jt(M, O, n, c, A);
        }), O3 = I0(function(M, n, c) {
          var O = N | S;
          if (c.length) {
            var A = Lp(c, bM(O3));
            O |= Y;
          }
          return Jt(n, O, M, c, A);
        });
        function s3(M, n, c) {
          n = c ? e : n;
          var O = Jt(M, V, e, e, e, e, e, n);
          return O.placeholder = s3.placeholder, O;
        }
        function A3(M, n, c) {
          n = c ? e : n;
          var O = Jt(M, H, e, e, e, e, e, n);
          return O.placeholder = A3.placeholder, O;
        }
        function u3(M, n, c) {
          var O, A, l, W, R, _, x = 0, F = !1, J = !1, p0 = !0;
          if (typeof M != "function")
            throw new y2(i);
          n = N2(n) || 0, B1(c) && (F = !!c.leading, J = "maxWait" in c, l = J ? Me(N2(c.maxWait) || 0, n) : l, p0 = "trailing" in c ? !!c.trailing : p0);
          function a0(U1) {
            var tt = O, Kt = A;
            return O = A = e, x = U1, W = M.apply(Kt, tt), W;
          }
          function q0(U1) {
            return x = U1, R = ib(k0, n), F ? a0(U1) : W;
          }
          function X0(U1) {
            var tt = U1 - _, Kt = U1 - x, D3 = n - tt;
            return J ? We(D3, l - Kt) : D3;
          }
          function f0(U1) {
            var tt = U1 - _, Kt = U1 - x;
            return _ === e || tt >= n || tt < 0 || J && Kt >= l;
          }
          function k0() {
            var U1 = Jn();
            if (f0(U1))
              return H0(U1);
            R = ib(k0, X0(U1));
          }
          function H0(U1) {
            return R = e, p0 && O ? a0(U1) : (O = A = e, W);
          }
          function b2() {
            R !== e && gs(R), x = 0, O = _ = A = R = e;
          }
          function we() {
            return R === e ? W : H0(Jn());
          }
          function n2() {
            var U1 = Jn(), tt = f0(U1);
            if (O = arguments, A = this, _ = U1, tt) {
              if (R === e)
                return q0(_);
              if (J)
                return gs(R), R = ib(k0, n), a0(_);
            }
            return R === e && (R = ib(k0, n)), W;
          }
          return n2.cancel = b2, n2.flush = we, n2;
        }
        var DW = I0(function(M, n) {
          return Ms(M, 1, n);
        }), XW = I0(function(M, n, c) {
          return Ms(M, N2(n) || 0, c);
        });
        function CW(M) {
          return Jt(M, y0);
        }
        function $n(M, n) {
          if (typeof M != "function" || n != null && typeof n != "function")
            throw new y2(i);
          var c = function() {
            var O = arguments, A = n ? n.apply(this, O) : O[0], l = c.cache;
            if (l.has(A))
              return l.get(A);
            var W = M.apply(this, O);
            return c.cache = l.set(A, W) || l, W;
          };
          return c.cache = new ($n.Cache || Ut)(), c;
        }
        $n.Cache = Ut;
        function Vn(M) {
          if (typeof M != "function")
            throw new y2(i);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !M.call(this);
              case 1:
                return !M.call(this, n[0]);
              case 2:
                return !M.call(this, n[0], n[1]);
              case 3:
                return !M.call(this, n[0], n[1], n[2]);
            }
            return !M.apply(this, n);
          };
        }
        function IW(M) {
          return a3(2, M);
        }
        var PW = yf(function(M, n) {
          n = n.length == 1 && B0(n[0]) ? R1(n[0], p2(l0())) : R1(Oe(n, 1), p2(l0()));
          var c = n.length;
          return I0(function(O) {
            for (var A = -1, l = We(O.length, c); ++A < l; )
              O[A] = n[A].call(this, O[A]);
            return t2(M, this, O);
          });
        }), Oc = I0(function(M, n) {
          var c = Lp(n, bM(Oc));
          return Jt(M, Y, e, n, c);
        }), d3 = I0(function(M, n) {
          var c = Lp(n, bM(d3));
          return Jt(M, t0, e, n, c);
        }), EW = $t(function(M, n) {
          return Jt(M, b0, e, e, e, n);
        });
        function kW(M, n) {
          if (typeof M != "function")
            throw new y2(i);
          return n = n === e ? n : S0(n), I0(M, n);
        }
        function xW(M, n) {
          if (typeof M != "function")
            throw new y2(i);
          return n = n == null ? 0 : Me(S0(n), 0), I0(function(c) {
            var O = c[n], A = Tp(c, 0, n);
            return O && gp(A, O), t2(M, this, A);
          });
        }
        function FW(M, n, c) {
          var O = !0, A = !0;
          if (typeof M != "function")
            throw new y2(i);
          return B1(c) && (O = "leading" in c ? !!c.leading : O, A = "trailing" in c ? !!c.trailing : A), u3(M, n, {
            leading: O,
            maxWait: n,
            trailing: A
          });
        }
        function UW(M) {
          return i3(M, 1);
        }
        function HW(M, n) {
          return Oc(Kr(n), M);
        }
        function JW() {
          if (!arguments.length)
            return [];
          var M = arguments[0];
          return B0(M) ? M : [M];
        }
        function $W(M) {
          return L2(M, y);
        }
        function VW(M, n) {
          return n = typeof n == "function" ? n : e, L2(M, y, n);
        }
        function YW(M) {
          return L2(M, h | y);
        }
        function GW(M, n) {
          return n = typeof n == "function" ? n : e, L2(M, h | y, n);
        }
        function KW(M, n) {
          return n == null || os(M, n, ce(n));
        }
        function et(M, n) {
          return M === n || M !== M && n !== n;
        }
        var QW = En(Pr), ZW = En(function(M, n) {
          return M >= n;
        }), io = cs(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? cs : function(M) {
          return P1(M) && p1.call(M, "callee") && !GO.call(M, "callee");
        }, B0 = X.isArray, jW = BO ? p2(BO) : nf;
        function Fe(M) {
          return M != null && Yn(M.length) && !Yt(M);
        }
        function F1(M) {
          return P1(M) && Fe(M);
        }
        function eh(M) {
          return M === !0 || M === !1 || P1(M) && Be(M) == i1;
        }
        var wp = sq || Rc, th = TO ? p2(TO) : zf;
        function ph(M) {
          return P1(M) && M.nodeType === 1 && !ab(M);
        }
        function oh(M) {
          if (M == null)
            return !0;
          if (Fe(M) && (B0(M) || typeof M == "string" || typeof M.splice == "function" || wp(M) || nM(M) || io(M)))
            return !M.length;
          var n = he(M);
          if (n == I || n == g0)
            return !M.size;
          if (cb(M))
            return !xr(M).length;
          for (var c in M)
            if (p1.call(M, c))
              return !1;
          return !0;
        }
        function Mh(M, n) {
          return nb(M, n);
        }
        function bh(M, n, c) {
          c = typeof c == "function" ? c : e;
          var O = c ? c(M, n) : e;
          return O === e ? nb(M, n, e, c) : !!O;
        }
        function sc(M) {
          if (!P1(M))
            return !1;
          var n = Be(M);
          return n == o1 || n == P0 || typeof M.message == "string" && typeof M.name == "string" && !ab(M);
        }
        function nh(M) {
          return typeof M == "number" && QO(M);
        }
        function Yt(M) {
          if (!B1(M))
            return !1;
          var n = Be(M);
          return n == E0 || n == m || n == x0 || n == t1;
        }
        function l3(M) {
          return typeof M == "number" && M == S0(M);
        }
        function Yn(M) {
          return typeof M == "number" && M > -1 && M % 1 == 0 && M <= W0;
        }
        function B1(M) {
          var n = typeof M;
          return M != null && (n == "object" || n == "function");
        }
        function P1(M) {
          return M != null && typeof M == "object";
        }
        var q3 = wO ? p2(wO) : cf;
        function zh(M, n) {
          return M === n || kr(M, n, oc(n));
        }
        function rh(M, n, c) {
          return c = typeof c == "function" ? c : e, kr(M, n, oc(n), c);
        }
        function ch(M) {
          return f3(M) && M != +M;
        }
        function ih(M) {
          if (Vf(M))
            throw new N0(r);
          return is(M);
        }
        function ah(M) {
          return M === null;
        }
        function Oh(M) {
          return M == null;
        }
        function f3(M) {
          return typeof M == "number" || P1(M) && Be(M) == E;
        }
        function ab(M) {
          if (!P1(M) || Be(M) != z0)
            return !1;
          var n = hn(M);
          if (n === null)
            return !0;
          var c = p1.call(n, "constructor") && n.constructor;
          return typeof c == "function" && c instanceof c && ln.call(c) == zq;
        }
        var Ac = SO ? p2(SO) : af;
        function sh(M) {
          return l3(M) && M >= -W0 && M <= W0;
        }
        var W3 = DO ? p2(DO) : Of;
        function Gn(M) {
          return typeof M == "string" || !B0(M) && P1(M) && Be(M) == je;
        }
        function M2(M) {
          return typeof M == "symbol" || P1(M) && Be(M) == K2;
        }
        var nM = XO ? p2(XO) : sf;
        function Ah(M) {
          return M === e;
        }
        function uh(M) {
          return P1(M) && he(M) == Qp;
        }
        function dh(M) {
          return P1(M) && Be(M) == ar;
        }
        var lh = En(Fr), qh = En(function(M, n) {
          return M <= n;
        });
        function h3(M) {
          if (!M)
            return [];
          if (Fe(M))
            return Gn(M) ? Z2(M) : xe(M);
          if (ZM && M[ZM])
            return G4(M[ZM]());
          var n = he(M), c = n == I ? Nr : n == g0 ? An : zM;
          return c(M);
        }
        function Gt(M) {
          if (!M)
            return M === 0 ? M : 0;
          if (M = N2(M), M === pe || M === -pe) {
            var n = M < 0 ? -1 : 1;
            return n * re;
          }
          return M === M ? M : 0;
        }
        function S0(M) {
          var n = Gt(M), c = n % 1;
          return n === n ? c ? n - c : n : 0;
        }
        function m3(M) {
          return M ? no(S0(M), 0, G1) : 0;
        }
        function N2(M) {
          if (typeof M == "number")
            return M;
          if (M2(M))
            return fe;
          if (B1(M)) {
            var n = typeof M.valueOf == "function" ? M.valueOf() : M;
            M = B1(n) ? n + "" : n;
          }
          if (typeof M != "string")
            return M === 0 ? M : +M;
          M = xO(M);
          var c = KM.test(M);
          return c || Vo.test(M) ? w4(M.slice(2), c ? 2 : 8) : Or.test(M) ? fe : +M;
        }
        function R3(M) {
          return ht(M, Ue(M));
        }
        function fh(M) {
          return M ? no(S0(M), -W0, W0) : M === 0 ? M : 0;
        }
        function e1(M) {
          return M == null ? "" : o2(M);
        }
        var Wh = oM(function(M, n) {
          if (cb(n) || Fe(n)) {
            ht(n, ce(n), M);
            return;
          }
          for (var c in n)
            p1.call(n, c) && ob(M, c, n[c]);
        }), y3 = oM(function(M, n) {
          ht(n, Ue(n), M);
        }), Kn = oM(function(M, n, c, O) {
          ht(n, Ue(n), M, O);
        }), hh = oM(function(M, n, c, O) {
          ht(n, ce(n), M, O);
        }), mh = $t(Xr);
        function Rh(M, n) {
          var c = pM(M);
          return n == null ? c : ps(c, n);
        }
        var yh = I0(function(M, n) {
          M = r1(M);
          var c = -1, O = n.length, A = O > 2 ? n[2] : e;
          for (A && Te(n[0], n[1], A) && (O = 1); ++c < O; )
            for (var l = n[c], W = Ue(l), R = -1, _ = W.length; ++R < _; ) {
              var x = W[R], F = M[x];
              (F === e || et(F, jo[x]) && !p1.call(M, x)) && (M[x] = l[x]);
            }
          return M;
        }), gh = I0(function(M) {
          return M.push(e, xs), t2(g3, e, M);
        });
        function Lh(M, n) {
          return IO(M, l0(n, 3), Wt);
        }
        function vh(M, n) {
          return IO(M, l0(n, 3), Ir);
        }
        function _h(M, n) {
          return M == null ? M : Cr(M, l0(n, 3), Ue);
        }
        function Nh(M, n) {
          return M == null ? M : zs(M, l0(n, 3), Ue);
        }
        function Bh(M, n) {
          return M && Wt(M, l0(n, 3));
        }
        function Th(M, n) {
          return M && Ir(M, l0(n, 3));
        }
        function wh(M) {
          return M == null ? [] : Tn(M, ce(M));
        }
        function Sh(M) {
          return M == null ? [] : Tn(M, Ue(M));
        }
        function uc(M, n, c) {
          var O = M == null ? e : zo(M, n);
          return O === e ? c : O;
        }
        function Dh(M, n) {
          return M != null && Hs(M, n, pf);
        }
        function dc(M, n) {
          return M != null && Hs(M, n, of);
        }
        var Xh = Cs(function(M, n, c) {
          n != null && typeof n.toString != "function" && (n = qn.call(n)), M[n] = c;
        }, qc(He)), Ch = Cs(function(M, n, c) {
          n != null && typeof n.toString != "function" && (n = qn.call(n)), p1.call(M, n) ? M[n].push(c) : M[n] = [c];
        }, l0), Ih = I0(bb);
        function ce(M) {
          return Fe(M) ? es(M) : xr(M);
        }
        function Ue(M) {
          return Fe(M) ? es(M, !0) : Af(M);
        }
        function Ph(M, n) {
          var c = {};
          return n = l0(n, 3), Wt(M, function(O, A, l) {
            Ht(c, n(O, A, l), O);
          }), c;
        }
        function Eh(M, n) {
          var c = {};
          return n = l0(n, 3), Wt(M, function(O, A, l) {
            Ht(c, A, n(O, A, l));
          }), c;
        }
        var kh = oM(function(M, n, c) {
          wn(M, n, c);
        }), g3 = oM(function(M, n, c, O) {
          wn(M, n, c, O);
        }), xh = $t(function(M, n) {
          var c = {};
          if (M == null)
            return c;
          var O = !1;
          n = R1(n, function(l) {
            return l = Bp(l, M), O || (O = l.length > 1), l;
          }), ht(M, tc(M), c), O && (c = L2(c, h | g | y, Xf));
          for (var A = n.length; A--; )
            Vr(c, n[A]);
          return c;
        });
        function Fh(M, n) {
          return L3(M, Vn(l0(n)));
        }
        var Uh = $t(function(M, n) {
          return M == null ? {} : df(M, n);
        });
        function L3(M, n) {
          if (M == null)
            return {};
          var c = R1(tc(M), function(O) {
            return [O];
          });
          return n = l0(n), ls(M, c, function(O, A) {
            return n(O, A[0]);
          });
        }
        function Hh(M, n, c) {
          n = Bp(n, M);
          var O = -1, A = n.length;
          for (A || (A = 1, M = e); ++O < A; ) {
            var l = M == null ? e : M[mt(n[O])];
            l === e && (O = A, l = c), M = Yt(l) ? l.call(M) : l;
          }
          return M;
        }
        function Jh(M, n, c) {
          return M == null ? M : zb(M, n, c);
        }
        function $h(M, n, c, O) {
          return O = typeof O == "function" ? O : e, M == null ? M : zb(M, n, c, O);
        }
        var v3 = Es(ce), _3 = Es(Ue);
        function Vh(M, n, c) {
          var O = B0(M), A = O || wp(M) || nM(M);
          if (n = l0(n, 4), c == null) {
            var l = M && M.constructor;
            A ? c = O ? new l() : [] : B1(M) ? c = Yt(l) ? pM(hn(M)) : {} : c = {};
          }
          return (A ? R2 : Wt)(M, function(W, R, _) {
            return n(c, W, R, _);
          }), c;
        }
        function Yh(M, n) {
          return M == null ? !0 : Vr(M, n);
        }
        function Gh(M, n, c) {
          return M == null ? M : ms(M, n, Kr(c));
        }
        function Kh(M, n, c, O) {
          return O = typeof O == "function" ? O : e, M == null ? M : ms(M, n, Kr(c), O);
        }
        function zM(M) {
          return M == null ? [] : _r(M, ce(M));
        }
        function Qh(M) {
          return M == null ? [] : _r(M, Ue(M));
        }
        function Zh(M, n, c) {
          return c === e && (c = n, n = e), c !== e && (c = N2(c), c = c === c ? c : 0), n !== e && (n = N2(n), n = n === n ? n : 0), no(N2(M), n, c);
        }
        function jh(M, n, c) {
          return n = Gt(n), c === e ? (c = n, n = 0) : c = Gt(c), M = N2(M), Mf(M, n, c);
        }
        function e6(M, n, c) {
          if (c && typeof c != "boolean" && Te(M, n, c) && (n = c = e), c === e && (typeof n == "boolean" ? (c = n, n = e) : typeof M == "boolean" && (c = M, M = e)), M === e && n === e ? (M = 0, n = 1) : (M = Gt(M), n === e ? (n = M, M = 0) : n = Gt(n)), M > n) {
            var O = M;
            M = n, n = O;
          }
          if (c || M % 1 || n % 1) {
            var A = ZO();
            return We(M + A * (n - M + T4("1e-" + ((A + "").length - 1))), n);
          }
          return Hr(M, n);
        }
        var t6 = MM(function(M, n, c) {
          return n = n.toLowerCase(), M + (c ? N3(n) : n);
        });
        function N3(M) {
          return lc(e1(M).toLowerCase());
        }
        function B3(M) {
          return M = e1(M), M && M.replace(zn, H4).replace(h4, "");
        }
        function p6(M, n, c) {
          M = e1(M), n = o2(n);
          var O = M.length;
          c = c === e ? O : no(S0(c), 0, O);
          var A = c;
          return c -= n.length, c >= 0 && M.slice(c, A) == n;
        }
        function o6(M) {
          return M = e1(M), M && Ne.test(M) ? M.replace(Q2, J4) : M;
        }
        function M6(M) {
          return M = e1(M), M && eo.test(M) ? M.replace(Jo, "\\$&") : M;
        }
        var b6 = MM(function(M, n, c) {
          return M + (c ? "-" : "") + n.toLowerCase();
        }), n6 = MM(function(M, n, c) {
          return M + (c ? " " : "") + n.toLowerCase();
        }), z6 = Ss("toLowerCase");
        function r6(M, n, c) {
          M = e1(M), n = S0(n);
          var O = n ? Qo(M) : 0;
          if (!n || O >= n)
            return M;
          var A = (n - O) / 2;
          return Pn(gn(A), c) + M + Pn(yn(A), c);
        }
        function c6(M, n, c) {
          M = e1(M), n = S0(n);
          var O = n ? Qo(M) : 0;
          return n && O < n ? M + Pn(n - O, c) : M;
        }
        function i6(M, n, c) {
          M = e1(M), n = S0(n);
          var O = n ? Qo(M) : 0;
          return n && O < n ? Pn(n - O, c) + M : M;
        }
        function a6(M, n, c) {
          return c || n == null ? n = 0 : n && (n = +n), lq(e1(M).replace(to, ""), n || 0);
        }
        function O6(M, n, c) {
          return (c ? Te(M, n, c) : n === e) ? n = 1 : n = S0(n), Jr(e1(M), n);
        }
        function s6() {
          var M = arguments, n = e1(M[0]);
          return M.length < 3 ? n : n.replace(M[1], M[2]);
        }
        var A6 = MM(function(M, n, c) {
          return M + (c ? "_" : "") + n.toLowerCase();
        });
        function u6(M, n, c) {
          return c && typeof c != "number" && Te(M, n, c) && (n = c = e), c = c === e ? G1 : c >>> 0, c ? (M = e1(M), M && (typeof n == "string" || n != null && !Ac(n)) && (n = o2(n), !n && Ko(M)) ? Tp(Z2(M), 0, c) : M.split(n, c)) : [];
        }
        var d6 = MM(function(M, n, c) {
          return M + (c ? " " : "") + lc(n);
        });
        function l6(M, n, c) {
          return M = e1(M), c = c == null ? 0 : no(S0(c), 0, M.length), n = o2(n), M.slice(c, c + n.length) == n;
        }
        function q6(M, n, c) {
          var O = u.templateSettings;
          c && Te(M, n, c) && (n = e), M = e1(M), n = Kn({}, n, O, ks);
          var A = Kn({}, n.imports, O.imports, ks), l = ce(A), W = _r(A, l), R, _, x = 0, F = n.interpolate || rn, J = "__p += '", p0 = Br(
            (n.escape || rn).source + "|" + F.source + "|" + (F === xt ? YM : rn).source + "|" + (n.evaluate || rn).source + "|$",
            "g"
          ), a0 = "//# sourceURL=" + (p1.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++L4 + "]") + `
`;
          M.replace(p0, function(f0, k0, H0, b2, we, n2) {
            return H0 || (H0 = b2), J += M.slice(x, n2).replace(o4, $4), k0 && (R = !0, J += `' +
__e(` + k0 + `) +
'`), we && (_ = !0, J += `';
` + we + `;
__p += '`), H0 && (J += `' +
((__t = (` + H0 + `)) == null ? '' : __t) +
'`), x = n2 + f0.length, f0;
          }), J += `';
`;
          var q0 = p1.call(n, "variable") && n.variable;
          if (!q0)
            J = `with (obj) {
` + J + `
}
`;
          else if (VM.test(q0))
            throw new N0(s);
          J = (_ ? J.replace(Y0, "") : J).replace(M1, "$1").replace(z1, "$1;"), J = "function(" + (q0 || "obj") + `) {
` + (q0 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (R ? ", __e = _.escape" : "") + (_ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + J + `return __p
}`;
          var X0 = w3(function() {
            return j0(l, a0 + "return " + J).apply(e, W);
          });
          if (X0.source = J, sc(X0))
            throw X0;
          return X0;
        }
        function f6(M) {
          return e1(M).toLowerCase();
        }
        function W6(M) {
          return e1(M).toUpperCase();
        }
        function h6(M, n, c) {
          if (M = e1(M), M && (c || n === e))
            return xO(M);
          if (!M || !(n = o2(n)))
            return M;
          var O = Z2(M), A = Z2(n), l = FO(O, A), W = UO(O, A) + 1;
          return Tp(O, l, W).join("");
        }
        function m6(M, n, c) {
          if (M = e1(M), M && (c || n === e))
            return M.slice(0, JO(M) + 1);
          if (!M || !(n = o2(n)))
            return M;
          var O = Z2(M), A = UO(O, Z2(n)) + 1;
          return Tp(O, 0, A).join("");
        }
        function R6(M, n, c) {
          if (M = e1(M), M && (c || n === e))
            return M.replace(to, "");
          if (!M || !(n = o2(n)))
            return M;
          var O = Z2(M), A = FO(O, Z2(n));
          return Tp(O, A).join("");
        }
        function y6(M, n) {
          var c = m0, O = V0;
          if (B1(n)) {
            var A = "separator" in n ? n.separator : A;
            c = "length" in n ? S0(n.length) : c, O = "omission" in n ? o2(n.omission) : O;
          }
          M = e1(M);
          var l = M.length;
          if (Ko(M)) {
            var W = Z2(M);
            l = W.length;
          }
          if (c >= l)
            return M;
          var R = c - Qo(O);
          if (R < 1)
            return O;
          var _ = W ? Tp(W, 0, R).join("") : M.slice(0, R);
          if (A === e)
            return _ + O;
          if (W && (R += _.length - R), Ac(A)) {
            if (M.slice(R).search(A)) {
              var x, F = _;
              for (A.global || (A = Br(A.source, e1(GM.exec(A)) + "g")), A.lastIndex = 0; x = A.exec(F); )
                var J = x.index;
              _ = _.slice(0, J === e ? R : J);
            }
          } else if (M.indexOf(o2(A), R) != R) {
            var p0 = _.lastIndexOf(A);
            p0 > -1 && (_ = _.slice(0, p0));
          }
          return _ + O;
        }
        function g6(M) {
          return M = e1(M), M && kt.test(M) ? M.replace(w0, j4) : M;
        }
        var L6 = MM(function(M, n, c) {
          return M + (c ? " " : "") + n.toUpperCase();
        }), lc = Ss("toUpperCase");
        function T3(M, n, c) {
          return M = e1(M), n = c ? e : n, n === e ? Y4(M) ? pq(M) : E4(M) : M.match(n) || [];
        }
        var w3 = I0(function(M, n) {
          try {
            return t2(M, e, n);
          } catch (c) {
            return sc(c) ? c : new N0(c);
          }
        }), v6 = $t(function(M, n) {
          return R2(n, function(c) {
            c = mt(c), Ht(M, c, ac(M[c], M));
          }), M;
        });
        function _6(M) {
          var n = M == null ? 0 : M.length, c = l0();
          return M = n ? R1(M, function(O) {
            if (typeof O[1] != "function")
              throw new y2(i);
            return [c(O[0]), O[1]];
          }) : [], I0(function(O) {
            for (var A = -1; ++A < n; ) {
              var l = M[A];
              if (t2(l[0], this, O))
                return t2(l[1], this, O);
            }
          });
        }
        function N6(M) {
          return jq(L2(M, h));
        }
        function qc(M) {
          return function() {
            return M;
          };
        }
        function B6(M, n) {
          return M == null || M !== M ? n : M;
        }
        var T6 = Xs(), w6 = Xs(!0);
        function He(M) {
          return M;
        }
        function fc(M) {
          return as(typeof M == "function" ? M : L2(M, h));
        }
        function S6(M) {
          return ss(L2(M, h));
        }
        function D6(M, n) {
          return As(M, L2(n, h));
        }
        var X6 = I0(function(M, n) {
          return function(c) {
            return bb(c, M, n);
          };
        }), C6 = I0(function(M, n) {
          return function(c) {
            return bb(M, c, n);
          };
        });
        function Wc(M, n, c) {
          var O = ce(n), A = Tn(n, O);
          c == null && !(B1(n) && (A.length || !O.length)) && (c = n, n = M, M = this, A = Tn(n, ce(n)));
          var l = !(B1(c) && "chain" in c) || !!c.chain, W = Yt(M);
          return R2(A, function(R) {
            var _ = n[R];
            M[R] = _, W && (M.prototype[R] = function() {
              var x = this.__chain__;
              if (l || x) {
                var F = M(this.__wrapped__), J = F.__actions__ = xe(this.__actions__);
                return J.push({ func: _, args: arguments, thisArg: M }), F.__chain__ = x, F;
              }
              return _.apply(M, gp([this.value()], arguments));
            });
          }), M;
        }
        function I6() {
          return ae._ === this && (ae._ = rq), this;
        }
        function hc() {
        }
        function P6(M) {
          return M = S0(M), I0(function(n) {
            return us(n, M);
          });
        }
        var E6 = Zr(R1), k6 = Zr(CO), x6 = Zr(Rr);
        function S3(M) {
          return bc(M) ? yr(mt(M)) : lf(M);
        }
        function F6(M) {
          return function(n) {
            return M == null ? e : zo(M, n);
          };
        }
        var U6 = Is(), H6 = Is(!0);
        function mc() {
          return [];
        }
        function Rc() {
          return !1;
        }
        function J6() {
          return {};
        }
        function $6() {
          return "";
        }
        function V6() {
          return !0;
        }
        function Y6(M, n) {
          if (M = S0(M), M < 1 || M > W0)
            return [];
          var c = G1, O = We(M, G1);
          n = l0(n), M -= G1;
          for (var A = vr(O, n); ++c < M; )
            n(c);
          return A;
        }
        function G6(M) {
          return B0(M) ? R1(M, mt) : M2(M) ? [M] : xe(js(e1(M)));
        }
        function K6(M) {
          var n = ++nq;
          return e1(M) + n;
        }
        var Q6 = In(function(M, n) {
          return M + n;
        }, 0), Z6 = jr("ceil"), j6 = In(function(M, n) {
          return M / n;
        }, 1), em = jr("floor");
        function tm(M) {
          return M && M.length ? Bn(M, He, Pr) : e;
        }
        function pm(M, n) {
          return M && M.length ? Bn(M, l0(n, 2), Pr) : e;
        }
        function om(M) {
          return EO(M, He);
        }
        function Mm(M, n) {
          return EO(M, l0(n, 2));
        }
        function bm(M) {
          return M && M.length ? Bn(M, He, Fr) : e;
        }
        function nm(M, n) {
          return M && M.length ? Bn(M, l0(n, 2), Fr) : e;
        }
        var zm = In(function(M, n) {
          return M * n;
        }, 1), rm = jr("round"), cm = In(function(M, n) {
          return M - n;
        }, 0);
        function im(M) {
          return M && M.length ? Lr(M, He) : 0;
        }
        function am(M, n) {
          return M && M.length ? Lr(M, l0(n, 2)) : 0;
        }
        return u.after = SW, u.ary = i3, u.assign = Wh, u.assignIn = y3, u.assignInWith = Kn, u.assignWith = hh, u.at = mh, u.before = a3, u.bind = ac, u.bindAll = v6, u.bindKey = O3, u.castArray = JW, u.chain = z3, u.chunk = e5, u.compact = t5, u.concat = p5, u.cond = _6, u.conforms = N6, u.constant = qc, u.countBy = iW, u.create = Rh, u.curry = s3, u.curryRight = A3, u.debounce = u3, u.defaults = yh, u.defaultsDeep = gh, u.defer = DW, u.delay = XW, u.difference = o5, u.differenceBy = M5, u.differenceWith = b5, u.drop = n5, u.dropRight = z5, u.dropRightWhile = r5, u.dropWhile = c5, u.fill = i5, u.filter = OW, u.flatMap = uW, u.flatMapDeep = dW, u.flatMapDepth = lW, u.flatten = o3, u.flattenDeep = a5, u.flattenDepth = O5, u.flip = CW, u.flow = T6, u.flowRight = w6, u.fromPairs = s5, u.functions = wh, u.functionsIn = Sh, u.groupBy = qW, u.initial = u5, u.intersection = d5, u.intersectionBy = l5, u.intersectionWith = q5, u.invert = Xh, u.invertBy = Ch, u.invokeMap = WW, u.iteratee = fc, u.keyBy = hW, u.keys = ce, u.keysIn = Ue, u.map = Hn, u.mapKeys = Ph, u.mapValues = Eh, u.matches = S6, u.matchesProperty = D6, u.memoize = $n, u.merge = kh, u.mergeWith = g3, u.method = X6, u.methodOf = C6, u.mixin = Wc, u.negate = Vn, u.nthArg = P6, u.omit = xh, u.omitBy = Fh, u.once = IW, u.orderBy = mW, u.over = E6, u.overArgs = PW, u.overEvery = k6, u.overSome = x6, u.partial = Oc, u.partialRight = d3, u.partition = RW, u.pick = Uh, u.pickBy = L3, u.property = S3, u.propertyOf = F6, u.pull = m5, u.pullAll = b3, u.pullAllBy = R5, u.pullAllWith = y5, u.pullAt = g5, u.range = U6, u.rangeRight = H6, u.rearg = EW, u.reject = LW, u.remove = L5, u.rest = kW, u.reverse = cc, u.sampleSize = _W, u.set = Jh, u.setWith = $h, u.shuffle = NW, u.slice = v5, u.sortBy = wW, u.sortedUniq = D5, u.sortedUniqBy = X5, u.split = u6, u.spread = xW, u.tail = C5, u.take = I5, u.takeRight = P5, u.takeRightWhile = E5, u.takeWhile = k5, u.tap = tW, u.throttle = FW, u.thru = Un, u.toArray = h3, u.toPairs = v3, u.toPairsIn = _3, u.toPath = G6, u.toPlainObject = R3, u.transform = Vh, u.unary = UW, u.union = x5, u.unionBy = F5, u.unionWith = U5, u.uniq = H5, u.uniqBy = J5, u.uniqWith = $5, u.unset = Yh, u.unzip = ic, u.unzipWith = n3, u.update = Gh, u.updateWith = Kh, u.values = zM, u.valuesIn = Qh, u.without = V5, u.words = T3, u.wrap = HW, u.xor = Y5, u.xorBy = G5, u.xorWith = K5, u.zip = Q5, u.zipObject = Z5, u.zipObjectDeep = j5, u.zipWith = eW, u.entries = v3, u.entriesIn = _3, u.extend = y3, u.extendWith = Kn, Wc(u, u), u.add = Q6, u.attempt = w3, u.camelCase = t6, u.capitalize = N3, u.ceil = Z6, u.clamp = Zh, u.clone = $W, u.cloneDeep = YW, u.cloneDeepWith = GW, u.cloneWith = VW, u.conformsTo = KW, u.deburr = B3, u.defaultTo = B6, u.divide = j6, u.endsWith = p6, u.eq = et, u.escape = o6, u.escapeRegExp = M6, u.every = aW, u.find = sW, u.findIndex = t3, u.findKey = Lh, u.findLast = AW, u.findLastIndex = p3, u.findLastKey = vh, u.floor = em, u.forEach = r3, u.forEachRight = c3, u.forIn = _h, u.forInRight = Nh, u.forOwn = Bh, u.forOwnRight = Th, u.get = uc, u.gt = QW, u.gte = ZW, u.has = Dh, u.hasIn = dc, u.head = M3, u.identity = He, u.includes = fW, u.indexOf = A5, u.inRange = jh, u.invoke = Ih, u.isArguments = io, u.isArray = B0, u.isArrayBuffer = jW, u.isArrayLike = Fe, u.isArrayLikeObject = F1, u.isBoolean = eh, u.isBuffer = wp, u.isDate = th, u.isElement = ph, u.isEmpty = oh, u.isEqual = Mh, u.isEqualWith = bh, u.isError = sc, u.isFinite = nh, u.isFunction = Yt, u.isInteger = l3, u.isLength = Yn, u.isMap = q3, u.isMatch = zh, u.isMatchWith = rh, u.isNaN = ch, u.isNative = ih, u.isNil = Oh, u.isNull = ah, u.isNumber = f3, u.isObject = B1, u.isObjectLike = P1, u.isPlainObject = ab, u.isRegExp = Ac, u.isSafeInteger = sh, u.isSet = W3, u.isString = Gn, u.isSymbol = M2, u.isTypedArray = nM, u.isUndefined = Ah, u.isWeakMap = uh, u.isWeakSet = dh, u.join = f5, u.kebabCase = b6, u.last = _2, u.lastIndexOf = W5, u.lowerCase = n6, u.lowerFirst = z6, u.lt = lh, u.lte = qh, u.max = tm, u.maxBy = pm, u.mean = om, u.meanBy = Mm, u.min = bm, u.minBy = nm, u.stubArray = mc, u.stubFalse = Rc, u.stubObject = J6, u.stubString = $6, u.stubTrue = V6, u.multiply = zm, u.nth = h5, u.noConflict = I6, u.noop = hc, u.now = Jn, u.pad = r6, u.padEnd = c6, u.padStart = i6, u.parseInt = a6, u.random = e6, u.reduce = yW, u.reduceRight = gW, u.repeat = O6, u.replace = s6, u.result = Hh, u.round = rm, u.runInContext = v, u.sample = vW, u.size = BW, u.snakeCase = A6, u.some = TW, u.sortedIndex = _5, u.sortedIndexBy = N5, u.sortedIndexOf = B5, u.sortedLastIndex = T5, u.sortedLastIndexBy = w5, u.sortedLastIndexOf = S5, u.startCase = d6, u.startsWith = l6, u.subtract = cm, u.sum = im, u.sumBy = am, u.template = q6, u.times = Y6, u.toFinite = Gt, u.toInteger = S0, u.toLength = m3, u.toLower = f6, u.toNumber = N2, u.toSafeInteger = fh, u.toString = e1, u.toUpper = W6, u.trim = h6, u.trimEnd = m6, u.trimStart = R6, u.truncate = y6, u.unescape = g6, u.uniqueId = K6, u.upperCase = L6, u.upperFirst = lc, u.each = r3, u.eachRight = c3, u.first = M3, Wc(u, (function() {
          var M = {};
          return Wt(u, function(n, c) {
            p1.call(u.prototype, c) || (M[c] = n);
          }), M;
        })(), { chain: !1 }), u.VERSION = o, R2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(M) {
          u[M].placeholder = u;
        }), R2(["drop", "take"], function(M, n) {
          F0.prototype[M] = function(c) {
            c = c === e ? 1 : Me(S0(c), 0);
            var O = this.__filtered__ && !n ? new F0(this) : this.clone();
            return O.__filtered__ ? O.__takeCount__ = We(c, O.__takeCount__) : O.__views__.push({
              size: We(c, G1),
              type: M + (O.__dir__ < 0 ? "Right" : "")
            }), O;
          }, F0.prototype[M + "Right"] = function(c) {
            return this.reverse()[M](c).reverse();
          };
        }), R2(["filter", "map", "takeWhile"], function(M, n) {
          var c = n + 1, O = c == Z0 || c == I1;
          F0.prototype[M] = function(A) {
            var l = this.clone();
            return l.__iteratees__.push({
              iteratee: l0(A, 3),
              type: c
            }), l.__filtered__ = l.__filtered__ || O, l;
          };
        }), R2(["head", "last"], function(M, n) {
          var c = "take" + (n ? "Right" : "");
          F0.prototype[M] = function() {
            return this[c](1).value()[0];
          };
        }), R2(["initial", "tail"], function(M, n) {
          var c = "drop" + (n ? "" : "Right");
          F0.prototype[M] = function() {
            return this.__filtered__ ? new F0(this) : this[c](1);
          };
        }), F0.prototype.compact = function() {
          return this.filter(He);
        }, F0.prototype.find = function(M) {
          return this.filter(M).head();
        }, F0.prototype.findLast = function(M) {
          return this.reverse().find(M);
        }, F0.prototype.invokeMap = I0(function(M, n) {
          return typeof M == "function" ? new F0(this) : this.map(function(c) {
            return bb(c, M, n);
          });
        }), F0.prototype.reject = function(M) {
          return this.filter(Vn(l0(M)));
        }, F0.prototype.slice = function(M, n) {
          M = S0(M);
          var c = this;
          return c.__filtered__ && (M > 0 || n < 0) ? new F0(c) : (M < 0 ? c = c.takeRight(-M) : M && (c = c.drop(M)), n !== e && (n = S0(n), c = n < 0 ? c.dropRight(-n) : c.take(n - M)), c);
        }, F0.prototype.takeRightWhile = function(M) {
          return this.reverse().takeWhile(M).reverse();
        }, F0.prototype.toArray = function() {
          return this.take(G1);
        }, Wt(F0.prototype, function(M, n) {
          var c = /^(?:filter|find|map|reject)|While$/.test(n), O = /^(?:head|last)$/.test(n), A = u[O ? "take" + (n == "last" ? "Right" : "") : n], l = O || /^find/.test(n);
          A && (u.prototype[n] = function() {
            var W = this.__wrapped__, R = O ? [1] : arguments, _ = W instanceof F0, x = R[0], F = _ || B0(W), J = function(k0) {
              var H0 = A.apply(u, gp([k0], R));
              return O && p0 ? H0[0] : H0;
            };
            F && c && typeof x == "function" && x.length != 1 && (_ = F = !1);
            var p0 = this.__chain__, a0 = !!this.__actions__.length, q0 = l && !p0, X0 = _ && !a0;
            if (!l && F) {
              W = X0 ? W : new F0(this);
              var f0 = M.apply(W, R);
              return f0.__actions__.push({ func: Un, args: [J], thisArg: e }), new g2(f0, p0);
            }
            return q0 && X0 ? M.apply(this, R) : (f0 = this.thru(J), q0 ? O ? f0.value()[0] : f0.value() : f0);
          });
        }), R2(["pop", "push", "shift", "sort", "splice", "unshift"], function(M) {
          var n = un[M], c = /^(?:push|sort|unshift)$/.test(M) ? "tap" : "thru", O = /^(?:pop|shift)$/.test(M);
          u.prototype[M] = function() {
            var A = arguments;
            if (O && !this.__chain__) {
              var l = this.value();
              return n.apply(B0(l) ? l : [], A);
            }
            return this[c](function(W) {
              return n.apply(B0(W) ? W : [], A);
            });
          };
        }), Wt(F0.prototype, function(M, n) {
          var c = u[n];
          if (c) {
            var O = c.name + "";
            p1.call(tM, O) || (tM[O] = []), tM[O].push({ name: n, func: c });
          }
        }), tM[Cn(e, S).name] = [{
          name: "wrapper",
          func: e
        }], F0.prototype.clone = yq, F0.prototype.reverse = gq, F0.prototype.value = Lq, u.prototype.at = pW, u.prototype.chain = oW, u.prototype.commit = MW, u.prototype.next = bW, u.prototype.plant = zW, u.prototype.reverse = rW, u.prototype.toJSON = u.prototype.valueOf = u.prototype.value = cW, u.prototype.first = u.prototype.head, ZM && (u.prototype[ZM] = nW), u;
      }), Zo = oq();
      po ? ((po.exports = Zo)._ = Zo, fr._ = Zo) : ae._ = Zo;
    }).call(Rv);
  })(ub, ub.exports)), ub.exports;
}
var Ae = yv();
function y1(p, t = { trimSpaces: !0 }) {
  let e = p;
  if (typeof e == "string" && t.trimSpaces == !0)
    e = e == null ? void 0 : e.trim();
  else if (typeof e == "number" || typeof e == "boolean" || Ae.isDate(p))
    return e === void 0;
  return Ae.isEmpty(e);
}
function C2(p) {
  if (p !== void 0)
    return { value: p };
}
function gv(p) {
  if (typeof p != "object") return {};
  const t = {};
  for (const e in p)
    t[e] = C2(p[e]);
  return t;
}
function Lv(p, t, e = !1) {
  if (p)
    return typeof p != "object" && e ? p : t && p.value ? t(p.value) : p.value;
}
function jd(p, t = !1) {
  let e = {};
  return Object.keys(p).forEach((o) => e[o] = Lv(p[o], void 0, t)), e;
}
Array.prototype.pushIfNotExists || (Array.prototype.pushIfNotExists = function(p, t = el) {
  this.some((e) => t(e, p)) || this.push(p);
});
Array.prototype.remove || (Array.prototype.remove = function(p) {
  return this.filter((t) => t !== p);
});
Array.prototype.removeAt || (Array.prototype.removeAt = function(p) {
  const t = this.slice();
  return t.splice(p, 1), t;
});
Array.prototype.removeIf || (Array.prototype.removeIf = function(p) {
  return this.filter((t) => !p(t));
});
Array.prototype.reorder || (Array.prototype.reorder = function(p, t) {
  const e = this.slice(), o = e[p], b = e[t];
  return e.splice(p, 1), e.splice(t, 0, o), {
    oldItems: this,
    items: e,
    srcItem: o,
    dstItem: b
  };
});
Array.prototype.toggle || (Array.prototype.toggle = function(p, t) {
  const e = this.slice(), o = t || ((r) => r === p), b = e.findIndex(o);
  return b < 0 ? e.push(p) : e.splice(b, 1), e;
});
Array.prototype.toMap || (Array.prototype.toMap = function(p) {
  return new Map(this.map((t) => [p(t), t]));
});
Array.prototype.groupBy || (Array.prototype.groupBy = function(p) {
  const t = /* @__PURE__ */ new Map();
  return this.forEach((e) => {
    const o = p(e), b = t.get(o);
    b ? b.push(e) : t.set(o, [e]);
  }), t;
});
Array.prototype.isEmpty || (Array.prototype.isEmpty = function() {
  return this.length == 0;
});
function el(p, t) {
  return p === t;
}
Array.prototype.isEquals || (Array.prototype.isEquals = function(p, t = el) {
  return this === p ? !0 : !this || !p || this.length !== p.length ? !1 : this.every((e, o) => p.find((b, r) => t(e, b, o, r)) != null);
});
Array.prototype.orderBy || (Array.prototype.orderBy = function(p = (t) => t) {
  return this ? this.slice().sort((t, e) => p(t) < p(e) ? -1 : 1) : [];
});
Array.prototype.orderByDesc || (Array.prototype.orderByDesc = function(p = (t) => t) {
  return this ? this.slice().sort((t, e) => p(e) < p(t) ? -1 : 1) : [];
});
Array.prototype.count || (Array.prototype.count = function(p = (t) => !0) {
  return this.filter(p).length;
});
Array.prototype.insert || (Array.prototype.insert = function(p, t) {
  const e = this.slice();
  return e.splice(t, 0, p), e;
});
Array.prototype.binarySearch || (Array.prototype.binarySearch = function(p, t) {
  var e = 0, o = this.length - 1, b, r;
  for (t = t || function(i, s) {
    return i < s ? -1 : i > s ? 1 : 0;
  }; e <= o; )
    if (b = e + o >>> 1, r = t(this[b], p), r < 0)
      e = b + 1;
    else if (r > 0)
      o = b - 1;
    else
      return b;
  return ~e;
});
Array.prototype.binaryInsert || (Array.prototype.binaryInsert = function(p, t, e) {
  const o = this.slice();
  var b = o.binarySearch(p, e);
  if (b >= 0) {
    if (!t)
      return { index: b, items: o };
  } else
    b = ~b;
  return o.splice(b, 0, p), { index: b, items: o };
});
Array.prototype.distinct || (Array.prototype.distinct = function() {
  return this.filter((p, t, e) => e.indexOf(p) === t);
});
Array.prototype.distinctBy || (Array.prototype.distinctBy = function(p) {
  return this.filter((t, e) => this.findIndex((o) => p(t) === p(o)) === e);
});
Array.prototype.flat || (Array.prototype.flat = function(p = 1 / 0) {
  return this.reduce(function(t, e) {
    return t.concat(Array.isArray(e) && p > 1 ? e.flat(p - 1) : e);
  }, []);
});
Array.prototype.shuffle || (Array.prototype.shuffle = function() {
  let p = this.slice();
  for (let t = p.length - 1; t > 0; t--) {
    const e = Math.floor(Math.random() * (t + 1));
    [p[t], p[e]] = [p[e], p[t]];
  }
  return p;
});
class Sa extends n0 {
  constructor(e) {
    super();
    z(this, "adminId");
    z(this, "expiredDate");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Sa({
      ...e,
      expiredDate: e.expiredDate ? new Date(e.expiredDate) : void 0
    });
  }
  update(e) {
    super.update(e);
  }
  get isAdmin() {
    return !Ae.isEmpty(this.adminId);
  }
}
var db = { exports: {} }, vv = db.exports, oA;
function _v() {
  return oA || (oA = 1, (function(p, t) {
    var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol ? "symbol" : typeof o;
    };
    (function(o, b) {
      e(t) === "object" ? p.exports = b() : o.Humanize = b();
    })(vv, function() {
      var o = [{
        name: "second",
        value: 1e3
      }, {
        name: "minute",
        value: 6e4
      }, {
        name: "hour",
        value: 36e5
      }, {
        name: "day",
        value: 864e5
      }, {
        name: "week",
        value: 6048e5
      }], b = {
        P: Math.pow(2, 50),
        T: Math.pow(2, 40),
        G: Math.pow(2, 30),
        M: Math.pow(2, 20)
      }, r = function(h) {
        return typeof h < "u" && h !== null;
      }, i = function(h) {
        return h !== h;
      }, s = function(h) {
        return isFinite(h) && !i(parseFloat(h));
      }, d = function(h) {
        var g = Object.prototype.toString.call(h);
        return g === "[object Array]";
      }, q = {
        // Converts a large integer to a friendly text representation.
        intword: function(h, g) {
          var y = arguments.length <= 2 || arguments[2] === void 0 ? 2 : arguments[2];
          return q.compactInteger(h, y);
        },
        // Converts an integer into its most compact representation
        compactInteger: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          g = Math.max(g, 0);
          var y = parseInt(h, 10), w = y < 0 ? "-" : "", U = Math.abs(y), N = String(U), S = N.length, D = [13, 10, 7, 4], V = ["T", "B", "M", "k"];
          if (U < 1e3)
            return "" + w + N;
          if (S > D[0] + 3)
            return y.toExponential(g).replace("e+", "x10^");
          for (var H = void 0, Y = 0; Y < D.length; Y++) {
            var t0 = D[Y];
            if (S >= t0) {
              H = t0;
              break;
            }
          }
          var j = S - H + 1, b0 = N.split(""), y0 = b0.slice(0, j), m0 = b0.slice(j, j + g + 1), V0 = y0.join(""), O0 = m0.join("");
          O0.length < g && (O0 += "" + Array(g - O0.length + 1).join("0"));
          var m1 = void 0;
          if (g === 0)
            m1 = "" + w + V0 + V[D.indexOf(H)];
          else {
            var Z0 = (+(V0 + "." + O0)).toFixed(g);
            m1 = "" + w + Z0 + V[D.indexOf(H)];
          }
          return m1;
        },
        // Converts an integer to a string containing commas every three digits.
        intComma: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          return q.formatNumber(h, g);
        },
        intcomma: function() {
          return q.intComma.apply(q, arguments);
        },
        // Formats the value like a 'human-readable' file size (i.e. '13 KB', '4.1 MB', '102 bytes', etc).
        fileSize: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 2 : arguments[1];
          for (var y in b)
            if (b.hasOwnProperty(y)) {
              var w = b[y];
              if (h >= w)
                return q.formatNumber(h / w, g, "") + " " + y + "B";
            }
          return h >= 1024 ? q.formatNumber(h / 1024, 0) + " KB" : q.formatNumber(h, 0) + q.pluralize(h, " byte");
        },
        filesize: function() {
          return q.fileSize.apply(q, arguments);
        },
        // Formats a number to a human-readable string.
        // Localize by overriding the precision, thousand and decimal arguments.
        formatNumber: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], y = arguments.length <= 2 || arguments[2] === void 0 ? "," : arguments[2], w = arguments.length <= 3 || arguments[3] === void 0 ? "." : arguments[3], U = function(j, b0, y0) {
            return y0 ? j.substr(0, y0) + b0 : "";
          }, N = function(j, b0, y0) {
            return j.substr(y0).replace(/(\d{3})(?=\d)/g, "$1" + b0);
          }, S = function(j, b0, y0) {
            return y0 ? b0 + q.toFixed(Math.abs(j), y0).split(".")[1] : "";
          }, D = q.normalizePrecision(g), V = h < 0 && "-" || "", H = String(parseInt(q.toFixed(Math.abs(h || 0), D), 10)), Y = H.length > 3 ? H.length % 3 : 0;
          return V + U(H, y, Y) + N(H, y, Y) + S(h, w, D);
        },
        // Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61')
        toFixed: function(h, g) {
          g = r(g) ? g : q.normalizePrecision(g, 0);
          var y = Math.pow(10, g);
          return (Math.round(h * y) / y).toFixed(g);
        },
        // Ensures precision value is a positive integer
        normalizePrecision: function(h, g) {
          return h = Math.round(Math.abs(h)), i(h) ? g : h;
        },
        // Converts an integer to its ordinal as a string.
        ordinal: function(h) {
          var g = parseInt(h, 10);
          if (g === 0)
            return h;
          var y = g % 100;
          if ([11, 12, 13].indexOf(y) >= 0)
            return g + "th";
          var w = g % 10, U = void 0;
          switch (w) {
            case 1:
              U = "st";
              break;
            case 2:
              U = "nd";
              break;
            case 3:
              U = "rd";
              break;
            default:
              U = "th";
          }
          return "" + g + U;
        },
        // Interprets numbers as occurences. Also accepts an optional array/map of overrides.
        times: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
          if (s(h) && h >= 0) {
            var y = parseFloat(h), w = ["never", "once", "twice"];
            if (r(g[y]))
              return String(g[y]);
            var U = r(w[y]) && w[y].toString();
            return U || y.toString() + " times";
          }
          return null;
        },
        // Returns the plural version of a given word if the value is not 1. The default suffix is 's'.
        pluralize: function(h, g, y) {
          return r(h) && r(g) ? (y = r(y) ? y : g + "s", parseInt(h, 10) === 1 ? g : y) : null;
        },
        // Truncates a string if it is longer than the specified number of characters (inclusive).
        // Truncated strings will end with a translatable ellipsis sequence ("…").
        truncate: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1], y = arguments.length <= 2 || arguments[2] === void 0 ? "..." : arguments[2];
          return h.length > g ? h.substring(0, g - y.length) + y : h;
        },
        // Truncates a string after a certain number of words.
        truncateWords: function(h, g) {
          for (var y = h.split(" "), w = "", U = 0; U < g; )
            r(y[U]) && (w += y[U] + " "), U++;
          return y.length > g ? w + "..." : null;
        },
        truncatewords: function() {
          return q.truncateWords.apply(q, arguments);
        },
        // Truncates a number to an upper bound.
        boundedNumber: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1], y = arguments.length <= 2 || arguments[2] === void 0 ? "+" : arguments[2], w = void 0;
          return s(h) && s(g) && h > g && (w = g + y), (w || h).toString();
        },
        truncatenumber: function() {
          return q.boundedNumber.apply(q, arguments);
        },
        // Converts a list of items to a human readable string with an optional limit.
        oxford: function(h, g, y) {
          var w = h.length, U = void 0;
          if (w < 2)
            return String(h);
          if (w === 2)
            return h.join(" and ");
          if (r(g) && w > g) {
            var N = w - g;
            U = g, y = r(y) ? y : ", and " + N + " " + q.pluralize(N, "other");
          } else
            U = -1, y = ", and " + h[w - 1];
          return h.slice(0, U).join(", ") + y;
        },
        // Converts an object to a definition-like string
        dictionary: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? " is " : arguments[1], y = arguments.length <= 2 || arguments[2] === void 0 ? ", " : arguments[2], w = "";
          if (r(h) && (typeof h > "u" ? "undefined" : e(h)) === "object" && !d(h)) {
            var U = [];
            for (var N in h)
              if (h.hasOwnProperty(N)) {
                var S = h[N];
                U.push("" + N + g + S);
              }
            return U.join(y);
          }
          return w;
        },
        // Describes how many times an item appears in a list
        frequency: function(h, g) {
          if (!d(h))
            return null;
          var y = h.length, w = q.times(y);
          return y === 0 ? w + " " + g : g + " " + w;
        },
        pace: function(h, g) {
          var y = arguments.length <= 2 || arguments[2] === void 0 ? "time" : arguments[2];
          if (h === 0 || g === 0)
            return "No " + q.pluralize(0, y);
          for (var w = "Approximately", U = void 0, N = void 0, S = h / g, D = 0; D < o.length; ++D) {
            var V = o[D];
            if (N = S * V.value, N > 1) {
              U = V.name;
              break;
            }
          }
          U || (w = "Less than", N = 1, U = o[o.length - 1].name);
          var H = Math.round(N);
          return y = q.pluralize(H, y), w + " " + H + " " + y + " per " + U;
        },
        // Converts newlines to <br/> tags
        nl2br: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? "<br/>" : arguments[1];
          return h.replace(/\n/g, g);
        },
        // Converts <br/> tags to newlines
        br2nl: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? `\r
` : arguments[1];
          return h.replace(/\<br\s*\/?\>/g, g);
        },
        // Capitalizes first letter in a string
        capitalize: function(h) {
          var g = arguments.length <= 1 || arguments[1] === void 0 ? !1 : arguments[1];
          return "" + h.charAt(0).toUpperCase() + (g ? h.slice(1).toLowerCase() : h.slice(1));
        },
        // Capitalizes the first letter of each word in a string
        capitalizeAll: function(h) {
          return h.replace(/(?:^|\s)\S/g, function(g) {
            return g.toUpperCase();
          });
        },
        // Titlecase words in a string.
        titleCase: function(h) {
          var g = /\b(a|an|and|at|but|by|de|en|for|if|in|of|on|or|the|to|via|vs?\.?)\b/i, y = /\S+[A-Z]+\S*/, w = /\s+/, U = /-/, N = void 0;
          return N = function(D) {
            for (var V = arguments.length <= 1 || arguments[1] === void 0 ? !1 : arguments[1], H = arguments.length <= 2 || arguments[2] === void 0 ? !0 : arguments[2], Y = [], t0 = D.split(V ? U : w), j = 0; j < t0.length; ++j) {
              var b0 = t0[j];
              if (b0.indexOf("-") !== -1) {
                Y.push(N(b0, !0, j === 0 || j === t0.length - 1));
                continue;
              }
              if (H && (j === 0 || j === t0.length - 1)) {
                Y.push(y.test(b0) ? b0 : q.capitalize(b0));
                continue;
              }
              y.test(b0) ? Y.push(b0) : g.test(b0) ? Y.push(b0.toLowerCase()) : Y.push(q.capitalize(b0));
            }
            return Y.join(V ? "-" : " ");
          }, N(h);
        },
        titlecase: function() {
          return q.titleCase.apply(q, arguments);
        }
      };
      return q;
    });
  })(db, db.exports)), db.exports;
}
var Nv = _v();
const Bv = /* @__PURE__ */ wa(Nv);
class Da extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "text");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Da({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0
    });
  }
}
class pr extends n0 {
  constructor(e) {
    super();
    z(this, "status", "default");
    z(this, "progress", 0);
    z(this, "scheduledDate");
    z(this, "settings");
    z(this, "error");
    e && this.update(e);
  }
  get isScheduled() {
    return this.status == "default" || this.status == "pending";
  }
  get isActive() {
    return this.status == "inProgress";
  }
  get isCompleted() {
    return this.status == "completed" || this.status == "aborted" || this.status == "error";
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      school: void 0,
      scheduledDate: (e = this.scheduledDate) == null ? void 0 : e.toISOString(),
      settingsJson: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  static fromJson(e) {
    return new pr({
      ...e,
      scheduledDate: e.scheduledDate ? L(e.scheduledDate) : void 0,
      settings: e.settingsJson ? JSON.parse(e.settingsJson) : void 0
    });
  }
}
var Tv = /* @__PURE__ */ ((p) => (p.Default = "default", p.Pending = "pending", p.InProgress = "inProgress", p.Completed = "completed", p.Aborted = "aborted", p.Error = "error", p))(Tv || {}), wv = Object.defineProperty, Sv = Object.getOwnPropertyDescriptor, D1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Sv(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && wv(t, e, b), b;
};
const _1 = class tl extends n0 {
  constructor(e) {
    super();
    z(this, "isActive");
    z(this, "agreementRequired");
    z(this, "agreementText");
    z(this, "agreementUrl");
    z(this, "partnerAssigningCookieDurationDays");
    z(this, "partnerAssigningDurationType");
    z(this, "partnerAssigningDurationDays");
    z(this, "transferBonusPartner");
    z(this, "transferBonusPartnerAmount");
    z(this, "transferBonusReferral");
    z(this, "transferBonusReferralAmount");
    z(this, "transferFeeMethod");
    z(this, "transferFeeAllowed");
    z(this, "transferFeeAllowedToBonus");
    z(this, "transferFeeMinAmount");
    z(this, "transferFeeHoldingPeriodDays");
    z(this, "partnershipVisible");
    z(this, "partnershipPaidOrdersVisible");
    z(this, "partnershipAllOrdersVisible");
    z(this, "partnershipOrdersContactVisible");
    z(this, "paymentGatewayFeeEnabled");
    z(this, "levelCount");
    i0(this), e && this.update(e);
  }
  get isSingleLevel() {
    return this.levelCount === 1;
  }
  static fromJson(e) {
    return new tl({
      ...e
    });
  }
};
D1([
  a
], _1.prototype, "isActive", 2);
D1([
  a
], _1.prototype, "agreementRequired", 2);
D1([
  a
], _1.prototype, "agreementText", 2);
D1([
  a
], _1.prototype, "agreementUrl", 2);
D1([
  a
], _1.prototype, "partnerAssigningCookieDurationDays", 2);
D1([
  a
], _1.prototype, "partnerAssigningDurationType", 2);
D1([
  a
], _1.prototype, "partnerAssigningDurationDays", 2);
D1([
  a
], _1.prototype, "transferBonusPartner", 2);
D1([
  a
], _1.prototype, "transferBonusPartnerAmount", 2);
D1([
  a
], _1.prototype, "transferBonusReferral", 2);
D1([
  a
], _1.prototype, "transferBonusReferralAmount", 2);
D1([
  a
], _1.prototype, "transferFeeMethod", 2);
D1([
  a
], _1.prototype, "transferFeeAllowed", 2);
D1([
  a
], _1.prototype, "transferFeeAllowedToBonus", 2);
D1([
  a
], _1.prototype, "transferFeeMinAmount", 2);
D1([
  a
], _1.prototype, "transferFeeHoldingPeriodDays", 2);
D1([
  a
], _1.prototype, "partnershipVisible", 2);
D1([
  a
], _1.prototype, "partnershipPaidOrdersVisible", 2);
D1([
  a
], _1.prototype, "partnershipAllOrdersVisible", 2);
D1([
  a
], _1.prototype, "partnershipOrdersContactVisible", 2);
D1([
  a
], _1.prototype, "paymentGatewayFeeEnabled", 2);
D1([
  a
], _1.prototype, "levelCount", 2);
D1([
  $
], _1.prototype, "isSingleLevel", 1);
let Dv = _1;
var Xv = Object.defineProperty, Cv = Object.getOwnPropertyDescriptor, At = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Cv(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Xv(t, e, b), b;
};
const x2 = class pl extends n0 {
  constructor(e) {
    super();
    z(this, "enabled", !1);
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "popupText", "");
    z(this, "popupJoinText", "");
    z(this, "sortType", "createdDate");
    z(this, "popularPostsWidgetEnabled", !0);
    z(this, "popularPostsWidgetSortType", "likesCount");
    z(this, "calendarWidgetEnabled", !0);
    z(this, "leaderboardWidgetEnabled", !0);
    i0(this), e && this.update(e);
  }
  // #endregion
  toJson() {
    return {
      ...this
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    return this.popupText != e.popupText || this.popupJoinText != e.popupJoinText || this.sortType !== e.sortType || this.popularPostsWidgetSortType !== e.popularPostsWidgetSortType || this.popularPostsWidgetEnabled !== e.popularPostsWidgetEnabled || this.calendarWidgetEnabled !== e.calendarWidgetEnabled || this.leaderboardWidgetEnabled !== e.leaderboardWidgetEnabled;
  }
  static fromJson(e) {
    return new pl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      popupText: e.popupText ?? "",
      popupJoinText: e.popupJoinText ?? ""
    });
  }
};
At([
  a
], x2.prototype, "enabled", 2);
At([
  a
], x2.prototype, "createdDate", 2);
At([
  a
], x2.prototype, "updatedDate", 2);
At([
  a
], x2.prototype, "popupText", 2);
At([
  a
], x2.prototype, "popupJoinText", 2);
At([
  a
], x2.prototype, "sortType", 2);
At([
  a
], x2.prototype, "popularPostsWidgetEnabled", 2);
At([
  a
], x2.prototype, "popularPostsWidgetSortType", 2);
At([
  a
], x2.prototype, "calendarWidgetEnabled", 2);
At([
  a
], x2.prototype, "leaderboardWidgetEnabled", 2);
At([
  C
], x2.prototype, "update", 1);
let Iv = x2;
class $1 extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "cloudKey");
    z(this, "size");
    z(this, "mimetype");
    z(this, "type");
    z(this, "extension");
    z(this, "createdDate");
    z(this, "nativeFile");
    z(this, "previewImage");
    z(this, "previewAudio");
    /**
    * external file source
    */
    z(this, "url");
    e && this.update(e);
  }
  get isExternalFile() {
    return !Ae.isEmpty(this.url);
  }
  get isImage() {
    return [".bmp", ".dib", ".rle", ".jpg", ".jpeg", ".jpe", ".jfif", ".gif", ".tif", ".tiff", ".png", ".svg", ".pjpeg", ".webp", ".ico"].includes(this.extension);
  }
  get isAudio() {
    return [".mp3", ".ogg", ".webm", ".m4a"].includes(this.extension);
  }
  get filename() {
    return this.name + this.extension;
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(e) {
    return new $1({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0
    });
  }
  static fromFile(e, o) {
    const b = e.name.lastIndexOf("."), r = new $1({
      nativeFile: e,
      size: e.size,
      mimetype: e.type,
      name: e.name.substring(0, b),
      extension: e.name.substring(b),
      createdDate: L(),
      ...o
    });
    return r.isImage && r.nativeFile && (r.previewImage = URL.createObjectURL(r.nativeFile)), r.isAudio && r.nativeFile && r.nativeFile.type.includes("audio") && (r.previewAudio = URL.createObjectURL(r.nativeFile)), r;
  }
}
class Sb extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "number");
    z(this, "domain");
    z(this, "customDomain");
    z(this, "disableOpenRegistration");
    z(this, "isForumAvailable");
    z(this, "settings");
    z(this, "profileSettings");
    z(this, "timezone");
    // owner: Admin;
    z(this, "logo");
    z(this, "favicon");
    z(this, "showUnavailableStartedCourses");
    z(this, "isExternal");
    /**
     * @deprecated use owner instead
     */
    z(this, "ownerId");
    z(this, "jsHeadCode");
    z(this, "jsBodyCode");
    z(this, "supportChatEnabled");
    z(this, "supportConversationTitle");
    z(this, "recordInternalCalls");
    z(this, "recordCRMCalls");
    z(this, "lang");
    z(this, "createdDate");
    // mainSiteDomain: SiteDomain | null;
    z(this, "phoneBalance");
    z(this, "isLocked");
    z(this, "currency");
    // billing: SchoolBilling;
    // metadata: SchoolMetadata;
    // country: Country;
    // appIntegrations: ApplicationType[];
    // chatChannelIntegrations: ChatChannelIntegration[];
    z(this, "allowCustomProductGatewaySettings");
    z(this, "allowCustomProductPaymentMethodsSettings");
    // organization: Organization;
    z(this, "partnership");
    z(this, "community");
    z(this, "gamification");
    z(this, "migration", null);
    e && this.update(e);
  }
  get hasMigrationLock() {
    var e, o;
    return ((e = this.migration) == null ? void 0 : e.isActive) || ((o = this.migration) == null ? void 0 : o.isCompleted);
  }
  // get canUseBillingAddress() {
  //     return this.billing.currency == Currency.USD;
  // }
  // get hasTgAppIntegration() {
  //     return this.appIntegrations.includes(ApplicationType.Telegram);
  // }
  // get hasChatChannelIntegrations() {
  //     return this.chatChannelIntegrations.length > 0;
  // }
  update(e) {
    super.update(e);
  }
  // clone(): School {
  //     return new School({
  //         ...this,
  //         settings: this.settings?.copy(),
  //         profileSettings: this.profileSettings.copy(),
  //         timezone: this.timezone.clone(),
  //         owner: this.owner?.clone(),
  //         logo: this.logo?.clone(),
  //         favicon: this.favicon?.clone(),
  //         createdDate: this.createdDate ? new Date(this.createdDate) : undefined,
  //         mainSiteDomain: this.mainSiteDomain?.clone(),
  //         billing: this.billing?.clone(),
  //         metadata: this.metadata?.clone(),
  //         chatChannelIntegrations: this.chatChannelIntegrations.map((c) => c.clone()),
  //         partnership: this.partnership?.clone(),
  //         organization: this.organization?.clone()
  //     });
  // }
  static fromJson(e) {
    return new Sb({
      ...e,
      timezone: e.timezone ? hM.fromJson(e.timezone) : hM.utc(),
      // settings: json.settings ? SchoolSettings.fromJson(json.settings) : new SchoolSettings(),
      // profileSettings: SchoolProfileSettings.fromJson(json.studentProfileSettings),
      logo: e.logo ? $1.fromJson(e.logo) : null,
      favicon: e.favicon ? $1.fromJson(e.favicon) : null,
      // createdDate: json.createdDate ? new Date(json.createdDate) : undefined,
      // mainSiteDomain: json.mainSiteDomain ? SiteDomain.fromJson(json.mainSiteDomain) : null,
      // billing: json.billing ? SchoolBilling.fromJson(json.billing) : undefined,
      // metadata: json.metadata ? SchoolMetadata.fromJson(json.metadata) : undefined,
      // country: json.country,
      // owner: json.owner ? Admin.fromJson(json.owner) : undefined,
      // appIntegrations: json.appIntegrations ?? [],
      // chatChannelIntegrations: json.chatChannelIntegrations
      //     ? json.chatChannelIntegrations.map(ChatChannelIntegration.fromJson)
      //     : [],
      allowCustomProductGatewaySettings: e.allowCustomProductGatewaySettings ?? !1,
      allowCustomProductPaymentMethodsSettings: e.allowCustomProductPaymentMethodsSettings ?? !1,
      partnership: e.partnership ? Dv.fromJson(e.partnership) : null,
      community: e.community ? Iv.fromJson(e.community) : null,
      gamification: e.gamification ? Rl.fromJson(e.gamification) : null,
      // organization: json.organization ? Organization.fromJson(json.organization) : undefined,
      migration: e.migration ? pr.fromJson(e.migration) : void 0
    });
  }
}
var Pv = Object.defineProperty, Ev = Object.getOwnPropertyDescriptor, u1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Ev(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Pv(t, e, b), b;
}, kv = /* @__PURE__ */ ((p) => (p.Simple = "simple", p.Api = "api", p))(kv || {}), xv = /* @__PURE__ */ ((p) => (p.NotPartner = "notPartner", p.Silver = "silver", p.Gold = "gold", p.Platinum = "platinum", p))(xv || {});
const c1 = class zz extends n0 {
  constructor(e) {
    super();
    z(this, "firstName");
    z(this, "lastName");
    z(this, "middleName");
    z(this, "phone");
    z(this, "email");
    z(this, "avatar");
    z(this, "gender");
    z(this, "birthday");
    z(this, "lang");
    z(this, "post");
    z(this, "isEmailConfirmed");
    z(this, "emailConfirmationSentDate");
    z(this, "isPhoneConfirmed");
    z(this, "needChangePassword");
    z(this, "school");
    z(this, "schools");
    z(this, "partner");
    z(this, "type");
    z(this, "partnerStatus");
    z(this, "createdDate");
    i0(this), e && this.update(e);
  }
  get isFirstNameEmpty() {
    return y1(this.firstName);
  }
  get isLastNameEmpty() {
    return y1(this.lastName);
  }
  get hasName() {
    return !this.isFirstNameEmpty || !this.isLastNameEmpty;
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  get fullNameNoEmail() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? "" : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  clone() {
    var e, o, b;
    return new zz({
      ...this,
      school: (e = this.school) == null ? void 0 : e.clone(),
      schools: this.schools.map((r) => r.clone()),
      partner: (o = this.partner) == null ? void 0 : o.clone(),
      avatar: (b = this.avatar) == null ? void 0 : b.clone(),
      birthday: this.birthday ? new Date(this.birthday) : void 0,
      createdDate: this.createdDate ? L(this.createdDate) : void 0,
      emailConfirmationSentDate: this.emailConfirmationSentDate ? new Date(this.emailConfirmationSentDate) : null
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new zz({
      ...e,
      school: e.school ? Sb.fromJson(e.school) : null,
      schools: e.schools ? e.schools.map(Sb.fromJson) : [],
      partner: e.partner ? zz.fromJson(e.partner) : null,
      avatar: e.avatar ? at.fromJson(e.avatar) : void 0,
      birthday: e.birthday ? new Date(e.birthday) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      emailConfirmationSentDate: e.emailConfirmationSentDate ? new Date(e.emailConfirmationSentDate) : null
    });
  }
};
u1([
  a
], c1.prototype, "firstName", 2);
u1([
  a
], c1.prototype, "lastName", 2);
u1([
  a
], c1.prototype, "middleName", 2);
u1([
  a
], c1.prototype, "phone", 2);
u1([
  a
], c1.prototype, "email", 2);
u1([
  a
], c1.prototype, "avatar", 2);
u1([
  a
], c1.prototype, "gender", 2);
u1([
  a
], c1.prototype, "birthday", 2);
u1([
  a
], c1.prototype, "lang", 2);
u1([
  a
], c1.prototype, "post", 2);
u1([
  a
], c1.prototype, "isEmailConfirmed", 2);
u1([
  a
], c1.prototype, "emailConfirmationSentDate", 2);
u1([
  a
], c1.prototype, "isPhoneConfirmed", 2);
u1([
  a
], c1.prototype, "needChangePassword", 2);
u1([
  a
], c1.prototype, "school", 2);
u1([
  a
], c1.prototype, "schools", 2);
u1([
  a
], c1.prototype, "partner", 2);
u1([
  a
], c1.prototype, "type", 2);
u1([
  a
], c1.prototype, "partnerStatus", 2);
u1([
  a
], c1.prototype, "createdDate", 2);
u1([
  $
], c1.prototype, "isFirstNameEmpty", 1);
u1([
  $
], c1.prototype, "isLastNameEmpty", 1);
u1([
  $
], c1.prototype, "hasName", 1);
u1([
  $
], c1.prototype, "fullName", 1);
u1([
  $
], c1.prototype, "fullNameNoEmail", 1);
u1([
  C
], c1.prototype, "update", 1);
let Xa = c1;
class wt extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "primaryImage");
    z(this, "dontAskFeedback");
    z(this, "totalItemCount");
    z(this, "freeAccess");
    z(this, "studentCanBuyAccess");
    z(this, "paymentUrl");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var o;
    return new wt({
      ...e,
      primaryImage: (o = e.primaryImage) != null && o.file ? $1.fromJson(e.primaryImage.file) : null
    });
  }
}
class DM extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "course");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new DM({
      ...e,
      course: e.course ? wt.fromJson(e.course) : void 0
    });
  }
}
class Fv extends J0 {
  constructor(e) {
    super();
    z(this, "courseId");
    z(this, "courseIds");
    z(this, "productPackageId");
    z(this, "isPopular");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var Uv = Object.defineProperty, Hv = Object.getOwnPropertyDescriptor, d0 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Hv(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Uv(t, e, b), b;
}, rz = /* @__PURE__ */ ((p) => (p.RegardlessOfPreviousSteps = "regardlessOfPreviousSteps", p.PreviousStepCompleted = "previousStepCompleted", p.AllPreviousStepsCompleted = "allPreviousStepsCompleted", p))(rz || {}), Dp = /* @__PURE__ */ ((p) => (p.PreviousStep = "previousStep", p.CourseStart = "courseStart", p.AccessStart = "accessStart", p.PreviousSectionStarted = "previousSectionStarted", p.PreviousSectionCompleted = "previousSectionCompleted", p))(Dp || {}), Xp = /* @__PURE__ */ ((p) => (p.PreviousStep = "previousStep", p.FlowStart = "flowStart", p.CourseStart = "courseStart", p.PreviousSectionStarted = "previousSectionStarted", p.PreviousSectionCompleted = "previousSectionCompleted", p))(Xp || {}), Z1 = /* @__PURE__ */ ((p) => (p.Step = "step", p.Section = "section", p))(Z1 || {});
const u0 = class cz extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "position");
    z(this, "isDraft");
    z(this, "isOptional");
    z(this, "type");
    z(this, "comment");
    z(this, "allowComments");
    z(this, "showComments");
    z(this, "disableCommentModeration");
    z(this, "ratingEnabled");
    z(this, "ratingRequired");
    z(this, "ratingCommentRequired");
    z(this, "availableOnAllPlans");
    z(this, "showRegardlessPlan");
    z(this, "availability");
    z(this, "regularTimeDelayActive");
    z(this, "regularTimeDelay");
    z(this, "regularTimeDelayCondition");
    z(this, "regularTimeDelayMeasureType");
    z(this, "regularWaitUntilTimeDaysOfWeekActive");
    z(this, "regularWaitUntilDaysOfWeek");
    z(this, "regularWaitUntilTimeActive");
    z(this, "regularWaitUntilTime", null);
    z(this, "flowTimeDelayActive");
    z(this, "flowTimeDelay");
    z(this, "flowTimeDelayCondition");
    z(this, "flowTimeDelayMeasureType");
    z(this, "flowWaitUntilTimeDaysOfWeekActive");
    z(this, "flowWaitUntilDaysOfWeek");
    z(this, "flowWaitUntilTimeActive");
    z(this, "flowWaitUntilTime");
    z(this, "dateDelayActive");
    z(this, "dateDelay", null);
    z(this, "preventCopingAndSelectingText");
    z(this, "blockCourseUntilTasksApproved");
    z(this, "theoryVisible");
    z(this, "tasksVisible");
    z(this, "testsVisible");
    z(this, "score");
    z(this, "plans", []);
    z(this, "files", []);
    z(this, "parent");
    z(this, "parentItemId", null);
    z(this, "children", []);
    z(this, "course");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "designSettings");
    z(this, "designSettingsPublished");
    z(this, "designHTMLPublished");
    z(this, "designStylePublished");
    z(this, "designConcurrencyStamp");
    i0(this), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new cz({
      ...e,
      regularTimeDelay: e.regularTimeDelay ? e.regularTimeDelay : 1,
      regularTimeDelayCondition: e.regularTimeDelayCondition ? e.regularTimeDelayCondition : "previousStep",
      regularTimeDelayMeasureType: e.regularTimeDelayMeasureType ? e.regularTimeDelayMeasureType : "days",
      flowTimeDelay: e.flowTimeDelay ? e.flowTimeDelay : 1,
      flowTimeDelayCondition: e.flowTimeDelayCondition ? e.flowTimeDelayCondition : "previousStep",
      flowTimeDelayMeasureType: e.flowTimeDelayMeasureType ? e.flowTimeDelayMeasureType : "days",
      // TODO simplify model?
      plans: e.plans ? e.plans.map((o) => DM.fromJson(o.coursePlan)) : void 0,
      parent: e.parentItem ? cz.fromJson(e.parentItem) : void 0,
      children: e.children ? e.children.map(cz.fromJson) : void 0,
      course: e.course ? wt.fromJson(e.course) : void 0,
      // TODO simplify model?
      files: e.fileLinks ? e.fileLinks.map((o) => $1.fromJson(o.file)) : [],
      dateDelay: e.dateDelay ? L(e.dateDelay) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      regularWaitUntilTime: e.regularWaitUntilTime ? L(e.regularWaitUntilTime) : void 0,
      flowWaitUntilTime: e.flowWaitUntilTime ? L(e.flowWaitUntilTime) : void 0
    });
  }
};
d0([
  a
], u0.prototype, "title", 2);
d0([
  a
], u0.prototype, "position", 2);
d0([
  a
], u0.prototype, "isDraft", 2);
d0([
  a
], u0.prototype, "isOptional", 2);
d0([
  a
], u0.prototype, "type", 2);
d0([
  a
], u0.prototype, "comment", 2);
d0([
  a
], u0.prototype, "allowComments", 2);
d0([
  a
], u0.prototype, "showComments", 2);
d0([
  a
], u0.prototype, "disableCommentModeration", 2);
d0([
  a
], u0.prototype, "ratingEnabled", 2);
d0([
  a
], u0.prototype, "ratingRequired", 2);
d0([
  a
], u0.prototype, "ratingCommentRequired", 2);
d0([
  a
], u0.prototype, "availableOnAllPlans", 2);
d0([
  a
], u0.prototype, "showRegardlessPlan", 2);
d0([
  a
], u0.prototype, "availability", 2);
d0([
  a
], u0.prototype, "regularTimeDelayActive", 2);
d0([
  a
], u0.prototype, "regularTimeDelay", 2);
d0([
  a
], u0.prototype, "regularTimeDelayCondition", 2);
d0([
  a
], u0.prototype, "regularTimeDelayMeasureType", 2);
d0([
  a
], u0.prototype, "regularWaitUntilTimeDaysOfWeekActive", 2);
d0([
  a
], u0.prototype, "regularWaitUntilDaysOfWeek", 2);
d0([
  a
], u0.prototype, "regularWaitUntilTimeActive", 2);
d0([
  a
], u0.prototype, "regularWaitUntilTime", 2);
d0([
  a
], u0.prototype, "flowTimeDelayActive", 2);
d0([
  a
], u0.prototype, "flowTimeDelay", 2);
d0([
  a
], u0.prototype, "flowTimeDelayCondition", 2);
d0([
  a
], u0.prototype, "flowTimeDelayMeasureType", 2);
d0([
  a
], u0.prototype, "flowWaitUntilTimeDaysOfWeekActive", 2);
d0([
  a
], u0.prototype, "flowWaitUntilDaysOfWeek", 2);
d0([
  a
], u0.prototype, "flowWaitUntilTimeActive", 2);
d0([
  a
], u0.prototype, "flowWaitUntilTime", 2);
d0([
  a
], u0.prototype, "dateDelayActive", 2);
d0([
  a
], u0.prototype, "dateDelay", 2);
d0([
  a
], u0.prototype, "preventCopingAndSelectingText", 2);
d0([
  a
], u0.prototype, "blockCourseUntilTasksApproved", 2);
d0([
  a
], u0.prototype, "theoryVisible", 2);
d0([
  a
], u0.prototype, "tasksVisible", 2);
d0([
  a
], u0.prototype, "testsVisible", 2);
d0([
  a
], u0.prototype, "score", 2);
d0([
  a
], u0.prototype, "plans", 2);
d0([
  a
], u0.prototype, "files", 2);
d0([
  a
], u0.prototype, "parent", 2);
d0([
  a
], u0.prototype, "parentItemId", 2);
d0([
  a
], u0.prototype, "children", 2);
d0([
  a
], u0.prototype, "course", 2);
d0([
  a
], u0.prototype, "createdDate", 2);
d0([
  a
], u0.prototype, "updatedDate", 2);
d0([
  a
], u0.prototype, "designSettings", 2);
d0([
  a
], u0.prototype, "designSettingsPublished", 2);
d0([
  a
], u0.prototype, "designHTMLPublished", 2);
d0([
  a
], u0.prototype, "designStylePublished", 2);
d0([
  a
], u0.prototype, "designConcurrencyStamp", 2);
d0([
  C
], u0.prototype, "update", 1);
let Qb = u0;
var Jv = Object.defineProperty, $v = Object.getOwnPropertyDescriptor, De = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? $v(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Jv(t, e, b), b;
};
const ge = class ol extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "lastActivityDate");
    z(this, "beginDate");
    z(this, "endDate");
    z(this, "state");
    z(this, "progress");
    z(this, "contact");
    z(this, "course");
    z(this, "currentCourseItem");
    z(this, "feedback");
    z(this, "score");
    /**
     * sections excluded
     */
    z(this, "totalItemCount");
    /**
     * @deprecated use currentCourseItem instead
     */
    z(this, "initialCourseItemId");
    z(this, "cohortBeginDate");
    z(this, "accessBeginDate");
    z(this, "accessEndDate");
    z(this, "isSubscription");
    i0(this), e && this.update(e);
  }
  get hasFeedback() {
    return !Ae.isEmpty(this.feedback);
  }
  get isInCohort() {
    return this.cohortBeginDate != null;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var o;
    return new ol({
      ...e,
      lastActivityDate: e.lastActivityDate ? L(e.lastActivityDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      course: e.course ? wt.fromJson(e.course) : void 0,
      // TODO remove from model, use currentCourseItem instead
      initialCourseItemId: (o = e.currentCourseItem) == null ? void 0 : o.id,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      beginDate: e.beginDate ? L(e.beginDate) : void 0,
      endDate: e.endDate ? L(e.endDate) : void 0,
      // TODO rename flowBeginDate to cohortBeginDate?
      cohortBeginDate: e.flowBeginDate ? L(e.flowBeginDate) : void 0,
      accessBeginDate: e.accessBeginDate ? L(e.accessBeginDate) : void 0,
      accessEndDate: e.accessEndDate ? L(e.accessEndDate) : void 0,
      isSubscription: e.isSubscription ?? !1,
      currentCourseItem: e.currentCourseItem ? Qb.fromJson(e.currentCourseItem) : void 0
    });
  }
};
De([
  a
], ge.prototype, "beginDate", 2);
De([
  a
], ge.prototype, "endDate", 2);
De([
  a
], ge.prototype, "state", 2);
De([
  a
], ge.prototype, "progress", 2);
De([
  a
], ge.prototype, "contact", 2);
De([
  a
], ge.prototype, "course", 2);
De([
  a
], ge.prototype, "currentCourseItem", 2);
De([
  a
], ge.prototype, "feedback", 2);
De([
  a
], ge.prototype, "score", 2);
De([
  a
], ge.prototype, "cohortBeginDate", 2);
De([
  a
], ge.prototype, "accessBeginDate", 2);
De([
  a
], ge.prototype, "accessEndDate", 2);
De([
  a
], ge.prototype, "isSubscription", 2);
De([
  $
], ge.prototype, "hasFeedback", 1);
De([
  $
], ge.prototype, "isInCohort", 1);
let or = ge;
var Vv = Object.defineProperty, cp = (p, t, e, o) => {
  for (var b = void 0, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && Vv(t, e, b), b;
};
const St = class Ml extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "title");
    z(this, "shortDescription");
    z(this, "freeAccess");
    z(this, "primaryImageCloudKey");
    z(this, "primaryImage");
    z(this, "studentAccessDate");
    z(this, "flowBeginDate");
    z(this, "studentHasAccess");
    z(this, "categories");
    i0(this), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var o;
    return new Ml({
      ...e,
      primaryImage: (o = e.primaryImage) != null && o.file ? $1.fromJson(e.primaryImage.file) : null,
      studentAccessDate: e.studentAccessDate ? new Date(e.studentAccessDate) : void 0,
      flowBeginDate: e.flowBeginDate ? new Date(e.flowBeginDate) : void 0
    });
  }
};
cp([
  a
], St.prototype, "name");
cp([
  a
], St.prototype, "title");
cp([
  a
], St.prototype, "shortDescription");
cp([
  a
], St.prototype, "freeAccess");
cp([
  a
], St.prototype, "primaryImageCloudKey");
cp([
  a
], St.prototype, "studentAccessDate");
cp([
  a
], St.prototype, "flowBeginDate");
cp([
  a
], St.prototype, "studentHasAccess");
cp([
  a
], St.prototype, "categories");
let Co = St;
class Bw extends J0 {
  constructor(t) {
    super(), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
var Yv = Object.defineProperty, Gv = Object.getOwnPropertyDescriptor, R0 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Gv(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Yv(t, e, b), b;
}, lb = /* @__PURE__ */ ((p) => (p.Section = "section", p.Article = "step", p))(lb || {});
const v0 = class qb extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "comment");
    z(this, "position");
    z(this, "avgRating");
    z(this, "designHTMLPublished");
    z(this, "designStylePublished");
    z(this, "type");
    z(this, "parent");
    z(this, "parentItemId");
    z(this, "isDraft");
    z(this, "allowComments");
    z(this, "showComments");
    z(this, "ratingEnabled");
    z(this, "disableCommentModeration");
    z(this, "ratingCommentRequired");
    z(this, "preventCopingAndSelectingText");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "flowTimeDelayActive");
    z(this, "flowTimeDelay");
    z(this, "flowTimeDelayCondition");
    z(this, "flowTimeDelayMeasureType");
    z(this, "library");
    z(this, "parentItem");
    z(this, "children", []);
    z(this, "section");
    z(this, "previousItem");
    z(this, "nextItem");
    z(this, "studentHasAccess");
    z(this, "flowBeginDate");
    z(this, "progress");
    z(this, "_tab");
    i0(this), e && this.update(e);
  }
  get ratingVisible() {
    return this.allowComments || this.ratingEnabled;
  }
  get tab() {
    return this._tab;
  }
  set tab(e) {
    switch (e) {
      case "article": {
        this._tab = "article";
        return;
      }
      case "rating": {
        if (this.allowComments || this.ratingEnabled) {
          this._tab = "rating";
          return;
        }
        break;
      }
    }
  }
  get completed() {
    return !y1(this.progress);
  }
  get fullPosition() {
    let e = "", o = this.section;
    for (; o != null; )
      e += `${o.position}.`, o = o.section;
    return e += this.position, e;
  }
  get lastChild() {
    return this.getLastNestedStep();
  }
  getLastNestedStep() {
    if (this.type == "step" || this.children.length == 0)
      return null;
    for (const e of this.children.slice().reverse()) {
      if (e.type == "step")
        return e;
      const o = e.getLastNestedStep();
      if (o != null)
        return o;
    }
    return null;
  }
  get firstChild() {
    return this.getFirstNestedStep();
  }
  getFirstNestedStep() {
    if (this.type == "step" || this.children.length == 0)
      return null;
    const e = this.children.filter(
      (o) => o.type == "step"
      /* Article */
    );
    if (e.length > 0)
      return e[0];
    for (const o of this.children) {
      const b = o.getFirstNestedStep();
      if (b != null)
        return b;
    }
    return null;
  }
  get parentAvailability() {
    return this.section != null ? this.section.availability : { result: !0 };
  }
  get canSelect() {
    return this.availability.result;
  }
  get availability() {
    const e = this.parentAvailability;
    return e.result ? this.availabilityRelativeToTimeDelay.result ? this.studentHasAccess ? { result: !0 } : { result: !1 } : this.availabilityRelativeToTimeDelay : { ...e, isSection: !0 };
  }
  get availabilityRelativeToTimeDelay() {
    if (this.flowTimeDelayActive)
      switch (this.flowTimeDelayCondition) {
        case "flowStart": {
          if (this.flowBeginDate == null)
            break;
          const e = L(), o = L(this.flowBeginDate).add(this.flowTimeDelayValue.milliseconds, "milliseconds");
          if (e <= o)
            return { result: !1, willBeAvailableOn: o };
          break;
        }
      }
    return { result: !0 };
  }
  get flowTimeDelayValue() {
    return Ae.isNil(this.flowTimeDelay) ? s1.zero : s1.fromTimeMeasure(this.flowTimeDelay, this.flowTimeDelayMeasureType ?? "days");
  }
  clone() {
    return new qb({
      ...this,
      parent: this.parent ? this.parent.clone() : void 0,
      library: this.library ? this.library.clone() : void 0
    });
  }
  static fromJson(e) {
    return new qb({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      library: e.library ? Co.fromJson(e.library) : void 0,
      parent: e.parentItem ? qb.fromJson(e.parentItem) : void 0,
      studentHasAccess: e.studentHasAccess,
      parentItem: e.parentItem ? qb.fromJson(e.parentItem) : null,
      progress: e.progress ? Kv.fromJson(e.progress) : void 0
    });
  }
  update(e) {
    super.update(e);
  }
};
R0([
  a
], v0.prototype, "title", 2);
R0([
  a
], v0.prototype, "comment", 2);
R0([
  a
], v0.prototype, "position", 2);
R0([
  a
], v0.prototype, "avgRating", 2);
R0([
  a
], v0.prototype, "designHTMLPublished", 2);
R0([
  a
], v0.prototype, "designStylePublished", 2);
R0([
  a
], v0.prototype, "type", 2);
R0([
  a
], v0.prototype, "parent", 2);
R0([
  a
], v0.prototype, "parentItemId", 2);
R0([
  a
], v0.prototype, "isDraft", 2);
R0([
  a
], v0.prototype, "allowComments", 2);
R0([
  a
], v0.prototype, "showComments", 2);
R0([
  a
], v0.prototype, "ratingEnabled", 2);
R0([
  a
], v0.prototype, "disableCommentModeration", 2);
R0([
  a
], v0.prototype, "ratingCommentRequired", 2);
R0([
  a
], v0.prototype, "preventCopingAndSelectingText", 2);
R0([
  a
], v0.prototype, "createdDate", 2);
R0([
  a
], v0.prototype, "updatedDate", 2);
R0([
  a
], v0.prototype, "flowTimeDelayActive", 2);
R0([
  a
], v0.prototype, "flowTimeDelay", 2);
R0([
  a
], v0.prototype, "flowTimeDelayCondition", 2);
R0([
  a
], v0.prototype, "flowTimeDelayMeasureType", 2);
R0([
  a
], v0.prototype, "library", 2);
R0([
  a
], v0.prototype, "parentItem", 2);
R0([
  a
], v0.prototype, "children", 2);
R0([
  a
], v0.prototype, "section", 2);
R0([
  a
], v0.prototype, "previousItem", 2);
R0([
  a
], v0.prototype, "nextItem", 2);
R0([
  a
], v0.prototype, "studentHasAccess", 2);
R0([
  a
], v0.prototype, "flowBeginDate", 2);
R0([
  a
], v0.prototype, "progress", 2);
R0([
  $
], v0.prototype, "ratingVisible", 1);
R0([
  a
], v0.prototype, "_tab", 2);
R0([
  $
], v0.prototype, "tab", 1);
R0([
  $
], v0.prototype, "completed", 1);
R0([
  $
], v0.prototype, "fullPosition", 1);
R0([
  $
], v0.prototype, "lastChild", 1);
R0([
  $
], v0.prototype, "firstChild", 1);
R0([
  $
], v0.prototype, "parentAvailability", 1);
R0([
  $
], v0.prototype, "canSelect", 1);
R0([
  $
], v0.prototype, "availability", 1);
R0([
  $
], v0.prototype, "availabilityRelativeToTimeDelay", 1);
R0([
  $
], v0.prototype, "flowTimeDelayValue", 1);
R0([
  C
], v0.prototype, "update", 1);
let Db = v0;
const Mr = class bl extends n0 {
  constructor(e) {
    super();
    z(this, "beginDate");
    z(this, "rating");
    i0(this), e && this.update(e);
  }
  static fromJson(e) {
    return new bl({
      ...e,
      beginDate: e.createdDate ? L(e.createdDate) : void 0,
      rating: e.rating ? zl.fromJson(e.rating) : null
    });
  }
  update(e) {
    super.update(e);
  }
};
R0([
  a
], Mr.prototype, "beginDate", 2);
R0([
  a
], Mr.prototype, "rating", 2);
R0([
  C
], Mr.prototype, "update", 1);
let Kv = Mr;
var Qv = Object.defineProperty, Zv = Object.getOwnPropertyDescriptor, V1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? Zv(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && Qv(t, e, b), b;
};
class jv extends J0 {
  constructor(e) {
    super();
    z(this, "courseItemId");
    z(this, "courseId");
    z(this, "libraryItemId");
    z(this, "libraryId");
    z(this, "progressId");
    z(this, "parentId");
    z(this, "studentId");
    z(this, "state");
    z(this, "states");
    z(this, "root");
    z(this, "parentSoftDeleted");
    z(this, "ratingId");
    z(this, "hasRating");
    z(this, "studentIds");
    z(this, "courseItemIds");
    z(this, "libraryItemIds");
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "sectionType");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var e_ = /* @__PURE__ */ ((p) => (p.Moderation = "moderation", p.Published = "published", p.NotPublished = "notPublished", p))(e_ || {});
const E1 = class iz extends n0 {
  constructor(e) {
    super();
    z(this, "text");
    z(this, "state");
    z(this, "contact");
    z(this, "admin");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "parentId");
    z(this, "replyId");
    z(this, "children");
    z(this, "childrenCount");
    z(this, "rating");
    z(this, "files");
    z(this, "reply");
    z(this, "courseItem");
    z(this, "libraryItem");
    z(this, "sectionType");
    i0(this), e && this.update(e);
  }
  get author() {
    return this.admin ?? this.contact;
  }
  get isEmpty() {
    return !this.text && this.files.length == 0;
  }
  get isRoot() {
    return this.parentId == null;
  }
  get hasMore() {
    return this.childrenCount > this.children.length;
  }
  static fromJson(e) {
    return new iz({
      ...e,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      admin: e.admin ? Xa.fromJson(e.admin) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      children: e.children ? e.children.map(iz.fromJson) : void 0,
      rating: e.progress ? e.progress.rating : void 0,
      files: e.files ? e.files.map(at.fromJson) : [],
      reply: e.reply ? iz.fromJson(e.reply) : void 0,
      courseItem: e.courseItem ? Qb.fromJson(e.courseItem) : void 0,
      libraryItem: e.libraryItem ? Db.fromJson(e.libraryItem) : void 0
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
};
V1([
  a
], E1.prototype, "text", 2);
V1([
  a
], E1.prototype, "state", 2);
V1([
  a
], E1.prototype, "contact", 2);
V1([
  a
], E1.prototype, "admin", 2);
V1([
  a
], E1.prototype, "createdDate", 2);
V1([
  a
], E1.prototype, "updatedDate", 2);
V1([
  a
], E1.prototype, "parentId", 2);
V1([
  a
], E1.prototype, "replyId", 2);
V1([
  a
], E1.prototype, "children", 2);
V1([
  a
], E1.prototype, "childrenCount", 2);
V1([
  a
], E1.prototype, "rating", 2);
V1([
  a
], E1.prototype, "files", 2);
V1([
  a
], E1.prototype, "reply", 2);
V1([
  a
], E1.prototype, "courseItem", 2);
V1([
  a
], E1.prototype, "libraryItem", 2);
V1([
  a
], E1.prototype, "sectionType", 2);
V1([
  $
], E1.prototype, "author", 1);
V1([
  $
], E1.prototype, "isEmpty", 1);
V1([
  $
], E1.prototype, "isRoot", 1);
V1([
  $
], E1.prototype, "hasMore", 1);
V1([
  C
], E1.prototype, "update", 1);
let Cp = E1;
var t_ = Object.defineProperty, p_ = Object.getOwnPropertyDescriptor, F2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? p_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && t_(t, e, b), b;
};
const s2 = class nl extends n0 {
  constructor(e) {
    super();
    z(this, "comment");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "comments");
    z(this, "commentsCount");
    z(this, "rating");
    z(this, "files", []);
    z(this, "courseItem");
    z(this, "libraryItem");
    z(this, "sectionType");
    i0(this), e && this.update(e);
  }
  get isCommentEmpty() {
    return Ae.isEmpty(this.comment) && this.files.length == 0;
  }
  update(e) {
    super.update(e);
  }
  // clone() {
  //     return new SchoolContentItemProgressRating({
  //         ...this,
  //         files: this.files.slice(),
  //     });
  // }
  static fromJson(e) {
    return new nl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      comments: e.comments ? e.comments.map(Cp.fromJson) : void 0,
      files: e.files ? e.files.map(at.fromJson) : [],
      courseItem: e.courseItem ? Qb.fromJson(e.courseItem) : void 0,
      libraryItem: e.libraryItem ? Co.fromJson(e.libraryItem) : void 0
    });
  }
};
F2([
  a
], s2.prototype, "comment", 2);
F2([
  a
], s2.prototype, "createdDate", 2);
F2([
  a
], s2.prototype, "updatedDate", 2);
F2([
  a
], s2.prototype, "comments", 2);
F2([
  a
], s2.prototype, "commentsCount", 2);
F2([
  a
], s2.prototype, "rating", 2);
F2([
  a
], s2.prototype, "files", 2);
F2([
  a
], s2.prototype, "courseItem", 2);
F2([
  a
], s2.prototype, "libraryItem", 2);
F2([
  a
], s2.prototype, "sectionType", 2);
F2([
  $
], s2.prototype, "isCommentEmpty", 1);
F2([
  C
], s2.prototype, "update", 1);
let zl = s2;
var o_ = Object.defineProperty, M_ = Object.getOwnPropertyDescriptor, Le = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? M_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && o_(t, e, b), b;
};
class Io extends n0 {
  constructor() {
    super();
    z(this, "beginDate");
    z(this, "completeDate");
    z(this, "numberUncheckedTasks", 0);
    z(this, "numberCorrectTasks", 0);
    z(this, "numberIncorrectTasks", 0);
    i0(this);
  }
}
Le([
  a
], Io.prototype, "beginDate", 2);
Le([
  a
], Io.prototype, "completeDate", 2);
Le([
  a
], Io.prototype, "numberUncheckedTasks", 2);
Le([
  a
], Io.prototype, "numberCorrectTasks", 2);
Le([
  a
], Io.prototype, "numberIncorrectTasks", 2);
class rl extends Io {
  constructor(t) {
    super(), i0(this), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
Le([
  C
], rl.prototype, "update", 1);
const ut = class cl extends Io {
  constructor(e) {
    super();
    z(this, "precompleteDate");
    z(this, "theoryStatus");
    z(this, "testStatus");
    z(this, "taskStatus");
    z(this, "status");
    z(this, "rating");
    i0(this), e && this.update(e);
  }
  get theoryCompleted() {
    return this.theoryStatus == !0;
  }
  get testsCompleted() {
    return this.testStatus == !0;
  }
  get tasksCompleted() {
    return this.taskStatus == "completed";
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new cl({
      ...e,
      beginDate: new Date(e.beginDate),
      completeDate: e.completeDate ? new Date(e.completeDate) : null,
      precompleteDate: e.precompleteDate ? new Date(e.precompleteDate) : null,
      rating: e.rating ? zl.fromJson(e.rating) : null
    });
  }
};
Le([
  a
], ut.prototype, "precompleteDate", 2);
Le([
  a
], ut.prototype, "theoryStatus", 2);
Le([
  a
], ut.prototype, "testStatus", 2);
Le([
  a
], ut.prototype, "taskStatus", 2);
Le([
  a
], ut.prototype, "status", 2);
Le([
  a
], ut.prototype, "rating", 2);
Le([
  $
], ut.prototype, "theoryCompleted", 1);
Le([
  $
], ut.prototype, "testsCompleted", 1);
Le([
  $
], ut.prototype, "tasksCompleted", 1);
Le([
  C
], ut.prototype, "update", 1);
let il = ut;
class $e {
  constructor(t) {
    z(this, "courseItemId");
    z(this, "contactCourse");
    z(this, "courseItemProgress");
    t && Object.assign(this, t);
  }
  static fromJson(t) {
    return new $e({
      courseItemId: t.courseItemId,
      contactCourse: t.studentCourse ? or.fromJson(t.studentCourse) : void 0,
      courseItemProgress: t.courseItemProgress ? il.fromJson(t.courseItemProgress) : void 0
    });
  }
}
var wc = { exports: {} }, az = { exports: {} };
const b_ = /* @__PURE__ */ Zd(uL);
var n_ = az.exports, MA;
function z_() {
  return MA || (MA = 1, (function(p) {
    //! moment-timezone.js
    //! version : 0.5.48
    //! Copyright (c) JS Foundation and other contributors
    //! license : MIT
    //! github.com/moment/moment-timezone
    (function(t, e) {
      p.exports ? p.exports = e(b_) : e(t.moment);
    })(n_, function(t) {
      t.version === void 0 && t.default && (t = t.default);
      var e = "0.5.48", o = {}, b = {}, r = {}, i = {}, s = {}, d;
      (!t || typeof t.version != "string") && d1("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
      var q = t.version.split("."), f = +q[0], h = +q[1];
      (f < 2 || f === 2 && h < 6) && d1("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com");
      function g(m) {
        return m > 96 ? m - 87 : m > 64 ? m - 29 : m - 48;
      }
      function y(m) {
        var I = 0, E = m.split("."), G = E[0], z0 = E[1] || "", h0 = 1, t1, _0 = 0, g0 = 1;
        for (m.charCodeAt(0) === 45 && (I = 1, g0 = -1), I; I < G.length; I++)
          t1 = g(G.charCodeAt(I)), _0 = 60 * _0 + t1;
        for (I = 0; I < z0.length; I++)
          h0 = h0 / 60, t1 = g(z0.charCodeAt(I)), _0 += t1 * h0;
        return _0 * g0;
      }
      function w(m) {
        for (var I = 0; I < m.length; I++)
          m[I] = y(m[I]);
      }
      function U(m, I) {
        for (var E = 0; E < I; E++)
          m[E] = Math.round((m[E - 1] || 0) + m[E] * 6e4);
        m[I - 1] = 1 / 0;
      }
      function N(m, I) {
        var E = [], G;
        for (G = 0; G < I.length; G++)
          E[G] = m[I[G]];
        return E;
      }
      function S(m) {
        var I = m.split("|"), E = I[2].split(" "), G = I[3].split(""), z0 = I[4].split(" ");
        return w(E), w(G), w(z0), U(z0, G.length), {
          name: I[0],
          abbrs: N(I[1].split(" "), G),
          offsets: N(E, G),
          untils: z0,
          population: I[5] | 0
        };
      }
      function D(m) {
        m && this._set(S(m));
      }
      function V(m, I) {
        var E = I.length;
        if (m < I[0])
          return 0;
        if (E > 1 && I[E - 1] === 1 / 0 && m >= I[E - 2])
          return E - 1;
        if (m >= I[E - 1])
          return -1;
        for (var G, z0 = 0, h0 = E - 1; h0 - z0 > 1; )
          G = Math.floor((z0 + h0) / 2), I[G] <= m ? z0 = G : h0 = G;
        return h0;
      }
      D.prototype = {
        _set: function(m) {
          this.name = m.name, this.abbrs = m.abbrs, this.untils = m.untils, this.offsets = m.offsets, this.population = m.population;
        },
        _index: function(m) {
          var I = +m, E = this.untils, G;
          if (G = V(I, E), G >= 0)
            return G;
        },
        countries: function() {
          var m = this.name;
          return Object.keys(r).filter(function(I) {
            return r[I].zones.indexOf(m) !== -1;
          });
        },
        parse: function(m) {
          var I = +m, E = this.offsets, G = this.untils, z0 = G.length - 1, h0, t1, _0, g0;
          for (g0 = 0; g0 < z0; g0++)
            if (h0 = E[g0], t1 = E[g0 + 1], _0 = E[g0 && g0 - 1], h0 < t1 && x0.moveAmbiguousForward ? h0 = t1 : h0 > _0 && x0.moveInvalidForward && (h0 = _0), I < G[g0] - h0 * 6e4)
              return E[g0];
          return E[z0];
        },
        abbr: function(m) {
          return this.abbrs[this._index(m)];
        },
        offset: function(m) {
          return d1("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(m)];
        },
        utcOffset: function(m) {
          return this.offsets[this._index(m)];
        }
      };
      function H(m, I) {
        this.name = m, this.zones = I;
      }
      function Y(m) {
        var I = m.toTimeString(), E = I.match(/\([a-z ]+\)/i);
        E && E[0] ? (E = E[0].match(/[A-Z]/g), E = E ? E.join("") : void 0) : (E = I.match(/[A-Z]{3,5}/g), E = E ? E[0] : void 0), E === "GMT" && (E = void 0), this.at = +m, this.abbr = E, this.offset = m.getTimezoneOffset();
      }
      function t0(m) {
        this.zone = m, this.offsetScore = 0, this.abbrScore = 0;
      }
      t0.prototype.scoreOffsetAt = function(m) {
        this.offsetScore += Math.abs(this.zone.utcOffset(m.at) - m.offset), this.zone.abbr(m.at).replace(/[^A-Z]/g, "") !== m.abbr && this.abbrScore++;
      };
      function j(m, I) {
        for (var E, G; G = ((I.at - m.at) / 12e4 | 0) * 6e4; )
          E = new Y(new Date(m.at + G)), E.offset === m.offset ? m = E : I = E;
        return m;
      }
      function b0() {
        var m = (/* @__PURE__ */ new Date()).getFullYear() - 2, I = new Y(new Date(m, 0, 1)), E = I.offset, G = [I], z0, h0, t1, _0;
        for (_0 = 1; _0 < 48; _0++)
          t1 = new Date(m, _0, 1).getTimezoneOffset(), t1 !== E && (h0 = new Y(new Date(m, _0, 1)), z0 = j(I, h0), G.push(z0), G.push(new Y(new Date(z0.at + 6e4))), I = h0, E = t1);
        for (_0 = 0; _0 < 4; _0++)
          G.push(new Y(new Date(m + _0, 0, 1))), G.push(new Y(new Date(m + _0, 6, 1)));
        return G;
      }
      function y0(m, I) {
        return m.offsetScore !== I.offsetScore ? m.offsetScore - I.offsetScore : m.abbrScore !== I.abbrScore ? m.abbrScore - I.abbrScore : m.zone.population !== I.zone.population ? I.zone.population - m.zone.population : I.zone.name.localeCompare(m.zone.name);
      }
      function m0(m, I) {
        var E, G;
        for (w(I), E = 0; E < I.length; E++)
          G = I[E], s[G] = s[G] || {}, s[G][m] = !0;
      }
      function V0(m) {
        var I = m.length, E = {}, G = [], z0 = {}, h0, t1, _0, g0;
        for (h0 = 0; h0 < I; h0++)
          if (_0 = m[h0].offset, !z0.hasOwnProperty(_0)) {
            g0 = s[_0] || {};
            for (t1 in g0)
              g0.hasOwnProperty(t1) && (E[t1] = !0);
            z0[_0] = !0;
          }
        for (h0 in E)
          E.hasOwnProperty(h0) && G.push(i[h0]);
        return G;
      }
      function O0() {
        try {
          var m = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (m && m.length > 3) {
            var I = i[Z0(m)];
            if (I)
              return I;
            d1("Moment Timezone found " + m + " from the Intl api, but did not have that data loaded.");
          }
        } catch {
        }
        var E = b0(), G = E.length, z0 = V0(E), h0 = [], t1, _0, g0;
        for (_0 = 0; _0 < z0.length; _0++) {
          for (t1 = new t0(I1(z0[_0])), g0 = 0; g0 < G; g0++)
            t1.scoreOffsetAt(E[g0]);
          h0.push(t1);
        }
        return h0.sort(y0), h0.length > 0 ? h0[0].zone.name : void 0;
      }
      function m1(m) {
        return (!d || m) && (d = O0()), d;
      }
      function Z0(m) {
        return (m || "").toLowerCase().replace(/\//g, "_");
      }
      function ze(m) {
        var I, E, G, z0;
        for (typeof m == "string" && (m = [m]), I = 0; I < m.length; I++)
          G = m[I].split("|"), E = G[0], z0 = Z0(E), o[z0] = m[I], i[z0] = E, m0(z0, G[2].split(" "));
      }
      function I1(m, I) {
        m = Z0(m);
        var E = o[m], G;
        return E instanceof D ? E : typeof E == "string" ? (E = new D(E), o[m] = E, E) : b[m] && I !== I1 && (G = I1(b[m], I1)) ? (E = o[m] = new D(), E._set(G), E.name = i[m], E) : null;
      }
      function pe() {
        var m, I = [];
        for (m in i)
          i.hasOwnProperty(m) && (o[m] || o[b[m]]) && i[m] && I.push(i[m]);
        return I.sort();
      }
      function W0() {
        return Object.keys(r);
      }
      function re(m) {
        var I, E, G, z0;
        for (typeof m == "string" && (m = [m]), I = 0; I < m.length; I++)
          E = m[I].split("|"), G = Z0(E[0]), z0 = Z0(E[1]), b[G] = z0, i[G] = E[0], b[z0] = G, i[z0] = E[1];
      }
      function fe(m) {
        var I, E, G, z0;
        if (!(!m || !m.length))
          for (I = 0; I < m.length; I++)
            z0 = m[I].split("|"), E = z0[0].toUpperCase(), G = z0[1].split(" "), r[E] = new H(
              E,
              G
            );
      }
      function G1(m) {
        return m = m.toUpperCase(), r[m] || null;
      }
      function W2(m, I) {
        if (m = G1(m), !m) return null;
        var E = m.zones.sort();
        return I ? E.map(function(G) {
          var z0 = I1(G);
          return {
            name: G,
            offset: z0.utcOffset(/* @__PURE__ */ new Date())
          };
        }) : E;
      }
      function h2(m) {
        ze(m.zones), re(m.links), fe(m.countries), x0.dataVersion = m.version;
      }
      function ke(m) {
        return ke.didShowError || (ke.didShowError = !0, d1("moment.tz.zoneExists('" + m + "') has been deprecated in favor of !moment.tz.zone('" + m + "')")), !!I1(m);
      }
      function K1(m) {
        var I = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === void 0 && !I);
      }
      function d1(m) {
        typeof console < "u" && typeof console.error == "function" && console.error(m);
      }
      function x0(m) {
        var I = Array.prototype.slice.call(arguments, 0, -1), E = arguments[arguments.length - 1], G = t.utc.apply(null, I), z0;
        return !t.isMoment(m) && K1(G) && (z0 = I1(E)) && G.add(z0.parse(G), "minutes"), G.tz(E), G;
      }
      x0.version = e, x0.dataVersion = "", x0._zones = o, x0._links = b, x0._names = i, x0._countries = r, x0.add = ze, x0.link = re, x0.load = h2, x0.zone = I1, x0.zoneExists = ke, x0.guess = m1, x0.names = pe, x0.Zone = D, x0.unpack = S, x0.unpackBase60 = y, x0.needsOffset = K1, x0.moveInvalidForward = !0, x0.moveAmbiguousForward = !1, x0.countries = W0, x0.zonesForCountry = W2;
      var i1 = t.fn;
      t.tz = x0, t.defaultZone = null, t.updateOffset = function(m, I) {
        var E = t.defaultZone, G;
        if (m._z === void 0 && (E && K1(m) && !m._isUTC && m.isValid() && (m._d = t.utc(m._a)._d, m.utc().add(E.parse(m), "minutes")), m._z = E), m._z)
          if (G = m._z.utcOffset(m), Math.abs(G) < 16 && (G = G / 60), m.utcOffset !== void 0) {
            var z0 = m._z;
            m.utcOffset(-G, I), m._z = z0;
          } else
            m.zone(G, I);
      }, i1.tz = function(m, I) {
        if (m) {
          if (typeof m != "string")
            throw new Error("Time zone name must be a string, got " + m + " [" + typeof m + "]");
          return this._z = I1(m), this._z ? t.updateOffset(this, I) : d1("Moment Timezone has no data for " + m + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
        }
        if (this._z)
          return this._z.name;
      };
      function a1(m) {
        return function() {
          return this._z ? this._z.abbr(this) : m.call(this);
        };
      }
      function P0(m) {
        return function() {
          return this._z = null, m.apply(this, arguments);
        };
      }
      function o1(m) {
        return function() {
          return arguments.length > 0 && (this._z = null), m.apply(this, arguments);
        };
      }
      i1.zoneName = a1(i1.zoneName), i1.zoneAbbr = a1(i1.zoneAbbr), i1.utc = P0(i1.utc), i1.local = P0(i1.local), i1.utcOffset = o1(i1.utcOffset), t.tz.setDefault = function(m) {
        return (f < 2 || f === 2 && h < 9) && d1("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = m ? I1(m) : null, t;
      };
      var E0 = t.momentProperties;
      return Object.prototype.toString.call(E0) === "[object Array]" ? (E0.push("_z"), E0.push("_a")) : E0 && (E0._z = null), t;
    });
  })(az)), az.exports;
}
const r_ = "2025b", c_ = /* @__PURE__ */ JSON.parse('["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"]'), i_ = ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Iceland", "Africa/Cairo|Egypt", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|US/Alaska", "America/Argentina/Buenos_Aires|America/Buenos_Aires", "America/Argentina/Catamarca|America/Argentina/ComodRivadavia", "America/Argentina/Catamarca|America/Catamarca", "America/Argentina/Cordoba|America/Cordoba", "America/Argentina/Cordoba|America/Rosario", "America/Argentina/Jujuy|America/Jujuy", "America/Argentina/Mendoza|America/Mendoza", "America/Chicago|CST6CDT", "America/Chicago|US/Central", "America/Denver|America/Shiprock", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Detroit|US/Michigan", "America/Edmonton|America/Yellowknife", "America/Edmonton|Canada/Mountain", "America/Fort_Wayne|America/Indiana/Indianapolis", "America/Fort_Wayne|America/Indianapolis", "America/Fort_Wayne|US/East-Indiana", "America/Godthab|America/Nuuk", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/Indiana/Knox|America/Knox_IN", "America/Indiana/Knox|US/Indiana-Starke", "America/Iqaluit|America/Pangnirtung", "America/Jamaica|Jamaica", "America/Kentucky/Louisville|America/Louisville", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Manaus|Brazil/West", "America/Mazatlan|Mexico/BajaSur", "America/Mexico_City|Mexico/General", "America/New_York|EST5EDT", "America/New_York|US/Eastern", "America/Noronha|Brazil/DeNoronha", "America/Panama|America/Atikokan", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|EST", "America/Phoenix|America/Creston", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Puerto_Rico|America/Anguilla", "America/Puerto_Rico|America/Antigua", "America/Puerto_Rico|America/Aruba", "America/Puerto_Rico|America/Blanc-Sablon", "America/Puerto_Rico|America/Curacao", "America/Puerto_Rico|America/Dominica", "America/Puerto_Rico|America/Grenada", "America/Puerto_Rico|America/Guadeloupe", "America/Puerto_Rico|America/Kralendijk", "America/Puerto_Rico|America/Lower_Princes", "America/Puerto_Rico|America/Marigot", "America/Puerto_Rico|America/Montserrat", "America/Puerto_Rico|America/Port_of_Spain", "America/Puerto_Rico|America/St_Barthelemy", "America/Puerto_Rico|America/St_Kitts", "America/Puerto_Rico|America/St_Lucia", "America/Puerto_Rico|America/St_Thomas", "America/Puerto_Rico|America/St_Vincent", "America/Puerto_Rico|America/Tortola", "America/Puerto_Rico|America/Virgin", "America/Regina|Canada/Saskatchewan", "America/Rio_Branco|America/Porto_Acre", "America/Rio_Branco|Brazil/Acre", "America/Santiago|Chile/Continental", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "America/Tijuana|America/Ensenada", "America/Tijuana|America/Santa_Isabel", "America/Tijuana|Mexico/BajaNorte", "America/Toronto|America/Montreal", "America/Toronto|America/Nassau", "America/Toronto|America/Nipigon", "America/Toronto|America/Thunder_Bay", "America/Toronto|Canada/Eastern", "America/Vancouver|Canada/Pacific", "America/Whitehorse|Canada/Yukon", "America/Winnipeg|America/Rainy_River", "America/Winnipeg|Canada/Central", "Asia/Ashgabat|Asia/Ashkhabad", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Indian/Christmas", "Asia/Brunei|Asia/Kuching", "Asia/Dhaka|Asia/Dacca", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Reunion", "Asia/Ho_Chi_Minh|Asia/Saigon", "Asia/Hong_Kong|Hongkong", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Singapore", "Asia/Macau|Asia/Macao", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Nicosia|Europe/Nicosia", "Asia/Qatar|Asia/Bahrain", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Riyadh|Antarctica/Syowa", "Asia/Riyadh|Asia/Aden", "Asia/Riyadh|Asia/Kuwait", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|PRC", "Asia/Taipei|ROC", "Asia/Tehran|Iran", "Asia/Thimphu|Asia/Thimbu", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Choibalsan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Urumqi|Asia/Kashgar", "Atlantic/Faroe|Atlantic/Faeroe", "Australia/Adelaide|Australia/South", "Australia/Brisbane|Australia/Queensland", "Australia/Broken_Hill|Australia/Yancowinna", "Australia/Darwin|Australia/North", "Australia/Hobart|Australia/Currie", "Australia/Hobart|Australia/Tasmania", "Australia/Lord_Howe|Australia/LHI", "Australia/Melbourne|Australia/Victoria", "Australia/Perth|Australia/West", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/NSW", "Etc/GMT-0|Etc/GMT", "Etc/GMT-0|Etc/GMT+0", "Etc/GMT-0|Etc/GMT0", "Etc/GMT-0|Etc/Greenwich", "Etc/GMT-0|GMT", "Etc/GMT-0|GMT+0", "Etc/GMT-0|GMT-0", "Etc/GMT-0|GMT0", "Etc/GMT-0|Greenwich", "Etc/UTC|Etc/UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UCT", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|EET", "Europe/Belgrade|Europe/Ljubljana", "Europe/Belgrade|Europe/Podgorica", "Europe/Belgrade|Europe/Sarajevo", "Europe/Belgrade|Europe/Skopje", "Europe/Belgrade|Europe/Zagreb", "Europe/Berlin|Arctic/Longyearbyen", "Europe/Berlin|Atlantic/Jan_Mayen", "Europe/Berlin|Europe/Copenhagen", "Europe/Berlin|Europe/Oslo", "Europe/Berlin|Europe/Stockholm", "Europe/Brussels|CET", "Europe/Brussels|Europe/Amsterdam", "Europe/Brussels|Europe/Luxembourg", "Europe/Brussels|MET", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Helsinki|Europe/Mariehamn", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Kiev|Europe/Kyiv", "Europe/Kiev|Europe/Uzhgorod", "Europe/Kiev|Europe/Zaporozhye", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|W-SU", "Europe/Paris|Europe/Monaco", "Europe/Prague|Europe/Bratislava", "Europe/Rome|Europe/San_Marino", "Europe/Rome|Europe/Vatican", "Europe/Warsaw|Poland", "Europe/Zurich|Europe/Busingen", "Europe/Zurich|Europe/Vaduz", "Indian/Maldives|Indian/Kerguelen", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Enderbury|Pacific/Kanton", "Pacific/Guadalcanal|Pacific/Pohnpei", "Pacific/Guadalcanal|Pacific/Ponape", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kwajalein|Kwajalein", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Port_Moresby|Antarctica/DumontDUrville", "Pacific/Port_Moresby|Pacific/Chuuk", "Pacific/Port_Moresby|Pacific/Truk", "Pacific/Port_Moresby|Pacific/Yap", "Pacific/Tarawa|Pacific/Funafuti", "Pacific/Tarawa|Pacific/Majuro", "Pacific/Tarawa|Pacific/Wake", "Pacific/Tarawa|Pacific/Wallis"], a_ = ["AD|Europe/Andorra", "AE|Asia/Dubai", "AF|Asia/Kabul", "AG|America/Puerto_Rico America/Antigua", "AI|America/Puerto_Rico America/Anguilla", "AL|Europe/Tirane", "AM|Asia/Yerevan", "AO|Africa/Lagos Africa/Luanda", "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa", "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia", "AS|Pacific/Pago_Pago", "AT|Europe/Vienna", "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo", "AW|America/Puerto_Rico America/Aruba", "AX|Europe/Helsinki Europe/Mariehamn", "AZ|Asia/Baku", "BA|Europe/Belgrade Europe/Sarajevo", "BB|America/Barbados", "BD|Asia/Dhaka", "BE|Europe/Brussels", "BF|Africa/Abidjan Africa/Ouagadougou", "BG|Europe/Sofia", "BH|Asia/Qatar Asia/Bahrain", "BI|Africa/Maputo Africa/Bujumbura", "BJ|Africa/Lagos Africa/Porto-Novo", "BL|America/Puerto_Rico America/St_Barthelemy", "BM|Atlantic/Bermuda", "BN|Asia/Kuching Asia/Brunei", "BO|America/La_Paz", "BQ|America/Puerto_Rico America/Kralendijk", "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco", "BS|America/Toronto America/Nassau", "BT|Asia/Thimphu", "BW|Africa/Maputo Africa/Gaborone", "BY|Europe/Minsk", "BZ|America/Belize", "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston", "CC|Asia/Yangon Indian/Cocos", "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi", "CF|Africa/Lagos Africa/Bangui", "CG|Africa/Lagos Africa/Brazzaville", "CH|Europe/Zurich", "CI|Africa/Abidjan", "CK|Pacific/Rarotonga", "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter", "CM|Africa/Lagos Africa/Douala", "CN|Asia/Shanghai Asia/Urumqi", "CO|America/Bogota", "CR|America/Costa_Rica", "CU|America/Havana", "CV|Atlantic/Cape_Verde", "CW|America/Puerto_Rico America/Curacao", "CX|Asia/Bangkok Indian/Christmas", "CY|Asia/Nicosia Asia/Famagusta", "CZ|Europe/Prague", "DE|Europe/Zurich Europe/Berlin Europe/Busingen", "DJ|Africa/Nairobi Africa/Djibouti", "DK|Europe/Berlin Europe/Copenhagen", "DM|America/Puerto_Rico America/Dominica", "DO|America/Santo_Domingo", "DZ|Africa/Algiers", "EC|America/Guayaquil Pacific/Galapagos", "EE|Europe/Tallinn", "EG|Africa/Cairo", "EH|Africa/El_Aaiun", "ER|Africa/Nairobi Africa/Asmara", "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary", "ET|Africa/Nairobi Africa/Addis_Ababa", "FI|Europe/Helsinki", "FJ|Pacific/Fiji", "FK|Atlantic/Stanley", "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei", "FO|Atlantic/Faroe", "FR|Europe/Paris", "GA|Africa/Lagos Africa/Libreville", "GB|Europe/London", "GD|America/Puerto_Rico America/Grenada", "GE|Asia/Tbilisi", "GF|America/Cayenne", "GG|Europe/London Europe/Guernsey", "GH|Africa/Abidjan Africa/Accra", "GI|Europe/Gibraltar", "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule", "GM|Africa/Abidjan Africa/Banjul", "GN|Africa/Abidjan Africa/Conakry", "GP|America/Puerto_Rico America/Guadeloupe", "GQ|Africa/Lagos Africa/Malabo", "GR|Europe/Athens", "GS|Atlantic/South_Georgia", "GT|America/Guatemala", "GU|Pacific/Guam", "GW|Africa/Bissau", "GY|America/Guyana", "HK|Asia/Hong_Kong", "HN|America/Tegucigalpa", "HR|Europe/Belgrade Europe/Zagreb", "HT|America/Port-au-Prince", "HU|Europe/Budapest", "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura", "IE|Europe/Dublin", "IL|Asia/Jerusalem", "IM|Europe/London Europe/Isle_of_Man", "IN|Asia/Kolkata", "IO|Indian/Chagos", "IQ|Asia/Baghdad", "IR|Asia/Tehran", "IS|Africa/Abidjan Atlantic/Reykjavik", "IT|Europe/Rome", "JE|Europe/London Europe/Jersey", "JM|America/Jamaica", "JO|Asia/Amman", "JP|Asia/Tokyo", "KE|Africa/Nairobi", "KG|Asia/Bishkek", "KH|Asia/Bangkok Asia/Phnom_Penh", "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati", "KM|Africa/Nairobi Indian/Comoro", "KN|America/Puerto_Rico America/St_Kitts", "KP|Asia/Pyongyang", "KR|Asia/Seoul", "KW|Asia/Riyadh Asia/Kuwait", "KY|America/Panama America/Cayman", "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral", "LA|Asia/Bangkok Asia/Vientiane", "LB|Asia/Beirut", "LC|America/Puerto_Rico America/St_Lucia", "LI|Europe/Zurich Europe/Vaduz", "LK|Asia/Colombo", "LR|Africa/Monrovia", "LS|Africa/Johannesburg Africa/Maseru", "LT|Europe/Vilnius", "LU|Europe/Brussels Europe/Luxembourg", "LV|Europe/Riga", "LY|Africa/Tripoli", "MA|Africa/Casablanca", "MC|Europe/Paris Europe/Monaco", "MD|Europe/Chisinau", "ME|Europe/Belgrade Europe/Podgorica", "MF|America/Puerto_Rico America/Marigot", "MG|Africa/Nairobi Indian/Antananarivo", "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro", "MK|Europe/Belgrade Europe/Skopje", "ML|Africa/Abidjan Africa/Bamako", "MM|Asia/Yangon", "MN|Asia/Ulaanbaatar Asia/Hovd", "MO|Asia/Macau", "MP|Pacific/Guam Pacific/Saipan", "MQ|America/Martinique", "MR|Africa/Abidjan Africa/Nouakchott", "MS|America/Puerto_Rico America/Montserrat", "MT|Europe/Malta", "MU|Indian/Mauritius", "MV|Indian/Maldives", "MW|Africa/Maputo Africa/Blantyre", "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana", "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur", "MZ|Africa/Maputo", "NA|Africa/Windhoek", "NC|Pacific/Noumea", "NE|Africa/Lagos Africa/Niamey", "NF|Pacific/Norfolk", "NG|Africa/Lagos", "NI|America/Managua", "NL|Europe/Brussels Europe/Amsterdam", "NO|Europe/Berlin Europe/Oslo", "NP|Asia/Kathmandu", "NR|Pacific/Nauru", "NU|Pacific/Niue", "NZ|Pacific/Auckland Pacific/Chatham", "OM|Asia/Dubai Asia/Muscat", "PA|America/Panama", "PE|America/Lima", "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier", "PG|Pacific/Port_Moresby Pacific/Bougainville", "PH|Asia/Manila", "PK|Asia/Karachi", "PL|Europe/Warsaw", "PM|America/Miquelon", "PN|Pacific/Pitcairn", "PR|America/Puerto_Rico", "PS|Asia/Gaza Asia/Hebron", "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores", "PW|Pacific/Palau", "PY|America/Asuncion", "QA|Asia/Qatar", "RE|Asia/Dubai Indian/Reunion", "RO|Europe/Bucharest", "RS|Europe/Belgrade", "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr", "RW|Africa/Maputo Africa/Kigali", "SA|Asia/Riyadh", "SB|Pacific/Guadalcanal", "SC|Asia/Dubai Indian/Mahe", "SD|Africa/Khartoum", "SE|Europe/Berlin Europe/Stockholm", "SG|Asia/Singapore", "SH|Africa/Abidjan Atlantic/St_Helena", "SI|Europe/Belgrade Europe/Ljubljana", "SJ|Europe/Berlin Arctic/Longyearbyen", "SK|Europe/Prague Europe/Bratislava", "SL|Africa/Abidjan Africa/Freetown", "SM|Europe/Rome Europe/San_Marino", "SN|Africa/Abidjan Africa/Dakar", "SO|Africa/Nairobi Africa/Mogadishu", "SR|America/Paramaribo", "SS|Africa/Juba", "ST|Africa/Sao_Tome", "SV|America/El_Salvador", "SX|America/Puerto_Rico America/Lower_Princes", "SY|Asia/Damascus", "SZ|Africa/Johannesburg Africa/Mbabane", "TC|America/Grand_Turk", "TD|Africa/Ndjamena", "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen", "TG|Africa/Abidjan Africa/Lome", "TH|Asia/Bangkok", "TJ|Asia/Dushanbe", "TK|Pacific/Fakaofo", "TL|Asia/Dili", "TM|Asia/Ashgabat", "TN|Africa/Tunis", "TO|Pacific/Tongatapu", "TR|Europe/Istanbul", "TT|America/Puerto_Rico America/Port_of_Spain", "TV|Pacific/Tarawa Pacific/Funafuti", "TW|Asia/Taipei", "TZ|Africa/Nairobi Africa/Dar_es_Salaam", "UA|Europe/Simferopol Europe/Kyiv", "UG|Africa/Nairobi Africa/Kampala", "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake", "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu", "UY|America/Montevideo", "UZ|Asia/Samarkand Asia/Tashkent", "VA|Europe/Rome Europe/Vatican", "VC|America/Puerto_Rico America/St_Vincent", "VE|America/Caracas", "VG|America/Puerto_Rico America/Tortola", "VI|America/Puerto_Rico America/St_Thomas", "VN|Asia/Bangkok Asia/Ho_Chi_Minh", "VU|Pacific/Efate", "WF|Pacific/Tarawa Pacific/Wallis", "WS|Pacific/Apia", "YE|Asia/Riyadh Asia/Aden", "YT|Africa/Nairobi Indian/Mayotte", "ZA|Africa/Johannesburg", "ZM|Africa/Maputo Africa/Lusaka", "ZW|Africa/Maputo Africa/Harare"], O_ = {
  version: r_,
  zones: c_,
  links: i_,
  countries: a_
};
var bA;
function s_() {
  if (bA) return wc.exports;
  bA = 1;
  var p = wc.exports = z_();
  return p.tz.load(O_), wc.exports;
}
var A_ = s_();
const T1 = /* @__PURE__ */ wa(A_);
var u_ = Object.defineProperty, d_ = Object.getOwnPropertyDescriptor, U2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? d_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && u_(t, e, b), b;
};
const A2 = class al extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "description");
    z(this, "position");
    z(this, "minPercentageCompletion");
    z(this, "minScoreCompletion");
    z(this, "questions");
    z(this, "files");
    z(this, "countingMethod");
    z(this, "shuffle");
    z(this, "isCompleted");
    z(this, "parent");
    i0(this), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e, o) {
    return new al({
      ...e,
      files: e.files ? e.files.map($1.fromJson) : void 0,
      parent: o
    });
  }
};
U2([
  a
], A2.prototype, "title", 2);
U2([
  a
], A2.prototype, "description", 2);
U2([
  a
], A2.prototype, "position", 2);
U2([
  a
], A2.prototype, "minPercentageCompletion", 2);
U2([
  a
], A2.prototype, "minScoreCompletion", 2);
U2([
  a
], A2.prototype, "questions", 2);
U2([
  a
], A2.prototype, "files", 2);
U2([
  a
], A2.prototype, "countingMethod", 2);
U2([
  a
], A2.prototype, "shuffle", 2);
U2([
  a
], A2.prototype, "isCompleted", 2);
U2([
  a
], A2.prototype, "parent", 2);
U2([
  C
], A2.prototype, "update", 1);
let l_ = A2;
var q_ = Object.defineProperty, f_ = (p, t, e, o) => {
  for (var b = void 0, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && q_(t, e, b), b;
};
const Ol = class sl extends ye {
  constructor(e) {
    super();
    z(this, "options");
    i0(this), e && this.update(e);
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new sl({
      options: [],
      ...e
    });
  }
};
f_([
  a
], Ol.prototype, "options");
let W_ = Ol;
class h_ {
  static build(t, e) {
    const o = e ? JSON.parse(e) : null;
    switch (t) {
      case Hi.MonoSelect:
      case Hi.MultiSelect:
        return W_.fromJson(o);
      default:
        return o;
    }
  }
}
var m_ = Object.defineProperty, R_ = Object.getOwnPropertyDescriptor, ip = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? R_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && m_(t, e, b), b;
}, Hi = /* @__PURE__ */ ((p) => (p.TextField = "textField", p.TextArea = "textArea", p.Checkbox = "checkbox", p.MultiSelect = "multiSelect", p.MonoSelect = "monoSelect", p))(Hi || {});
const Dt = class Al extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "placeholder");
    z(this, "description");
    z(this, "required");
    z(this, "position");
    z(this, "type");
    z(this, "task");
    z(this, "settings");
    i0(this), e && this.update(e);
  }
  get listSettings() {
    return this.settings;
  }
  get isListType() {
    return this.type == "monoSelect" || this.type == "multiSelect";
  }
  toJson() {
    var e;
    return {
      id: this.id,
      title: this.title,
      placeholder: this.placeholder,
      description: this.description,
      required: this.required,
      position: this.position,
      type: this.type,
      taskId: (e = this.task) == null ? void 0 : e.id,
      additionalData: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new Al({
      id: e.id,
      title: e.title,
      placeholder: e.placeholder,
      description: e.description,
      required: e.required,
      position: e.position,
      type: e.type,
      task: e.task ? Wl.fromJson(e.task) : void 0,
      settings: h_.build(e.type, e.additionalData)
    });
  }
};
ip([
  a
], Dt.prototype, "title", 2);
ip([
  a
], Dt.prototype, "placeholder", 2);
ip([
  a
], Dt.prototype, "description", 2);
ip([
  a
], Dt.prototype, "required", 2);
ip([
  a
], Dt.prototype, "position", 2);
ip([
  a
], Dt.prototype, "type", 2);
ip([
  a
], Dt.prototype, "task", 2);
ip([
  a
], Dt.prototype, "settings", 2);
ip([
  C
], Dt.prototype, "update", 1);
let ul = Dt;
var y_ = Object.defineProperty, g_ = Object.getOwnPropertyDescriptor, Up = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? g_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && y_(t, e, b), b;
};
const ap = class Ji extends n0 {
  constructor(e) {
    super();
    z(this, "stringValue");
    z(this, "booleanValue");
    z(this, "listValue");
    z(this, "listLabelValue");
    z(this, "multiListValue");
    z(this, "multiListLabelValue");
    z(this, "field");
    i0(this), e && this.update(e);
  }
  get value() {
    if (this.booleanValue !== void 0) return this.booleanValue;
    if (this.stringValue !== void 0) return this.stringValue;
    if (this.listValue !== void 0) return this.listValue;
    if (this.multiListValue !== void 0) return this.multiListValue;
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  isEquals(e) {
    return this.field.id != e.field.id ? !1 : this.booleanValue !== void 0 ? this.booleanValue === e.booleanValue : this.listValue !== void 0 ? this.listValue === e.listValue : this.multiListValue !== void 0 ? this.multiListValue === e.multiListValue : this.stringValue === e.stringValue;
  }
  copy() {
    var e, o;
    return new Ji({
      id: this.id,
      field: this.field,
      stringValue: this.stringValue,
      booleanValue: this.booleanValue,
      listValue: this.listValue,
      listLabelValue: this.listLabelValue,
      multiListValue: (e = this.multiListValue) == null ? void 0 : e.slice(),
      multiListLabelValue: (o = this.multiListLabelValue) == null ? void 0 : o.slice()
    });
  }
  get valueJson() {
    return typeof this.value == "object" ? JSON.stringify(this.value) : this.value;
  }
  toJson() {
    return {
      id: this.field.id,
      value: this.valueJson
    };
  }
  static fromJson(e) {
    return new Ji({
      id: e.id,
      stringValue: e.stringValue ?? void 0,
      booleanValue: e.booleanValue ?? void 0,
      listValue: e.listValue ?? void 0,
      listLabelValue: e.listLabelValue ?? void 0,
      multiListValue: e.multiListValue ? JSON.parse(e.multiListValue) : void 0,
      multiListLabelValue: e.multiListLabelValue ? JSON.parse(e.multiListLabelValue) : void 0,
      field: e.field ? ul.fromJson(e.field) : void 0
    });
  }
};
Up([
  a
], ap.prototype, "stringValue", 2);
Up([
  a
], ap.prototype, "booleanValue", 2);
Up([
  a
], ap.prototype, "listValue", 2);
Up([
  a
], ap.prototype, "listLabelValue", 2);
Up([
  a
], ap.prototype, "multiListValue", 2);
Up([
  a
], ap.prototype, "multiListLabelValue", 2);
Up([
  a
], ap.prototype, "field", 2);
Up([
  C
], ap.prototype, "update", 1);
let L_ = ap;
class Tw extends J0 {
  constructor(e) {
    super();
    z(this, "contactId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var v_ = Object.defineProperty, __ = Object.getOwnPropertyDescriptor, H2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? __(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && v_(t, e, b), b;
};
const Hp = class dl extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "comment");
    z(this, "contact", null);
    z(this, "admin", null);
    z(this, "files", []);
    i0(this), e && this.update(e);
  }
  get author() {
    return this.contact ?? this.admin;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new dl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      admin: e.admin ? Xa.fromJson(e.admin) : void 0,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      files: e.files ? e.files.map($1.fromJson) : []
    });
  }
};
H2([
  a
], Hp.prototype, "createdDate", 2);
H2([
  a
], Hp.prototype, "updatedDate", 2);
H2([
  a
], Hp.prototype, "comment", 2);
H2([
  a
], Hp.prototype, "contact", 2);
H2([
  a
], Hp.prototype, "admin", 2);
H2([
  a
], Hp.prototype, "files", 2);
H2([
  C
], Hp.prototype, "update", 1);
let Ca = Hp;
class XM extends J0 {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "answerId");
    z(this, "adminId");
    z(this, "studentId");
    z(this, "createdDateLessThan");
    i0(this), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
H2([
  a
], XM.prototype, "id", 2);
H2([
  a
], XM.prototype, "answerId", 2);
H2([
  a
], XM.prototype, "adminId", 2);
H2([
  a
], XM.prototype, "studentId", 2);
H2([
  a
], XM.prototype, "createdDateLessThan", 2);
var N_ = Object.defineProperty, B_ = Object.getOwnPropertyDescriptor, dt = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? B_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && N_(t, e, b), b;
}, $i = /* @__PURE__ */ ((p) => (p.Default = "default", p.Pending = "pending", p.Incorrect = "incorrect", p.Correct = "correct", p.Incomplete = "incomplete", p.Editing = "editing", p))($i || {});
const J2 = class ll extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "text");
    z(this, "contact");
    z(this, "status");
    z(this, "comments");
    z(this, "commentCount");
    z(this, "files");
    z(this, "fields");
    i0(this), e && this.update(e);
  }
  getFieldValue(e) {
    return this.fields.find((b) => b.field.id == e) ?? null;
  }
  setFieldValue(e) {
    const o = this.getFieldValue(e.field.id);
    o ? o.update(e, !0) : this.fields.push(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new ll({
      ...e,
      text: Ae.isEmpty(e.text) ? void 0 : e.text,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      comments: e.comments ? e.comments.map(Ca.fromJson) : void 0,
      files: e.files ? e.files.map($1.fromJson) : void 0,
      fields: e.studentAnswerFields ? e.studentAnswerFields.map(L_.fromJson) : void 0
    });
  }
};
dt([
  a
], J2.prototype, "createdDate", 2);
dt([
  a
], J2.prototype, "updatedDate", 2);
dt([
  a
], J2.prototype, "text", 2);
dt([
  a
], J2.prototype, "contact", 2);
dt([
  a
], J2.prototype, "status", 2);
dt([
  a
], J2.prototype, "comments", 2);
dt([
  a
], J2.prototype, "commentCount", 2);
dt([
  a
], J2.prototype, "files", 2);
dt([
  a
], J2.prototype, "fields", 2);
dt([
  C
], J2.prototype, "setFieldValue", 1);
dt([
  C
], J2.prototype, "update", 1);
let ql = J2;
var T_ = Object.defineProperty, w_ = Object.getOwnPropertyDescriptor, Ye = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? w_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && T_(t, e, b), b;
};
const Xe = class fl extends n0 {
  constructor(e) {
    super();
    z(this, "question");
    z(this, "description");
    z(this, "correctAnswer");
    z(this, "position");
    z(this, "files");
    z(this, "disableVerification");
    z(this, "fields");
    z(this, "answer");
    z(this, "parent");
    i0(this), e && this.update(e);
  }
  get hasDescription() {
    return !Ae.isEmpty(this.description);
  }
  get hasQuestion() {
    return !Ae.isEmpty(this.question);
  }
  get status() {
    var e;
    return ((e = this.answer) == null ? void 0 : e.status) || $i.Default;
  }
  get isCompleted() {
    return this.status === $i.Correct;
  }
  static fromJson(e, o) {
    return new fl({
      ...e,
      files: e.files ? e.files.map($1.fromJson) : void 0,
      answer: e.answer ? ql.fromJson(e.answer) : void 0,
      fields: e.fields ? e.fields.map(ul.fromJson) : void 0,
      parent: o
    });
  }
  update(e) {
    super.update(e);
  }
};
Ye([
  a
], Xe.prototype, "question", 2);
Ye([
  a
], Xe.prototype, "description", 2);
Ye([
  a
], Xe.prototype, "correctAnswer", 2);
Ye([
  a
], Xe.prototype, "position", 2);
Ye([
  a
], Xe.prototype, "files", 2);
Ye([
  a
], Xe.prototype, "disableVerification", 2);
Ye([
  a
], Xe.prototype, "fields", 2);
Ye([
  $
], Xe.prototype, "hasDescription", 1);
Ye([
  $
], Xe.prototype, "hasQuestion", 1);
Ye([
  a
], Xe.prototype, "answer", 2);
Ye([
  a
], Xe.prototype, "parent", 2);
Ye([
  $
], Xe.prototype, "status", 1);
Ye([
  $
], Xe.prototype, "isCompleted", 1);
Ye([
  C
], Xe.prototype, "update", 1);
let Wl = Xe;
var S_ = Object.defineProperty, D_ = Object.getOwnPropertyDescriptor, Z = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? D_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && S_(t, e, b), b;
}, vt;
const Q = (vt = class extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "position");
    z(this, "isDraft");
    z(this, "isOptional");
    z(this, "type");
    z(this, "comment");
    z(this, "allowComments");
    z(this, "showComments");
    z(this, "disableCommentModeration");
    z(this, "ratingEnabled");
    z(this, "ratingRequired");
    z(this, "ratingCommentRequired");
    z(this, "availability");
    z(this, "disableTimeLimits");
    z(this, "regularTimeDelayActive");
    z(this, "regularTimeDelay");
    z(this, "regularTimeDelayCondition");
    z(this, "regularTimeDelayMeasureType");
    z(this, "regularWaitUntilTimeActive");
    z(this, "regularWaitUntilTime");
    z(this, "regularWaitUntilTimeDaysOfWeekActive");
    z(this, "regularWaitUntilDaysOfWeek");
    z(this, "flowTimeDelayActive");
    z(this, "flowTimeDelay");
    z(this, "flowTimeDelayCondition");
    z(this, "flowTimeDelayMeasureType");
    z(this, "flowWaitUntilTimeActive");
    z(this, "flowWaitUntilTime");
    z(this, "flowWaitUntilTimeDaysOfWeekActive");
    z(this, "flowWaitUntilDaysOfWeek");
    z(this, "dateDelayActive");
    z(this, "dateDelay");
    z(this, "preventCopingAndSelectingText");
    z(this, "designHTMLPublished");
    z(this, "designStylePublished");
    z(this, "blockCourseUntilTasksApproved");
    z(this, "theoryVisible");
    z(this, "tasksVisible");
    z(this, "testsVisible");
    z(this, "score");
    z(this, "files");
    z(this, "progress");
    z(this, "tests", []);
    z(this, "tasks", []);
    z(this, "requiredPlans");
    z(this, "currentTest", null);
    z(this, "parent");
    z(this, "parentItemId");
    z(this, "children", []);
    z(this, "previousItem");
    z(this, "nextItem");
    z(this, "studentCourse");
    z(this, "course");
    z(this, "fetching");
    /** 
     * position regarding all steps
    */
    z(this, "globalPosition");
    /**
     * level of the item in the tree
     */
    z(this, "level");
    z(this, "schoolTimezone");
    z(this, "_tab");
    i0(this), this._tab = this.defaultTab, e && this.update(e);
  }
  get ratingVisible() {
    return this.allowComments || this.ratingEnabled;
  }
  get previousSection() {
    var o, b, r;
    let e = ((o = this.previousItem) == null ? void 0 : o.parent) ?? null;
    for (; e != null; ) {
      if (((b = e.parent) == null ? void 0 : b.id) === ((r = this.parent) == null ? void 0 : r.id))
        return e;
      e = e.parent ?? null;
    }
    return null;
  }
  get firstAvailableTab() {
    return this.theoryVisible ? "theory" : this.testsVisible ? "tests" : this.tasksVisible ? "tasks" : this.ratingVisible ? "rating" : "theory";
  }
  get itemCount() {
    if (this.type == Z1.Step) return 0;
    let e = this.children.length;
    for (const o of this.children)
      e += o.itemCount;
    return e;
  }
  get itemCompletedCount() {
    if (this.type == Z1.Step) return 0;
    let e = this.children.filter((o) => o.completed).length;
    for (const o of this.children)
      e += o.itemCompletedCount;
    return e;
  }
  get stepCount() {
    if (this.type == Z1.Step) return 0;
    let e = this.children.count((o) => o.type == Z1.Step);
    for (const o of this.children)
      e += o.stepCount;
    return e;
  }
  get taskCount() {
    return this.type == Z1.Step ? this.tasks.length : this.children.reduce((e, o) => e + o.taskCount, 0);
  }
  get taskCompletedCount() {
    var e;
    return this.type == Z1.Step ? ((e = this.progress) == null ? void 0 : e.numberCorrectTasks) ?? 0 : this.children.reduce((o, b) => o + b.taskCompletedCount, 0);
  }
  get sectionProgress() {
    const e = new rl();
    let o = !0;
    for (const b of this.accessibleChildren) {
      const r = b.type == Z1.Section ? b.sectionProgress : b.progress;
      if (!r) {
        o = !1, e.completeDate = null;
        continue;
      }
      e.numberCorrectTasks += r.numberCorrectTasks, e.numberIncorrectTasks += r.numberIncorrectTasks, e.numberUncheckedTasks += r.numberUncheckedTasks, o && (r.completeDate ? (!e.completeDate || e.completeDate < r.completeDate) && (e.completeDate = r.completeDate) : (o = !1, e.completeDate = null)), r.beginDate && (!e.beginDate || e.beginDate > r.beginDate) && (e.beginDate = r.beginDate);
    }
    return e;
  }
  get ratingCompleted() {
    var e, o;
    return !this.ratingEnabled || !this.ratingRequired ? !0 : ((e = this.progress) == null ? void 0 : e.rating) == null ? !1 : this.ratingCommentRequired ? ((o = this.progress.rating.comment) == null ? void 0 : o.length) > 0 : !0;
  }
  get completed() {
    var e, o;
    return this.type == Z1.Step ? ((e = this.progress) == null ? void 0 : e.completeDate) != null : ((o = this.sectionProgress) == null ? void 0 : o.completeDate) != null;
  }
  get beginDate() {
    var e, o;
    return this.type == Z1.Step ? (e = this.progress) == null ? void 0 : e.beginDate : (o = this.sectionProgress) == null ? void 0 : o.beginDate;
  }
  get completeDate() {
    var e, o;
    return this.type == Z1.Step ? (e = this.progress) == null ? void 0 : e.completeDate : (o = this.sectionProgress) == null ? void 0 : o.completeDate;
  }
  get precompleted() {
    var e;
    return ((e = this.progress) == null ? void 0 : e.precompleteDate) != null;
  }
  get fullPosition() {
    let e = "", o = this.parent;
    for (; o != null; )
      e += `${o.position}.`, o = o.parent;
    return e += this.position, e;
  }
  get tab() {
    return this._tab;
  }
  set tab(e) {
    switch (e) {
      case "theory": {
        if (this.theoryVisible) {
          this._tab = "theory";
          return;
        }
        break;
      }
      case "tests": {
        if (this.testsVisible) {
          this._tab = "tests";
          return;
        }
        break;
      }
      case "tasks": {
        if (this.tasksVisible) {
          this._tab = "tasks";
          return;
        }
        break;
      }
      case "rating": {
        if (this.allowComments || this.ratingEnabled) {
          this._tab = "rating";
          return;
        }
        break;
      }
    }
  }
  get defaultTab() {
    return this.progress == null || this.theoryVisible && !this.progress.theoryCompleted ? "theory" : this.testsVisible && !this.progress.testsCompleted ? "tests" : this.tasksVisible && !this.progress.tasksCompleted ? "tasks" : "theory";
  }
  get canSelect() {
    return this.courseItemAvailability.result;
  }
  get previousRequiredItem() {
    return this.previousAccessibleItem == null ? null : this.previousAccessibleItem.canSkip ? this.previousAccessibleItem.previousRequiredItem : this.previousAccessibleItem;
  }
  get previousAccessibleItem() {
    return this.previousItem == null ? null : this.previousItem.hasPlanAccess ? this.previousItem : this.previousItem.previousAccessibleItem;
  }
  get nextAccessibleItem() {
    return this.nextItem == null ? null : this.nextItem.hasPlanAccess ? this.nextItem : this.nextItem.nextAccessibleItem;
  }
  get hasAccessibleItems() {
    if (this.type != Z1.Section || this.children.length == 0)
      return !1;
    for (const e of this.children)
      if (e.hasPlanAccess && (e.type == Z1.Step || e.hasAccessibleItems))
        return !0;
    return !1;
  }
  get accessibleChildren() {
    return this.children.filter((e) => e.hasPlanAccess);
  }
  hasAncestor(e) {
    let o = this.parent;
    for (; o; ) {
      if (o == e) return !0;
      o = o.parent;
    }
    return !1;
  }
  get courseItemAvailability() {
    if (this.progress != null && this.progress.status == "opened")
      return { result: !0 };
    if (!this.hasPlanAccess)
      return { result: !1, requiredPlans: this.requiredPlans };
    if (!this.availabilityRelativeToTimeDelay.result)
      return this.availabilityRelativeToTimeDelay;
    const e = this.parentAvailability;
    return e.result ? this.availabilityRelativeToOther.result ? { result: !0 } : this.availabilityRelativeToOther : { ...e, isSection: !0 };
  }
  get parentAvailability() {
    return this.parent != null ? this.parent.courseItemAvailability : { result: !0 };
  }
  get availabilityRelativeToTimeDelay() {
    if (this.disableTimeLimits) return { result: !0 };
    if (this.flowTimeDelayActive && this.studentCourse.isInCohort)
      switch (this.flowTimeDelayCondition) {
        case Xp.CourseStart: {
          const b = T1(), r = this.calculateDelay(
            T1(this.studentCourse.beginDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Xp.FlowStart: {
          if (this.studentCourse.cohortBeginDate == null)
            break;
          const b = T1(), r = this.calculateDelay(
            T1(this.studentCourse.cohortBeginDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Xp.PreviousStep: {
          if (!this.previousAccessibleItem)
            break;
          if (!this.previousAccessibleItem.precompleted)
            return { result: !1, needToCompletePrevStep: !0 };
          const b = T1(), r = this.calculateDelay(
            T1(this.previousAccessibleItem.progress.precompleteDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Xp.PreviousSectionStarted:
        case Xp.PreviousSectionCompleted: {
          const b = this.previousSection;
          if (b && b.hasAccessibleItems) {
            const r = this.flowTimeDelayCondition == Xp.PreviousSectionStarted ? b.beginDate : b.completeDate;
            if (r) {
              const i = T1(), s = this.calculateDelay(
                T1(r),
                this.flowTimeDelayValue,
                this.flowWaitUntilTimeActive,
                this.flowWaitUntilTime,
                this.flowWaitUntilTimeDaysOfWeekActive,
                this.flowWaitUntilDaysOfWeek
              );
              if (i <= s)
                return { result: !1, willBeAvailableOn: s };
            } else
              return {
                result: !1,
                willBeAvailableIf: {
                  in: this.flowTimeDelayValue,
                  item: b,
                  condition: this.flowTimeDelayCondition == Xp.PreviousSectionStarted ? "afterStart" : "afterComplete"
                }
              };
          }
          break;
        }
      }
    if (this.regularTimeDelayActive)
      switch (this.regularTimeDelayCondition) {
        case Dp.AccessStart: {
          const b = T1(), r = this.calculateDelay(
            T1(this.studentCourse.accessBeginDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Dp.CourseStart: {
          const b = T1(), r = this.calculateDelay(
            T1(this.studentCourse.beginDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Dp.PreviousStep: {
          if (!this.previousAccessibleItem)
            break;
          if (!this.previousAccessibleItem.precompleted)
            return { result: !1, needToCompletePrevStep: !0 };
          const b = T1(), r = this.calculateDelay(
            T1(this.previousAccessibleItem.progress.precompleteDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (b <= r)
            return { result: !1, willBeAvailableOn: r };
          break;
        }
        case Dp.PreviousSectionStarted:
        case Dp.PreviousSectionCompleted: {
          const b = this.previousSection;
          if (b && b.hasAccessibleItems) {
            const r = this.regularTimeDelayCondition == Dp.PreviousSectionStarted ? b.beginDate : b.completeDate;
            if (r) {
              const i = T1(), s = this.calculateDelay(
                T1(r),
                this.regularTimeDelayValue,
                this.regularWaitUntilTimeActive,
                this.regularWaitUntilTime,
                this.regularWaitUntilTimeDaysOfWeekActive,
                this.regularWaitUntilDaysOfWeek
              );
              if (i <= s)
                return { result: !1, willBeAvailableOn: s };
            } else
              return {
                result: !1,
                willBeAvailableIf: {
                  in: this.regularTimeDelayValue,
                  item: b,
                  condition: this.regularTimeDelayCondition == Dp.PreviousSectionStarted ? "afterStart" : "afterComplete"
                }
              };
          }
          break;
        }
      }
    return this.dateDelayActive && this.dateDelay != null && !T1().isAfter(this.dateDelay) ? { result: !1, willBeAvailableOn: this.dateDelay } : { result: !0 };
  }
  get availabilityRelativeToOther() {
    var e;
    switch (this.availability) {
      case rz.RegardlessOfPreviousSteps: {
        let o = this.previousRequiredItem;
        for (; o; ) {
          if (o.blockCourseUntilTasksApproved == !0) {
            if (o.completed == !1) {
              if (((e = o.nextAccessibleItem) == null ? void 0 : e.progress) != null) break;
              return { result: !1, blockingCourseItem: o };
            }
            break;
          }
          o = o.previousRequiredItem;
        }
        break;
      }
      case rz.AllPreviousStepsCompleted: {
        let o = this.previousRequiredItem;
        for (; o; ) {
          if (o.blockCourseUntilTasksApproved == !0 && o.completed == !1)
            return { result: !1, blockingCourseItem: o };
          if (o.blockCourseUntilTasksApproved == !1 && o.precompleted == !1)
            return { result: !1, blockingCourseItem: o };
          o = o.previousRequiredItem;
        }
        break;
      }
      case rz.PreviousStepCompleted: {
        if (!this.previousRequiredItem)
          break;
        if (this.previousRequiredItem.blockCourseUntilTasksApproved == !0 && this.previousRequiredItem.completed == !1)
          return { result: !1, blockingCourseItem: this.previousRequiredItem };
        if (this.previousRequiredItem.blockCourseUntilTasksApproved == !1 && this.previousRequiredItem.precompleted == !1)
          return { result: !1, blockingCourseItem: this.previousRequiredItem };
        break;
      }
    }
    return { result: !0 };
  }
  get hasPlanAccess() {
    var e;
    return this.hasAccessGrantedByAdmin || ((e = this.requiredPlans) == null ? void 0 : e.length) == 0;
  }
  get hasAccessGrantedByAdmin() {
    var e;
    return this.type == Z1.Step ? ((e = this.progress) == null ? void 0 : e.status) == "opened" : this.children.some((o) => o.hasAccessGrantedByAdmin);
  }
  get canSkip() {
    return this.isOptional == !0 || !this.hasPlanAccess;
  }
  update(e) {
    super.update(e);
  }
  get regularTimeDelayValue() {
    return Ae.isNil(this.regularTimeDelay) ? s1.zero : s1.fromTimeMeasure(this.regularTimeDelay, this.regularTimeDelayMeasureType ?? "days");
  }
  get flowTimeDelayValue() {
    return Ae.isNil(this.flowTimeDelay) ? s1.zero : s1.fromTimeMeasure(this.flowTimeDelay, this.flowTimeDelayMeasureType ?? "days");
  }
  calculateDelay(e, o, b, r, i, s) {
    let d = T1(e).utc().tz(this.schoolTimezone.id);
    if (d.add(o, "milliseconds"), b) {
      const f = T1(r).utc().tz(this.schoolTimezone.id), h = f.hours(), g = f.minutes();
      let y = d.clone().hours(h).minutes(g).seconds(0).milliseconds(0);
      y.isBefore(d) && y.add(1, "day"), d = y;
    }
    if (i && s && s.length > 0) {
      const f = s.map((h) => vt.DayOfWeekMap[h]);
      for (; !f.includes(d.day()); )
        d.add(1, "day");
    }
    const q = T1.tz.guess();
    return d.tz(q);
  }
  static fromJson(e) {
    const o = new vt({
      ...e,
      plans: e.plans ? e.plans.map((b) => DM.fromJson(b.coursePlan)) : void 0,
      parent: e.parentItem ? vt.fromJson(e.parentItem) : void 0,
      children: e.children ? e.children.map((b) => vt.fromJson(b)) : void 0,
      course: e.course ? wt.fromJson(e.course) : void 0,
      files: e.files ? e.files.map((b) => at.fromJson(b)) : [],
      progress: e.progress ? il.fromJson(e.progress) : void 0,
      tests: [],
      tasks: [],
      dateDelay: e.dateDelay ? T1(e.dateDelay) : void 0,
      regularWaitUntilTime: e.regularWaitUntilTime ? T1(e.regularWaitUntilTime) : void 0,
      flowWaitUntilTime: e.flowWaitUntilTime ? T1(e.flowWaitUntilTime) : void 0
    });
    return e.tasks && (o.tasks = e.tasks.map((b) => Wl.fromJson(b, o))), e.tests && (o.tests = e.tests.map((b) => l_.fromJson(b, o))), o;
  }
}, z(vt, "DayOfWeekMap", {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
}), vt);
Z([
  a
], Q.prototype, "title", 2);
Z([
  a
], Q.prototype, "position", 2);
Z([
  a
], Q.prototype, "isDraft", 2);
Z([
  a
], Q.prototype, "isOptional", 2);
Z([
  a
], Q.prototype, "type", 2);
Z([
  a
], Q.prototype, "comment", 2);
Z([
  a
], Q.prototype, "allowComments", 2);
Z([
  a
], Q.prototype, "showComments", 2);
Z([
  a
], Q.prototype, "disableCommentModeration", 2);
Z([
  a
], Q.prototype, "ratingEnabled", 2);
Z([
  a
], Q.prototype, "ratingRequired", 2);
Z([
  a
], Q.prototype, "ratingCommentRequired", 2);
Z([
  a
], Q.prototype, "availability", 2);
Z([
  a
], Q.prototype, "disableTimeLimits", 2);
Z([
  a
], Q.prototype, "regularTimeDelayActive", 2);
Z([
  a
], Q.prototype, "regularTimeDelay", 2);
Z([
  a
], Q.prototype, "regularTimeDelayCondition", 2);
Z([
  a
], Q.prototype, "regularTimeDelayMeasureType", 2);
Z([
  a
], Q.prototype, "regularWaitUntilTimeActive", 2);
Z([
  a
], Q.prototype, "regularWaitUntilTime", 2);
Z([
  a
], Q.prototype, "regularWaitUntilTimeDaysOfWeekActive", 2);
Z([
  a
], Q.prototype, "regularWaitUntilDaysOfWeek", 2);
Z([
  a
], Q.prototype, "flowTimeDelayActive", 2);
Z([
  a
], Q.prototype, "flowTimeDelay", 2);
Z([
  a
], Q.prototype, "flowTimeDelayCondition", 2);
Z([
  a
], Q.prototype, "flowTimeDelayMeasureType", 2);
Z([
  a
], Q.prototype, "flowWaitUntilTimeActive", 2);
Z([
  a
], Q.prototype, "flowWaitUntilTime", 2);
Z([
  a
], Q.prototype, "flowWaitUntilTimeDaysOfWeekActive", 2);
Z([
  a
], Q.prototype, "flowWaitUntilDaysOfWeek", 2);
Z([
  a
], Q.prototype, "dateDelayActive", 2);
Z([
  a
], Q.prototype, "dateDelay", 2);
Z([
  a
], Q.prototype, "preventCopingAndSelectingText", 2);
Z([
  a
], Q.prototype, "designHTMLPublished", 2);
Z([
  a
], Q.prototype, "designStylePublished", 2);
Z([
  a
], Q.prototype, "blockCourseUntilTasksApproved", 2);
Z([
  a
], Q.prototype, "theoryVisible", 2);
Z([
  a
], Q.prototype, "tasksVisible", 2);
Z([
  a
], Q.prototype, "testsVisible", 2);
Z([
  $
], Q.prototype, "ratingVisible", 1);
Z([
  a
], Q.prototype, "score", 2);
Z([
  a
], Q.prototype, "files", 2);
Z([
  a
], Q.prototype, "progress", 2);
Z([
  a
], Q.prototype, "tests", 2);
Z([
  a
], Q.prototype, "tasks", 2);
Z([
  a
], Q.prototype, "requiredPlans", 2);
Z([
  a
], Q.prototype, "currentTest", 2);
Z([
  a
], Q.prototype, "parent", 2);
Z([
  a
], Q.prototype, "parentItemId", 2);
Z([
  a
], Q.prototype, "children", 2);
Z([
  a
], Q.prototype, "previousItem", 2);
Z([
  a
], Q.prototype, "nextItem", 2);
Z([
  a
], Q.prototype, "studentCourse", 2);
Z([
  a
], Q.prototype, "course", 2);
Z([
  a
], Q.prototype, "fetching", 2);
Z([
  $
], Q.prototype, "previousSection", 1);
Z([
  $
], Q.prototype, "firstAvailableTab", 1);
Z([
  $
], Q.prototype, "itemCount", 1);
Z([
  $
], Q.prototype, "itemCompletedCount", 1);
Z([
  $
], Q.prototype, "stepCount", 1);
Z([
  $
], Q.prototype, "taskCount", 1);
Z([
  $
], Q.prototype, "taskCompletedCount", 1);
Z([
  $
], Q.prototype, "sectionProgress", 1);
Z([
  $
], Q.prototype, "ratingCompleted", 1);
Z([
  $
], Q.prototype, "completed", 1);
Z([
  $
], Q.prototype, "beginDate", 1);
Z([
  $
], Q.prototype, "completeDate", 1);
Z([
  $
], Q.prototype, "precompleted", 1);
Z([
  $
], Q.prototype, "fullPosition", 1);
Z([
  a
], Q.prototype, "_tab", 2);
Z([
  $
], Q.prototype, "tab", 1);
Z([
  $
], Q.prototype, "defaultTab", 1);
Z([
  $
], Q.prototype, "canSelect", 1);
Z([
  $
], Q.prototype, "previousRequiredItem", 1);
Z([
  $
], Q.prototype, "previousAccessibleItem", 1);
Z([
  $
], Q.prototype, "nextAccessibleItem", 1);
Z([
  $
], Q.prototype, "hasAccessibleItems", 1);
Z([
  $
], Q.prototype, "accessibleChildren", 1);
Z([
  $
], Q.prototype, "courseItemAvailability", 1);
Z([
  $
], Q.prototype, "parentAvailability", 1);
Z([
  $
], Q.prototype, "availabilityRelativeToTimeDelay", 1);
Z([
  $
], Q.prototype, "availabilityRelativeToOther", 1);
Z([
  $
], Q.prototype, "hasPlanAccess", 1);
Z([
  $
], Q.prototype, "hasAccessGrantedByAdmin", 1);
Z([
  $
], Q.prototype, "canSkip", 1);
Z([
  C
], Q.prototype, "update", 1);
Z([
  $
], Q.prototype, "regularTimeDelayValue", 1);
Z([
  $
], Q.prototype, "flowTimeDelayValue", 1);
let Lo = Q;
class X_ extends J0 {
  constructor(e) {
    super();
    z(this, "studentCourseId");
    /**
     * Item we'd like to select
     * In addition to root branch, request the item section branch
     */
    z(this, "courseItemId");
    /**
     * Request only the section items
     */
    z(this, "sectionId");
    this.sortName = "position", this.sortType = "Asc", e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var C_ = Object.defineProperty, I_ = Object.getOwnPropertyDescriptor, ve = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? I_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && C_(t, e, b), b;
};
const ue = class hl extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "shortDescription");
    z(this, "freeAccess");
    z(this, "isCompleteAnyCourseRequirement");
    z(this, "primaryImageCloudKey");
    z(this, "studentCourse");
    z(this, "studentAccessDate");
    z(this, "studentHasAccess");
    z(this, "categories");
    z(this, "requirements");
    z(this, "certId");
    z(this, "paymentUrl");
    z(this, "studentCanBuyAccess");
    i0(this), e && this.update(e);
  }
  get hasRequirements() {
    return this.requirements && this.requirements.length > 0;
  }
  get hasCourseItem() {
    return this.studentCourse && this.studentCourse.currentCourseItem;
  }
  static fromJson(e) {
    var o, b;
    return new hl({
      ...e,
      studentAccessDate: e.studentAccessDate ? new Date(e.studentAccessDate) : void 0,
      studentCourse: e.studentCourse ? or.fromJson(e.studentCourse) : void 0,
      certId: e.cert ? (b = (o = e.cert) == null ? void 0 : o.image) == null ? void 0 : b.id : void 0
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
};
ve([
  a
], ue.prototype, "title", 2);
ve([
  a
], ue.prototype, "shortDescription", 2);
ve([
  a
], ue.prototype, "freeAccess", 2);
ve([
  a
], ue.prototype, "isCompleteAnyCourseRequirement", 2);
ve([
  a
], ue.prototype, "primaryImageCloudKey", 2);
ve([
  a
], ue.prototype, "studentCourse", 2);
ve([
  a
], ue.prototype, "studentAccessDate", 2);
ve([
  a
], ue.prototype, "studentHasAccess", 2);
ve([
  a
], ue.prototype, "categories", 2);
ve([
  a
], ue.prototype, "requirements", 2);
ve([
  a
], ue.prototype, "certId", 2);
ve([
  a
], ue.prototype, "paymentUrl", 2);
ve([
  a
], ue.prototype, "studentCanBuyAccess", 2);
ve([
  $
], ue.prototype, "hasRequirements", 1);
ve([
  $
], ue.prototype, "hasCourseItem", 1);
ve([
  C
], ue.prototype, "update", 1);
let P_ = ue;
class Rb extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "description");
    z(this, "coverCloudKey");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "position");
    z(this, "parentId");
    z(this, "parent");
    z(this, "course");
    z(this, "library");
    z(this, "type");
    z(this, "sectionType");
    z(this, "children");
    e && this.update(e);
  }
  get progress() {
    var o, b;
    if (this.sectionType == "library") return 0;
    if (this.type == "item")
      return ((b = (o = this.course) == null ? void 0 : o.studentCourse) == null ? void 0 : b.progress) ?? 0;
    let e = 0;
    return this.children.forEach((r) => e += r.progress), e > 0 && (e = Math.floor(e / this.children.length)), e;
  }
  get itemCount() {
    if (this.type == "item") return 1;
    let e = 0;
    for (const o of this.children)
      e += o.itemCount;
    return e;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    const o = new Rb({
      id: e.id,
      title: e.title,
      description: e.description,
      type: e.type,
      sectionType: e.sectionType,
      position: e.position,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      coverCloudKey: e.coverCloudKey,
      parentId: e.parentId,
      parent: e.parent ? Rb.fromJson(e.parent) : e.parent === null ? null : void 0,
      course: e.course ? P_.fromJson(e.course) : void 0,
      library: e.library ? Co.fromJson(e.library) : void 0,
      children: e.children ? e.children.map(Rb.fromJson) : []
    });
    return o.children.forEach((b) => b.update({ parent: o })), o;
  }
}
class E_ extends J0 {
  constructor(e) {
    super(e);
    z(this, "courseType");
    z(this, "onlyAvailable");
    z(this, "sectionType");
    e && this.update(e);
  }
}
class Vi extends n0 {
  constructor(e) {
    super();
    z(this, "email");
    z(this, "emailNeedConfirm");
    z(this, "blockAccessIfEmailUnconfirmed");
    z(this, "blockEmailChange");
    z(this, "phone");
    z(this, "phoneRequired");
    z(this, "phoneNeedConfirm");
    z(this, "blockAccessIfPhoneUnconfirmed");
    z(this, "firstName");
    z(this, "firstNameRequired");
    z(this, "lastName");
    z(this, "lastNameRequired");
    z(this, "middleName");
    z(this, "middleNameRequired");
    z(this, "birthday");
    z(this, "birthdayRequired");
    z(this, "gender");
    z(this, "genderRequired");
    e && this.update(e);
  }
  clone() {
    return new Vi({
      ...this
    });
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Vi({
      ...e
    });
  }
}
class Yi extends n0 {
  constructor(e) {
    super();
    z(this, "registrationAgreementText");
    z(this, "isRegistrationAgreementEnabled");
    z(this, "isCookieNotificationEnabled");
    z(this, "cookieNotificationText");
    z(this, "footerHtml");
    z(this, "isPageFooterEnabled");
    z(this, "isLearnPageFooterEnabled");
    e && this.update(e);
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  copy() {
    return new Yi({
      id: this.id,
      registrationAgreementText: this.registrationAgreementText,
      isRegistrationAgreementEnabled: this.isRegistrationAgreementEnabled,
      footerHtml: this.footerHtml,
      isPageFooterEnabled: this.isPageFooterEnabled,
      isLearnPageFooterEnabled: this.isLearnPageFooterEnabled,
      cookieNotificationText: this.cookieNotificationText,
      isCookieNotificationEnabled: this.isCookieNotificationEnabled
    });
  }
  static fromJson(e) {
    return new Yi({
      ...e,
      footerHtml: e.footerText
    });
  }
}
var k_ = /* @__PURE__ */ ((p) => (p.Created = "created", p.CheckoutData = "checkoutData", p.Payment = "payment", p.PartiallyPaid = "partiallyPaid", p.Paid = "paid", p.PreparingShipment = "preparingShipment", p.Shipped = "shipped", p.Fulfilled = "fulfilled", p.Canceled = "canceled", p.Refund = "refund", p))(k_ || {});
class CM extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "paidDate");
    z(this, "currency");
    z(this, "isDigitalDelivery");
    z(this, "fullyPaid");
    z(this, "shippingPrice");
    z(this, "number");
    z(this, "totalAmount");
    z(this, "paidAmount");
    z(this, "savingsAmount");
    z(this, "paidBonusAmount");
    z(this, "feeAmount");
    z(this, "contact");
    z(this, "completed");
    z(this, "status");
    z(this, "contents");
    e && this.update(e);
  }
  get isPartiallyPaid() {
    return this.paidAmount > 0 && this.paidAmount < this.totalAmount;
  }
  toJson() {
    return {
      ...this
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new CM({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      contact: e.contact ? L1.fromJson(e.contact) : null,
      contents: e.contents ? e.contents.map(Ia.fromJson) : [],
      paidDate: e.paidDate ? L(e.paidDate) : null
    });
  }
}
class x_ extends J0 {
  constructor(e) {
    super();
    z(this, "createdFromDate");
    z(this, "createdToDate");
    z(this, "paidFromDate");
    z(this, "paidToDate");
    z(this, "status");
    z(this, "number");
    z(this, "currency");
    z(this, "isDigitalDelivery");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var F_ = /* @__PURE__ */ ((p) => (p.Digital = "digital", p.Physical = "physical", p.Service = "service", p.Material = "material", p.Subscription = "subscription", p.Cohort = "cohort", p))(F_ || {});
class IM extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "price");
    z(this, "type");
    z(this, "subsPrice");
    z(this, "subsDuration");
    z(this, "subsDurationType");
    z(this, "image");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new IM({
      ...e,
      image: e.image ? $1.fromJson(e.image) : void 0
    });
  }
}
class Ia extends n0 {
  constructor(e) {
    super();
    z(this, "quantity");
    z(this, "product");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Ia({
      ...e,
      product: e.product ? IM.fromJson(e.product) : void 0
    });
  }
}
class Pa extends n0 {
  constructor(e) {
    super();
    z(this, "beginDate");
    z(this, "endDate");
    e && this.update(e);
  }
  get periodInDays() {
    return this.beginDate != null && this.endDate != null ? this.endDate.diff(this.beginDate, "days") : 0;
  }
  get isActive() {
    return this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Pa({
      ...e,
      beginDate: e.beginDate ? L(e.beginDate) : void 0,
      endDate: e.endDate ? L(e.endDate) : null
    });
  }
}
class Xb extends n0 {
  constructor(e) {
    super();
    z(this, "beginDate");
    z(this, "endDate");
    z(this, "creditEndDate");
    z(this, "type");
    z(this, "state");
    z(this, "product");
    z(this, "currentSuspension");
    z(this, "course");
    z(this, "coursePlan");
    z(this, "library");
    e && this.update(e);
  }
  get isActive() {
    return this.endDate == null ? this.beginDate.isSameOrBefore(L()) : this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  get isSuspended() {
    return this.currentSuspension != null;
  }
  get isBeginInFuture() {
    return this.beginDate.isAfter(L());
  }
  //#region Subscription
  get isSubscriptionActive() {
    return this.beginDate.isSameOrBefore() && (this.creditEndDate && this.creditEndDate.isAfter() || !this.creditEndDate && this.endDate && this.endDate.isAfter() || this.endDate == null);
  }
  get isSubscriptionEnding() {
    return this.isSubscriptionActive && this.endDate && this.creditEndDate && this.endDate.isSameOrBefore() && this.creditEndDate.isAfter();
  }
  get isSubscriptionEnded() {
    return !this.isSubscriptionActive && this.endDate && this.creditEndDate && this.creditEndDate.isSameOrBefore();
  }
  get canPauseSubscription() {
    return this.state == "active";
  }
  get canContinueSubscription() {
    return this.state == "paused" && !this.isSubscriptionEnded;
  }
  //#endregion
  get periodInDays() {
    return this.beginDate != null && this.endDate != null ? this.endDate.diff(this.beginDate, "days") : 0;
  }
  get daysAndHoursLeft() {
    return this.calculateDaysLeft(this.endDate, !1);
  }
  get creditDaysAndHoursLeft() {
    return this.calculateDaysLeft(this.creditEndDate, !0);
  }
  calculateDaysLeft(e, o) {
    if (e == null)
      return { days: o ? 0 : 1 / 0, hours: 0, lessThanOneDay: !1, lessThanOneHour: !1, daysAgo: 0 };
    let b = e.diff(L.now(), "hours", !0), r = Math.trunc(b / 24), i = Math.floor(b % 24);
    if (b < 0)
      return { days: 0, hours: 0, daysAgo: Math.abs(r), lessThanOneDay: !1, lessThanOneHour: !1 };
    const s = r < 1, d = r === 0 && b < 1;
    return { days: r, hours: i, lessThanOneDay: s, lessThanOneHour: d, daysAgo: 0 };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var b, r;
    const o = new Xb({
      ...e,
      beginDate: e.beginDate ? L(e.beginDate) : void 0,
      endDate: e.endDate ? L(e.endDate) : null,
      creditEndDate: e.creditEndDate ? L(e.creditEndDate) : null,
      product: e.product ? new IM(e.product) : void 0,
      currentSuspension: e.currentSuspension ? Pa.fromJson(e.currentSuspension) : null,
      coursePlan: e.coursePlan ? DM.fromJson(e.coursePlan) : void 0,
      library: (b = e.libraryAccess) != null && b.library ? Co.fromJson(e.libraryAccess.library) : void 0,
      course: e.course ? wt.fromJson(e.course) : void 0
    });
    return o.coursePlan && o.update({ course: (r = o.coursePlan) == null ? void 0 : r.course }), o;
  }
}
class Ea extends J0 {
  constructor(e) {
    super();
    z(this, "studentId");
    z(this, "isActive");
    z(this, "isExpired");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var U_ = Object.defineProperty, H_ = Object.getOwnPropertyDescriptor, M0 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? H_(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && U_(t, e, b), b;
};
const ie = class ml extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "enabled");
    z(this, "shopEnabled");
    z(this, "leaderboardEnabled");
    z(this, "leaderboardTakeCount");
    z(this, "leaderboardDuration");
    z(this, "leaderboardDurationType");
    z(this, "pointsName");
    z(this, "pointsShortName");
    z(this, "pointsExpireDuration");
    z(this, "pointsExpireDurationType");
    z(this, "pointsIconType");
    z(this, "pointsIconCloudKey");
    z(this, "pointsCustomIcon");
    z(this, "achievementStyle");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      pointsCustomIconId: this.pointsCustomIcon === null ? null : (e = this.pointsCustomIcon) == null ? void 0 : e.id,
      // skip some fields just in case,
      pointsCustomIcon: void 0,
      scenario: void 0
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    var o, b;
    return this.achievementStyle !== e.achievementStyle || this.pointsName !== e.pointsName || this.pointsShortName !== e.pointsShortName || this.pointsExpireDuration !== e.pointsExpireDuration || this.pointsExpireDurationType !== e.pointsExpireDurationType || this.pointsIconType !== e.pointsIconType || this.pointsIconCloudKey !== e.pointsIconCloudKey || ((o = this.pointsCustomIcon) == null ? void 0 : o.id) !== ((b = e.pointsCustomIcon) == null ? void 0 : b.id) || this.leaderboardEnabled !== e.leaderboardEnabled || this.leaderboardTakeCount !== e.leaderboardTakeCount || this.leaderboardDuration !== e.leaderboardDuration || this.leaderboardDurationType !== e.leaderboardDurationType;
  }
  static fromJson(e) {
    return new ml({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      pointsCustomIcon: e.pointsCustomIcon ? $1.fromJson(e.pointsCustomIcon) : void 0
    });
  }
};
M0([
  a
], ie.prototype, "createdDate", 2);
M0([
  a
], ie.prototype, "updatedDate", 2);
M0([
  a
], ie.prototype, "enabled", 2);
M0([
  a
], ie.prototype, "shopEnabled", 2);
M0([
  a
], ie.prototype, "leaderboardEnabled", 2);
M0([
  a
], ie.prototype, "leaderboardTakeCount", 2);
M0([
  a
], ie.prototype, "leaderboardDuration", 2);
M0([
  a
], ie.prototype, "leaderboardDurationType", 2);
M0([
  a
], ie.prototype, "pointsName", 2);
M0([
  a
], ie.prototype, "pointsShortName", 2);
M0([
  a
], ie.prototype, "pointsExpireDuration", 2);
M0([
  a
], ie.prototype, "pointsExpireDurationType", 2);
M0([
  a
], ie.prototype, "pointsIconType", 2);
M0([
  a
], ie.prototype, "pointsIconCloudKey", 2);
M0([
  a
], ie.prototype, "pointsCustomIcon", 2);
M0([
  a
], ie.prototype, "achievementStyle", 2);
M0([
  C
], ie.prototype, "update", 1);
let Rl = ie;
const de = class Oz extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "enabled");
    z(this, "points");
    z(this, "title");
    z(this, "description");
    z(this, "type");
    z(this, "subtype");
    z(this, "style");
    z(this, "imageType");
    z(this, "imageCloudKey");
    z(this, "customImage");
    z(this, "systemAchievement");
    z(this, "gamificationId");
    z(this, "achievedDate");
    z(this, "count");
    i0(this), e && this.update(e);
  }
  get isOverrided() {
    return this.systemAchievement !== null;
  }
  get isSystem() {
    return this.type == "system";
  }
  get executionMethod() {
    switch (this.subtype) {
      case "firstStep":
      case "firstTask":
      case "firstTest":
        return "once-material";
      case "activeStudent":
        return "many";
      default:
        return "once";
    }
  }
  toJson() {
    var e, o;
    return {
      ...this,
      customImageId: this.customImage === null ? null : (e = this.customImage) == null ? void 0 : e.id,
      systemAchievementId: this.systemAchievement === null ? null : (o = this.systemAchievement) == null ? void 0 : o.id,
      // skip some fields just in case,
      customImage: void 0,
      systemAchievement: void 0
    };
  }
  clone(e) {
    var o, b;
    return new Oz({
      ...this,
      customImage: (o = this.customImage) == null ? void 0 : o.clone(),
      systemAchievement: (b = this.systemAchievement) == null ? void 0 : b.clone(),
      ...e
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    return Object.keys(e).some((o) => e[o] !== this[o]);
  }
  static fromJson(e) {
    return new Oz({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      customImage: e.customImage ? $1.fromJson(e.customImage) : null,
      systemAchievement: e.systemAchievement ? Oz.fromJson(e.systemAchievement) : null,
      achievedDate: e.achievedDate ? L(e.achievedDate) : void 0
    });
  }
};
M0([
  a
], de.prototype, "createdDate", 2);
M0([
  a
], de.prototype, "updatedDate", 2);
M0([
  a
], de.prototype, "enabled", 2);
M0([
  a
], de.prototype, "points", 2);
M0([
  a
], de.prototype, "title", 2);
M0([
  a
], de.prototype, "description", 2);
M0([
  a
], de.prototype, "type", 2);
M0([
  a
], de.prototype, "subtype", 2);
M0([
  a
], de.prototype, "style", 2);
M0([
  a
], de.prototype, "imageType", 2);
M0([
  a
], de.prototype, "imageCloudKey", 2);
M0([
  a
], de.prototype, "customImage", 2);
M0([
  a
], de.prototype, "systemAchievement", 2);
M0([
  $
], de.prototype, "isOverrided", 1);
M0([
  $
], de.prototype, "isSystem", 1);
M0([
  C
], de.prototype, "update", 1);
let ka = de;
class J_ extends J0 {
  constructor(e) {
    super();
    z(this, "style");
    z(this, "gamificationId");
    z(this, "showAll");
    z(this, "enabled");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
const Ce = class Gi extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "description");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "enabled");
    z(this, "points");
    z(this, "useAvailableCount");
    z(this, "availableCount");
    z(this, "contentType");
    z(this, "bonusAmount");
    z(this, "image");
    z(this, "product");
    z(this, "gamification");
    z(this, "purchasedDate");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e, o, b;
    return {
      ...this,
      imageId: this.image === null ? null : (e = this.image) == null ? void 0 : e.id,
      productId: this.product === null ? null : (o = this.product) == null ? void 0 : o.id,
      gamificationId: this.gamification === null ? null : (b = this.gamification) == null ? void 0 : b.id,
      // skip some fields just in case,
      image: void 0,
      product: void 0,
      scenario: void 0,
      gamification: void 0
    };
  }
  clone() {
    var e, o, b;
    return new Gi({
      ...this,
      image: (e = this.image) == null ? void 0 : e.clone(),
      product: (o = this.product) == null ? void 0 : o.clone(),
      gamification: (b = this.gamification) == null ? void 0 : b.clone()
    });
  }
  setContentType(e) {
    this.contentType = e;
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    var o, b, r, i;
    return this.title !== e.title || this.description !== e.description || this.points !== e.points || this.useAvailableCount !== e.useAvailableCount || this.availableCount !== e.availableCount || this.contentType !== e.contentType || this.bonusAmount !== e.bonusAmount || ((o = this.image) == null ? void 0 : o.id) !== ((b = e.image) == null ? void 0 : b.id) || ((r = this.product) == null ? void 0 : r.id) !== ((i = e.product) == null ? void 0 : i.id) || this.enabled !== e.enabled;
  }
  static fromJson(e) {
    return new Gi({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      image: e.image ? $1.fromJson(e.image) : null,
      product: e.product ? IM.fromJson(e.product) : null,
      gamification: e.gamification ? Rl.fromJson(e.gamification) : void 0,
      purchaseDate: e.purchaseDate ? L(e.purchaseDate) : void 0
    });
  }
};
M0([
  a
], Ce.prototype, "title", 2);
M0([
  a
], Ce.prototype, "description", 2);
M0([
  a
], Ce.prototype, "createdDate", 2);
M0([
  a
], Ce.prototype, "updatedDate", 2);
M0([
  a
], Ce.prototype, "enabled", 2);
M0([
  a
], Ce.prototype, "points", 2);
M0([
  a
], Ce.prototype, "useAvailableCount", 2);
M0([
  a
], Ce.prototype, "availableCount", 2);
M0([
  a
], Ce.prototype, "contentType", 2);
M0([
  a
], Ce.prototype, "bonusAmount", 2);
M0([
  a
], Ce.prototype, "image", 2);
M0([
  a
], Ce.prototype, "product", 2);
M0([
  C
], Ce.prototype, "setContentType", 1);
M0([
  C
], Ce.prototype, "update", 1);
let yl = Ce;
class ww extends J0 {
  constructor(e) {
    super();
    z(this, "gamificationId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var $_ = /* @__PURE__ */ ((p) => (p.Day = "day", p.Month = "month", p.Year = "year", p))($_ || {}), V_ = /* @__PURE__ */ ((p) => (p.Endless = "endless", p.Duration = "duration", p.Date = "date", p))(V_ || {});
const Ie = class sz extends n0 {
  constructor(e) {
    super();
    z(this, "points");
    z(this, "type");
    z(this, "comment");
    z(this, "burnedTransaction");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "expiredDate");
    z(this, "contact");
    z(this, "achievement");
    z(this, "product");
    z(this, "duration");
    z(this, "durationType");
    z(this, "validUntilDate");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e, o, b, r;
    return {
      ...this,
      contactId: this.contact === null ? null : (e = this.contact) == null ? void 0 : e.id,
      studentAchievementId: this.achievement === null ? null : (o = this.achievement) == null ? void 0 : o.id,
      productId: this.product === null ? null : (b = this.product) == null ? void 0 : b.id,
      burnedTransactionId: this.burnedTransaction === null ? null : (r = this.burnedTransaction) == null ? void 0 : r.id,
      // skip some fields just in case,
      contact: void 0,
      adminCreator: void 0,
      achievement: void 0,
      product: void 0,
      scenarioNode: void 0,
      burnedTransaction: void 0
    };
  }
  clone() {
    var e, o, b, r;
    return new sz({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone(),
      achievement: (o = this.achievement) == null ? void 0 : o.clone(),
      product: (b = this.product) == null ? void 0 : b.clone(),
      burnedTransaction: (r = this.burnedTransaction) == null ? void 0 : r.clone()
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    return Object.keys(e).some((o) => e[o] !== this[o]);
  }
  static fromJson(e) {
    return new sz({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      expiredDate: e.expiredDate ? L(e.expiredDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : null,
      achievement: e.studentAchievement ? G_.fromJson(e.studentAchievement) : null,
      product: e.product ? yl.fromJson(e.product) : null,
      course: e.course ? wt.fromJson(e.course) : null,
      courseItem: e.courseItem ? Qb.fromJson(e.courseItem) : null,
      burnedTransaction: e.burnedTransaction ? sz.fromJson(e.burnedTransaction) : null
    });
  }
};
M0([
  a
], Ie.prototype, "points", 2);
M0([
  a
], Ie.prototype, "type", 2);
M0([
  a
], Ie.prototype, "comment", 2);
M0([
  a
], Ie.prototype, "burnedTransaction", 2);
M0([
  a
], Ie.prototype, "createdDate", 2);
M0([
  a
], Ie.prototype, "updatedDate", 2);
M0([
  a
], Ie.prototype, "expiredDate", 2);
M0([
  a
], Ie.prototype, "contact", 2);
M0([
  a
], Ie.prototype, "achievement", 2);
M0([
  a
], Ie.prototype, "product", 2);
M0([
  a
], Ie.prototype, "duration", 2);
M0([
  a
], Ie.prototype, "durationType", 2);
M0([
  a
], Ie.prototype, "validUntilDate", 2);
M0([
  C
], Ie.prototype, "update", 1);
let Y_ = Ie;
class Sw extends J0 {
  constructor(e) {
    super();
    z(this, "gamificationId");
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "studentId");
    z(this, "studentIds");
    z(this, "type");
    z(this, "pointsFrom");
    z(this, "pointsTo");
    z(this, "productId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
const Po = class gl extends n0 {
  constructor(e) {
    super();
    z(this, "course");
    z(this, "courseItem");
    z(this, "library");
    z(this, "libraryItem");
    z(this, "achievement");
    z(this, "points");
    i0(this), e && this.update(e);
  }
  static fromJson(e) {
    return new gl({
      ...e,
      achievement: e.achievement ? ka.fromJson(e.achievement) : void 0,
      course: e.course ? wt.fromJson(e.course) : null,
      courseItem: e.courseItem ? Qb.fromJson(e.courseItem) : null,
      library: e.library ? Co.fromJson(e.library) : null,
      libraryItem: e.libraryItem ? Db.fromJson(e.libraryItem) : null
    });
  }
};
M0([
  a
], Po.prototype, "course", 2);
M0([
  a
], Po.prototype, "courseItem", 2);
M0([
  a
], Po.prototype, "library", 2);
M0([
  a
], Po.prototype, "libraryItem", 2);
M0([
  a
], Po.prototype, "achievement", 2);
M0([
  a
], Po.prototype, "points", 2);
let G_ = Po;
class xa extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "subtype");
    z(this, "imageCloudKey");
    z(this, "count");
    e && this.update(e);
  }
  static fromJson(e) {
    return new xa({
      ...e
    });
  }
}
const Eo = class Ki extends n0 {
  constructor(e) {
    super();
    z(this, "place");
    z(this, "score");
    z(this, "createdDate");
    z(this, "contact");
    z(this, "achievements");
    i0(this), e && this.update(e);
  }
  toJson() {
    return {
      ...this
    };
  }
  clone() {
    var e;
    return new Ki({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone()
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new Ki({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : null,
      achievements: e.achievements ? e.achievements.map(xa.fromJson) : null
    });
  }
};
M0([
  a
], Eo.prototype, "place", 2);
M0([
  a
], Eo.prototype, "score", 2);
M0([
  a
], Eo.prototype, "createdDate", 2);
M0([
  a
], Eo.prototype, "contact", 2);
M0([
  a
], Eo.prototype, "achievements", 2);
M0([
  C
], Eo.prototype, "update", 1);
let K_ = Eo;
class Ll extends J0 {
  constructor(e) {
    super();
    z(this, "gamificationId");
    z(this, "registrationDateFrom");
    z(this, "registrationDateTo");
    z(this, "studentIds");
    z(this, "scoreFrom");
    z(this, "scoreTo");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class wz extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "details");
    z(this, "url");
    z(this, "address");
    z(this, "beginDate");
    z(this, "endDate");
    z(this, "isMember");
    z(this, "duration");
    e && this.update(e);
  }
  get isOutdated() {
    return this.endDate ? this.endDate.isBefore(L()) : !1;
  }
  get isActive() {
    return L().isBetween(this.beginDate, this.endDate, null, "[]");
  }
  get allDay() {
    return this.duration === "day";
  }
  toJson() {
    var e, o;
    return {
      ...this,
      beginDate: (e = this.beginDate) == null ? void 0 : e.toISOString(),
      endDate: (o = this.endDate) == null ? void 0 : o.toISOString()
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new wz({
      ...e,
      beginDate: e.beginDate ? L(e.beginDate) : void 0,
      endDate: e.endDate ? L(e.endDate) : void 0
    });
  }
}
class Q_ extends J0 {
  constructor(e) {
    super();
    z(this, "beginDateFrom");
    z(this, "beginDateTo");
    z(this, "isOutdated");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var Se = /* @__PURE__ */ ((p) => (p.AccountLoginSuccess = "accountLoginSuccess", p.AccountLoginPrevented = "accountLoginPrevented", p.EmailConfirmed = "adminEmailConfirmed", p.CourseTaskAnswer = "courseTaskAnswer", p.Order = "order", p.OrderPayment = "orderPayment", p.AdminTaskStatus = "adminTaskStatus", p.AdminTaskCreated = "adminTaskCreated", p.AdminTaskReminder = "adminTaskReminder", p.CustomNotification = "customNotification", p.CourseTaskComment = "courseTaskComment", p.CourseItemComment = "courseItemComment", p.LibraryItemComment = "libraryItemComment", p.PipelineDealCreated = "pipelineDealCreated", p.PipelineDealCompleted = "pipelineDealCompleted", p.CourseTaskAnswerStatus = "courseTaskAnswerStatus", p.PasswordChanged = "passwordChanged", p.NewChatMessage = "receivedNewChatMessage", p.NewEmailMessage = "receivedNewEmailMessage", p.AdminPartnershipTransactionRequest = "adminPartnershipTransactionRequest", p.StudentPartnershipTransaction = "studentPartnershipTransaction", p.StudentPartnershipRegistration = "studentPartnershipRegistration", p.StudentBonusTransaction = "studentBonusTransaction", p.CommunityPostComment = "communityPostComment", p.CommunityCommentReply = "communityCommentReply", p))(Se || {});
class br extends n0 {
  constructor(e) {
    super();
    z(this, "type");
    z(this, "payload");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "seenDate");
    z(this, "adminTaskId");
    z(this, "courseItemId");
    z(this, "libraryItemId");
    z(this, "taskAnswerId");
    z(this, "courseItemTaskId");
    z(this, "schoolContentItemCommentId");
    z(this, "orderId");
    z(this, "orderPaymentId");
    z(this, "scenarioId");
    z(this, "chatConversationId");
    z(this, "courseId");
    z(this, "libraryId");
    z(this, "contactId");
    z(this, "adminId");
    z(this, "schoolContentItemProgressRatingId");
    //#region Partnership
    z(this, "partnershipTransactionId");
    z(this, "partnershipTransactionRequestId");
    z(this, "studentBonusTransactionId");
    //#endregion
    //#region Community
    z(this, "communityPostId");
    z(this, "communityPostCommentId");
    e && this.update(e);
  }
  get isSeen() {
    return this.seenDate != null;
  }
  //#endregion
  static fromJson(e) {
    return new br({
      ...e,
      payload: e.payloadJson ? JSON.parse(e.payloadJson) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      seenDate: e.seenDate ? L(e.seenDate) : null
    });
  }
  update(e) {
    super.update(e);
  }
}
class Z_ extends J0 {
  constructor(e) {
    super();
    z(this, "adminId");
    z(this, "studentId");
    z(this, "read");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class vo extends n0 {
  constructor(e) {
    super();
    z(this, "type");
    e && this.update(e);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(e) {
    return new vo({
      ...e
    });
  }
  update(e) {
    super.update(e);
  }
}
class vl extends n0 {
  constructor(e) {
    super();
    z(this, "reason");
    z(this, "beginDate");
    z(this, "endDate");
    z(this, "contact");
    e && this.update(e);
  }
  static fromJson(e) {
    return new vl({
      ...e,
      beginDate: e.beginDate ? new Date(e.beginDate) : void 0,
      endDate: e.endDate ? new Date(e.endDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : null
    });
  }
  update(e) {
    super.update(e);
  }
}
class Dw extends J0 {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "isActive");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class qo extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "description");
    z(this, "canStudentCreateTopics");
    z(this, "isPublished");
    z(this, "isLimitedAccess");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "lastActivityDate");
    z(this, "parentThread");
    z(this, "moderators");
    z(this, "topicCount");
    z(this, "commentCount");
    z(this, "designSettings");
    z(this, "designSettingsPublished");
    z(this, "designHTMLPublished");
    z(this, "designStylePublished");
    z(this, "designConcurrencyStamp");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      parentThread: (e = this.parentThread) == null ? void 0 : e.toJson(),
      moderators: this.moderators.map((o) => o.toJson())
    };
  }
  static fromJson(e) {
    return new qo({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? new Date(e.lastActivityDate) : void 0,
      parentThread: e.parentThread ? qo.fromJson(e.parentThread) : null,
      moderators: e.moderators ? e.moderators.map((o) => L1.fromJson(o.student)) : []
    });
  }
}
class Xw extends J0 {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "parentThreadId");
    z(this, "onlyRoots");
    z(this, "flowId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class _o extends n0 {
  constructor(e) {
    super();
    z(this, "text");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "reply");
    z(this, "contact");
    z(this, "files");
    z(this, "sequenceNumber");
    z(this, "likeCount", 0);
    z(this, "dislikeCount", 0);
    z(this, "currentUserReaction");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new _o({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      reply: e.replyToComment ? _o.fromJson(e.replyToComment) : null,
      files: e.files ? e.files.map($1.fromJson) : [],
      contact: e.student ? L1.fromJson(e.student) : null,
      currentUserReaction: e.currentUserReaction ? vo.fromJson(e.currentUserReaction) : null
    });
  }
}
class _l extends J0 {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "topicId");
    z(this, "studentId");
    z(this, "replyToCommentId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Zb extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "text");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "lastActivityDate");
    z(this, "lastComment");
    z(this, "commentCount");
    z(this, "contact");
    z(this, "files");
    z(this, "likeCount");
    z(this, "dislikeCount");
    z(this, "currentUserReaction");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Zb({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? new Date(e.lastActivityDate) : void 0,
      lastComment: e.lastComment ? _o.fromJson(e.lastComment) : null,
      contact: e.student ? L1.fromJson(e.student) : null,
      files: e.files ? e.files.map($1.fromJson) : [],
      currentUserReaction: e.currentUserReaction ? vo.fromJson(e.currentUserReaction) : null
    });
  }
}
class Cw extends J0 {
  constructor(e) {
    super();
    z(this, "id");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var j_ = Object.defineProperty, eN = Object.getOwnPropertyDescriptor, $2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? eN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && j_(t, e, b), b;
};
const u2 = class Qi extends n0 {
  constructor(e) {
    super();
    z(this, "amount");
    z(this, "fee");
    z(this, "useBonus");
    z(this, "comment");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "partner");
    z(this, "type");
    z(this, "order");
    z(this, "validAfterDate");
    z(this, "level");
    z(this, "levelPartner");
    i0(this), e && this.update(e);
  }
  get canWithdraw() {
    return this.validAfterDate && this.validAfterDate.isBefore(L());
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e, o, b;
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      fee: this.fee,
      comment: this.comment,
      partnerId: (e = this.partner) == null ? void 0 : e.id,
      orderId: (o = this.order) == null ? void 0 : o.id,
      useBonus: this.useBonus,
      level: this.level,
      levelPartnerId: (b = this.levelPartner) == null ? void 0 : b.id
    };
  }
  static fromJson(e) {
    return new Qi({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      partner: e.partner ? L1.fromJson(e.partner) : void 0,
      order: e.order ? CM.fromJson(e.order) : void 0,
      validAfterDate: e.validAfterDate ? L(e.validAfterDate) : void 0,
      levelPartner: e.levelPartner ? L1.fromJson(e.levelPartner) : void 0
    });
  }
  static default() {
    return new Qi({
      fee: 0,
      type: "deposit"
    });
  }
};
$2([
  a
], u2.prototype, "amount", 2);
$2([
  a
], u2.prototype, "fee", 2);
$2([
  a
], u2.prototype, "useBonus", 2);
$2([
  a
], u2.prototype, "comment", 2);
$2([
  a
], u2.prototype, "createdDate", 2);
$2([
  a
], u2.prototype, "updatedDate", 2);
$2([
  a
], u2.prototype, "partner", 2);
$2([
  a
], u2.prototype, "type", 2);
$2([
  a
], u2.prototype, "order", 2);
$2([
  a
], u2.prototype, "validAfterDate", 2);
$2([
  $
], u2.prototype, "canWithdraw", 1);
$2([
  C
], u2.prototype, "update", 1);
let Nl = u2;
class tN extends J0 {
  constructor(e) {
    super();
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "partnerIds");
    z(this, "amountFrom");
    z(this, "amountTo");
    z(this, "feeFrom");
    z(this, "feeTo");
    /**
     * has admin => manual transaction
     */
    z(this, "hasAdminId");
    z(this, "type");
    z(this, "orderId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var pN = Object.defineProperty, oN = Object.getOwnPropertyDescriptor, d2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? oN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && pN(t, e, b), b;
}, MN = /* @__PURE__ */ ((p) => (p.Day = "day", p.Month = "month", p))(MN || {}), bN = /* @__PURE__ */ ((p) => (p.Endless = "endless", p.Duration = "duration", p.Date = "date", p))(bN || {});
const Ge = class fb extends n0 {
  constructor(e) {
    super();
    z(this, "amount");
    z(this, "comment");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "contact");
    z(this, "order");
    z(this, "type");
    z(this, "transaction");
    z(this, "burnedTransaction");
    z(this, "duration");
    z(this, "durationType");
    z(this, "validUntilDate");
    i0(this), e && this.update(e);
  }
  clone() {
    return new fb({
      ...this
    });
  }
  toJson() {
    var e, o;
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      comment: this.comment,
      studentId: (e = this.contact) == null ? void 0 : e.id,
      orderId: (o = this.order) == null ? void 0 : o.id,
      duration: this.duration,
      durationType: this.durationType,
      validUntilDate: this.validUntilDate
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new fb({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      validUntilDate: e.validUntilDate ? L(e.validUntilDate) : null,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      order: e.order ? CM.fromJson(e.order) : void 0,
      transaction: e.transaction ? Nl.fromJson(e.transaction) : void 0,
      burnedTransaction: e.burnedTransaction ? fb.fromJson(e.burnedTransaction) : void 0
    });
  }
  static default() {
    return new fb({
      amount: 0,
      type: "deposit"
    });
  }
};
d2([
  a
], Ge.prototype, "amount", 2);
d2([
  a
], Ge.prototype, "comment", 2);
d2([
  a
], Ge.prototype, "createdDate", 2);
d2([
  a
], Ge.prototype, "updatedDate", 2);
d2([
  a
], Ge.prototype, "contact", 2);
d2([
  a
], Ge.prototype, "order", 2);
d2([
  a
], Ge.prototype, "type", 2);
d2([
  a
], Ge.prototype, "transaction", 2);
d2([
  a
], Ge.prototype, "burnedTransaction", 2);
d2([
  a
], Ge.prototype, "duration", 2);
d2([
  a
], Ge.prototype, "durationType", 2);
d2([
  a
], Ge.prototype, "validUntilDate", 2);
d2([
  C
], Ge.prototype, "update", 1);
let nN = Ge;
class zN extends J0 {
  constructor(e) {
    super();
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "studentIds");
    z(this, "amountFrom");
    z(this, "amountTo");
    /**
     * has admin => manual transaction
     */
    z(this, "hasAdminId");
    z(this, "adminId");
    z(this, "type");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var rN = Object.defineProperty, cN = Object.getOwnPropertyDescriptor, Op = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? cN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && rN(t, e, b), b;
};
const Xt = class Bl extends n0 {
  constructor(e) {
    super();
    z(this, "notificationType");
    z(this, "useSite");
    z(this, "useEmail");
    z(this, "useTg");
    z(this, "useWebPush");
    z(this, "contact");
    z(this, "subscriptionId");
    i0(this), e && this.update(e);
  }
  get hasSubscription() {
    return this.subscriptionId != null;
  }
  get canUseAsGlobalSub() {
    switch (this.notificationType) {
      case Se.AdminTaskStatus:
      case Se.AdminTaskCreated:
      case Se.CourseTaskAnswer:
      case Se.CourseTaskComment:
      case Se.Order:
      case Se.OrderPayment:
      case Se.CommunityPostComment:
      case Se.CommunityCommentReply:
        return !0;
      default:
        return !1;
    }
  }
  /**
   * indicates whether this type of subscription can be used for a personal subscription to a contact
   */
  get canUseAsPersonalSub() {
    switch (this.notificationType) {
      case Se.CourseTaskAnswer:
      case Se.CourseTaskComment:
      case Se.OrderPayment:
      case Se.Order:
      case Se.CommunityPostComment:
      case Se.CommunityCommentReply:
        return !0;
      default:
        return !1;
    }
  }
  static fromJson(e) {
    return new Bl({
      id: e.id,
      notificationType: e.notificationType,
      useSite: e.useSite,
      useEmail: e.useEmail,
      useTg: e.useTg,
      useWebPush: e.useWebPush,
      subscriptionId: e.subscriptionId,
      contact: e.student ? L1.fromJson(e.student) : void 0
    });
  }
  update(e, o = !1) {
    super.update(e, o);
  }
};
Op([
  a
], Xt.prototype, "notificationType", 2);
Op([
  a
], Xt.prototype, "useSite", 2);
Op([
  a
], Xt.prototype, "useEmail", 2);
Op([
  a
], Xt.prototype, "useTg", 2);
Op([
  a
], Xt.prototype, "useWebPush", 2);
Op([
  a
], Xt.prototype, "contact", 2);
Op([
  a
], Xt.prototype, "subscriptionId", 2);
Op([
  $
], Xt.prototype, "hasSubscription", 1);
Op([
  C
], Xt.prototype, "update", 1);
let iN = Xt;
class Iw extends J0 {
  constructor(t) {
    super(), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
var aN = Object.defineProperty, ON = Object.getOwnPropertyDescriptor, sp = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? ON(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && aN(t, e, b), b;
};
const Ct = class Tl extends n0 {
  constructor(e) {
    super();
    z(this, "contact");
    z(this, "useEmail");
    z(this, "email");
    z(this, "customEmail");
    z(this, "useTg");
    z(this, "tgId");
    z(this, "channels");
    z(this, "tgLink");
    z(this, "useWebPush");
    i0(this), e && this.update(e);
  }
  static fromJson(e) {
    return new Tl({
      id: e.id,
      contact: e.student ? L1.fromJson(e.student) : void 0,
      useEmail: e.useEmail,
      email: e.email,
      customEmail: e.customEmail,
      useTg: e.useTg,
      tgId: e.tgId,
      tgLink: e.tgLink,
      useWebPush: e.useWebPush,
      channels: e.channels ? e.channels.map(iN.fromJson) : []
    });
  }
  update(e) {
    super.update(e);
  }
};
sp([
  a
], Ct.prototype, "contact", 2);
sp([
  a
], Ct.prototype, "useEmail", 2);
sp([
  a
], Ct.prototype, "email", 2);
sp([
  a
], Ct.prototype, "customEmail", 2);
sp([
  a
], Ct.prototype, "useTg", 2);
sp([
  a
], Ct.prototype, "tgId", 2);
sp([
  a
], Ct.prototype, "channels", 2);
sp([
  a
], Ct.prototype, "useWebPush", 2);
sp([
  C
], Ct.prototype, "update", 1);
let sN = Ct;
var AN = Object.defineProperty, uN = Object.getOwnPropertyDescriptor, _e = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? uN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && AN(t, e, b), b;
};
const le = class wl extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "url");
    z(this, "urls");
    z(this, "description");
    z(this, "isActive");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "fee");
    z(this, "feeType");
    z(this, "productType");
    z(this, "partnerType");
    z(this, "purchaseType");
    z(this, "products");
    z(this, "partners");
    z(this, "levels");
    i0(this), e && this.update(e);
  }
  toJson() {
    return {
      id: this.id,
      title: this.title,
      url: this.url,
      urls: this.urls,
      description: this.description,
      isActive: this.isActive,
      feeType: this.feeType,
      productType: this.productType,
      partnerType: this.partnerType,
      purchaseType: this.purchaseType,
      productIds: this.products.map((e) => e.id),
      partnerIds: this.partners.map((e) => e.id),
      levels: this.levels
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new wl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      urls: e.urlsJson ? JSON.parse(e.urlsJson) : void 0,
      products: e.productLinks ? e.productLinks.map((o) => IM.fromJson(o.product)) : void 0,
      partners: e.partnerLinks ? e.partnerLinks.map((o) => L1.fromJson(o.partner)) : void 0
    });
  }
};
_e([
  a
], le.prototype, "title", 2);
_e([
  a
], le.prototype, "url", 2);
_e([
  a
], le.prototype, "urls", 2);
_e([
  a
], le.prototype, "description", 2);
_e([
  a
], le.prototype, "isActive", 2);
_e([
  a
], le.prototype, "createdDate", 2);
_e([
  a
], le.prototype, "updatedDate", 2);
_e([
  a
], le.prototype, "fee", 2);
_e([
  a
], le.prototype, "feeType", 2);
_e([
  a
], le.prototype, "productType", 2);
_e([
  a
], le.prototype, "partnerType", 2);
_e([
  a
], le.prototype, "purchaseType", 2);
_e([
  a
], le.prototype, "products", 2);
_e([
  a
], le.prototype, "partners", 2);
_e([
  a
], le.prototype, "levels", 2);
_e([
  C
], le.prototype, "update", 1);
let dN = le;
class lN extends J0 {
  constructor(e) {
    super();
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "feeFrom");
    z(this, "feeTo");
    z(this, "productIds");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var qN = Object.defineProperty, fN = Object.getOwnPropertyDescriptor, V2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? fN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && qN(t, e, b), b;
};
const l2 = class Sl extends n0 {
  constructor(e) {
    super();
    z(this, "isActive");
    z(this, "navigationCount");
    z(this, "registrationCount");
    z(this, "amount");
    z(this, "fee");
    z(this, "availableFee");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "acceptedDate");
    z(this, "contact");
    z(this, "code");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      id: this.id,
      acceptedDate: this.acceptedDate,
      studentId: (e = this.contact) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Sl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : null,
      acceptedDate: e.acceptedDate ? L(e.acceptedDate) : null
    });
  }
};
V2([
  a
], l2.prototype, "isActive", 2);
V2([
  a
], l2.prototype, "navigationCount", 2);
V2([
  a
], l2.prototype, "registrationCount", 2);
V2([
  a
], l2.prototype, "amount", 2);
V2([
  a
], l2.prototype, "fee", 2);
V2([
  a
], l2.prototype, "availableFee", 2);
V2([
  a
], l2.prototype, "createdDate", 2);
V2([
  a
], l2.prototype, "updatedDate", 2);
V2([
  a
], l2.prototype, "acceptedDate", 2);
V2([
  a
], l2.prototype, "contact", 2);
V2([
  a
], l2.prototype, "code", 2);
V2([
  C
], l2.prototype, "update", 1);
let Dl = l2;
class WN extends J0 {
  constructor(e) {
    super();
    z(this, "createdFromDate");
    z(this, "createdToDate");
    z(this, "statisticFromDate");
    z(this, "statisticToDate");
    z(this, "acceptedFromDate");
    z(this, "acceptedToDate");
    z(this, "code");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var hN = Object.defineProperty, mN = Object.getOwnPropertyDescriptor, Jp = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? mN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && hN(t, e, b), b;
};
const Ap = class Xl extends n0 {
  constructor(e) {
    super();
    z(this, "amount");
    z(this, "partnerComment");
    z(this, "adminComment");
    z(this, "status");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "partner");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      id: this.id,
      amount: this.amount,
      partnerComment: this.partnerComment,
      adminComment: this.adminComment,
      status: this.status,
      partnerId: (e = this.partner) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Xl({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      partner: e.partner ? L1.fromJson(e.partner) : void 0
    });
  }
};
Jp([
  a
], Ap.prototype, "amount", 2);
Jp([
  a
], Ap.prototype, "partnerComment", 2);
Jp([
  a
], Ap.prototype, "adminComment", 2);
Jp([
  a
], Ap.prototype, "status", 2);
Jp([
  a
], Ap.prototype, "createdDate", 2);
Jp([
  a
], Ap.prototype, "updatedDate", 2);
Jp([
  a
], Ap.prototype, "partner", 2);
Jp([
  C
], Ap.prototype, "update", 1);
let RN = Ap;
class yN extends J0 {
  constructor(e) {
    super();
    z(this, "createdDateFrom");
    z(this, "createdDateTo");
    z(this, "partnerIds");
    z(this, "amountFrom");
    z(this, "amountTo");
    z(this, "feeFrom");
    z(this, "feeTo");
    /**
     * has admin => manual transaction
     */
    z(this, "hasAdminId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var gN = Object.defineProperty, LN = Object.getOwnPropertyDescriptor, k1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? LN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && gN(t, e, b), b;
};
const X1 = class Az extends n0 {
  constructor(e) {
    super();
    z(this, "title", "");
    z(this, "titleEmoji", "");
    z(this, "position");
    z(this, "type", "space");
    z(this, "parentId");
    z(this, "segment");
    z(this, "url");
    z(this, "parent");
    z(this, "showIfNoAccess", !1);
    z(this, "showPaymentLink", !1);
    z(this, "paymentUrl", "");
    z(this, "viewAccessType", "public");
    z(this, "viewAccessFilterJson");
    z(this, "likesAccessType", "public");
    z(this, "likesAccessFilterJson");
    z(this, "commentsAccessType", "public");
    z(this, "commentsAccessFilterJson");
    z(this, "publishAccessType", "public");
    z(this, "publishAccessFilterJson");
    /**
     * Restrictions for the current member
     */
    z(this, "restrictions", {
      commentsRestrictionEnabled: !1,
      likesRestrictionEnabled: !1,
      publishRestrictionEnabled: !1,
      viewRestrictionEnabled: !1
    });
    i0(this), e && this.update(e);
  }
  get isSection() {
    return this.type === "section";
  }
  get isSpace() {
    return this.type === "space";
  }
  toJson() {
    var e;
    return {
      ...this,
      viewAccessFilterJson: this.viewAccessFilterJson,
      likesAccessFilterJson: this.likesAccessFilterJson,
      commentsAccessFilterJson: this.commentsAccessFilterJson,
      publishAccessFilterJson: this.publishAccessFilterJson,
      parentId: (e = this.parent) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    return this.title !== e.title || this.titleEmoji !== e.titleEmoji || this.type !== e.type || this.position !== e.position || this.parentId !== e.parentId || this.segment !== e.segment || this.url !== e.url || this.showIfNoAccess !== e.showIfNoAccess || this.showPaymentLink !== e.showPaymentLink || this.paymentUrl !== e.paymentUrl;
  }
  clone() {
    return new Az({
      ...this
    });
  }
  static fromJson(e) {
    return new Az({
      ...e,
      viewAccessFilterJson: e.viewAccessExtendedFilterJson,
      likesAccessFilterJson: e.likesAccessExtendedFilterJson,
      commentsAccessFilterJson: e.commentsAccessExtendedFilterJson,
      publishAccessFilterJson: e.publishAccessExtendedFilterJson,
      parent: e.parent ? Az.fromJson(e.parent) : void 0,
      restrictions: e.currentMember ? e.currentMember : {
        commentsRestrictionEnabled: !1,
        likesRestrictionEnabled: !1,
        publishRestrictionEnabled: !1,
        viewRestrictionEnabled: !1
      }
    });
  }
};
k1([
  a
], X1.prototype, "title", 2);
k1([
  a
], X1.prototype, "titleEmoji", 2);
k1([
  a
], X1.prototype, "position", 2);
k1([
  a
], X1.prototype, "type", 2);
k1([
  a
], X1.prototype, "parentId", 2);
k1([
  a
], X1.prototype, "segment", 2);
k1([
  a
], X1.prototype, "url", 2);
k1([
  a
], X1.prototype, "parent", 2);
k1([
  a
], X1.prototype, "showIfNoAccess", 2);
k1([
  a
], X1.prototype, "showPaymentLink", 2);
k1([
  a
], X1.prototype, "paymentUrl", 2);
k1([
  a
], X1.prototype, "viewAccessType", 2);
k1([
  a
], X1.prototype, "viewAccessFilterJson", 2);
k1([
  a
], X1.prototype, "likesAccessType", 2);
k1([
  a
], X1.prototype, "likesAccessFilterJson", 2);
k1([
  a
], X1.prototype, "commentsAccessType", 2);
k1([
  a
], X1.prototype, "commentsAccessFilterJson", 2);
k1([
  a
], X1.prototype, "publishAccessType", 2);
k1([
  a
], X1.prototype, "publishAccessFilterJson", 2);
k1([
  $
], X1.prototype, "isSection", 1);
k1([
  $
], X1.prototype, "isSpace", 1);
k1([
  C
], X1.prototype, "update", 1);
let Cl = X1;
class vN extends J0 {
  constructor(e) {
    super();
    z(this, "communityId");
    z(this, "type");
    z(this, "parentId");
    z(this, "segment");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Il {
  generate(t = 10) {
    return [...Array(t)].map((e) => (~~(Math.random() * 36)).toString(36)).join("");
  }
  static generate(t = 10) {
    return [...Array(t)].map((e) => (~~(Math.random() * 36)).toString(36)).join("");
  }
}
var _N = Object.defineProperty, NN = Object.getOwnPropertyDescriptor, $p = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? NN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && _N(t, e, b), b;
};
const up = class Zi extends n0 {
  constructor(e) {
    super();
    z(this, "name", "");
    z(this, "file");
    z(this, "position");
    z(this, "url");
    i0(this), e && this.update(e);
  }
  get isExternalVideo() {
    return !y1(this.url);
  }
  get isMedia() {
    return this.isExternalVideo || this.file != null && (this.file.isVideo || this.file.isImage);
  }
  get externalVideoFile() {
    return this.isExternalVideo ? new at({
      key: Il.generate(5),
      name: this.name,
      url: this.url,
      type: Fl.Video,
      extension: ".mp4"
    }) : void 0;
  }
  toJson() {
    var e;
    return {
      id: this.id,
      name: this.name,
      position: this.position,
      url: this.url,
      fileId: (e = this.file) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var o, b;
    return this.name !== e.name || this.position !== e.position || ((o = this.file) == null ? void 0 : o.id) !== ((b = e.file) == null ? void 0 : b.id) || this.url !== e.url;
  }
  clone() {
    var e;
    return new Zi({
      ...this,
      file: (e = this.file) == null ? void 0 : e.clone()
    });
  }
  static fromJson(e) {
    return new Zi({
      ...e,
      file: e.file ? at.fromJson(e.file) : void 0
    });
  }
};
$p([
  a
], up.prototype, "name", 2);
$p([
  a
], up.prototype, "file", 2);
$p([
  a
], up.prototype, "position", 2);
$p([
  a
], up.prototype, "url", 2);
$p([
  $
], up.prototype, "isExternalVideo", 1);
$p([
  $
], up.prototype, "isMedia", 1);
$p([
  $
], up.prototype, "externalVideoFile", 1);
$p([
  C
], up.prototype, "update", 1);
let Pl = up;
var BN = Object.defineProperty, TN = Object.getOwnPropertyDescriptor, jb = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? TN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && BN(t, e, b), b;
};
const PM = class El extends n0 {
  constructor(e) {
    super();
    z(this, "name", "");
    z(this, "description", "");
    z(this, "emoji", "");
    z(this, "image", null);
    i0(this), e && this.update(e);
  }
  toJson() {
    var e, o;
    return {
      ...this,
      imageId: (e = this.image) == null ? void 0 : e.id,
      imageJson: (o = this.image) == null ? void 0 : o.toJson(),
      image: void 0
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var o, b;
    return this.name !== e.name || this.description !== e.description || this.emoji !== e.emoji || ((o = this.image) == null ? void 0 : o.id) !== ((b = e.image) == null ? void 0 : b.id);
  }
  static fromJson(e) {
    return new El({
      ...e,
      image: e.image ? at.fromJson(e.image) : void 0
    });
  }
};
jb([
  a
], PM.prototype, "name", 2);
jb([
  a
], PM.prototype, "description", 2);
jb([
  a
], PM.prototype, "emoji", 2);
jb([
  a
], PM.prototype, "image", 2);
jb([
  C
], PM.prototype, "update", 1);
let wN = PM;
class Pw extends J0 {
  constructor(e) {
    super();
    z(this, "communityId");
    z(this, "memberId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var SN = Object.defineProperty, DN = Object.getOwnPropertyDescriptor, Fa = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? DN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && SN(t, e, b), b;
};
const nr = class kl extends n0 {
  constructor(e) {
    super();
    z(this, "badge");
    z(this, "member");
    i0(this), e && this.update(e);
  }
  toJson(e) {
    var o, b;
    return {
      badgeId: (o = this.badge) == null ? void 0 : o.id,
      memberId: e ?? ((b = this.member) == null ? void 0 : b.id)
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new kl({
      ...e,
      badge: e.badge ? wN.fromJson(e.badge) : void 0,
      member: e.member ? ko.fromJson(e.member) : void 0
    });
  }
};
Fa([
  a
], nr.prototype, "badge", 2);
Fa([
  a
], nr.prototype, "member", 2);
Fa([
  C
], nr.prototype, "update", 1);
let XN = nr;
var CN = Object.defineProperty, IN = Object.getOwnPropertyDescriptor, Ke = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? IN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && CN(t, e, b), b;
};
const Pe = class ji extends n0 {
  constructor(e) {
    super();
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "lastActivityDate");
    z(this, "contact");
    z(this, "admin");
    z(this, "role");
    z(this, "viewRestrictionEnabled", !1);
    z(this, "likesRestrictionEnabled", !1);
    z(this, "commentsRestrictionEnabled", !1);
    z(this, "publishRestrictionEnabled", !1);
    z(this, "badges", []);
    i0(this), e && this.update(e);
  }
  get userId() {
    var e, o;
    return ((e = this.contact) == null ? void 0 : e.id) || ((o = this.admin) == null ? void 0 : o.id);
  }
  get fullName() {
    return this.contact ? this.contact.fullName : this.admin ? this.admin.fullName : "";
  }
  toJson() {
    var e, o;
    return {
      ...this,
      contactId: (e = this.contact) == null ? void 0 : e.id,
      contact: void 0,
      adminId: (o = this.admin) == null ? void 0 : o.id,
      admin: void 0,
      badges: this.badges.map((b) => b.toJson(this.id))
      // hack to pass member id to badge
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var o, b;
    return ((o = this.contact) == null ? void 0 : o.id) !== ((b = e.contact) == null ? void 0 : b.id);
  }
  clone() {
    var e, o;
    return new ji({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone(),
      admin: (o = this.admin) == null ? void 0 : o.clone()
    });
  }
  static fromJson(e) {
    return new ji({
      ...e,
      contact: e.contact ? L1.fromJson(e.contact) : void 0,
      admin: e.admin ? Xa.fromJson(e.admin) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? L(e.lastActivityDate) : void 0,
      badges: e.badges ? e.badges.map(XN.fromJson) : []
    });
  }
};
Ke([
  a
], Pe.prototype, "createdDate", 2);
Ke([
  a
], Pe.prototype, "updatedDate", 2);
Ke([
  a
], Pe.prototype, "lastActivityDate", 2);
Ke([
  a
], Pe.prototype, "contact", 2);
Ke([
  a
], Pe.prototype, "admin", 2);
Ke([
  a
], Pe.prototype, "role", 2);
Ke([
  a
], Pe.prototype, "viewRestrictionEnabled", 2);
Ke([
  a
], Pe.prototype, "likesRestrictionEnabled", 2);
Ke([
  a
], Pe.prototype, "commentsRestrictionEnabled", 2);
Ke([
  a
], Pe.prototype, "publishRestrictionEnabled", 2);
Ke([
  a
], Pe.prototype, "badges", 2);
Ke([
  $
], Pe.prototype, "userId", 1);
Ke([
  $
], Pe.prototype, "fullName", 1);
Ke([
  C
], Pe.prototype, "update", 1);
let ko = Pe;
class PN extends J0 {
  constructor(e) {
    super();
    z(this, "communityId");
    z(this, "contactId");
    z(this, "role");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var EN = Object.defineProperty, kN = Object.getOwnPropertyDescriptor, x1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? kN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && EN(t, e, b), b;
};
const C1 = class ea extends n0 {
  constructor(e) {
    super();
    z(this, "title", "");
    z(this, "body", "");
    z(this, "spaceId");
    z(this, "space");
    z(this, "number");
    z(this, "attachments", []);
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "status", "default");
    z(this, "author");
    z(this, "isLikedByCurrentUser", !1);
    z(this, "pinDate", null);
    z(this, "pinPosition", null);
    z(this, "reports", []);
    z(this, "likesCount", 0);
    z(this, "commentsCount", 0);
    z(this, "viewsCount", 0);
    z(this, "reportsCount", 0);
    i0(this), e && this.update(e);
  }
  get coverAttachment() {
    return this.mediaAttachments.length === 0 ? null : this.mediaAttachments[0];
  }
  get mediaAttachments() {
    return this.attachments.filter((e) => e.isMedia);
  }
  get fileAttachments() {
    return this.attachments.filter((e) => !e.isMedia);
  }
  toJson() {
    var e;
    return {
      ...this,
      attachments: this.attachments.map((o) => o.toJson()),
      spaceId: (e = this.space) == null ? void 0 : e.id,
      space: void 0,
      status: this.status
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    return this.title !== e.title || this.body !== e.body || this.spaceId !== e.spaceId || !this.attachments.isEquals(e.attachments, (o, b) => !o.hasChanges(b));
  }
  clone() {
    var e, o;
    return new ea({
      ...this,
      attachments: this.attachments.map((b) => b.clone()),
      author: (e = this.author) == null ? void 0 : e.clone(),
      space: (o = this.space) == null ? void 0 : o.clone()
    });
  }
  static fromJson(e) {
    var o;
    return new ea({
      ...e,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      attachments: ((o = e.attachments) == null ? void 0 : o.map(Pl.fromJson)) || [],
      author: e.author ? ko.fromJson(e.author) : void 0,
      space: e.space ? Cl.fromJson(e.space) : void 0,
      pinDate: e.pinDate ? L(e.pinDate) : null
    });
  }
};
x1([
  a
], C1.prototype, "title", 2);
x1([
  a
], C1.prototype, "body", 2);
x1([
  a
], C1.prototype, "spaceId", 2);
x1([
  a
], C1.prototype, "space", 2);
x1([
  a
], C1.prototype, "number", 2);
x1([
  a
], C1.prototype, "attachments", 2);
x1([
  $
], C1.prototype, "coverAttachment", 1);
x1([
  $
], C1.prototype, "mediaAttachments", 1);
x1([
  $
], C1.prototype, "fileAttachments", 1);
x1([
  a
], C1.prototype, "createdDate", 2);
x1([
  a
], C1.prototype, "updatedDate", 2);
x1([
  a
], C1.prototype, "status", 2);
x1([
  a
], C1.prototype, "author", 2);
x1([
  a
], C1.prototype, "isLikedByCurrentUser", 2);
x1([
  a
], C1.prototype, "pinDate", 2);
x1([
  a
], C1.prototype, "pinPosition", 2);
x1([
  a
], C1.prototype, "reports", 2);
x1([
  a
], C1.prototype, "likesCount", 2);
x1([
  a
], C1.prototype, "commentsCount", 2);
x1([
  a
], C1.prototype, "viewsCount", 2);
x1([
  a
], C1.prototype, "reportsCount", 2);
x1([
  C
], C1.prototype, "update", 1);
let zr = C1;
class xN extends J0 {
  constructor(e) {
    super();
    z(this, "communityId");
    z(this, "spaceId");
    z(this, "spaceIds");
    z(this, "statuses");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var FN = Object.defineProperty, UN = Object.getOwnPropertyDescriptor, ne = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? UN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && FN(t, e, b), b;
};
const ee = class uz extends n0 {
  constructor(e) {
    super();
    z(this, "text", "");
    z(this, "status", "default");
    z(this, "postId");
    z(this, "post");
    z(this, "author");
    z(this, "files", []);
    z(this, "likesCount", 0);
    z(this, "replyId");
    z(this, "reply");
    z(this, "parent");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "isLikedByCurrentUser", !1);
    z(this, "childrenCollapsed", !0);
    z(this, "childrenCount", 0);
    z(this, "children", []);
    z(this, "reports", []);
    z(this, "reportsCount", 0);
    i0(this), e && this.update(e);
  }
  toJson() {
    var e, o, b, r;
    return {
      id: this.id,
      text: this.text,
      status: this.status,
      postId: (e = this.post) == null ? void 0 : e.id,
      authorId: (o = this.author) == null ? void 0 : o.id,
      fileIds: this.files.map((i) => i.id),
      replyId: (b = this.reply) == null ? void 0 : b.id,
      parentId: (r = this.parent) == null ? void 0 : r.id,
      reportsCount: this.reportsCount
    };
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  hasChanges(e) {
    var o, b, r, i, s, d, q, f, h, g;
    return this.text !== e.text || ((o = this.post) == null ? void 0 : o.id) !== ((b = e.post) == null ? void 0 : b.id) || ((r = this.author) == null ? void 0 : r.id) !== ((i = e.author) == null ? void 0 : i.id) || ((s = this.reply) == null ? void 0 : s.id) !== ((d = e.reply) == null ? void 0 : d.id) || !this.files.isEquals(e.files, (y, w) => y.id === w.id) || ((q = this.reply) == null ? void 0 : q.id) !== ((f = e.reply) == null ? void 0 : f.id) || ((h = this.parent) == null ? void 0 : h.id) !== ((g = e.parent) == null ? void 0 : g.id);
  }
  static fromJson(e) {
    return new uz({
      ...e,
      post: e.post ? zr.fromJson(e.post) : void 0,
      author: e.author ? ko.fromJson(e.author) : void 0,
      files: e.files ? e.files.map(at.fromJson) : [],
      reply: e.reply ? uz.fromJson(e.reply) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      parent: e.parent ? uz.fromJson(e.parent) : void 0
    });
  }
};
ne([
  a
], ee.prototype, "text", 2);
ne([
  a
], ee.prototype, "status", 2);
ne([
  a
], ee.prototype, "postId", 2);
ne([
  a
], ee.prototype, "post", 2);
ne([
  a
], ee.prototype, "author", 2);
ne([
  a
], ee.prototype, "files", 2);
ne([
  a
], ee.prototype, "likesCount", 2);
ne([
  a
], ee.prototype, "replyId", 2);
ne([
  a
], ee.prototype, "reply", 2);
ne([
  a
], ee.prototype, "parent", 2);
ne([
  a
], ee.prototype, "createdDate", 2);
ne([
  a
], ee.prototype, "updatedDate", 2);
ne([
  a
], ee.prototype, "isLikedByCurrentUser", 2);
ne([
  a
], ee.prototype, "childrenCollapsed", 2);
ne([
  a
], ee.prototype, "childrenCount", 2);
ne([
  a
], ee.prototype, "children", 2);
ne([
  a
], ee.prototype, "reports", 2);
ne([
  a
], ee.prototype, "reportsCount", 2);
ne([
  C
], ee.prototype, "update", 1);
let Ua = ee;
class nA extends J0 {
  constructor(e) {
    super();
    z(this, "postId");
    z(this, "communityId");
    z(this, "authorId");
    z(this, "replyId");
    z(this, "parentId");
    z(this, "hasParentId");
    z(this, "statuses");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var HN = Object.defineProperty, JN = Object.getOwnPropertyDescriptor, lt = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? JN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && HN(t, e, b), b;
};
const Y2 = class xl extends n0 {
  constructor(e) {
    super();
    z(this, "text", "");
    z(this, "type", "custom");
    z(this, "postId");
    z(this, "post");
    z(this, "commentId");
    z(this, "comment");
    z(this, "memberId");
    z(this, "member");
    z(this, "createdDate");
    z(this, "updatedDate");
    i0(this), e && this.update(e);
  }
  toJson() {
    var e, o, b;
    return {
      ...this,
      postId: (e = this.post) == null ? void 0 : e.id,
      commentId: (o = this.comment) == null ? void 0 : o.id,
      memberId: (b = this.member) == null ? void 0 : b.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new xl({
      ...e,
      post: e.post ? zr.fromJson(e.post) : void 0,
      comment: e.comment ? Ua.fromJson(e.comment) : void 0,
      member: e.member ? ko.fromJson(e.member) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0
    });
  }
};
lt([
  a
], Y2.prototype, "text", 2);
lt([
  a
], Y2.prototype, "type", 2);
lt([
  a
], Y2.prototype, "postId", 2);
lt([
  a
], Y2.prototype, "post", 2);
lt([
  a
], Y2.prototype, "commentId", 2);
lt([
  a
], Y2.prototype, "comment", 2);
lt([
  a
], Y2.prototype, "memberId", 2);
lt([
  a
], Y2.prototype, "member", 2);
lt([
  a
], Y2.prototype, "createdDate", 2);
lt([
  a
], Y2.prototype, "updatedDate", 2);
lt([
  C
], Y2.prototype, "update", 1);
let $N = Y2;
class VN extends J0 {
  constructor(e) {
    super();
    z(this, "postId");
    z(this, "commentId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var yt = /* @__PURE__ */ ((p) => (p[p.Kilobytes = 1024] = "Kilobytes", p[p.Megabytes = 1048576] = "Megabytes", p[p.Gigabytes = 1073741824] = "Gigabytes", p))(yt || {}), OM = /* @__PURE__ */ ((p) => (p[p.Bytes = 0] = "Bytes", p[p.Kilobytes = 1] = "Kilobytes", p[p.Megabytes = 2] = "Megabytes", p[p.Gigabytes = 3] = "Gigabytes", p))(OM || {});
class YN {
  static toBytes(t, e = 0) {
    switch (e) {
      case 3:
        return t * yt.Gigabytes;
      case 2:
        return t * yt.Megabytes;
      case 1:
        return t * yt.Kilobytes;
      case 0:
        return t;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
  static fromBytes(t, e) {
    switch (e) {
      case 3:
        return t / yt.Gigabytes;
      case 2:
        return t / yt.Megabytes;
      case 1:
        return t / yt.Kilobytes;
      case 0:
        return t;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
}
class Rt {
  constructor(t, e = OM.Bytes) {
    z(this, "bytes");
    z(this, "kilobytes");
    z(this, "megabytes");
    z(this, "gigabytes");
    const o = YN.toBytes(t, e);
    this.bytes = o, this.kilobytes = o / yt.Kilobytes, this.megabytes = o / yt.Megabytes, this.gigabytes = o / yt.Gigabytes;
  }
  add(t) {
    return Rt.fromBytes(this.bytes + t.bytes);
  }
  substract(t) {
    return Rt.fromBytes(this.bytes - t.bytes);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.bytes == 0;
  }
  static from(t, e) {
    return new Rt(t, e);
  }
  static fromBytes(t) {
    return new Rt(t, OM.Bytes);
  }
  static fromKilobytes(t) {
    return new Rt(t, OM.Kilobytes);
  }
  static fromMegabytes(t) {
    return new Rt(t, OM.Megabytes);
  }
  static fromGigabytes(t) {
    return new Rt(t, OM.Gigabytes);
  }
  static get zero() {
    return new Rt(0);
  }
}
var GN = Object.defineProperty, KN = Object.getOwnPropertyDescriptor, q2 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? KN(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && GN(t, e, b), b;
}, Fl = /* @__PURE__ */ ((p) => (p.Other = "other", p.Image = "image", p.Video = "video", p.Audio = "audio", p.Doc = "doc", p.Pdf = "pdf", p.Zip = "zip", p.Ppt = "ppt", p.Xls = "xls", p.Json = "json", p.Csv = "csv", p))(Fl || {}), QN = /* @__PURE__ */ ((p) => (p.Amazon = "amazon", p))(QN || {});
const Qe = class Wb extends n0 {
  constructor(e) {
    super();
    z(this, "name");
    z(this, "description");
    z(this, "cloudKey");
    z(this, "size");
    z(this, "mimetype");
    z(this, "type");
    z(this, "source");
    z(this, "additionalData");
    z(this, "extension");
    z(this, "createdDate");
    z(this, "videoThumbnailUrl");
    z(this, "originalName");
    z(this, "isPublic");
    z(this, "isVoice");
    z(this, "key");
    z(this, "nativeFile");
    z(this, "previewImage");
    z(this, "previewAudio");
    z(this, "url");
    i0(this), e && this.update(e);
  }
  get audioMeta() {
    return this.additionalData;
  }
  set audioMeta(e) {
    this.additionalData = e;
  }
  /**
   * remove 'size' and rename
   */
  get fileSize() {
    return Rt.fromBytes(this.size);
  }
  get fileSizeString() {
    return Bv.fileSize(this.size);
  }
  get isUploaded() {
    return !y1(this.cloudKey);
  }
  get isExternalFile() {
    return !y1(this.url);
  }
  get isVideo() {
    return [".mp4", ".mov", ".avi", ".wmv", ".flv", ".mkv"].includes(this.extension);
  }
  get isImage() {
    return [".bmp", ".dib", ".rle", ".jpg", ".jpeg", ".jpe", ".jfif", ".gif", ".tif", ".tiff", ".png", ".svg", ".pjpeg", ".webp", ".ico"].includes(this.extension);
  }
  get isAudio() {
    return [".mp3", ".ogg", ".webm", ".m4a"].includes(this.extension);
  }
  get filename() {
    return this.name + this.extension;
  }
  replaceFile(e) {
    this.update({
      ...Wb.fromFile(e),
      id: this.id,
      name: this.name,
      description: this.description,
      createdDate: this.createdDate,
      isPublic: this.isPublic
    }, !0);
  }
  update(e, o = !1) {
    super.update(e, o);
  }
  toJson() {
    return {
      ...this,
      additionalData: JSON.stringify(this.additionalData),
      nativeFile: void 0
    };
  }
  clone() {
    return new Wb({
      ...this
    });
  }
  static fromJson(e) {
    return new Wb({
      ...e,
      key: e.id,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      convertData: e.convertDataJson ? JSON.parse(e.convertDataJson) : void 0,
      additionalData: e.additionalData ? JSON.parse(e.additionalData) : void 0
    });
  }
  static fromFile(e, o) {
    const b = e.name.lastIndexOf("."), r = new Wb({
      key: Il.generate(10),
      source: "amazon",
      nativeFile: e,
      size: e.size,
      mimetype: e.type,
      name: e.name.substring(0, b),
      extension: e.name.substring(b),
      createdDate: L(),
      ...o
    });
    return r.isImage && r.nativeFile && (r.previewImage = URL.createObjectURL(r.nativeFile)), r.isAudio && r.nativeFile && r.nativeFile.type.includes("audio") && (r.previewAudio = URL.createObjectURL(r.nativeFile)), r;
  }
};
q2([
  a
], Qe.prototype, "name", 2);
q2([
  a
], Qe.prototype, "description", 2);
q2([
  a
], Qe.prototype, "cloudKey", 2);
q2([
  a
], Qe.prototype, "isPublic", 2);
q2([
  a
], Qe.prototype, "isVoice", 2);
q2([
  $
], Qe.prototype, "audioMeta", 1);
q2([
  a
], Qe.prototype, "key", 2);
q2([
  a
], Qe.prototype, "nativeFile", 2);
q2([
  a
], Qe.prototype, "previewImage", 2);
q2([
  a
], Qe.prototype, "previewAudio", 2);
q2([
  $
], Qe.prototype, "isUploaded", 1);
q2([
  a
], Qe.prototype, "url", 2);
q2([
  C
], Qe.prototype, "update", 1);
let at = Qe;
class L1 extends n0 {
  constructor(e) {
    super();
    z(this, "avatar");
    z(this, "email");
    z(this, "firstName");
    z(this, "middleName");
    z(this, "lastName");
    z(this, "gender");
    z(this, "phone");
    z(this, "isSchoolEmailConfirmed");
    z(this, "birthday");
    z(this, "bonusBalance");
    z(this, "session");
    z(this, "emailConfirmationSentDate");
    z(this, "needChangePassword");
    z(this, "communityMember");
    e && this.update(e);
  }
  get isFirstNameEmpty() {
    return y1(this.firstName);
  }
  get isLastNameEmpty() {
    return y1(this.lastName);
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  get fullNameNoEmail() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? "" : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  toJson() {
    var e, o;
    return {
      ...this,
      birthday: (e = this.birthday) == null ? void 0 : e.toISOString(),
      avatarId: (o = this.avatar) == null ? void 0 : o.id,
      avatar: void 0
    };
  }
  static fromJson(e) {
    return new L1({
      ...e,
      avatar: e.avatar ? at.fromJson(e.avatar) : void 0,
      bonusBalance: e.bonusBalance ?? 0,
      session: e.session ? Sa.fromJson(e.session) : void 0,
      birthday: e.birthday ? L(e.birthday) : void 0,
      emailConfirmationSentDate: e.emailConfirmationSentDate ? new Date(e.emailConfirmationSentDate) : null,
      communityMember: e.communityMember ? ko.fromJson(e.communityMember) : null
    });
  }
}
class ZN {
  constructor(t) {
    z(this, "login", (t) => this.api.post("/authorization/login", t));
    z(this, "logout", (t) => this.api.put("/authorization/logout", { token: t }));
    z(this, "refreshToken", (t) => this.api.put("/authorization/refresh", { token: t }));
    z(this, "register", (t) => this.api.post("/authorization/register", t));
    // registerContact = (body: RegisterContactRequestBody) => this.api.post('/authorization/register-contact', body);
    z(this, "resetPassword", (t) => this.api.put("/authorization/reset-password", t));
    z(this, "confirmEmail", (t) => this.api.put("/authorization/confirm-email", t));
    z(this, "checkInvite", (t) => this.api.get(`/authorization/check-invite/${t}`));
    z(this, "confirmInvite", (t) => this.api.put("/authorization/confirm-invite", t));
    z(this, "sendInvite", (t) => this.api.post("/authorization/send-invite", { email: t }));
    z(this, "forgotPassword", (t) => this.api.put("/authorization/forgot-password", { email: t }));
    z(this, "loginToken", (t) => this.api.post("/authorization/login-token", { token: t }));
    z(this, "loginAs", (t) => this.api.post("/authorization/login-as", t));
    z(this, "prolongSession", (t) => this.api.put("/authorization/prolong-session", { token: t }));
    z(this, "fetchContact", (t) => this.api.get(`/authorization/contact/${t}`));
    z(this, "fetchMe", () => this.api.get("/authorization/me", void 0, L1.fromJson));
    z(this, "fetchEmailNotificationsSubscriptionStatus", (t) => this.api.execute({ method: "GET", url: "/authorization/email-notifications-subscription-status", body: t }, (e) => ({ subscribed: e.subscribed })));
    z(this, "fetchStudentEmailStatus", ({ studentId: t, messageId: e }) => this.api.get(`/student/email-broadcast-subscription-status/${t}/${e}`));
    z(this, "unsubscribeStudentEmailStatus", (t) => this.api.put("/student/unsubscribe-email-broadcast", t));
    z(this, "unsubscribeEmailNotifications", (t) => this.api.put("/authorization/unsubscribe-email-notifications", t));
    z(this, "getQr", () => this.api.get("/authorization/qr"));
    z(this, "loginQr", (t) => this.api.execute({ method: "GET", url: "/authorization/qr/login", body: { token: t, responseType: "json" } }));
    this.api = t;
  }
}
class jN {
  constructor(t) {
    z(this, "fetch", () => this.api.get("/announcement", "", (t) => t.map(Da.fromJson)));
    z(this, "close", (t) => this.api.post("/announcement/close", { id: t }));
    this.api = t;
  }
}
class e7 {
  constructor(t) {
    z(this, "fetch", (t) => this.api.execute({
      method: "GET",
      url: "/school-content-item",
      body: t,
      fields: t.fields
    }, (e) => ({
      items: e.items.map(Rb.fromJson),
      filter: new E_(e.filter)
    })));
    this.api = t;
  }
}
class t7 {
  constructor(t) {
    z(this, "fetch", (t) => this.api.execute({ method: "GET", url: "/school-setting" }, Sb.fromJson));
    this.api = t;
  }
}
const p7 = `{
            id,
            beginDate,
            endDate,
            state,
            flowBeginDate,
            accessBeginDate,
            accessEndDate,
            isSubscription,
            course{
                id,
                name,
                dontAskFeedback
            },
            currentCourseItem{
                id
            },        
            feedback,
            progress,
            student{
                id
            }
        }`, o7 = `{
        id,
        parentItemId,
        title,
        type,
        position,
        availability,
        disableTimeLimits,
        regularTimeDelayActive,
        regularTimeDelay,
        regularTimeDelayCondition,
        regularTimeDelayMeasureType,
        regularWaitUntilTimeActive,
        regularWaitUntilTime,
        regularWaitUntilTimeDaysOfWeekActive,
        regularWaitUntilDaysOfWeek,
        flowTimeDelayActive,
        flowTimeDelay,
        flowTimeDelayCondition,
        flowTimeDelayMeasureType,
        flowWaitUntilTimeActive,
        flowWaitUntilTime,
        flowWaitUntilTimeDaysOfWeekActive,
        flowWaitUntilDaysOfWeek,
        dateDelayActive,
        dateDelay,
        preventCopingAndSelectingText,
        blockCourseUntilTasksApproved,
        isOptional,
        allowComments,
        showComments,
        ratingEnabled,
        ratingRequired,
        ratingCommentRequired,
        theoryVisible,
        testsVisible,
        tasksVisible,
        requiredPlans,
        progress{
            id,
            beginDate,
            completeDate,
            precompleteDate,
            status,
            theoryStatus,
            testStatus,
            taskStatus,
            numberUncheckedTasks,
            numberCorrectTasks,
            numberIncorrectTasks,
        },
        tasks{
            id,
        }
    }`, M7 = `{
    id,
    title,
    type,
    designHTMLPublished,
    designStylePublished,
    ratingEnabled,
    progress{
        id,
        beginDate,
        rating {
            id,
            comment,
            rating,
            createdDate,
            updatedDate,
            files(filter:"{take:0}") {
                id,
                name,
                cloudKey,
                extension,
                size,
                type
            }
        }
    }
}`, b7 = `{
    id,
    title,
    type,
    flowTimeDelayActive,
    flowTimeDelay,
    flowTimeDelayCondition,
    flowTimeDelayMeasureType,
    preventCopingAndSelectingText,
    allowComments,
    showComments,
    ratingEnabled,
    ratingCommentRequired,
    studentHasAccess,
    position,
    parentItem {
        id,
    }
    progress {
        id
    }
}`;
class n7 extends J0 {
  constructor(e) {
    super();
    z(this, "libraryId");
    /**
     * Item we'd like to select
     * In addition to root branch, request the item section branch
     */
    z(this, "libraryItemId");
    /**
     * Request only the section items
     */
    z(this, "sectionId");
    this.sortName = "position", this.sortType = "Asc", e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class z7 {
  constructor(t) {
    z(this, "contentItemComment", {
      create: (t) => this.api.post("/school-content-item-comment", t, (e) => ({ id: e })),
      save: (t) => this.api.put("/school-content-item-comment", t),
      fetch: (t, e) => this.api.execute({ method: "GET", url: `/school-content-item-comment/${t}`, body: e }, (o) => ({
        filter: new jv(o.filter),
        items: o.items.map(Cp.fromJson)
      })),
      remove: (t) => this.api.delete(`/school-content-item-comment/${t}`)
    });
    z(this, "contentItemRating", {
      create: (t) => this.api.post("/school-content-item-rating", t, (e) => ({
        id: e.ratingId,
        progress: $e.fromJson(e.progress)
      })),
      save: (t) => {
        var e;
        return this.api.put("/school-content-item-rating", {
          ...t,
          fileIds: ((e = t.files) == null ? void 0 : e.map((o) => o.id)) ?? []
        });
      }
    });
    z(this, "studentCourse", {
      fetchItem: (t) => this.api.get(`/student-course/${t}`, p7, (e) => ({
        studentCourse: or.fromJson(e.studentCourse),
        hasItemAccess: e.hasItemAccess
      })),
      startCourse: (t) => this.api.post("/student-course", { courseId: t }, (e) => ({
        studentCourseId: e.studentCourseId,
        currentCourseItemId: e.currentCourseItemId
      })),
      completeTheory: (t) => this.api.put("/student-course-item/complete-theory", { studentCourseItemProgressId: t }, (e) => ({
        progress: $e.fromJson(e)
      })),
      completeTest: (t, e, o) => this.api.post("/student-course-item/complete-test", { studentCourseItemProgressId: t, courseItemTestId: e, isRight: o }, (b) => $e.fromJson(b)),
      sendFeedback: (t, e) => this.api.post("/student-course/send-feedback", { studentCourseId: t, text: e }),
      item: {
        fetch: (t) => this.api.execute({ method: "GET", url: "/student-course-item", body: t, fields: o7 }, (e) => e.items.map(Lo.fromJson)),
        fetchItem: (t, e) => this.api.get(`/student-course-item/${t}/${e}`, "", Lo.fromJson),
        resetTaskAnswerStatus: (t) => this.api.put("/student-course-item/task-answer/reset-status", { answerId: t }, (e) => ({
          progress: $e.fromJson(e)
        })),
        saveTaskAnswer: (t) => this.api.put("/student-course-item/task-answer", t, (e) => ({
          status: e.answerStatus,
          progress: $e.fromJson(e.progress)
        })),
        createTaskAnswer: (t) => this.api.post("/student-course-item/task-answer", t, (e) => ({
          id: e.answerId,
          status: e.answerStatus,
          progress: $e.fromJson(e.progress)
        })),
        fetchTaskAnswerComments: (t) => this.api.execute({ method: "GET", url: "/student-course-item/task-answer/comment", body: t }, (e) => ({
          filter: new XM(e.filter),
          items: e.items.map(Ca.fromJson)
        })),
        createTaskAnswerComment: (t) => this.api.post("/student-course-item/task-answer/comment", t, (e) => ({
          id: e
        })),
        saveTaskAnswerComment: (t) => this.api.put("/student-course-item/task-answer/comment", t),
        deleteTaskAnswerComment: (t) => this.api.delete(`/student-course-item/task-answer/comment/${t}`)
      }
    });
    z(this, "studentLibrary", {
      fetchLibrary: (t) => this.api.get(`/school-library/${t}`, "{ id, title, flowBeginDate }", (e) => ({
        library: Co.fromJson(e)
      })),
      fetchLibraryItem: (t, e) => this.api.get(`/school-library-item/${t}/${e}`, M7, (o) => ({
        item: Db.fromJson(o)
      })),
      fetchLibraryItems: (t) => this.api.execute({ method: "GET", url: "/school-library-item", fields: b7, body: new n7({ libraryId: t, useBaseFilter: !1 }) }, (e) => ({
        items: e.items.map(Db.fromJson)
      }))
    });
    z(this, "service", {
      trackForm: (t) => this.api.post("/t/f", t),
      contactInFilter: (t, e) => this.api.execute({
        method: "GET",
        url: "/service/contact-in-filter",
        body: {
          f: t,
          c: e
        }
      }, (o) => ({ isInFilter: o.isInFilter })),
      runCustomEvent: (t) => this.api.post("/service/run-custom-event", t)
    });
    this.api = t;
  }
}
class Ee {
  constructor(t, e) {
    this.baseApi = t, this.settings = e;
  }
  create(t, e) {
    return this.baseApi.post(
      this.settings.endpoint,
      this.settings.serialize ? this.settings.serialize(t) : t.toJson(),
      e
    );
  }
  fetch(t, e) {
    return this.baseApi.getList(
      this.settings.endpoint,
      t ?? this.settings.defaultFields,
      e,
      (o) => ({
        filter: new J0(o.filter),
        items: o.items.map((b) => this.settings.parse(b))
      })
    );
  }
  fetchItem(t, e) {
    return this.baseApi.get(
      `${this.settings.endpoint}/${t}`,
      e ?? this.settings.defaultFields,
      this.settings.parse
    );
  }
  save(t) {
    return this.baseApi.put(
      this.settings.endpoint,
      this.settings.serialize ? this.settings.serialize(t) : { ...gv(t), id: t.id }
    );
  }
  delete(t, e) {
    return this.baseApi.delete(`${this.settings.endpoint}/${t}`, e);
  }
}
class r7 {
  constructor(t) {
    z(this, "member");
    z(this, "transaction");
    z(this, "transactionRequest");
    z(this, "offer");
    z(this, "order");
    z(this, "utmTagApi");
    z(this, "fetchTotals", (t) => this.api.post("/partnership/totals", { filter: t }, (e) => ({ items: e.items })));
    z(this, "fetchMaxAmount", () => this.api.get("/partnership/max-amount"));
    this.api = t, this.member = new i7(this.api), this.transaction = new c7(this.api), this.transactionRequest = new s7(this.api), this.offer = new a7(this.api), this.order = new O7(this.api), this.utmTagApi = new A7(this.api);
  }
}
class Ew extends J0 {
  constructor(e) {
    super();
    z(this, "dateFrom", null);
    z(this, "dateTo", null);
    z(this, "utmSources", []);
    z(this, "utmMediums", []);
    z(this, "utmCampaigns", []);
    z(this, "utmTerms", []);
    z(this, "utmContents", []);
    e && this.update(e);
  }
  get hasChanges() {
    return this.dateFrom !== null || this.dateTo !== null || this.utmSources.length > 0 || this.utmMediums.length > 0 || this.utmCampaigns.length > 0 || this.utmTerms.length > 0 || this.utmContents.length > 0;
  }
}
class c7 extends Ee {
  constructor(e) {
    super(e, {
      endpoint: "/partnership/transaction",
      parse: (o) => Nl.fromJson(o),
      defaultFields: `{
                id,
                createdDate,
                amount,
                fee,
                comment,
                partner{
                    id,
                    firstName,
                    lastName,
                    email
                },
                student{
                    id,
                    firstName,
                    lastName,
                    email
                },
                type,
                order{
                    id,
                    number
                },
                validAfterDate,
                level,
                levelPartner{
                    id,
                    firstName,
                    lastName,
                    email
                }
            }`
    });
    z(this, "fetchTotals", (e) => this.api.post(this.settings.endpoint + "/totals", { filter: e }, (o) => ({ items: o.items })));
    this.api = e;
  }
}
let i7 = class extends Ee {
  constructor(e) {
    super(e, {
      endpoint: "/partnership/member",
      parse: (o) => Dl.fromJson(o),
      defaultFields: `{
                id,
                acceptedDate
            }`
    });
    z(this, "accept", () => this.api.put(this.settings.endpoint, { accepted: !0 }));
    this.api = e;
  }
};
class a7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/offer",
      parse: (e) => dN.fromJson(e),
      defaultFields: `{
                id,
                title,
                url,
                urlsJson,
                description,
                fee,
                feeType,
                productType,
                levels,
                productLinks{
                    product{
                        id,
                        name
                    }
                }
            }`
    }), this.api = t;
  }
}
class O7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/order",
      parse: (e) => CM.fromJson(e)
    }), this.api = t;
  }
}
class s7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/transaction/request",
      parse: (e) => RN.fromJson(e),
      defaultFields: `{
                id,
                amount,
                partnerComment,
                adminComment,
                status,
                createdDate
            }`
    }), this.api = t;
  }
}
class A7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/utm",
      parse: (e) => e
    });
  }
}
class u7 {
  constructor(t) {
    z(this, "spaceItem");
    z(this, "post");
    z(this, "postComment");
    z(this, "member");
    z(this, "report");
    /**
     * Join community - creates member if not exists => reset tokens => update current user
     */
    z(this, "join", () => this.api.post("/community/join", {}, (t) => ko.fromJson(t)));
    this.api = t, this.spaceItem = new d7(this.api), this.post = new l7(this.api), this.postComment = new q7(this.api), this.member = new f7(this.api), this.report = new W7(this.api);
  }
  /**
   * Get current member or null if not joined
   */
  // getCurrentMember = () => this.api.get<CommunityMember | null>('/community/member/current', '', json => json ? CommunityMember.fromJson(json) : null);
}
class d7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/community/space",
      parse: (e) => Cl.fromJson(e),
      defaultFields: `{
                id,
                title,
                titleEmoji,
                position,
                type,
                parentId,
                segment,
                viewAccessType,
                likesAccessType,
                commentsAccessType,
                publishAccessType,
                viewAccessExtendedFilterJson,
                likesAccessExtendedFilterJson,
                commentsAccessExtendedFilterJson,
                publishAccessExtendedFilterJson,
                children {
                    id
                },
                parent {
                    id,
                    position
                }
            }`
    }), this.api = t;
  }
}
class l7 extends Ee {
  constructor(e) {
    super(e, {
      endpoint: "/community/post",
      parse: (o) => zr.fromJson(o),
      defaultFields: `{
                id,
                title,
                body,
                spaceId,
                number,
                createdDate,
                updatedDate,
                likesCount,
                commentsCount,
                viewsCount,
                status,
                isLikedByCurrentUser,
                space {
                    id,
                    title,
                    titleEmoji,
                    type
                },
                author {
                    id,
                    contact{
                        id,
                        firstName,
                        lastName,
                        email,
                        avatar {
                            id,
                            cloudKey,
                            size
                        }
                    },
                    badges {
                        badge {
                            id,
                            name,
                            description,
                            emoji,
                            image {
                                id,
                                cloudKey,
                                size
                            }
                        }
                    }
                },
                attachments(filter:"{sortName:'Position', sortType:'Asc', useBaseFilter: false}") {
                    id,
                    name,
                    position,
                    url,
                    file {
                        id,
                        cloudKey,
                        size,
                        type,
                        name,
                        extension
                    }
                },
                reports {
                    _count
                }
            }`
    });
    z(this, "like", (e) => this.api.post("/community/reaction", {
      postId: e,
      type: "like"
    }));
    z(this, "unlike", (e) => this.api.post("/community/reaction", {
      postId: e,
      type: "unlike"
    }));
    z(this, "fetchByNumber", (e) => this.api.get(`${this.settings.endpoint}/${e}`, this.settings.defaultFields, this.settings.parse));
    this.api = e;
  }
}
class q7 extends Ee {
  constructor(e) {
    super(e, {
      endpoint: "/community/post/comment",
      parse: (o) => Ua.fromJson(o)
    });
    z(this, "like", (e) => this.api.post("/community/reaction", {
      commentId: e,
      type: "like"
    }));
    z(this, "unlike", (e) => this.api.post("/community/reaction", {
      commentId: e,
      type: "unlike"
    }));
    this.api = e;
  }
}
class f7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/community/member",
      parse: (o) => ko.fromJson(o),
      defaultFields: `{
                id,
                createdDate,
                updatedDate,
                lastActivityDate,
                role,
                viewRestrictionEnabled,
                likesRestrictionEnabled,
                commentsRestrictionEnabled,
                publishRestrictionEnabled,
                contact {
                    id,
                    firstName,
                    lastName,
                    email,
                    phone,
                    avatar {
                        id,
                        cloudKey,
                        size
                    }
                },
                badges {
                    badge {
                        
            id,
            name,
            description,
            emoji,
            image {
                id,
                cloudKey,
                size
            }
        
                    },
                    member {
                        id
                    }
                }
            }`
    }), this.api = t;
  }
}
class W7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/community/report",
      parse: (e) => $N.fromJson(e),
      defaultFields: `{
                id,
                createdDate,
                updatedDate,
                text,
                type,
                post {
                    id,
                    title
                },
                comment {
                    id,
                    text
                },
                member {
                    id,
                    contact {
                        id,
                        firstName,
                        lastName,
                        email,
                        avatar {
                            id,
                            cloudKey,
                            size
                        }
                    }
                }
            }`
    }), this.api = t;
  }
}
const h7 = `{
    canModerate,
    thread{
        id,
        title,
        description,
        designHTMLPublished,
        designStylePublished,
        canStudentCreateTopics,
        createdDate,
        updatedDate,
        lastActivityDate,
        topicCount,
        commentCount
    },
    threads{
        id,
        title,
        description,
        createdDate,
        updatedDate,
        lastActivityDate,
        topicCount,
        commentCount
    },
    topics{
        id,
        title,
        text,
        createdDate,
        updatedDate,
        lastActivityDate,
        commentCount,
        lastComment{
            id,
            createdDate,
            student{
                id,
                firstName,
                lastName
            }
        },
        student{
            id,
            firstName,
            lastName,
            email
        }
    },
    breadcrumbs(filter:"{useSort:false}"){
        id, 
        title
    },
    banStatus{
        type,
        untilDate
    }
}`, m7 = `{
    canModerate,
    topic{
        id,
        title,
        text,
        createdDate,
        updatedDate,
        lastActivityDate,
        commentCount,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        },
        files{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        },
        likeCount,
        dislikeCount,
        currentUserReaction{
            id,
            type
        }
    },
    breadcrumbs(filter:"{useSort:false}"){
        id, 
        title
    },
    banStatus{
        type,
        untilDate
    }
}`, R7 = `{
    id,
    text,
    createdDate,
    updatedDate,
    sequenceNumber,
    replyToComment{
        id,
        text,
        createdDate,
        sequenceNumber,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        }
    }
    student{
        id,
        firstName,
        lastName,
        email,
        avatar {
            id,
            cloudKey
        }
    },
    files{
        id,
        name,
        cloudKey,
        extension,
        size,
        type
    },
    likeCount,
    dislikeCount,
    currentUserReaction{
        id,
        type
    }
}`, y7 = `
        id,
        text,
        createdDate,
        sequenceNumber,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        }
    `, g7 = `{
        id,
        text,
        createdDate,
        updatedDate,
        sequenceNumber,
        replyToComment{
           ${y7}
        }
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        },
        files{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        },
        likeCount,
        dislikeCount,
        currentUserReaction{
            id,
            type
        }
    }`;
class L7 {
  constructor(t) {
    z(this, "thread");
    z(this, "topic");
    z(this, "comment");
    z(this, "reaction");
    z(this, "blockStudent", async (t, e, o, b, r, i, s) => this.api.post("/forum/block-student", {
      threadId: t,
      studentId: e,
      beginDate: o,
      endDate: b,
      reason: r,
      topicId: i,
      commentId: s
    }));
    this.api = t, this.thread = new v7(t), this.topic = new _7(t), this.comment = new N7(t), this.reaction = new B7(t);
  }
}
class v7 {
  constructor(t) {
    z(this, "fetchThread", async (t) => {
      const e = t ? `/forum/thread/${t}` : "/forum/thread";
      return this.api.execute({ method: "GET", url: e, fields: h7 }, (o) => ({
        canModerate: o.canModerate,
        thread: o.thread ? qo.fromJson(o.thread) : null,
        threads: o.threads.map(qo.fromJson),
        topics: o.topics.map(Zb.fromJson),
        breadcrumbs: o.breadcrumbs.map(qo.fromJson),
        banStatus: o.banStatus ? {
          ...o.banStatus,
          untilDate: o.banStatus.untilDate ? new Date(o.banStatus.untilDate) : null
        } : null
      }));
    });
    this.api = t;
  }
}
class _7 {
  constructor(t) {
    z(this, "fetchTopic", async (t) => this.api.execute({ method: "GET", url: `/forum/topic/${t}`, fields: m7 }, (e) => ({
      canModerate: e.canModerate,
      topic: Zb.fromJson(e.topic),
      breadcrumbs: e.breadcrumbs.map(qo.fromJson),
      banStatus: e.banStatus ? {
        ...e.banStatus,
        untilDate: e.banStatus.untilDate ? new Date(e.banStatus.untilDate) : null
      } : null
    })));
    z(this, "createTopic", async (t, e, o, b) => this.api.post("/forum/topic", { threadId: t, title: e, text: o, files: b }));
    z(this, "updateTopic", async (t, e, o) => this.api.put("/forum/topic", { id: t, text: e, files: o }));
    z(this, "deleteTopic", async (t) => this.api.delete(`/forum/topic/${t}`));
    this.api = t;
  }
}
class N7 {
  constructor(t) {
    z(this, "fetchTopicComments", async (t) => this.api.getList("/forum/topic/comment", R7, t, (e) => ({
      filter: new _l(e.filter),
      items: e.items.map(_o.fromJson)
    })));
    z(this, "createTopicComment", async (t, e, o, b) => this.api.post("/forum/topic/comment", { topicId: t, text: e, replyId: o, files: b, fields: g7 }, (r) => ({
      comment: _o.fromJson(r.comment),
      itemsTotal: r.itemsTotal
    })));
    z(this, "updateTopicComment", async (t, e, o, b) => this.api.put("/forum/topic/comment", { id: t, text: e, files: o, replyId: b }));
    z(this, "deleteTopicComment", async (t) => this.api.delete(`/forum/topic/comment/${t}`));
    z(this, "fetchTopicCommentPosition", async (t, e) => {
      const o = `/forum/topic/${t}/comment-position/${e}`;
      return this.api.execute({ method: "GET", url: o }, (b) => b.body);
    });
    this.api = t;
  }
}
class B7 {
  constructor(t) {
    z(this, "create", async (t, e, o) => this.api.post("/forum/reaction", { topicId: t, commentId: e, type: o }, (b) => vo.fromJson(b)));
    z(this, "update", async (t, e) => this.api.put("/forum/reaction", { id: e, type: t }, (o) => vo.fromJson(o)));
    z(this, "delete", async (t) => this.api.delete(`/forum/reaction/${t}`));
    this.api = t;
  }
}
class T7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/student/bonus-transaction",
      parse: (e) => nN.fromJson(e),
      defaultFields: `{
                id,
                amount,
                comment,
                createdDate,
                order{
                    id,
                    number
                },
                type,
                transaction{
                    id
                },
                validUntilDate
            }`
    });
  }
}
const w7 = `{
            id,
            beginDate,
            endDate,
            type,
            coursePlan {
                id,
                name,
                softDeleted,
                course {
                    id,
                    name,
                    softDeleted
                }
            },
            course {
                id,
                name,
                softDeleted,
                primaryImage{
                    id,
                    file{
                        id,
                        name,
                        cloudKey,
                        extension,
                        size,
                        type
                    }
                }
            },
            libraryAccess{
                library{
                    id,
                    name,
                    softDeleted,
                    primaryImage{
                        id,
                        file{
                            id,
                            name,
                            cloudKey,
                            extension,
                            size,
                            type
                        }
                    }
                }
            }
        }`;
class S7 {
  constructor(t) {
    z(this, "fetch", (t, e = w7) => this.api.execute({ url: "/student/license", method: "GET", body: t, fields: e }, (o) => ({ items: o.items.map(Xb.fromJson), filter: o.filter })));
    this.api = t;
  }
}
const D7 = `{
                id,
                createdDate,
                paidDate,
                currency,
                isDigitalDelivery,
                fullyPaid,
                shippingPrice,
                totalAmount,
                paidAmount,
                savingsAmount,
                status,
                completed,
                number,
                contents{
                    id,
                    quantity,
                    product{
                        id,
                        name,
                        type,
                        price,
                        softDeleted
                    }
                }
            }`;
class X7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/student/order",
      parse: (e) => CM.fromJson(e),
      defaultFields: D7
    }), this.api = t;
  }
}
const zA = `{
    id,
    beginDate,
    endDate,
    creditEndDate,
    type,
    state,
    product{
        id,
        name,
        subsPrice,
        subsDuration,
        subsDurationType,
        image{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        }
    },
    currentSuspension{
        id,
        beginDate,
        endDate
    }
}`;
class C7 {
  constructor(t) {
    z(this, "fetch", (t, e = zA) => this.api.get("/student/subscription", e, (o) => ({
      items: o.items.map(Xb.fromJson),
      filter: new Ea(o.filter)
    })));
    z(this, "fetchItem", (t, e = zA) => this.api.get(`/student/subscription/${t}`, e, (o) => Xb.fromJson(o)));
    z(this, "save", (t) => this.api.put("/student/subscription", { id: t.id, state: { value: t.state } }));
    this.api = t;
  }
}
class I7 {
  constructor(t) {
    z(this, "order");
    z(this, "sub");
    z(this, "license");
    z(this, "bonusTransaction");
    z(this, "save", (t) => {
      var e;
      return this.api.put("/student", {
        avatarId: t.avatarId,
        email: t.email,
        firstName: t.firstName,
        middleName: t.middleName,
        lastName: t.lastName,
        phone: t.phone,
        gender: t.gender,
        birthday: (e = t.birthday) == null ? void 0 : e.toISOString(),
        password: t.password
      });
    });
    z(this, "resendEmailConfirmation", () => this.api.post("/student/resend-email-confirmation", null));
    z(this, "selectLang", (t) => this.api.put("/student/select-lang", { lang: t }));
    z(this, "updatePassword", (t) => this.api.put("/student/update-password", { password: t }));
    this.api = t, this.order = new X7(this.api), this.sub = new C7(this.api), this.license = new S7(this.api), this.bonusTransaction = new T7(this.api);
  }
}
class P7 {
  constructor(t) {
    z(this, "product");
    z(this, "transaction");
    z(this, "fetchTotals", () => this.api.get("/gamification/totals"));
    z(this, "fetchBalance", () => this.api.get("/gamification/balance"));
    z(this, "fetchAchievements", (t) => this.api.getList(
      "/gamification/achievement",
      void 0,
      t,
      (e) => ({
        items: e.items.map(ka.fromJson),
        filter: new J_(e.filter)
      })
    ));
    z(this, "fetchLeaders", (t) => this.api.getList(
      "/gamification/leaders",
      void 0,
      t,
      (e) => ({
        items: e.items.map(K_.fromJson),
        filter: new Ll(e.filter)
      })
    ));
    this.api = t, this.product = new E7(this.api), this.transaction = new k7(this.api);
  }
}
class E7 extends Ee {
  constructor(e) {
    super(e, {
      endpoint: "/gamification/product",
      parse: (o) => yl.fromJson(o),
      defaultFields: ""
    });
    z(this, "pay", (e) => this.api.post(this.settings.endpoint, { productId: e }));
    this.api = e;
  }
}
class k7 extends Ee {
  constructor(t) {
    super(t, {
      endpoint: "/gamification/transaction",
      parse: (e) => Y_.fromJson(e),
      defaultFields: ""
    }), this.api = t;
  }
}
class x7 {
  constructor(t) {
    /**
     * Get single event by ID
     */
    z(this, "getItem", (t) => this.api.get(
      `/event-calendar/${t}`,
      "",
      (e) => wz.fromJson(e)
    ));
    /**
     * Get list of events with filter
     */
    z(this, "getItems", (t) => this.api.getList(
      "/event-calendar",
      void 0,
      t,
      (e) => ({
        items: e.items.map(wz.fromJson),
        filter: new Q_(e.filter)
      })
    ));
    /**
     * Register for an event
     */
    z(this, "register", (t) => this.api.post("/event-calendar/register", { id: t }));
    this.api = t;
  }
}
const F7 = `{
    id,
    beginDate,
    endDate,
    state,
    flowBeginDate,
    accessBeginDate,
    course{
        id,
        name,
        dontAskFeedback
    },
    currentCourseItem{
        id
    },        
    student{
        id,
        firstName,
        lastName
    },
    progress
}`;
class U7 {
  constructor(t) {
    z(this, "fetchStudentCourse", async (t) => this.api.get(`/student-course-preview/${t}`, F7, (e) => ({
      studentCourse: or.fromJson(e)
    })));
    z(this, "fetchStudentCourseItem", async (t, e) => this.api.get(`/student-course-preview/${t}/items/${e}`, "", (o) => ({
      studentCourseItem: Lo.fromJson(o)
    })));
    z(this, "fetchStudentCourseItems", async (t) => this.api.get(`/student-course-preview/${t}/items`, "", (e) => ({
      items: e.items.map(Lo.fromJson)
    })));
    z(this, "completeStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/complete", { studentCourseId: t, courseItemId: e }, (o) => ({
      progresses: o.map($e.fromJson)
    })));
    z(this, "resetStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/uncomplete", { studentCourseId: t, courseItemId: e }, (o) => ({
      progresses: o.map($e.fromJson)
    })));
    z(this, "unblockStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/open", { studentCourseId: t, courseItemId: e }, (o) => ({
      progresses: o.map($e.fromJson)
    })));
    z(this, "blockStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/close", { studentCourseId: t, courseItemId: e }, (o) => ({
      progresses: o.map($e.fromJson)
    })));
    this.api = t;
  }
}
class H7 {
  constructor(t) {
    z(this, "fetchCourse", async (t) => this.api.get(`/course-preview/${t}`, "{ id, name }", (e) => ({
      course: wt.fromJson(e)
    })));
    z(this, "fetchCourseItem", async (t, e) => this.api.get(`/course-preview/${t}/items/${e}`, "", (o) => ({
      courseItem: Lo.fromJson(o)
    })));
    z(this, "fetchCourseItems", async (t, e) => this.api.execute({ method: "GET", url: `/course-preview/${t}/items`, body: { planId: e } }, (o) => ({
      items: o.items.map(Lo.fromJson)
    })));
    z(this, "fetchCoursePlans", async (t) => this.api.get(
      `/course-preview/${t}/plans`,
      `{
        id,
        name,
        disableTimeLimits,
        softDeleted
    }`,
      (e) => ({
        filter: new Fv(e.filter),
        items: e.items.map(DM.fromJson)
      })
    ));
    this.api = t;
  }
}
const J7 = `{
    id,
    type,
    payloadJson,
    createdDate,
    seenDate,
    adminId,
    studentId,
    adminTaskId,
    courseItemId,
    libraryItemId,
    orderId,
    orderPaymentId,
    scenarioId,
    chatConversationId,
    courseId,
    libraryId,
    courseItemTaskId,
    schoolContentItemCommentId,
    communityPostId,
    communityCommentId,
}`, $7 = `{
    useEmail,
    email,
    customEmail,
    useTg,
    tgId,
    tgLink,
    channels {
        id,
        useSite,
        useEmail,
        useTg,
        notificationType,
        subscriptionId
    }
}`;
class V7 {
  constructor(t) {
    z(this, "settings");
    z(this, "channel");
    z(this, "fetch", async (t) => this.api.getList("/notification", J7, t, (e) => ({
      items: e.items.map(br.fromJson),
      filter: new Z_(e.filter)
    })));
    z(this, "save", async (t) => this.api.put("/notification", { id: t.id, seenDate: C2(t.seenDate) }));
    z(this, "delete", async (t) => this.api.delete(`/notification/${t}`));
    z(this, "fetchCount", async (t) => this.api.execute({ method: "GET", url: "/notification/count", body: t }, (e) => ({
      count: e
    })));
    z(this, "markAllAsRead", async () => this.api.post("/notification/markAllAsRead", {}));
    this.api = t, this.settings = new Y7(this.api), this.channel = new G7(this.api);
  }
}
class Y7 {
  constructor(t) {
    z(this, "fetch", async () => this.api.get("/notification/settings", $7, (t) => ({
      settings: sN.fromJson(t)
    })));
    z(this, "save", async (t) => this.api.put("/notification/settings", {
      useEmail: C2(t.useEmail),
      customEmail: C2(t.customEmail ?? void 0),
      useTg: C2(t.useTg)
    }));
    this.api = t;
  }
}
class G7 {
  constructor(t) {
    z(this, "create", async (t) => this.api.post("/notification/channel", {
      notificationType: t.notificationType,
      useSite: t.useSite,
      useEmail: t.useEmail,
      useTg: t.useTg
    }, (e) => ({
      id: e
    })));
    z(this, "save", async (t, e) => this.api.put("/notification/channel", {
      id: t,
      useEmail: C2(e.useEmail),
      useSite: C2(e.useSite),
      useTg: C2(e.useTg)
    }));
    this.api = t;
  }
}
class K7 {
  constructor(t) {
    z(this, "fetch", async (t, e) => this.api.execute(
      { method: "GET", url: "/localization", body: { lang: t, timestamp: e } },
      (o) => ({
        words: o.words ? o.words : {},
        timestamp: o.timestamp,
        needSync: o.needSync,
        excludedLangs: o.excludedLangs ?? []
      })
    ));
    this.api = t;
  }
}
class Q7 {
  constructor(t) {
    z(this, "download", (t, e = !1) => this.api.get(`/file/${t}?isPreview=${e}`));
    z(this, "abort", (t) => this.api.execute({ url: "/file/abort", method: "PUT", headers: { "X-Content-Id": t } }));
    z(this, "begin", (t, e, o) => {
      const b = {};
      return b["X-Content-Type"] = t.type ? t.type : "application/octet-stream", t.size && (b["X-Content-Length"] = t.size), e && (b["X-Chunk-Size"] = e), t.name && (b["X-Content-Name"] = encodeURI(t.name)), o.fileId && (b["X-Content-File-Id"] = o.fileId), o.source && (b["X-Source"] = o.source), o.schoolId && (b["X-School-Id"] = o.schoolId), o.courseItemId && (b["X-Course-Item-Id"] = o.courseItemId), o.courseItemTaskId && (b["X-Course-Item-Task-Id"] = o.courseItemTaskId), o.courseItemTestId && (b["X-Course-Item-Test-Id"] = o.courseItemTestId), o.courseItemTestQuestionId && (b["X-Course-Item-Test-Question-Id"] = o.courseItemTestQuestionId), o.courseItemTestAnswerId && (b["X-Course-Item-Test-Answer-Id"] = o.courseItemTestAnswerId), o.courseItemTaskAnswerId && (b["X-Course-Item-Task-Answer-Id"] = o.courseItemTaskAnswerId), o.courseItemTaskAnswerCommentId && (b["X-Course-Item-Task-Answer-Comment-Id"] = o.courseItemTaskAnswerCommentId), o.isPublic && (b["X-Is-Public"] = o.isPublic), o.siteId && (b["X-Site-Id"] = o.siteId), o.meta && (b["X-Meta"] = JSON.stringify(o.meta)), o.voice && (b["X-Voice"] = o.voice), this.api.execute({
        url: "/file/begin",
        method: "POST",
        headers: b
      });
    });
    z(this, "complete", (t, e) => this.api.execute({ url: "/file/complete", method: "POST", body: { id: t, eTags: e } }, (o) => at.fromJson(o)));
    z(this, "save", (t) => this.api.execute({
      url: "/file",
      method: "PUT",
      body: {
        id: t.id,
        name: C2(t.name),
        description: C2(t.description),
        isPublic: C2(t.isPublic),
        metadataJson: C2(t.additionalData ? JSON.stringify(t.additionalData) : void 0)
      }
    }));
    z(this, "remove", (t) => this.api.execute({ url: `/file/${t}`, method: "DELETE" }));
    /**
     * Prepares a file for future use, calc metadata, convert to another type if needed, etc.
     */
    z(this, "prepare", (t) => this.api.execute({ method: "PUT", url: `/file/prepare/${t}` }));
    this.api = t;
  }
}
class Z7 {
  constructor(t) {
    //#region Methods
    z(this, "auth", new ZN(this));
    z(this, "file", new Q7(this));
    z(this, "loc", new K7(this));
    z(this, "announcement", new jN(this));
    z(this, "content", new e7(this));
    z(this, "school", new t7(this));
    z(this, "education", new z7(this));
    z(this, "partnership", new r7(this));
    z(this, "community", new u7(this));
    z(this, "forum", new L7(this));
    z(this, "account", new I7(this));
    z(this, "gamification", new P7(this));
    z(this, "eventCalendar", new x7(this));
    z(this, "coursePreview", new H7(this));
    z(this, "studentCoursePreview", new U7(this));
    z(this, "notification", new V7(this));
    this.client = t;
  }
  //#endregion
  //#region Core
  async execute(t, e) {
    const o = { ...t, v: t.v ?? 1, authorized: t.authorized ?? !0, cancellationToken: new AbortController() }, b = await this.client.execute(o, this);
    return b.body && e && (b.body = e(b.body)), b;
  }
  async put(t, e, o) {
    return this.execute({ method: "PUT", url: t, body: e }, o);
  }
  async get(t, e = "", o) {
    return this.execute({ method: "GET", url: t, fields: e }, o);
  }
  async getList(t, e = "", o, b) {
    const r = {
      method: "GET",
      url: t,
      fields: e,
      body: o ?? {},
      cancellationToken: new AbortController()
    }, i = await this.execute(r);
    return i.body && b && (i.body = b(i.body)), i;
  }
  async post(t, e, o) {
    return this.execute({ method: "POST", url: t, body: e }, o);
  }
  async delete(t, e) {
    return this.execute({ method: "DELETE", url: t }, e);
  }
  //#endregion
}
class j7 {
  constructor(t) {
    this.sdk = t;
  }
  get isAuthenticated() {
    return this.sdk.tokenStorage.hasTokens;
  }
  async login(t, e = !1) {
    if (y1(t.email) || y1(t.password))
      throw new Error("Email and password are required");
    const o = await this.sdk.api.auth.login(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  async register(t, e = !1) {
    if (y1(t.email) || y1(t.password))
      throw new Error("Email and password are required");
    const o = await this.sdk.api.auth.register(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  async logout(t = !1) {
    var b;
    const e = (b = this.sdk.tokenStorage.tokens) == null ? void 0 : b.refreshToken;
    if (!e) throw new Error("No refresh token");
    const o = await this.sdk.api.auth.logout(e);
    return o.success && (await this.sdk.tokenStorage.setTokens(null, t), this.sdk.dispatcher.emit("auth.logout", void 0)), o;
  }
  async refreshToken(t, e = !1) {
    if (!t) throw new Error("Refresh token is required");
    const o = await this.sdk.api.auth.refreshToken(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  // TODO: check if needed
  // async registerContact(body: RegisterContactRequestBody) {
  //     const result = await this.sdk.api.auth.registerContact(body);
  //     return result;
  // }
  async resetPassword(t, e = !1) {
    if (!t.token || y1(t.password) || y1(t.confirmPassword))
      throw new Error("Token, password and confirmPassword are required");
    return await this.sdk.api.auth.resetPassword(t);
  }
  async confirmEmail(t) {
    if (!t.token || !t.userId)
      throw new Error("Token and userId are required");
    return await this.sdk.api.auth.confirmEmail(t);
  }
  async checkInvite(t) {
    if (!t) throw new Error("Invite token is required");
    return await this.sdk.api.auth.checkInvite(t);
  }
  async confirmInvite(t) {
    if (!t.token || !t.password || !t.confirmPassword)
      throw new Error("Token, password and confirmPassword are required");
    return await this.sdk.api.auth.confirmInvite(t);
  }
  async sendInvite(t) {
    if (y1(t)) throw new Error("Email is required");
    return await this.sdk.api.auth.sendInvite(t);
  }
  async forgotPassword(t) {
    if (y1(t)) throw new Error("Email is required");
    return await this.sdk.api.auth.forgotPassword(t);
  }
  async loginToken(t, e = !1) {
    if (y1(t)) throw new Error("Token is required");
    const o = await this.sdk.api.auth.loginToken(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  async loginAs(t, e = !1) {
    const o = await this.sdk.api.auth.loginAs(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  async prolongSession(t, e = !1) {
    if (!t) throw new Error("Refresh token is required");
    const o = await this.sdk.api.auth.prolongSession(t);
    return o.success && await this.sdk.tokenStorage.setTokens(o.body, e), o;
  }
  async fetchContact(t) {
    if (y1(t)) throw new Error("Contact id is required");
    return await this.sdk.api.auth.fetchContact(t);
  }
  async fetchMe() {
    return await this.sdk.api.auth.fetchMe();
  }
  async fetchEmailNotificationsSubscriptionStatus(t) {
    if (y1(t.studentId)) throw new Error("Student id is required");
    return await this.sdk.api.auth.fetchEmailNotificationsSubscriptionStatus(t);
  }
  async fetchStudentEmailStatus(t) {
    if (y1(t.studentId) || y1(t.messageId))
      throw new Error("studentId and messageId is required");
    return await this.sdk.api.auth.fetchStudentEmailStatus(t);
  }
  async unsubscribeStudentEmailStatus(t) {
    if (y1(t.messageId))
      throw new Error("messageId is required");
    return await this.sdk.api.auth.unsubscribeStudentEmailStatus(t);
  }
  async unsubscribeEmailNotifications(t) {
    if (y1(t.studentId)) throw new Error("Student id is required");
    return await this.sdk.api.auth.unsubscribeEmailNotifications(t);
  }
}
class eB extends S1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  async fetchItems(t) {
    return this.sdk.api.content.fetch(t || this.filter);
  }
}
class rA {
  constructor(t, e) {
    z(this, "store");
    this.sdk = t, this.store = new eB(t), e && this.store.updateFilter(e);
  }
  async init() {
    this.store.inited || await this.store.fetch();
  }
}
class tB extends S1 {
  constructor(t) {
    super(), this.sdk = t, this.sdk = t;
  }
  async fetchItems(t) {
    return await this.sdk.api.account.license.fetch(t ?? this.filter);
  }
  createFilter(t) {
    return new Ea({ ...this.filter, ...t });
  }
  async startCourse(t) {
    return await this.sdk.api.education.studentCourse.startCourse(t);
  }
}
class pB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.account.bonusTransaction;
  }
  createFilter(t) {
    return new zN({ ...this.filter, ...t });
  }
}
class oB extends S1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  async fetchItems(t) {
    return await this.sdk.api.account.sub.fetch(t ?? this.filter);
  }
  async fetchItem(t, e) {
    return await this.sdk.api.account.sub.fetchItem(t, e);
  }
  createFilter(t) {
    return new Ea({ ...this.filter, ...t });
  }
  async save(t, e) {
    const o = await this.sdk.api.account.sub.save({ id: t.id, ...e });
    return o.success && t.update(e), o;
  }
}
class MB extends v1 {
  constructor(t) {
    super(), this.sdk = t, this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.account.order;
  }
}
class bB {
  constructor(t) {
    z(this, "user", null);
    z(this, "license");
    z(this, "order");
    z(this, "bonus");
    z(this, "subscription");
    this.sdk = t, this.sdk.dispatcher.on("auth.token.changed", this.onTokenChanged.bind(this)), this.license = new tB(this.sdk), this.bonus = new pB(this.sdk), this.subscription = new oB(this.sdk), this.order = new MB(this.sdk);
  }
  get isAuthorized() {
    return this.user != null;
  }
  setUser(t) {
    this.user = t, this.sdk.dispatcher.emit("auth.user.changed", this.user);
  }
  async onTokenChanged(t) {
    t ? await this.fetchUser() : this.setUser(null);
  }
  async fetchUser() {
    var e;
    const t = await this.sdk.api.auth.fetchMe();
    return t.success ? this.setUser(t.body) : (this.setUser(null), this.sdk.dispatcher.emit("error", { message: ((e = t.errors[0]) == null ? void 0 : e.message) ?? "Token invalid or expired" })), t;
  }
  // async saveUser(user: SaveStudentModel) {
  //     const result = await this.sdk.api.account.save(user);
  //     if (result.success) {
  //         this.user?.update(user);
  //         this.setUser(this.user);
  //     }
  //     return result;
  // }
}
class Ul extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.member;
  }
  createFilter(t) {
    return new WN({ ...this.filter, ...t });
  }
  async acceptAgreement(t) {
    const e = await this.sdk.api.partnership.member.accept();
    return e.success && t.update({ acceptedDate: L() }), e;
  }
}
class nB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.offer;
  }
  createFilter(t) {
    return new lN({ ...this.filter, ...t });
  }
}
class zB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.order;
  }
  createFilter(t) {
    return new x_({ ...this.filter, ...t });
  }
}
class rB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.transactionRequest;
  }
  createFilter(t) {
    return new yN({ ...this.filter, ...t });
  }
}
var Hl = /* @__PURE__ */ ((p) => (p[p.InvalidModel = 0] = "InvalidModel", p[p.UserNotFound = 1] = "UserNotFound", p[p.InternalError = 2] = "InternalError", p[p.MustSpecifyFieldsToSelect = 3] = "MustSpecifyFieldsToSelect", p[p.IsRequired = 4] = "IsRequired", p[p.TokenExpired = 5] = "TokenExpired", p[p.AccessDenied = 6] = "AccessDenied", p[p.FileNotFound = 7] = "FileNotFound", p[p.NeedFillField = 8] = "NeedFillField", p[p.EditingProhibited = 9] = "EditingProhibited", p[p.LoginFailed = 10] = "LoginFailed", p[p.RequestLogLevelFailed = 11] = "RequestLogLevelFailed", p[p.UnknownTimezone = 12] = "UnknownTimezone", p[p.NumberAttemptsExceeded = 13] = "NumberAttemptsExceeded", p[p.EmailAlreadyConfirmed = 14] = "EmailAlreadyConfirmed", p[p.AlreadyExists = 15] = "AlreadyExists", p[p.EmailAlreadyExists = 16] = "EmailAlreadyExists", p[p.InvalidDatePeriod = 17] = "InvalidDatePeriod", p[p.FailedSendEmail = 18] = "FailedSendEmail", p[p.InvalidEmail = 19] = "InvalidEmail", p[p.EmailNotConfirmed = 20] = "EmailNotConfirmed", p[p.EmailNotFound = 21] = "EmailNotFound", p[p.AlreadyHasDifferentWebhook = 27] = "AlreadyHasDifferentWebhook", p[p.AlreadyHasBeenChanged = 31] = "AlreadyHasBeenChanged", p[p.InvalidParameter = 1e3] = "InvalidParameter", p[p.WrongPassword = 1001] = "WrongPassword", p[p.PasswordMustBeBetween6And30Characters = 1002] = "PasswordMustBeBetween6And30Characters", p[p.PasswordAndConfirmationPasswordDoNotMatch = 1003] = "PasswordAndConfirmationPasswordDoNotMatch", p[p.InvalidRefreshToken = 1005] = "InvalidRefreshToken", p[p.UserAlreadyExist = 1006] = "UserAlreadyExist", p[p.InvalidAccessToken = 1007] = "InvalidAccessToken", p[p.InvalidResetToken = 1008] = "InvalidResetToken", p[p.SchoolNotFound = 1009] = "SchoolNotFound", p[p.CannotDeleteOwnerFromSchool = 1010] = "CannotDeleteOwnerFromSchool", p[p.SchoolPhoneInsufficientFunds = 1011] = "SchoolPhoneInsufficientFunds", p[p.LockedSchoolAccessDenied = 1012] = "LockedSchoolAccessDenied", p[p.LockedUserAccessDenied = 1013] = "LockedUserAccessDenied", p[p.ConfirmCodeSendExceedLimit = 1014] = "ConfirmCodeSendExceedLimit", p[p.InvalidConfirmCode = 1015] = "InvalidConfirmCode", p[p.NewPasswordMustBeDifferent = 1016] = "NewPasswordMustBeDifferent", p[p.ResetPasswordRequired = 1017] = "ResetPasswordRequired", p[p.LocWordAlreadyExist = 2001] = "LocWordAlreadyExist", p[p.LocWordNotFound = 2002] = "LocWordNotFound", p[p.LocTranslationNotFound = 2003] = "LocTranslationNotFound", p[p.LocNeedFillFields = 2004] = "LocNeedFillFields", p[p.LocLanguageNotFound = 2005] = "LocLanguageNotFound", p[p.LocWordNeedText = 2006] = "LocWordNeedText", p[p.LocWordNeedTranslations = 2007] = "LocWordNeedTranslations", p[p.LocTranslationNeedText = 2008] = "LocTranslationNeedText", p[p.LocNeedFields = 2009] = "LocNeedFields", p[p.EmailTemplateNotFound = 3001] = "EmailTemplateNotFound", p[p.PhoneAlreadyExist = 4001] = "PhoneAlreadyExist", p[p.InvalidPhone = 4002] = "InvalidPhone", p[p.SchoolAlreadyExist = 5001] = "SchoolAlreadyExist", p[p.SchoolAdminNotFound = 5002] = "SchoolAdminNotFound", p[p.SchoolProfileSettingsNotFound = 5003] = "SchoolProfileSettingsNotFound", p[p.SchoolStatisticsNotFound = 5101] = "SchoolStatisticsNotFound", p[p.SchoolBillingNotFound = 5201] = "SchoolBillingNotFound", p[p.SchoolDomainAlreadyExist = 5251] = "SchoolDomainAlreadyExist", p[p.CourseNotFound = 6001] = "CourseNotFound", p[p.CoursePlanNotFound = 6002] = "CoursePlanNotFound", p[p.CourseCategoryNotFound = 6003] = "CourseCategoryNotFound", p[p.CourseAlreadyContainsPackage = 6005] = "CourseAlreadyContainsPackage", p[p.CourseNotFoundPackageLink = 6006] = "CourseNotFoundPackageLink", p[p.CourseCategoryRequireName = 6007] = "CourseCategoryRequireName", p[p.CourseAlreadyContainCategory = 6008] = "CourseAlreadyContainCategory", p[p.CourseNotContainCategory = 6009] = "CourseNotContainCategory", p[p.CourseItemNotFound = 6010] = "CourseItemNotFound", p[p.CourseFileBelongsToAnotherCourse = 6011] = "CourseFileBelongsToAnotherCourse", p[p.CourseItemNotValidPosition = 6013] = "CourseItemNotValidPosition", p[p.CourseItemAlreadyContainsPlan = 6014] = "CourseItemAlreadyContainsPlan", p[p.CourseItemNotFoundPlanLink = 6015] = "CourseItemNotFoundPlanLink", p[p.CourseItemCommentNotFound = 6016] = "CourseItemCommentNotFound", p[p.CourseItemTaskNotFound = 6016] = "CourseItemTaskNotFound", p[p.CourseItemTestQuestionNotFound = 6017] = "CourseItemTestQuestionNotFound", p[p.CourseItemTestAnswerNotFound = 6018] = "CourseItemTestAnswerNotFound", p[p.CourseItemTestNotFound = 6019] = "CourseItemTestNotFound", p[p.CourseStudentNotFound = 6020] = "CourseStudentNotFound", p[p.CourseItemTestQuestionMustHaveCorrectAnswer = 6021] = "CourseItemTestQuestionMustHaveCorrectAnswer", p[p.CourseItemTaskFieldNotFound = 6027] = "CourseItemTaskFieldNotFound", p[p.FileInitiateError = 7001] = "FileInitiateError", p[p.FileUploadError = 7002] = "FileUploadError", p[p.FileCompleteError = 7003] = "FileCompleteError", p[p.DirectoryWithSameNameAlreadyExist = 7004] = "DirectoryWithSameNameAlreadyExist", p[p.DirectoryCannotBeRecursive = 7005] = "DirectoryCannotBeRecursive", p[p.DirectoryNotFound = 7006] = "DirectoryNotFound", p[p.FileManagerItemNotFound = 7007] = "FileManagerItemNotFound", p[p.YouCannotDeleteDirectoryBecauseIsNotEmpty = 7008] = "YouCannotDeleteDirectoryBecauseIsNotEmpty", p[p.FileWithSameNameAlreadyExist = 7009] = "FileWithSameNameAlreadyExist", p[p.FileUpdateCannedACLError = 7010] = "FileUpdateCannedACLError", p[p.FileReplaceExtensionError = 7011] = "FileReplaceExtensionError", p[p.FileUpdateError = 7012] = "FileUpdateError", p[p.StudentNotFound = 8001] = "StudentNotFound", p[p.StudentCourseNotFound = 8002] = "StudentCourseNotFound", p[p.StudentCourseItemProgressNotFound = 8003] = "StudentCourseItemProgressNotFound", p[p.StudentCourseItemTaskAnswerNotFound = 8004] = "StudentCourseItemTaskAnswerNotFound", p[p.StudentCourseStepAccessDenied = 8005] = "StudentCourseStepAccessDenied", p[p.StudentCourseCannotBeCompleted = 8006] = "StudentCourseCannotBeCompleted", p[p.StudentCourseItemTaskAnswerCommentNotFound = 8007] = "StudentCourseItemTaskAnswerCommentNotFound", p[p.StudentCourseItemCommentTimeLimit = 8009] = "StudentCourseItemCommentTimeLimit", p[p.StudentCourseStartError = 8010] = "StudentCourseStartError", p[p.StudentNotHaveEmail = 8011] = "StudentNotHaveEmail", p[p.StudentAlreadyMerging = 8012] = "StudentAlreadyMerging", p[p.StudentLibraryItemsNotFound = 8013] = "StudentLibraryItemsNotFound", p[p.StudentCourseHasRequirements = 8040] = "StudentCourseHasRequirements", p[p.StudentCourseItemsNotFound = 8500] = "StudentCourseItemsNotFound", p[p.InvalidInviteToken = 9001] = "InvalidInviteToken", p[p.TagNotFound = 10001] = "TagNotFound", p[p.TagAlreadyExists = 10002] = "TagAlreadyExists", p[p.StudentTagLinkNotFound = 11001] = "StudentTagLinkNotFound", p[p.LeadNotFound = 12001] = "LeadNotFound", p[p.StudentLicenseNotFound = 12003] = "StudentLicenseNotFound", p[p.LeadAttributeNotFound = 12100] = "LeadAttributeNotFound", p[p.LeadAttributeNameAlreadyExists = 12101] = "LeadAttributeNameAlreadyExists", p[p.LeadAttributeKeyNameAlreadyExists = 12102] = "LeadAttributeKeyNameAlreadyExists", p[p.LeadAttributeKeyNameBusyBySystem = 12103] = "LeadAttributeKeyNameBusyBySystem", p[p.FlowNotFound = 13001] = "FlowNotFound", p[p.FlowDateNotFound = 13002] = "FlowDateNotFound", p[p.AdminNotFound = 14001] = "AdminNotFound", p[p.AdminResponsibleNotFound = 14002] = "AdminResponsibleNotFound", p[p.AdminResponsibleFromUserExists = 14011] = "AdminResponsibleFromUserExists", p[p.AdminCRMSettingsNotFound = 14050] = "AdminCRMSettingsNotFound", p[p.AdminPartnerTariffNotFound = 14100] = "AdminPartnerTariffNotFound", p[p.AdminPartnerTariffAlreadyExists = 14101] = "AdminPartnerTariffAlreadyExists", p[p.AdminPartnerTransactionNotFound = 14200] = "AdminPartnerTransactionNotFound", p[p.AdminPartnerTransactionInsufficientFunds = 14201] = "AdminPartnerTransactionInsufficientFunds", p[p.CRMImportInvalidFile = 15001] = "CRMImportInvalidFile", p[p.CRMImportInvalidText = 15002] = "CRMImportInvalidText", p[p.CRMImportNoRowsFound = 15003] = "CRMImportNoRowsFound", p[p.CRMImportError = 15004] = "CRMImportError", p[p.CRMImportInvalidRow = 15005] = "CRMImportInvalidRow", p[p.CRMImportFieldInvalidPattern = 15006] = "CRMImportFieldInvalidPattern", p[p.CRMImportEmailRequired = 15007] = "CRMImportEmailRequired", p[p.CRMImportInvalidFieldCast = 15008] = "CRMImportInvalidFieldCast", p[p.CRMImportRequiredFields = 15012] = "CRMImportRequiredFields", p[p.ForumThreadNotFound = 17001] = "ForumThreadNotFound", p[p.ForumThreadCannotDeleteWhileHasNestedThreads = 17002] = "ForumThreadCannotDeleteWhileHasNestedThreads", p[p.ForumAccessDenied = 17003] = "ForumAccessDenied", p[p.ForumThreadModeratorNotFound = 17100] = "ForumThreadModeratorNotFound", p[p.ForumTopicNotFound = 17200] = "ForumTopicNotFound", p[p.ForumTopicCommentNotFound = 17201] = "ForumTopicCommentNotFound", p[p.ForumReactionNotFound = 17300] = "ForumReactionNotFound", p[p.ForumSubscriptionNotFound = 17400] = "ForumSubscriptionNotFound", p[p.ForumUnableCreateTopic = 17451] = "ForumUnableCreateTopic", p[p.ForumUnableEditTopic = 17452] = "ForumUnableEditTopic", p[p.ForumUnableEditTopicComment = 17453] = "ForumUnableEditTopicComment", p[p.ForumUnableCreateTopicTooOften = 17454] = "ForumUnableCreateTopicTooOften", p[p.ForumBanNotFound = 17800] = "ForumBanNotFound", p[p.ForumBanAccessDenied = 17801] = "ForumBanAccessDenied", p[p.ChatConversationNotFound = 18001] = "ChatConversationNotFound", p[p.ChatCurrentContactNotFound = 18002] = "ChatCurrentContactNotFound", p[p.ChatContactNotFound = 18003] = "ChatContactNotFound", p[p.ChatDepartmentNotFound = 18004] = "ChatDepartmentNotFound", p[p.ChatConversationMemberNotFound = 18005] = "ChatConversationMemberNotFound", p[p.ChatMessageNotFound = 18006] = "ChatMessageNotFound", p[p.ChatMessageCouldntBeEmpty = 18007] = "ChatMessageCouldntBeEmpty", p[p.ChatConversationWrongType = 18008] = "ChatConversationWrongType", p[p.ChatConversationWrongContactCount = 18009] = "ChatConversationWrongContactCount", p[p.EmailProfileNotFound = 19001] = "EmailProfileNotFound", p[p.EmailProfileFailedDeletePrimary = 19002] = "EmailProfileFailedDeletePrimary", p[p.EmailProfileFailedDeleteActive = 19003] = "EmailProfileFailedDeleteActive", p[p.EmailProfileTestFailed = 19004] = "EmailProfileTestFailed", p[p.ExtendedFilterNotFound = 20001] = "ExtendedFilterNotFound", p[p.EmailDomainNotFound = 21001] = "EmailDomainNotFound", p[p.EmailDomainFailedDelete = 21002] = "EmailDomainFailedDelete", p[p.EmailDomainFailedAdd = 21003] = "EmailDomainFailedAdd", p[p.EmailDomainFailedVerify = 21004] = "EmailDomainFailedVerify", p[p.EmailDomainNeedVerify = 21005] = "EmailDomainNeedVerify", p[p.EmailDomainWaitRegistration = 21007] = "EmailDomainWaitRegistration", p[p.EmailMessageNotFound = 25001] = "EmailMessageNotFound", p[p.EmailMessageBlockedEmails = 25002] = "EmailMessageBlockedEmails", p[p.EmailMessageNotEnoughDataToSend = 25003] = "EmailMessageNotEnoughDataToSend", p[p.EmailMessageAttachmentsSizeExceeded = 25004] = "EmailMessageAttachmentsSizeExceeded", p[p.EmailMessageExceedLimit = 25006] = "EmailMessageExceedLimit", p[p.CallAccountAlreadyInUse = 27015] = "CallAccountAlreadyInUse", p[p.CallAccountCantSetWebhookUrl = 27016] = "CallAccountCantSetWebhookUrl", p[p.LibraryNotFound = 29001] = "LibraryNotFound", p[p.LibraryItemNotFound = 29501] = "LibraryItemNotFound", p[p.LibraryItemAccessDenied = 29502] = "LibraryItemAccessDenied", p[p.ProductPackageNotFound = 30001] = "ProductPackageNotFound", p[p.SiteNotFound = 31001] = "SiteNotFound", p[p.SiteAlreadyExists = 31002] = "SiteAlreadyExists", p[p.SitePageNotFound = 31003] = "SitePageNotFound", p[p.SitePageAlreadyExists = 31004] = "SitePageAlreadyExists", p[p.SiteDomainNotFound = 31005] = "SiteDomainNotFound", p[p.SiteDomainAlreadyExists = 31006] = "SiteDomainAlreadyExists", p[p.SiteMenuItemAlreadyExists = 31007] = "SiteMenuItemAlreadyExists", p[p.SiteMenuItemNotFound = 31008] = "SiteMenuItemNotFound", p[p.ProductNotFound = 33001] = "ProductNotFound", p[p.ProductImageLinkNotFound = 33002] = "ProductImageLinkNotFound", p[p.ProductContentAlreadyExists = 33100] = "ProductContentAlreadyExists", p[p.WebinarNotFound = 38001] = "WebinarNotFound", p[p.WebinarShortNameAlreadyExist = 38003] = "WebinarShortNameAlreadyExist", p[p.WebinarScheduleInvalid = 38004] = "WebinarScheduleInvalid", p[p.WebinarImportEventInvalidFileFormat = 38451] = "WebinarImportEventInvalidFileFormat", p[p.WebinarImportEventInvalidEventFormat = 38452] = "WebinarImportEventInvalidEventFormat", p[p.ChatChannelNotFound = 41001] = "ChatChannelNotFound", p[p.ChatChannelResponseTimeLimitExceeded = 41002] = "ChatChannelResponseTimeLimitExceeded", p[p.BulkActionRegisterWebinarMaxSizeExceeded = 44001] = "BulkActionRegisterWebinarMaxSizeExceeded", p[p.DocumentNotFound = 45001] = "DocumentNotFound", p[p.DocumentContentNotFound = 45100] = "DocumentContentNotFound", p[p.DocumentUrlAlreadyExists = 45200] = "DocumentUrlAlreadyExists", p[p.DocumentTitleAlreadyExists = 45300] = "DocumentTitleAlreadyExists", p[p.BillingPlanNotFound = 49001] = "BillingPlanNotFound", p[p.BillingPlanNameAlreadyExists = 49002] = "BillingPlanNameAlreadyExists", p[p.BillingPaymentMethodNotFound = 49100] = "BillingPaymentMethodNotFound", p[p.BillingPaymentNotFound = 49200] = "BillingPaymentNotFound", p[p.BillingPaymentFailed = 49201] = "BillingPaymentFailed", p[p.BillingInvoiceNotFound = 49301] = "BillingInvoiceNotFound", p[p.BillingCurrencyExchangeRateChanged = 49401] = "BillingCurrencyExchangeRateChanged", p[p.RequisiteNotFound = 52001] = "RequisiteNotFound", p[p.RequisiteAlreadyExists = 52002] = "RequisiteAlreadyExists", p[p.PipelineNotFound = 53001] = "PipelineNotFound", p[p.PipelineStageNotFound = 53050] = "PipelineStageNotFound", p[p.PipelineStageItemNotFound = 53100] = "PipelineStageItemNotFound", p[p.PipelineTagNotFound = 53150] = "PipelineTagNotFound", p[p.PipelineFieldNotFound = 53200] = "PipelineFieldNotFound", p[p.PipelineFieldValueUpdatedFailed = 53201] = "PipelineFieldValueUpdatedFailed", p[p.PipelineFieldKeyAlreadyExists = 53202] = "PipelineFieldKeyAlreadyExists", p[p.PipelineFieldRequired = 53203] = "PipelineFieldRequired", p[p.PipelineItemNotFound = 53301] = "PipelineItemNotFound", p[p.ApplicationNotFound = 54001] = "ApplicationNotFound", p[p.ApplicationCantHasMultipleInstance = 54002] = "ApplicationCantHasMultipleInstance", p[p.ApplicationSchoolLinkNotFound = 54101] = "ApplicationSchoolLinkNotFound", p[p.ApplicationSchoolLinkCantBeRestored = 54102] = "ApplicationSchoolLinkCantBeRestored", p[p.TelegramGroupNotFound = 54201] = "TelegramGroupNotFound", p[p.TelegramGroupCantRegistered = 54202] = "TelegramGroupCantRegistered", p[p.TelegramGroupUserNotFound = 54301] = "TelegramGroupUserNotFound", p[p.TelegramGroupCannotDeleteOwnerFromGroup = 54302] = "TelegramGroupCannotDeleteOwnerFromGroup", p[p.TelegramGroupCannotUpdateOwner = 54303] = "TelegramGroupCannotUpdateOwner", p[p.TelegramGroupCannotDeleteAdminFromGroup = 54304] = "TelegramGroupCannotDeleteAdminFromGroup", p[p.MetaConversionCantRegistered = 54350] = "MetaConversionCantRegistered", p[p.TelegramGroupApproveChatJoinRequest = 54401] = "TelegramGroupApproveChatJoinRequest", p[p.TelegramGroupDeclineChatJoinRequest = 54402] = "TelegramGroupDeclineChatJoinRequest", p[p.YandexMetrikaGoalNotFound = 54501] = "YandexMetrikaGoalNotFound", p[p.YandexMetrikaAuthError = 54502] = "YandexMetrikaAuthError", p[p.YandexMetrikaExportError = 54503] = "YandexMetrikaExportError", p[p.YandexMetrikaImportError = 54504] = "YandexMetrikaImportError", p[p.GlossaryNotFound = 55001] = "GlossaryNotFound", p[p.GlossaryAlreadyExists = 55002] = "GlossaryAlreadyExists", p[p.GlossaryWordsCountExceeded = 55003] = "GlossaryWordsCountExceeded", p[p.GlobalVariableNotFound = 56001] = "GlobalVariableNotFound", p[p.WebhookNumberAttemptsExceeded = 57001] = "WebhookNumberAttemptsExceeded", p[p.PartnershipNotFound = 58001] = "PartnershipNotFound", p[p.PartnershipAlreadyExists = 58002] = "PartnershipAlreadyExists", p[p.PartnershipInsufficientFunds = 58003] = "PartnershipInsufficientFunds", p[p.PartnershipTransferMinFeeAmountRestrictions = 58004] = "PartnershipTransferMinFeeAmountRestrictions", p[p.PartnershipMemberNotFound = 58050] = "PartnershipMemberNotFound", p[p.PartnershipTransactionNotFound = 58100] = "PartnershipTransactionNotFound", p[p.PartnershipOfferNotFound = 58200] = "PartnershipOfferNotFound", p[p.PartnershipOfferWithSameProductAlreadyExists = 58201] = "PartnershipOfferWithSameProductAlreadyExists", p[p.PartnershipTransactionRequestNotFound = 58251] = "PartnershipTransactionRequestNotFound", p[p.SharedSettingsExportNotFound = 59001] = "SharedSettingsExportNotFound", p[p.SharedSettingsReexportProhibited = 59002] = "SharedSettingsReexportProhibited", p[p.SharedSettingsImportNotFound = 59100] = "SharedSettingsImportNotFound", p))(Hl || {}), cB = Object.defineProperty, iB = Object.getOwnPropertyDescriptor, xo = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? iB(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && cB(t, e, b), b;
};
class Vp {
  constructor(t) {
    z(this, "currentMember");
    z(this, "inited", !1);
    z(this, "partnership");
    z(this, "memberStore");
    z(this, "accepting", !1);
    z(this, "fetchingTotals", !1);
    z(this, "fetching", !1);
    this.sdk = t, i0(this), this.memberStore = new Ul(t);
  }
  async init() {
    var o;
    if (this.inited) return;
    this.partnership = this.sdk.school.partnership;
    const t = await this.memberStore.fetchItem("");
    if (!t.success && !((o = t.errors) != null && o.some((b) => b.code === Hl.PartnershipMemberNotFound)))
      return !1;
    const e = t.body ?? new Dl();
    if (!e.id) {
      const b = await this.memberStore.create(e);
      if (!b.success) return b.success;
    }
    return s0(() => {
      this.currentMember = e, this.inited = !0;
    }), !0;
  }
  async acceptAgreement() {
    this.accepting = !0;
    try {
      return await this.memberStore.acceptAgreement(this.currentMember);
    } finally {
      s0(() => this.accepting = !1);
    }
  }
  async fetchTotals(t) {
    this.fetchingTotals = !0;
    try {
      return await this.sdk.api.partnership.fetchTotals(t);
    } finally {
      s0(() => this.fetchingTotals = !1);
    }
  }
  async fetchMaxAvailableAmount() {
    this.fetching = !0;
    try {
      return await this.sdk.api.partnership.fetchMaxAmount();
    } finally {
      s0(() => this.fetching = !1);
    }
  }
}
xo([
  a
], Vp.prototype, "currentMember", 2);
xo([
  a
], Vp.prototype, "inited", 2);
xo([
  C
], Vp.prototype, "init", 1);
xo([
  a
], Vp.prototype, "accepting", 2);
xo([
  C
], Vp.prototype, "acceptAgreement", 1);
xo([
  a
], Vp.prototype, "fetchingTotals", 2);
xo([
  a
], Vp.prototype, "fetching", 2);
var aB = Object.defineProperty, OB = (p, t, e, o) => {
  for (var b = void 0, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && aB(t, e, b), b;
};
class Jl extends v1 {
  constructor(e) {
    super();
    z(this, "fetchingTotals", !1);
    this.sdk = e, i0(this);
  }
  get crudApi() {
    return this.sdk.api.partnership.transaction;
  }
  async fetchTotals(e) {
    this.fetchingTotals = !0;
    try {
      return await this.crudApi.fetchTotals(e);
    } finally {
      s0(() => this.fetchingTotals = !1);
    }
  }
  createFilter(e) {
    return new tN({ ...this.filter, ...e });
  }
}
OB([
  a
], Jl.prototype, "fetchingTotals");
class sB {
  constructor(t) {
    z(this, "store");
    z(this, "memberStore");
    z(this, "transactionStore");
    z(this, "requestStore");
    z(this, "orderStore");
    z(this, "offerStore");
    this.sdk = t, this.store = new Vp(this.sdk), this.memberStore = new Ul(this.sdk), this.transactionStore = new Jl(this.sdk), this.requestStore = new rB(this.sdk), this.orderStore = new zB(this.sdk), this.offerStore = new nB(this.sdk);
  }
  async init() {
    this.store.inited || await this.store.init();
  }
}
class AB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.member;
  }
  createFilter(t) {
    return new PN({ ...this.filter, ...t });
  }
}
class uB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.spaceItem;
  }
  createFilter(t) {
    return new vN({ ...this.filter, ...t });
  }
}
var dB = Object.defineProperty, lB = Object.getOwnPropertyDescriptor, en = (p, t, e, o) => {
  for (var b = lB(t, e), r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && dB(t, e, b), b;
};
class EM extends v1 {
  constructor(t) {
    super("infinity"), this.sdk = t, i0(this);
  }
  get crudApi() {
    return this.sdk.api.community.post;
  }
  createFilter(t) {
    return new xN({ ...this.filter, ...t });
  }
  async like(t) {
    t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 });
    const e = await this.crudApi.like(t.id);
    return e.success || t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 }), e;
  }
  async unlike(t) {
    t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 });
    const e = await this.crudApi.unlike(t.id);
    return e.success || t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 }), e;
  }
  addPost(t) {
    this.insertItems(t);
  }
  updatePost(t) {
    const e = this.items.find((o) => o.id === t.id);
    e && e.update({
      updatedDate: t.updatedDate,
      title: t.title,
      body: t.body,
      pinPosition: t.pinPosition,
      status: t.status,
      likesCount: t.likesCount,
      commentsCount: t.commentsCount,
      viewsCount: t.viewsCount,
      pinDate: t.pinDate,
      attachments: t.attachments
    });
  }
  removePost(t) {
    this.removeItems(t);
  }
  async fetchItemByNumber(t) {
    return await this.crudApi.fetchByNumber(t);
  }
}
en([
  C
], EM.prototype, "like");
en([
  C
], EM.prototype, "unlike");
en([
  C
], EM.prototype, "addPost");
en([
  C
], EM.prototype, "updatePost");
en([
  C
], EM.prototype, "removePost");
var qB = Object.defineProperty, fB = Object.getOwnPropertyDescriptor, kM = (p, t, e, o) => {
  for (var b = fB(t, e), r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && qB(t, e, b), b;
};
class Fo extends v1 {
  constructor(t) {
    super("infinity"), this.sdk = t, i0(this);
  }
  get crudApi() {
    return this.sdk.api.community.postComment;
  }
  createFilter(t) {
    return new nA({ ...this.filter, ...t });
  }
  async fetchReplies(t) {
    const e = await this.fetchItems(new nA({
      parentId: t.id,
      skip: t.children.length,
      sortName: "CreatedDate",
      sortType: "Asc",
      take: 100
    }));
    return e.success && t.update({
      children: [...t.children, ...e.body.items],
      childrenCount: e.body.filter.itemsTotal,
      childrenCollapsed: !0
    }), e;
  }
  async like(t) {
    t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 });
    const e = await this.crudApi.like(t.id);
    return e.success || t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 }), e;
  }
  async unlike(t) {
    t.update({ likesCount: Math.max(t.likesCount - 1, 0), isLikedByCurrentUser: !1 });
    const e = await this.crudApi.unlike(t.id);
    return e.success || t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 }), e;
  }
  addComment(t) {
    if (t.parent) {
      const e = this.items.find((o) => o.id === t.parent.id);
      e && e.update({
        childrenCount: e.childrenCount + 1,
        children: e.childrenCollapsed ? e.children : [...e.children, t]
      });
    } else
      this.insertItems(t);
  }
  updateComment(t) {
    if (t.parent) {
      const e = this.items.find((o) => o.id === t.parent.id);
      if (e) {
        const o = e.children.find((b) => b.id === t.id);
        o && o.update(o);
      }
    } else {
      const e = this.items.find((o) => o.id === t.id);
      e && e.update({
        text: t.text,
        status: t.status,
        likesCount: t.likesCount,
        files: t.files,
        updatedDate: t.updatedDate
      });
    }
  }
  removeComment(t) {
    if (t.parent) {
      const e = this.items.find((o) => o.id === t.parent.id);
      if (e) {
        const o = e.children.find((b) => b.id === t.id);
        o && e.update({ children: e.children.filter((b) => b.id !== o.id), childrenCount: e.childrenCount - 1 });
      }
    } else
      this.removeItems(t);
  }
}
kM([
  C
], Fo.prototype, "fetchReplies");
kM([
  C
], Fo.prototype, "like");
kM([
  C
], Fo.prototype, "unlike");
kM([
  C
], Fo.prototype, "addComment");
kM([
  C
], Fo.prototype, "updateComment");
kM([
  C
], Fo.prototype, "removeComment");
class WB extends v1 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.report;
  }
  createFilter(t) {
    return new VN({ ...this.filter, ...t });
  }
}
var hB = Object.defineProperty, mB = Object.getOwnPropertyDescriptor, Yp = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? mB(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && hB(t, e, b), b;
};
class dp {
  constructor(t) {
    z(this, "memberStore");
    z(this, "spaceItemStore");
    z(this, "postStore");
    z(this, "postCommentStore");
    z(this, "reportStore");
    z(this, "currentMember", null);
    z(this, "inited", !1);
    z(this, "joining", !1);
    this.sdk = t, i0(this), this.memberStore = new AB(this.sdk), this.spaceItemStore = new uB(this.sdk), this.postStore = new EM(this.sdk), this.postCommentStore = new Fo(this.sdk), this.reportStore = new WB(this.sdk);
  }
  get community() {
    return this.sdk.school.community;
  }
  get isJoined() {
    return this.currentMember !== null;
  }
  get isModerator() {
    var t;
    return ((t = this.currentMember) == null ? void 0 : t.role) === "moderator";
  }
  async init() {
    var t;
    return this.inited || (this.currentMember = ((t = this.sdk.account.user) == null ? void 0 : t.communityMember) || null, this.inited = !0), !0;
  }
  async join() {
    this.joining = !0;
    try {
      const t = await this.sdk.api.community.join();
      return t.success && s0(() => {
        var e;
        this.currentMember = ((e = this.sdk.account.user) == null ? void 0 : e.communityMember) || null;
      }), t;
    } finally {
      s0(() => this.joining = !1);
    }
  }
  reset() {
    this.currentMember = null, this.inited = !1;
  }
}
Yp([
  a
], dp.prototype, "currentMember", 2);
Yp([
  a
], dp.prototype, "inited", 2);
Yp([
  $
], dp.prototype, "isJoined", 1);
Yp([
  $
], dp.prototype, "isModerator", 1);
Yp([
  C
], dp.prototype, "init", 1);
Yp([
  a
], dp.prototype, "joining", 2);
Yp([
  C
], dp.prototype, "join", 1);
Yp([
  C
], dp.prototype, "reset", 1);
class fo extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(t, e) {
    const o = new.target.prototype;
    super(`${t}: Status code '${e}'`), this.statusCode = e, this.__proto__ = o;
  }
}
class Ha extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "A timeout occurred.") {
    const e = new.target.prototype;
    super(t), this.__proto__ = e;
  }
}
class Mt extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "An abort occurred.") {
    const e = new.target.prototype;
    super(t), this.__proto__ = e;
  }
}
class RB extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const o = new.target.prototype;
    super(t), this.transport = e, this.errorType = "UnsupportedTransportError", this.__proto__ = o;
  }
}
class yB extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const o = new.target.prototype;
    super(t), this.transport = e, this.errorType = "DisabledTransportError", this.__proto__ = o;
  }
}
class gB extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const o = new.target.prototype;
    super(t), this.transport = e, this.errorType = "FailedToStartTransportError", this.__proto__ = o;
  }
}
class cA extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(t) {
    const e = new.target.prototype;
    super(t), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = e;
  }
}
class LB extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(t, e) {
    const o = new.target.prototype;
    super(t), this.innerErrors = e, this.__proto__ = o;
  }
}
class $l {
  constructor(t, e, o) {
    this.statusCode = t, this.statusText = e, this.content = o;
  }
}
class rr {
  get(t, e) {
    return this.send({
      ...e,
      method: "GET",
      url: t
    });
  }
  post(t, e) {
    return this.send({
      ...e,
      method: "POST",
      url: t
    });
  }
  delete(t, e) {
    return this.send({
      ...e,
      method: "DELETE",
      url: t
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(t) {
    return "";
  }
}
var k;
(function(p) {
  p[p.Trace = 0] = "Trace", p[p.Debug = 1] = "Debug", p[p.Information = 2] = "Information", p[p.Warning = 3] = "Warning", p[p.Error = 4] = "Error", p[p.Critical = 5] = "Critical", p[p.None = 6] = "None";
})(k || (k = {}));
class Cb {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(t, e) {
  }
}
Cb.instance = new Cb();
const vB = "8.0.17";
class j1 {
  static isRequired(t, e) {
    if (t == null)
      throw new Error(`The '${e}' argument is required.`);
  }
  static isNotEmpty(t, e) {
    if (!t || t.match(/^\s*$/))
      throw new Error(`The '${e}' argument should not be empty.`);
  }
  static isIn(t, e, o) {
    if (!(t in e))
      throw new Error(`Unknown ${o} value: ${t}.`);
  }
}
class w1 {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return !w1.isNode && typeof window == "object" && typeof window.document == "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return !w1.isNode && typeof self == "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return !w1.isNode && typeof window == "object" && typeof window.document > "u";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return typeof process < "u" && process.release && process.release.name === "node";
  }
}
function Ib(p, t) {
  let e = "";
  return No(p) ? (e = `Binary data of length ${p.byteLength}`, t && (e += `. Content: '${_B(p)}'`)) : typeof p == "string" && (e = `String data of length ${p.length}`, t && (e += `. Content: '${p}'`)), e;
}
function _B(p) {
  const t = new Uint8Array(p);
  let e = "";
  return t.forEach((o) => {
    const b = o < 16 ? "0" : "";
    e += `0x${b}${o.toString(16)} `;
  }), e.substr(0, e.length - 1);
}
function No(p) {
  return p && typeof ArrayBuffer < "u" && (p instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  p.constructor && p.constructor.name === "ArrayBuffer");
}
async function Vl(p, t, e, o, b, r) {
  const i = {}, [s, d] = gM();
  i[s] = d, p.log(k.Trace, `(${t} transport) sending data. ${Ib(b, r.logMessageContent)}.`);
  const q = No(b) ? "arraybuffer" : "text", f = await e.post(o, {
    content: b,
    headers: { ...i, ...r.headers },
    responseType: q,
    timeout: r.timeout,
    withCredentials: r.withCredentials
  });
  p.log(k.Trace, `(${t} transport) request complete. Response status: ${f.statusCode}.`);
}
function NB(p) {
  return p === void 0 ? new Sz(k.Information) : p === null ? Cb.instance : p.log !== void 0 ? p : new Sz(p);
}
class BB {
  constructor(t, e) {
    this._subject = t, this._observer = e;
  }
  dispose() {
    const t = this._subject.observers.indexOf(this._observer);
    t > -1 && this._subject.observers.splice(t, 1), this._subject.observers.length === 0 && this._subject.cancelCallback && this._subject.cancelCallback().catch((e) => {
    });
  }
}
class Sz {
  constructor(t) {
    this._minLevel = t, this.out = console;
  }
  log(t, e) {
    if (t >= this._minLevel) {
      const o = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${k[t]}: ${e}`;
      switch (t) {
        case k.Critical:
        case k.Error:
          this.out.error(o);
          break;
        case k.Warning:
          this.out.warn(o);
          break;
        case k.Information:
          this.out.info(o);
          break;
        default:
          this.out.log(o);
          break;
      }
    }
  }
}
function gM() {
  let p = "X-SignalR-User-Agent";
  return w1.isNode && (p = "User-Agent"), [p, TB(vB, wB(), DB(), SB())];
}
function TB(p, t, e, o) {
  let b = "Microsoft SignalR/";
  const r = p.split(".");
  return b += `${r[0]}.${r[1]}`, b += ` (${p}; `, t && t !== "" ? b += `${t}; ` : b += "Unknown OS; ", b += `${e}`, o ? b += `; ${o}` : b += "; Unknown Runtime Version", b += ")", b;
}
function wB() {
  if (w1.isNode)
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  else
    return "";
}
function SB() {
  if (w1.isNode)
    return process.versions.node;
}
function DB() {
  return w1.isNode ? "NodeJS" : "Browser";
}
function Sc(p) {
  return p.stack ? p.stack : p.message ? p.message : `${p}`;
}
function XB() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("could not find global");
}
class CB extends rr {
  constructor(t) {
    if (super(), this._logger = t, typeof fetch > "u" || w1.isNode) {
      const e = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._jar = new (e("tough-cookie")).CookieJar(), typeof fetch > "u" ? this._fetchType = e("node-fetch") : this._fetchType = fetch, this._fetchType = e("fetch-cookie")(this._fetchType, this._jar);
    } else
      this._fetchType = fetch.bind(XB());
    if (typeof AbortController > "u") {
      const e = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._abortControllerType = e("abort-controller");
    } else
      this._abortControllerType = AbortController;
  }
  /** @inheritDoc */
  async send(t) {
    if (t.abortSignal && t.abortSignal.aborted)
      throw new Mt();
    if (!t.method)
      throw new Error("No method defined.");
    if (!t.url)
      throw new Error("No url defined.");
    const e = new this._abortControllerType();
    let o;
    t.abortSignal && (t.abortSignal.onabort = () => {
      e.abort(), o = new Mt();
    });
    let b = null;
    if (t.timeout) {
      const d = t.timeout;
      b = setTimeout(() => {
        e.abort(), this._logger.log(k.Warning, "Timeout from HTTP request."), o = new Ha();
      }, d);
    }
    t.content === "" && (t.content = void 0), t.content && (t.headers = t.headers || {}, No(t.content) ? t.headers["Content-Type"] = "application/octet-stream" : t.headers["Content-Type"] = "text/plain;charset=UTF-8");
    let r;
    try {
      r = await this._fetchType(t.url, {
        body: t.content,
        cache: "no-cache",
        credentials: t.withCredentials === !0 ? "include" : "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...t.headers
        },
        method: t.method,
        mode: "cors",
        redirect: "follow",
        signal: e.signal
      });
    } catch (d) {
      throw o || (this._logger.log(k.Warning, `Error from HTTP request. ${d}.`), d);
    } finally {
      b && clearTimeout(b), t.abortSignal && (t.abortSignal.onabort = null);
    }
    if (!r.ok) {
      const d = await iA(r, "text");
      throw new fo(d || r.statusText, r.status);
    }
    const s = await iA(r, t.responseType);
    return new $l(r.status, r.statusText, s);
  }
  getCookieString(t) {
    let e = "";
    return w1.isNode && this._jar && this._jar.getCookies(t, (o, b) => e = b.join("; ")), e;
  }
}
function iA(p, t) {
  let e;
  switch (t) {
    case "arraybuffer":
      e = p.arrayBuffer();
      break;
    case "text":
      e = p.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${t} is not supported.`);
    default:
      e = p.text();
      break;
  }
  return e;
}
class IB extends rr {
  constructor(t) {
    super(), this._logger = t;
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new Mt()) : t.method ? t.url ? new Promise((e, o) => {
      const b = new XMLHttpRequest();
      b.open(t.method, t.url, !0), b.withCredentials = t.withCredentials === void 0 ? !0 : t.withCredentials, b.setRequestHeader("X-Requested-With", "XMLHttpRequest"), t.content === "" && (t.content = void 0), t.content && (No(t.content) ? b.setRequestHeader("Content-Type", "application/octet-stream") : b.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
      const r = t.headers;
      r && Object.keys(r).forEach((i) => {
        b.setRequestHeader(i, r[i]);
      }), t.responseType && (b.responseType = t.responseType), t.abortSignal && (t.abortSignal.onabort = () => {
        b.abort(), o(new Mt());
      }), t.timeout && (b.timeout = t.timeout), b.onload = () => {
        t.abortSignal && (t.abortSignal.onabort = null), b.status >= 200 && b.status < 300 ? e(new $l(b.status, b.statusText, b.response || b.responseText)) : o(new fo(b.response || b.responseText || b.statusText, b.status));
      }, b.onerror = () => {
        this._logger.log(k.Warning, `Error from HTTP request. ${b.status}: ${b.statusText}.`), o(new fo(b.statusText, b.status));
      }, b.ontimeout = () => {
        this._logger.log(k.Warning, "Timeout from HTTP request."), o(new Ha());
      }, b.send(t.content);
    }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
}
class PB extends rr {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(t) {
    if (super(), typeof fetch < "u" || w1.isNode)
      this._httpClient = new CB(t);
    else if (typeof XMLHttpRequest < "u")
      this._httpClient = new IB(t);
    else
      throw new Error("No usable HttpClient found.");
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new Mt()) : t.method ? t.url ? this._httpClient.send(t) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
  getCookieString(t) {
    return this._httpClient.getCookieString(t);
  }
}
class z2 {
  static write(t) {
    return `${t}${z2.RecordSeparator}`;
  }
  static parse(t) {
    if (t[t.length - 1] !== z2.RecordSeparator)
      throw new Error("Message is incomplete.");
    const e = t.split(z2.RecordSeparator);
    return e.pop(), e;
  }
}
z2.RecordSeparatorCode = 30;
z2.RecordSeparator = String.fromCharCode(z2.RecordSeparatorCode);
class EB {
  // Handshake request is always JSON
  writeHandshakeRequest(t) {
    return z2.write(JSON.stringify(t));
  }
  parseHandshakeResponse(t) {
    let e, o;
    if (No(t)) {
      const s = new Uint8Array(t), d = s.indexOf(z2.RecordSeparatorCode);
      if (d === -1)
        throw new Error("Message is incomplete.");
      const q = d + 1;
      e = String.fromCharCode.apply(null, Array.prototype.slice.call(s.slice(0, q))), o = s.byteLength > q ? s.slice(q).buffer : null;
    } else {
      const s = t, d = s.indexOf(z2.RecordSeparator);
      if (d === -1)
        throw new Error("Message is incomplete.");
      const q = d + 1;
      e = s.substring(0, q), o = s.length > q ? s.substring(q) : null;
    }
    const b = z2.parse(e), r = JSON.parse(b[0]);
    if (r.type)
      throw new Error("Expected a handshake response from the server.");
    return [o, r];
  }
}
var T0;
(function(p) {
  p[p.Invocation = 1] = "Invocation", p[p.StreamItem = 2] = "StreamItem", p[p.Completion = 3] = "Completion", p[p.StreamInvocation = 4] = "StreamInvocation", p[p.CancelInvocation = 5] = "CancelInvocation", p[p.Ping = 6] = "Ping", p[p.Close = 7] = "Close", p[p.Ack = 8] = "Ack", p[p.Sequence = 9] = "Sequence";
})(T0 || (T0 = {}));
class kB {
  constructor() {
    this.observers = [];
  }
  next(t) {
    for (const e of this.observers)
      e.next(t);
  }
  error(t) {
    for (const e of this.observers)
      e.error && e.error(t);
  }
  complete() {
    for (const t of this.observers)
      t.complete && t.complete();
  }
  subscribe(t) {
    return this.observers.push(t), new BB(this, t);
  }
}
class xB {
  constructor(t, e, o) {
    this._bufferSize = 1e5, this._messages = [], this._totalMessageCount = 0, this._waitForSequenceMessage = !1, this._nextReceivingSequenceId = 1, this._latestReceivedSequenceId = 0, this._bufferedByteCount = 0, this._reconnectInProgress = !1, this._protocol = t, this._connection = e, this._bufferSize = o;
  }
  async _send(t) {
    const e = this._protocol.writeMessage(t);
    let o = Promise.resolve();
    if (this._isInvocationMessage(t)) {
      this._totalMessageCount++;
      let b = () => {
      }, r = () => {
      };
      No(e) ? this._bufferedByteCount += e.byteLength : this._bufferedByteCount += e.length, this._bufferedByteCount >= this._bufferSize && (o = new Promise((i, s) => {
        b = i, r = s;
      })), this._messages.push(new FB(e, this._totalMessageCount, b, r));
    }
    try {
      this._reconnectInProgress || await this._connection.send(e);
    } catch {
      this._disconnected();
    }
    await o;
  }
  _ack(t) {
    let e = -1;
    for (let o = 0; o < this._messages.length; o++) {
      const b = this._messages[o];
      if (b._id <= t.sequenceId)
        e = o, No(b._message) ? this._bufferedByteCount -= b._message.byteLength : this._bufferedByteCount -= b._message.length, b._resolver();
      else if (this._bufferedByteCount < this._bufferSize)
        b._resolver();
      else
        break;
    }
    e !== -1 && (this._messages = this._messages.slice(e + 1));
  }
  _shouldProcessMessage(t) {
    if (this._waitForSequenceMessage)
      return t.type !== T0.Sequence ? !1 : (this._waitForSequenceMessage = !1, !0);
    if (!this._isInvocationMessage(t))
      return !0;
    const e = this._nextReceivingSequenceId;
    return this._nextReceivingSequenceId++, e <= this._latestReceivedSequenceId ? (e === this._latestReceivedSequenceId && this._ackTimer(), !1) : (this._latestReceivedSequenceId = e, this._ackTimer(), !0);
  }
  _resetSequence(t) {
    if (t.sequenceId > this._nextReceivingSequenceId) {
      this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
      return;
    }
    this._nextReceivingSequenceId = t.sequenceId;
  }
  _disconnected() {
    this._reconnectInProgress = !0, this._waitForSequenceMessage = !0;
  }
  async _resend() {
    const t = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
    await this._connection.send(this._protocol.writeMessage({ type: T0.Sequence, sequenceId: t }));
    const e = this._messages;
    for (const o of e)
      await this._connection.send(o._message);
    this._reconnectInProgress = !1;
  }
  _dispose(t) {
    t ?? (t = new Error("Unable to reconnect to server."));
    for (const e of this._messages)
      e._rejector(t);
  }
  _isInvocationMessage(t) {
    switch (t.type) {
      case T0.Invocation:
      case T0.StreamItem:
      case T0.Completion:
      case T0.StreamInvocation:
      case T0.CancelInvocation:
        return !0;
      case T0.Close:
      case T0.Sequence:
      case T0.Ping:
      case T0.Ack:
        return !1;
    }
  }
  _ackTimer() {
    this._ackTimerHandle === void 0 && (this._ackTimerHandle = setTimeout(async () => {
      try {
        this._reconnectInProgress || await this._connection.send(this._protocol.writeMessage({ type: T0.Ack, sequenceId: this._latestReceivedSequenceId }));
      } catch {
      }
      clearTimeout(this._ackTimerHandle), this._ackTimerHandle = void 0;
    }, 1e3));
  }
}
class FB {
  constructor(t, e, o, b) {
    this._message = t, this._id = e, this._resolver = o, this._rejector = b;
  }
}
const UB = 30 * 1e3, HB = 15 * 1e3, JB = 1e5;
var C0;
(function(p) {
  p.Disconnected = "Disconnected", p.Connecting = "Connecting", p.Connected = "Connected", p.Disconnecting = "Disconnecting", p.Reconnecting = "Reconnecting";
})(C0 || (C0 = {}));
class Ja {
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(t, e, o, b, r, i, s) {
    return new Ja(t, e, o, b, r, i, s);
  }
  constructor(t, e, o, b, r, i, s) {
    this._nextKeepAlive = 0, this._freezeEventListener = () => {
      this._logger.log(k.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    }, j1.isRequired(t, "connection"), j1.isRequired(e, "logger"), j1.isRequired(o, "protocol"), this.serverTimeoutInMilliseconds = r ?? UB, this.keepAliveIntervalInMilliseconds = i ?? HB, this._statefulReconnectBufferSize = s ?? JB, this._logger = e, this._protocol = o, this.connection = t, this._reconnectPolicy = b, this._handshakeProtocol = new EB(), this.connection.onreceive = (d) => this._processIncomingData(d), this.connection.onclose = (d) => this._connectionClosed(d), this._callbacks = {}, this._methods = {}, this._closedCallbacks = [], this._reconnectingCallbacks = [], this._reconnectedCallbacks = [], this._invocationId = 0, this._receivedHandshakeResponse = !1, this._connectionState = C0.Disconnected, this._connectionStarted = !1, this._cachedPingMessage = this._protocol.writeMessage({ type: T0.Ping });
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection && this.connection.connectionId || null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(t) {
    if (this._connectionState !== C0.Disconnected && this._connectionState !== C0.Reconnecting)
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    if (!t)
      throw new Error("The HubConnection url must be a valid url.");
    this.connection.baseUrl = t;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    return this._startPromise = this._startWithStateTransitions(), this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== C0.Disconnected)
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    this._connectionState = C0.Connecting, this._logger.log(k.Debug, "Starting HubConnection.");
    try {
      await this._startInternal(), w1.isBrowser && window.document.addEventListener("freeze", this._freezeEventListener), this._connectionState = C0.Connected, this._connectionStarted = !0, this._logger.log(k.Debug, "HubConnection connected successfully.");
    } catch (t) {
      return this._connectionState = C0.Disconnected, this._logger.log(k.Debug, `HubConnection failed to start successfully because of error '${t}'.`), Promise.reject(t);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0, this._receivedHandshakeResponse = !1;
    const t = new Promise((e, o) => {
      this._handshakeResolver = e, this._handshakeRejecter = o;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      let e = this._protocol.version;
      this.connection.features.reconnect || (e = 1);
      const o = {
        protocol: this._protocol.name,
        version: e
      };
      if (this._logger.log(k.Debug, "Sending handshake request."), await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(o)), this._logger.log(k.Information, `Using HubProtocol '${this._protocol.name}'.`), this._cleanupTimeout(), this._resetTimeoutPeriod(), this._resetKeepAliveInterval(), await t, this._stopDuringStartError)
        throw this._stopDuringStartError;
      (this.connection.features.reconnect || !1) && (this._messageBuffer = new xB(this._protocol, this.connection, this._statefulReconnectBufferSize), this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer), this.connection.features.resend = () => {
        if (this._messageBuffer)
          return this._messageBuffer._resend();
      }), this.connection.features.inherentKeepAlive || await this._sendMessage(this._cachedPingMessage);
    } catch (e) {
      throw this._logger.log(k.Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`), this._cleanupTimeout(), this._cleanupPingTimer(), await this.connection.stop(e), e;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const t = this._startPromise;
    this.connection.features.reconnect = !1, this._stopPromise = this._stopInternal(), await this._stopPromise;
    try {
      await t;
    } catch {
    }
  }
  _stopInternal(t) {
    if (this._connectionState === C0.Disconnected)
      return this._logger.log(k.Debug, `Call to HubConnection.stop(${t}) ignored because it is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === C0.Disconnecting)
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    const e = this._connectionState;
    return this._connectionState = C0.Disconnecting, this._logger.log(k.Debug, "Stopping HubConnection."), this._reconnectDelayHandle ? (this._logger.log(k.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this._reconnectDelayHandle), this._reconnectDelayHandle = void 0, this._completeClose(), Promise.resolve()) : (e === C0.Connected && this._sendCloseMessage(), this._cleanupTimeout(), this._cleanupPingTimer(), this._stopDuringStartError = t || new Mt("The connection was stopped before the hub handshake could complete."), this.connection.stop(t));
  }
  async _sendCloseMessage() {
    try {
      await this._sendWithProtocol(this._createCloseMessage());
    } catch {
    }
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(t, ...e) {
    const [o, b] = this._replaceStreamingParams(e), r = this._createStreamInvocation(t, e, b);
    let i;
    const s = new kB();
    return s.cancelCallback = () => {
      const d = this._createCancelInvocation(r.invocationId);
      return delete this._callbacks[r.invocationId], i.then(() => this._sendWithProtocol(d));
    }, this._callbacks[r.invocationId] = (d, q) => {
      if (q) {
        s.error(q);
        return;
      } else d && (d.type === T0.Completion ? d.error ? s.error(new Error(d.error)) : s.complete() : s.next(d.item));
    }, i = this._sendWithProtocol(r).catch((d) => {
      s.error(d), delete this._callbacks[r.invocationId];
    }), this._launchStreams(o, i), s;
  }
  _sendMessage(t) {
    return this._resetKeepAliveInterval(), this.connection.send(t);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(t) {
    return this._messageBuffer ? this._messageBuffer._send(t) : this._sendMessage(this._protocol.writeMessage(t));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(t, ...e) {
    const [o, b] = this._replaceStreamingParams(e), r = this._sendWithProtocol(this._createInvocation(t, e, !0, b));
    return this._launchStreams(o, r), r;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(t, ...e) {
    const [o, b] = this._replaceStreamingParams(e), r = this._createInvocation(t, e, !1, b);
    return new Promise((s, d) => {
      this._callbacks[r.invocationId] = (f, h) => {
        if (h) {
          d(h);
          return;
        } else f && (f.type === T0.Completion ? f.error ? d(new Error(f.error)) : s(f.result) : d(new Error(`Unexpected message type: ${f.type}`)));
      };
      const q = this._sendWithProtocol(r).catch((f) => {
        d(f), delete this._callbacks[r.invocationId];
      });
      this._launchStreams(o, q);
    });
  }
  on(t, e) {
    !t || !e || (t = t.toLowerCase(), this._methods[t] || (this._methods[t] = []), this._methods[t].indexOf(e) === -1 && this._methods[t].push(e));
  }
  off(t, e) {
    if (!t)
      return;
    t = t.toLowerCase();
    const o = this._methods[t];
    if (o)
      if (e) {
        const b = o.indexOf(e);
        b !== -1 && (o.splice(b, 1), o.length === 0 && delete this._methods[t]);
      } else
        delete this._methods[t];
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(t) {
    t && this._closedCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(t) {
    t && this._reconnectingCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(t) {
    t && this._reconnectedCallbacks.push(t);
  }
  _processIncomingData(t) {
    if (this._cleanupTimeout(), this._receivedHandshakeResponse || (t = this._processHandshakeResponse(t), this._receivedHandshakeResponse = !0), t) {
      const e = this._protocol.parseMessages(t, this._logger);
      for (const o of e)
        if (!(this._messageBuffer && !this._messageBuffer._shouldProcessMessage(o)))
          switch (o.type) {
            case T0.Invocation:
              this._invokeClientMethod(o).catch((b) => {
                this._logger.log(k.Error, `Invoke client method threw error: ${Sc(b)}`);
              });
              break;
            case T0.StreamItem:
            case T0.Completion: {
              const b = this._callbacks[o.invocationId];
              if (b) {
                o.type === T0.Completion && delete this._callbacks[o.invocationId];
                try {
                  b(o);
                } catch (r) {
                  this._logger.log(k.Error, `Stream callback threw error: ${Sc(r)}`);
                }
              }
              break;
            }
            case T0.Ping:
              break;
            case T0.Close: {
              this._logger.log(k.Information, "Close message received from server.");
              const b = o.error ? new Error("Server returned an error on close: " + o.error) : void 0;
              o.allowReconnect === !0 ? this.connection.stop(b) : this._stopPromise = this._stopInternal(b);
              break;
            }
            case T0.Ack:
              this._messageBuffer && this._messageBuffer._ack(o);
              break;
            case T0.Sequence:
              this._messageBuffer && this._messageBuffer._resetSequence(o);
              break;
            default:
              this._logger.log(k.Warning, `Invalid message type: ${o.type}.`);
              break;
          }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(t) {
    let e, o;
    try {
      [o, e] = this._handshakeProtocol.parseHandshakeResponse(t);
    } catch (b) {
      const r = "Error parsing handshake response: " + b;
      this._logger.log(k.Error, r);
      const i = new Error(r);
      throw this._handshakeRejecter(i), i;
    }
    if (e.error) {
      const b = "Server returned handshake error: " + e.error;
      this._logger.log(k.Error, b);
      const r = new Error(b);
      throw this._handshakeRejecter(r), r;
    } else
      this._logger.log(k.Debug, "Server handshake complete.");
    return this._handshakeResolver(), o;
  }
  _resetKeepAliveInterval() {
    this.connection.features.inherentKeepAlive || (this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this._cleanupPingTimer());
  }
  _resetTimeoutPeriod() {
    if ((!this.connection.features || !this.connection.features.inherentKeepAlive) && (this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this._pingServerHandle === void 0)) {
      let t = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
      t < 0 && (t = 0), this._pingServerHandle = setTimeout(async () => {
        if (this._connectionState === C0.Connected)
          try {
            await this._sendMessage(this._cachedPingMessage);
          } catch {
            this._cleanupPingTimer();
          }
      }, t);
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  async _invokeClientMethod(t) {
    const e = t.target.toLowerCase(), o = this._methods[e];
    if (!o) {
      this._logger.log(k.Warning, `No client method with the name '${e}' found.`), t.invocationId && (this._logger.log(k.Warning, `No result given for '${e}' method and invocation ID '${t.invocationId}'.`), await this._sendWithProtocol(this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)));
      return;
    }
    const b = o.slice(), r = !!t.invocationId;
    let i, s, d;
    for (const q of b)
      try {
        const f = i;
        i = await q.apply(this, t.arguments), r && i && f && (this._logger.log(k.Error, `Multiple results provided for '${e}'. Sending error to server.`), d = this._createCompletionMessage(t.invocationId, "Client provided multiple results.", null)), s = void 0;
      } catch (f) {
        s = f, this._logger.log(k.Error, `A callback for the method '${e}' threw error '${f}'.`);
      }
    d ? await this._sendWithProtocol(d) : r ? (s ? d = this._createCompletionMessage(t.invocationId, `${s}`, null) : i !== void 0 ? d = this._createCompletionMessage(t.invocationId, null, i) : (this._logger.log(k.Warning, `No result given for '${e}' method and invocation ID '${t.invocationId}'.`), d = this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)), await this._sendWithProtocol(d)) : i && this._logger.log(k.Error, `Result given for '${e}' method but server is not expecting a result.`);
  }
  _connectionClosed(t) {
    this._logger.log(k.Debug, `HubConnection.connectionClosed(${t}) called while in state ${this._connectionState}.`), this._stopDuringStartError = this._stopDuringStartError || t || new Mt("The underlying connection was closed before the hub handshake could complete."), this._handshakeResolver && this._handshakeResolver(), this._cancelCallbacksWithError(t || new Error("Invocation canceled due to the underlying connection being closed.")), this._cleanupTimeout(), this._cleanupPingTimer(), this._connectionState === C0.Disconnecting ? this._completeClose(t) : this._connectionState === C0.Connected && this._reconnectPolicy ? this._reconnect(t) : this._connectionState === C0.Connected && this._completeClose(t);
  }
  _completeClose(t) {
    if (this._connectionStarted) {
      this._connectionState = C0.Disconnected, this._connectionStarted = !1, this._messageBuffer && (this._messageBuffer._dispose(t ?? new Error("Connection closed.")), this._messageBuffer = void 0), w1.isBrowser && window.document.removeEventListener("freeze", this._freezeEventListener);
      try {
        this._closedCallbacks.forEach((e) => e.apply(this, [t]));
      } catch (e) {
        this._logger.log(k.Error, `An onclose callback called with error '${t}' threw error '${e}'.`);
      }
    }
  }
  async _reconnect(t) {
    const e = Date.now();
    let o = 0, b = t !== void 0 ? t : new Error("Attempting to reconnect due to a unknown error."), r = this._getNextRetryDelay(o++, 0, b);
    if (r === null) {
      this._logger.log(k.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), this._completeClose(t);
      return;
    }
    if (this._connectionState = C0.Reconnecting, t ? this._logger.log(k.Information, `Connection reconnecting because of error '${t}'.`) : this._logger.log(k.Information, "Connection reconnecting."), this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((i) => i.apply(this, [t]));
      } catch (i) {
        this._logger.log(k.Error, `An onreconnecting callback called with error '${t}' threw error '${i}'.`);
      }
      if (this._connectionState !== C0.Reconnecting) {
        this._logger.log(k.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    for (; r !== null; ) {
      if (this._logger.log(k.Information, `Reconnect attempt number ${o} will start in ${r} ms.`), await new Promise((i) => {
        this._reconnectDelayHandle = setTimeout(i, r);
      }), this._reconnectDelayHandle = void 0, this._connectionState !== C0.Reconnecting) {
        this._logger.log(k.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        if (await this._startInternal(), this._connectionState = C0.Connected, this._logger.log(k.Information, "HubConnection reconnected successfully."), this._reconnectedCallbacks.length !== 0)
          try {
            this._reconnectedCallbacks.forEach((i) => i.apply(this, [this.connection.connectionId]));
          } catch (i) {
            this._logger.log(k.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${i}'.`);
          }
        return;
      } catch (i) {
        if (this._logger.log(k.Information, `Reconnect attempt failed because of error '${i}'.`), this._connectionState !== C0.Reconnecting) {
          this._logger.log(k.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`), this._connectionState === C0.Disconnecting && this._completeClose();
          return;
        }
        b = i instanceof Error ? i : new Error(i.toString()), r = this._getNextRetryDelay(o++, Date.now() - e, b);
      }
    }
    this._logger.log(k.Information, `Reconnect retries have been exhausted after ${Date.now() - e} ms and ${o} failed attempts. Connection disconnecting.`), this._completeClose();
  }
  _getNextRetryDelay(t, e, o) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds: e,
        previousRetryCount: t,
        retryReason: o
      });
    } catch (b) {
      return this._logger.log(k.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${t}, ${e}) threw error '${b}'.`), null;
    }
  }
  _cancelCallbacksWithError(t) {
    const e = this._callbacks;
    this._callbacks = {}, Object.keys(e).forEach((o) => {
      const b = e[o];
      try {
        b(null, t);
      } catch (r) {
        this._logger.log(k.Error, `Stream 'error' callback called with '${t}' threw error: ${Sc(r)}`);
      }
    });
  }
  _cleanupPingTimer() {
    this._pingServerHandle && (clearTimeout(this._pingServerHandle), this._pingServerHandle = void 0);
  }
  _cleanupTimeout() {
    this._timeoutHandle && clearTimeout(this._timeoutHandle);
  }
  _createInvocation(t, e, o, b) {
    if (o)
      return b.length !== 0 ? {
        arguments: e,
        streamIds: b,
        target: t,
        type: T0.Invocation
      } : {
        arguments: e,
        target: t,
        type: T0.Invocation
      };
    {
      const r = this._invocationId;
      return this._invocationId++, b.length !== 0 ? {
        arguments: e,
        invocationId: r.toString(),
        streamIds: b,
        target: t,
        type: T0.Invocation
      } : {
        arguments: e,
        invocationId: r.toString(),
        target: t,
        type: T0.Invocation
      };
    }
  }
  _launchStreams(t, e) {
    if (t.length !== 0) {
      e || (e = Promise.resolve());
      for (const o in t)
        t[o].subscribe({
          complete: () => {
            e = e.then(() => this._sendWithProtocol(this._createCompletionMessage(o)));
          },
          error: (b) => {
            let r;
            b instanceof Error ? r = b.message : b && b.toString ? r = b.toString() : r = "Unknown error", e = e.then(() => this._sendWithProtocol(this._createCompletionMessage(o, r)));
          },
          next: (b) => {
            e = e.then(() => this._sendWithProtocol(this._createStreamItemMessage(o, b)));
          }
        });
    }
  }
  _replaceStreamingParams(t) {
    const e = [], o = [];
    for (let b = 0; b < t.length; b++) {
      const r = t[b];
      if (this._isObservable(r)) {
        const i = this._invocationId;
        this._invocationId++, e[i] = r, o.push(i.toString()), t.splice(b, 1);
      }
    }
    return [e, o];
  }
  _isObservable(t) {
    return t && t.subscribe && typeof t.subscribe == "function";
  }
  _createStreamInvocation(t, e, o) {
    const b = this._invocationId;
    return this._invocationId++, o.length !== 0 ? {
      arguments: e,
      invocationId: b.toString(),
      streamIds: o,
      target: t,
      type: T0.StreamInvocation
    } : {
      arguments: e,
      invocationId: b.toString(),
      target: t,
      type: T0.StreamInvocation
    };
  }
  _createCancelInvocation(t) {
    return {
      invocationId: t,
      type: T0.CancelInvocation
    };
  }
  _createStreamItemMessage(t, e) {
    return {
      invocationId: t,
      item: e,
      type: T0.StreamItem
    };
  }
  _createCompletionMessage(t, e, o) {
    return e ? {
      error: e,
      invocationId: t,
      type: T0.Completion
    } : {
      invocationId: t,
      result: o,
      type: T0.Completion
    };
  }
  _createCloseMessage() {
    return { type: T0.Close };
  }
}
const $B = [0, 2e3, 1e4, 3e4, null];
class aA {
  constructor(t) {
    this._retryDelays = t !== void 0 ? [...t, null] : $B;
  }
  nextRetryDelayInMilliseconds(t) {
    return this._retryDelays[t.previousRetryCount];
  }
}
class Wo {
}
Wo.Authorization = "Authorization";
Wo.Cookie = "Cookie";
class VB extends rr {
  constructor(t, e) {
    super(), this._innerClient = t, this._accessTokenFactory = e;
  }
  async send(t) {
    let e = !0;
    this._accessTokenFactory && (!this._accessToken || t.url && t.url.indexOf("/negotiate?") > 0) && (e = !1, this._accessToken = await this._accessTokenFactory()), this._setAuthorizationHeader(t);
    const o = await this._innerClient.send(t);
    return e && o.statusCode === 401 && this._accessTokenFactory ? (this._accessToken = await this._accessTokenFactory(), this._setAuthorizationHeader(t), await this._innerClient.send(t)) : o;
  }
  _setAuthorizationHeader(t) {
    t.headers || (t.headers = {}), this._accessToken ? t.headers[Wo.Authorization] = `Bearer ${this._accessToken}` : this._accessTokenFactory && t.headers[Wo.Authorization] && delete t.headers[Wo.Authorization];
  }
  getCookieString(t) {
    return this._innerClient.getCookieString(t);
  }
}
var Q1;
(function(p) {
  p[p.None = 0] = "None", p[p.WebSockets = 1] = "WebSockets", p[p.ServerSentEvents = 2] = "ServerSentEvents", p[p.LongPolling = 4] = "LongPolling";
})(Q1 || (Q1 = {}));
var me;
(function(p) {
  p[p.Text = 1] = "Text", p[p.Binary = 2] = "Binary";
})(me || (me = {}));
let YB = class {
  constructor() {
    this._isAborted = !1, this.onabort = null;
  }
  abort() {
    this._isAborted || (this._isAborted = !0, this.onabort && this.onabort());
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
};
class OA {
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  constructor(t, e, o) {
    this._httpClient = t, this._logger = e, this._pollAbort = new YB(), this._options = o, this._running = !1, this.onreceive = null, this.onclose = null;
  }
  async connect(t, e) {
    if (j1.isRequired(t, "url"), j1.isRequired(e, "transferFormat"), j1.isIn(e, me, "transferFormat"), this._url = t, this._logger.log(k.Trace, "(LongPolling transport) Connecting."), e === me.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string")
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    const [o, b] = gM(), r = { [o]: b, ...this._options.headers }, i = {
      abortSignal: this._pollAbort.signal,
      headers: r,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    e === me.Binary && (i.responseType = "arraybuffer");
    const s = `${t}&_=${Date.now()}`;
    this._logger.log(k.Trace, `(LongPolling transport) polling: ${s}.`);
    const d = await this._httpClient.get(s, i);
    d.statusCode !== 200 ? (this._logger.log(k.Error, `(LongPolling transport) Unexpected response code: ${d.statusCode}.`), this._closeError = new fo(d.statusText || "", d.statusCode), this._running = !1) : this._running = !0, this._receiving = this._poll(this._url, i);
  }
  async _poll(t, e) {
    try {
      for (; this._running; )
        try {
          const o = `${t}&_=${Date.now()}`;
          this._logger.log(k.Trace, `(LongPolling transport) polling: ${o}.`);
          const b = await this._httpClient.get(o, e);
          b.statusCode === 204 ? (this._logger.log(k.Information, "(LongPolling transport) Poll terminated by server."), this._running = !1) : b.statusCode !== 200 ? (this._logger.log(k.Error, `(LongPolling transport) Unexpected response code: ${b.statusCode}.`), this._closeError = new fo(b.statusText || "", b.statusCode), this._running = !1) : b.content ? (this._logger.log(k.Trace, `(LongPolling transport) data received. ${Ib(b.content, this._options.logMessageContent)}.`), this.onreceive && this.onreceive(b.content)) : this._logger.log(k.Trace, "(LongPolling transport) Poll timed out, reissuing.");
        } catch (o) {
          this._running ? o instanceof Ha ? this._logger.log(k.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this._closeError = o, this._running = !1) : this._logger.log(k.Trace, `(LongPolling transport) Poll errored after shutdown: ${o.message}`);
        }
    } finally {
      this._logger.log(k.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this._raiseOnClose();
    }
  }
  async send(t) {
    return this._running ? Vl(this._logger, "LongPolling", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  async stop() {
    this._logger.log(k.Trace, "(LongPolling transport) Stopping polling."), this._running = !1, this._pollAbort.abort();
    try {
      await this._receiving, this._logger.log(k.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const t = {}, [e, o] = gM();
      t[e] = o;
      const b = {
        headers: { ...t, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      let r;
      try {
        await this._httpClient.delete(this._url, b);
      } catch (i) {
        r = i;
      }
      r ? r instanceof fo && (r.statusCode === 404 ? this._logger.log(k.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this._logger.log(k.Trace, `(LongPolling transport) Error sending a DELETE request: ${r}`)) : this._logger.log(k.Trace, "(LongPolling transport) DELETE request accepted.");
    } finally {
      this._logger.log(k.Trace, "(LongPolling transport) Stop finished."), this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let t = "(LongPolling transport) Firing onclose event.";
      this._closeError && (t += " Error: " + this._closeError), this._logger.log(k.Trace, t), this.onclose(this._closeError);
    }
  }
}
class GB {
  constructor(t, e, o, b) {
    this._httpClient = t, this._accessToken = e, this._logger = o, this._options = b, this.onreceive = null, this.onclose = null;
  }
  async connect(t, e) {
    return j1.isRequired(t, "url"), j1.isRequired(e, "transferFormat"), j1.isIn(e, me, "transferFormat"), this._logger.log(k.Trace, "(SSE transport) Connecting."), this._url = t, this._accessToken && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`), new Promise((o, b) => {
      let r = !1;
      if (e !== me.Text) {
        b(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let i;
      if (w1.isBrowser || w1.isWebWorker)
        i = new this._options.EventSource(t, { withCredentials: this._options.withCredentials });
      else {
        const s = this._httpClient.getCookieString(t), d = {};
        d.Cookie = s;
        const [q, f] = gM();
        d[q] = f, i = new this._options.EventSource(t, { withCredentials: this._options.withCredentials, headers: { ...d, ...this._options.headers } });
      }
      try {
        i.onmessage = (s) => {
          if (this.onreceive)
            try {
              this._logger.log(k.Trace, `(SSE transport) data received. ${Ib(s.data, this._options.logMessageContent)}.`), this.onreceive(s.data);
            } catch (d) {
              this._close(d);
              return;
            }
        }, i.onerror = (s) => {
          r ? this._close() : b(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
        }, i.onopen = () => {
          this._logger.log(k.Information, `SSE connected to ${this._url}`), this._eventSource = i, r = !0, o();
        };
      } catch (s) {
        b(s);
        return;
      }
    });
  }
  async send(t) {
    return this._eventSource ? Vl(this._logger, "SSE", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  stop() {
    return this._close(), Promise.resolve();
  }
  _close(t) {
    this._eventSource && (this._eventSource.close(), this._eventSource = void 0, this.onclose && this.onclose(t));
  }
}
class KB {
  constructor(t, e, o, b, r, i) {
    this._logger = o, this._accessTokenFactory = e, this._logMessageContent = b, this._webSocketConstructor = r, this._httpClient = t, this.onreceive = null, this.onclose = null, this._headers = i;
  }
  async connect(t, e) {
    j1.isRequired(t, "url"), j1.isRequired(e, "transferFormat"), j1.isIn(e, me, "transferFormat"), this._logger.log(k.Trace, "(WebSockets transport) Connecting.");
    let o;
    return this._accessTokenFactory && (o = await this._accessTokenFactory()), new Promise((b, r) => {
      t = t.replace(/^http/, "ws");
      let i;
      const s = this._httpClient.getCookieString(t);
      let d = !1;
      if (w1.isNode || w1.isReactNative) {
        const q = {}, [f, h] = gM();
        q[f] = h, o && (q[Wo.Authorization] = `Bearer ${o}`), s && (q[Wo.Cookie] = s), i = new this._webSocketConstructor(t, void 0, {
          headers: { ...q, ...this._headers }
        });
      } else
        o && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(o)}`);
      i || (i = new this._webSocketConstructor(t)), e === me.Binary && (i.binaryType = "arraybuffer"), i.onopen = (q) => {
        this._logger.log(k.Information, `WebSocket connected to ${t}.`), this._webSocket = i, d = !0, b();
      }, i.onerror = (q) => {
        let f = null;
        typeof ErrorEvent < "u" && q instanceof ErrorEvent ? f = q.error : f = "There was an error with the transport", this._logger.log(k.Information, `(WebSockets transport) ${f}.`);
      }, i.onmessage = (q) => {
        if (this._logger.log(k.Trace, `(WebSockets transport) data received. ${Ib(q.data, this._logMessageContent)}.`), this.onreceive)
          try {
            this.onreceive(q.data);
          } catch (f) {
            this._close(f);
            return;
          }
      }, i.onclose = (q) => {
        if (d)
          this._close(q);
        else {
          let f = null;
          typeof ErrorEvent < "u" && q instanceof ErrorEvent ? f = q.error : f = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", r(new Error(f));
        }
      };
    });
  }
  send(t) {
    return this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN ? (this._logger.log(k.Trace, `(WebSockets transport) sending data. ${Ib(t, this._logMessageContent)}.`), this._webSocket.send(t), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    return this._webSocket && this._close(void 0), Promise.resolve();
  }
  _close(t) {
    this._webSocket && (this._webSocket.onclose = () => {
    }, this._webSocket.onmessage = () => {
    }, this._webSocket.onerror = () => {
    }, this._webSocket.close(), this._webSocket = void 0), this._logger.log(k.Trace, "(WebSockets transport) socket closed."), this.onclose && (this._isCloseEvent(t) && (t.wasClean === !1 || t.code !== 1e3) ? this.onclose(new Error(`WebSocket closed with status code: ${t.code} (${t.reason || "no reason given"}).`)) : t instanceof Error ? this.onclose(t) : this.onclose());
  }
  _isCloseEvent(t) {
    return t && typeof t.wasClean == "boolean" && typeof t.code == "number";
  }
}
const sA = 100;
class QB {
  constructor(t, e = {}) {
    if (this._stopPromiseResolver = () => {
    }, this.features = {}, this._negotiateVersion = 1, j1.isRequired(t, "url"), this._logger = NB(e.logger), this.baseUrl = this._resolveUrl(t), e = e || {}, e.logMessageContent = e.logMessageContent === void 0 ? !1 : e.logMessageContent, typeof e.withCredentials == "boolean" || e.withCredentials === void 0)
      e.withCredentials = e.withCredentials === void 0 ? !0 : e.withCredentials;
    else
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    e.timeout = e.timeout === void 0 ? 100 * 1e3 : e.timeout;
    let o = null, b = null;
    if (w1.isNode && typeof require < "u") {
      const r = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      o = r("ws"), b = r("eventsource");
    }
    !w1.isNode && typeof WebSocket < "u" && !e.WebSocket ? e.WebSocket = WebSocket : w1.isNode && !e.WebSocket && o && (e.WebSocket = o), !w1.isNode && typeof EventSource < "u" && !e.EventSource ? e.EventSource = EventSource : w1.isNode && !e.EventSource && typeof b < "u" && (e.EventSource = b), this._httpClient = new VB(e.httpClient || new PB(this._logger), e.accessTokenFactory), this._connectionState = "Disconnected", this._connectionStarted = !1, this._options = e, this.onreceive = null, this.onclose = null;
  }
  async start(t) {
    if (t = t || me.Binary, j1.isIn(t, me, "transferFormat"), this._logger.log(k.Debug, `Starting connection with transfer format '${me[t]}'.`), this._connectionState !== "Disconnected")
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    if (this._connectionState = "Connecting", this._startInternalPromise = this._startInternal(t), await this._startInternalPromise, this._connectionState === "Disconnecting") {
      const e = "Failed to start the HttpConnection before stop() was called.";
      return this._logger.log(k.Error, e), await this._stopPromise, Promise.reject(new Mt(e));
    } else if (this._connectionState !== "Connected") {
      const e = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      return this._logger.log(k.Error, e), Promise.reject(new Mt(e));
    }
    this._connectionStarted = !0;
  }
  send(t) {
    return this._connectionState !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this._sendQueue || (this._sendQueue = new $a(this.transport)), this._sendQueue.send(t));
  }
  async stop(t) {
    if (this._connectionState === "Disconnected")
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === "Disconnecting")
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    this._connectionState = "Disconnecting", this._stopPromise = new Promise((e) => {
      this._stopPromiseResolver = e;
    }), await this._stopInternal(t), await this._stopPromise;
  }
  async _stopInternal(t) {
    this._stopError = t;
    try {
      await this._startInternalPromise;
    } catch {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (e) {
        this._logger.log(k.Error, `HttpConnection.transport.stop() threw error '${e}'.`), this._stopConnection();
      }
      this.transport = void 0;
    } else
      this._logger.log(k.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
  }
  async _startInternal(t) {
    let e = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory, this._httpClient._accessTokenFactory = this._accessTokenFactory;
    try {
      if (this._options.skipNegotiation)
        if (this._options.transport === Q1.WebSockets)
          this.transport = this._constructTransport(Q1.WebSockets), await this._startTransport(e, t);
        else
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
      else {
        let o = null, b = 0;
        do {
          if (o = await this._getNegotiationResponse(e), this._connectionState === "Disconnecting" || this._connectionState === "Disconnected")
            throw new Mt("The connection was stopped during negotiation.");
          if (o.error)
            throw new Error(o.error);
          if (o.ProtocolVersion)
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          if (o.url && (e = o.url), o.accessToken) {
            const r = o.accessToken;
            this._accessTokenFactory = () => r, this._httpClient._accessToken = r, this._httpClient._accessTokenFactory = void 0;
          }
          b++;
        } while (o.url && b < sA);
        if (b === sA && o.url)
          throw new Error("Negotiate redirection limit exceeded.");
        await this._createTransport(e, this._options.transport, o, t);
      }
      this.transport instanceof OA && (this.features.inherentKeepAlive = !0), this._connectionState === "Connecting" && (this._logger.log(k.Debug, "The HttpConnection connected successfully."), this._connectionState = "Connected");
    } catch (o) {
      return this._logger.log(k.Error, "Failed to start the connection: " + o), this._connectionState = "Disconnected", this.transport = void 0, this._stopPromiseResolver(), Promise.reject(o);
    }
  }
  async _getNegotiationResponse(t) {
    const e = {}, [o, b] = gM();
    e[o] = b;
    const r = this._resolveNegotiateUrl(t);
    this._logger.log(k.Debug, `Sending negotiation request: ${r}.`);
    try {
      const i = await this._httpClient.post(r, {
        content: "",
        headers: { ...e, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (i.statusCode !== 200)
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${i.statusCode}'`));
      const s = JSON.parse(i.content);
      return (!s.negotiateVersion || s.negotiateVersion < 1) && (s.connectionToken = s.connectionId), s.useStatefulReconnect && this._options._useStatefulReconnect !== !0 ? Promise.reject(new cA("Client didn't negotiate Stateful Reconnect but the server did.")) : s;
    } catch (i) {
      let s = "Failed to complete negotiation with the server: " + i;
      return i instanceof fo && i.statusCode === 404 && (s = s + " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this._logger.log(k.Error, s), Promise.reject(new cA(s));
    }
  }
  _createConnectUrl(t, e) {
    return e ? t + (t.indexOf("?") === -1 ? "?" : "&") + `id=${e}` : t;
  }
  async _createTransport(t, e, o, b) {
    let r = this._createConnectUrl(t, o.connectionToken);
    if (this._isITransport(e)) {
      this._logger.log(k.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = e, await this._startTransport(r, b), this.connectionId = o.connectionId;
      return;
    }
    const i = [], s = o.availableTransports || [];
    let d = o;
    for (const q of s) {
      const f = this._resolveTransportOrError(q, e, b, (d == null ? void 0 : d.useStatefulReconnect) === !0);
      if (f instanceof Error)
        i.push(`${q.transport} failed:`), i.push(f);
      else if (this._isITransport(f)) {
        if (this.transport = f, !d) {
          try {
            d = await this._getNegotiationResponse(t);
          } catch (h) {
            return Promise.reject(h);
          }
          r = this._createConnectUrl(t, d.connectionToken);
        }
        try {
          await this._startTransport(r, b), this.connectionId = d.connectionId;
          return;
        } catch (h) {
          if (this._logger.log(k.Error, `Failed to start the transport '${q.transport}': ${h}`), d = void 0, i.push(new gB(`${q.transport} failed: ${h}`, Q1[q.transport])), this._connectionState !== "Connecting") {
            const g = "Failed to select transport before stop() was called.";
            return this._logger.log(k.Debug, g), Promise.reject(new Mt(g));
          }
        }
      }
    }
    return i.length > 0 ? Promise.reject(new LB(`Unable to connect to the server with any of the available transports. ${i.join(" ")}`, i)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(t) {
    switch (t) {
      case Q1.WebSockets:
        if (!this._options.WebSocket)
          throw new Error("'WebSocket' is not supported in your environment.");
        return new KB(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case Q1.ServerSentEvents:
        if (!this._options.EventSource)
          throw new Error("'EventSource' is not supported in your environment.");
        return new GB(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
      case Q1.LongPolling:
        return new OA(this._httpClient, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${t}.`);
    }
  }
  _startTransport(t, e) {
    return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (o) => {
      let b = !1;
      if (this.features.reconnect)
        try {
          this.features.disconnected(), await this.transport.connect(t, e), await this.features.resend();
        } catch {
          b = !0;
        }
      else {
        this._stopConnection(o);
        return;
      }
      b && this._stopConnection(o);
    } : this.transport.onclose = (o) => this._stopConnection(o), this.transport.connect(t, e);
  }
  _resolveTransportOrError(t, e, o, b) {
    const r = Q1[t.transport];
    if (r == null)
      return this._logger.log(k.Debug, `Skipping transport '${t.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${t.transport}' because it is not supported by this client.`);
    if (ZB(e, r))
      if (t.transferFormats.map((s) => me[s]).indexOf(o) >= 0) {
        if (r === Q1.WebSockets && !this._options.WebSocket || r === Q1.ServerSentEvents && !this._options.EventSource)
          return this._logger.log(k.Debug, `Skipping transport '${Q1[r]}' because it is not supported in your environment.'`), new RB(`'${Q1[r]}' is not supported in your environment.`, r);
        this._logger.log(k.Debug, `Selecting transport '${Q1[r]}'.`);
        try {
          return this.features.reconnect = r === Q1.WebSockets ? b : void 0, this._constructTransport(r);
        } catch (s) {
          return s;
        }
      } else
        return this._logger.log(k.Debug, `Skipping transport '${Q1[r]}' because it does not support the requested transfer format '${me[o]}'.`), new Error(`'${Q1[r]}' does not support ${me[o]}.`);
    else
      return this._logger.log(k.Debug, `Skipping transport '${Q1[r]}' because it was disabled by the client.`), new yB(`'${Q1[r]}' is disabled by the client.`, r);
  }
  _isITransport(t) {
    return t && typeof t == "object" && "connect" in t;
  }
  _stopConnection(t) {
    if (this._logger.log(k.Debug, `HttpConnection.stopConnection(${t}) called while in state ${this._connectionState}.`), this.transport = void 0, t = this._stopError || t, this._stopError = void 0, this._connectionState === "Disconnected") {
      this._logger.log(k.Debug, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting")
      throw this._logger.log(k.Warning, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${t}) was called while the connection is still in the connecting state.`);
    if (this._connectionState === "Disconnecting" && this._stopPromiseResolver(), t ? this._logger.log(k.Error, `Connection disconnected with error '${t}'.`) : this._logger.log(k.Information, "Connection disconnected."), this._sendQueue && (this._sendQueue.stop().catch((e) => {
      this._logger.log(k.Error, `TransportSendQueue.stop() threw error '${e}'.`);
    }), this._sendQueue = void 0), this.connectionId = void 0, this._connectionState = "Disconnected", this._connectionStarted) {
      this._connectionStarted = !1;
      try {
        this.onclose && this.onclose(t);
      } catch (e) {
        this._logger.log(k.Error, `HttpConnection.onclose(${t}) threw error '${e}'.`);
      }
    }
  }
  _resolveUrl(t) {
    if (t.lastIndexOf("https://", 0) === 0 || t.lastIndexOf("http://", 0) === 0)
      return t;
    if (!w1.isBrowser)
      throw new Error(`Cannot resolve '${t}'.`);
    const e = window.document.createElement("a");
    return e.href = t, this._logger.log(k.Information, `Normalizing '${t}' to '${e.href}'.`), e.href;
  }
  _resolveNegotiateUrl(t) {
    const e = new URL(t);
    e.pathname.endsWith("/") ? e.pathname += "negotiate" : e.pathname += "/negotiate";
    const o = new URLSearchParams(e.searchParams);
    return o.has("negotiateVersion") || o.append("negotiateVersion", this._negotiateVersion.toString()), o.has("useStatefulReconnect") ? o.get("useStatefulReconnect") === "true" && (this._options._useStatefulReconnect = !0) : this._options._useStatefulReconnect === !0 && o.append("useStatefulReconnect", "true"), e.search = o.toString(), e.toString();
  }
}
function ZB(p, t) {
  return !p || (t & p) !== 0;
}
class $a {
  constructor(t) {
    this._transport = t, this._buffer = [], this._executing = !0, this._sendBufferedData = new tz(), this._transportResult = new tz(), this._sendLoopPromise = this._sendLoop();
  }
  send(t) {
    return this._bufferData(t), this._transportResult || (this._transportResult = new tz()), this._transportResult.promise;
  }
  stop() {
    return this._executing = !1, this._sendBufferedData.resolve(), this._sendLoopPromise;
  }
  _bufferData(t) {
    if (this._buffer.length && typeof this._buffer[0] != typeof t)
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof t}`);
    this._buffer.push(t), this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    for (; ; ) {
      if (await this._sendBufferedData.promise, !this._executing) {
        this._transportResult && this._transportResult.reject("Connection stopped.");
        break;
      }
      this._sendBufferedData = new tz();
      const t = this._transportResult;
      this._transportResult = void 0;
      const e = typeof this._buffer[0] == "string" ? this._buffer.join("") : $a._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(e), t.resolve();
      } catch (o) {
        t.reject(o);
      }
    }
  }
  static _concatBuffers(t) {
    const e = t.map((r) => r.byteLength).reduce((r, i) => r + i), o = new Uint8Array(e);
    let b = 0;
    for (const r of t)
      o.set(new Uint8Array(r), b), b += r.byteLength;
    return o.buffer;
  }
}
class tz {
  constructor() {
    this.promise = new Promise((t, e) => [this._resolver, this._rejecter] = [t, e]);
  }
  resolve() {
    this._resolver();
  }
  reject(t) {
    this._rejecter(t);
  }
}
const jB = "json";
class eT {
  constructor() {
    this.name = jB, this.version = 2, this.transferFormat = me.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(t, e) {
    if (typeof t != "string")
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    if (!t)
      return [];
    e === null && (e = Cb.instance);
    const o = z2.parse(t), b = [];
    for (const r of o) {
      const i = JSON.parse(r);
      if (typeof i.type != "number")
        throw new Error("Invalid payload.");
      switch (i.type) {
        case T0.Invocation:
          this._isInvocationMessage(i);
          break;
        case T0.StreamItem:
          this._isStreamItemMessage(i);
          break;
        case T0.Completion:
          this._isCompletionMessage(i);
          break;
        case T0.Ping:
          break;
        case T0.Close:
          break;
        case T0.Ack:
          this._isAckMessage(i);
          break;
        case T0.Sequence:
          this._isSequenceMessage(i);
          break;
        default:
          e.log(k.Information, "Unknown message type '" + i.type + "' ignored.");
          continue;
      }
      b.push(i);
    }
    return b;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(t) {
    return z2.write(JSON.stringify(t));
  }
  _isInvocationMessage(t) {
    this._assertNotEmptyString(t.target, "Invalid payload for Invocation message."), t.invocationId !== void 0 && this._assertNotEmptyString(t.invocationId, "Invalid payload for Invocation message.");
  }
  _isStreamItemMessage(t) {
    if (this._assertNotEmptyString(t.invocationId, "Invalid payload for StreamItem message."), t.item === void 0)
      throw new Error("Invalid payload for StreamItem message.");
  }
  _isCompletionMessage(t) {
    if (t.result && t.error)
      throw new Error("Invalid payload for Completion message.");
    !t.result && t.error && this._assertNotEmptyString(t.error, "Invalid payload for Completion message."), this._assertNotEmptyString(t.invocationId, "Invalid payload for Completion message.");
  }
  _isAckMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Ack message.");
  }
  _isSequenceMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Sequence message.");
  }
  _assertNotEmptyString(t, e) {
    if (typeof t != "string" || t === "")
      throw new Error(e);
  }
}
const tT = {
  trace: k.Trace,
  debug: k.Debug,
  info: k.Information,
  information: k.Information,
  warn: k.Warning,
  warning: k.Warning,
  error: k.Error,
  critical: k.Critical,
  none: k.None
};
function pT(p) {
  const t = tT[p.toLowerCase()];
  if (typeof t < "u")
    return t;
  throw new Error(`Unknown log level: ${p}`);
}
class oT {
  configureLogging(t) {
    if (j1.isRequired(t, "logging"), MT(t))
      this.logger = t;
    else if (typeof t == "string") {
      const e = pT(t);
      this.logger = new Sz(e);
    } else
      this.logger = new Sz(t);
    return this;
  }
  withUrl(t, e) {
    return j1.isRequired(t, "url"), j1.isNotEmpty(t, "url"), this.url = t, typeof e == "object" ? this.httpConnectionOptions = { ...this.httpConnectionOptions, ...e } : this.httpConnectionOptions = {
      ...this.httpConnectionOptions,
      transport: e
    }, this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(t) {
    return j1.isRequired(t, "protocol"), this.protocol = t, this;
  }
  withAutomaticReconnect(t) {
    if (this.reconnectPolicy)
      throw new Error("A reconnectPolicy has already been set.");
    return t ? Array.isArray(t) ? this.reconnectPolicy = new aA(t) : this.reconnectPolicy = t : this.reconnectPolicy = new aA(), this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withServerTimeout(t) {
    return j1.isRequired(t, "milliseconds"), this._serverTimeoutInMilliseconds = t, this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withKeepAliveInterval(t) {
    return j1.isRequired(t, "milliseconds"), this._keepAliveIntervalInMilliseconds = t, this;
  }
  /** Enables and configures options for the Stateful Reconnect feature.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withStatefulReconnect(t) {
    return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._useStatefulReconnect = !0, this._statefulReconnectBufferSize = t == null ? void 0 : t.bufferSize, this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const t = this.httpConnectionOptions || {};
    if (t.logger === void 0 && (t.logger = this.logger), !this.url)
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    const e = new QB(this.url, t);
    return Ja.create(e, this.logger || Cb.instance, this.protocol || new eT(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
  }
}
function MT(p) {
  return p.log !== void 0;
}
class q1 {
  constructor(t, e, o) {
    this.client = t, this.method = e, this.parse = o;
  }
  subscribe(t) {
    const e = ({ payload: o, caller: b }) => {
      try {
        const r = this.parse ? this.parse(o) : o;
        t(r, b);
      } catch (r) {
        console.error(r);
      }
    };
    return this.client.on(this.method, e);
  }
}
class Bo extends n0 {
  constructor(e) {
    super();
    z(this, "firstName");
    z(this, "lastName");
    z(this, "middleName");
    z(this, "birthday");
    z(this, "phone");
    z(this, "email");
    z(this, "avatar");
    z(this, "userId");
    z(this, "studentId");
    z(this, "adminId");
    z(this, "lastActivityDate");
    z(this, "onlineStatus");
    z(this, "isActive");
    z(this, "isSystem");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "syncedDate");
    z(this, "lastSeenMessageIndex");
    z(this, "internalNumber");
    z(this, "type");
    z(this, "post");
    z(this, "userName");
    e && this.update(e);
  }
  get canCall() {
    return !Ae.isEmpty(this.internalNumber);
  }
  get isFirstNameEmpty() {
    return Ae.isEmpty(this.firstName);
  }
  get isLastNameEmpty() {
    return Ae.isEmpty(this.lastName);
  }
  get hasName() {
    return !this.isFirstNameEmpty || !this.isLastNameEmpty;
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Bo({
      ...e,
      birthday: e.birthday ? L(e.birthday) : void 0,
      avatar: e.avatar ? $1.fromJson(e.avatar) : null,
      lastActivityDate: e.lastActivityDate ? L(e.lastActivityDate) : void 0,
      createdDate: e.createdDate ? L(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      syncedDate: e.syncedDate ? L(e.syncedDate) : void 0
    });
  }
}
class Va extends ye {
  constructor(e) {
    super();
    z(this, "link");
    z(this, "scenarioNodePortId");
    z(this, "title");
    z(this, "type");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Va({
      ...e
    });
  }
}
class To extends n0 {
  constructor(e) {
    super();
    z(this, "index");
    z(this, "text");
    z(this, "plainText");
    z(this, "authorId");
    z(this, "author");
    z(this, "reply");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "type");
    z(this, "attachments");
    z(this, "isDraft");
    z(this, "location");
    z(this, "hasAttachments");
    z(this, "hasLocation");
    z(this, "callDurationInSec");
    z(this, "template");
    z(this, "buttons");
    z(this, "sent");
    z(this, "sentError");
    z(this, "sentErrorMessage");
    z(this, "deleting");
    z(this, "deleted");
    z(this, "deletedError");
    z(this, "deletedErrorMessage");
    z(this, "renderMethod");
    e && this.update(e);
  }
  get hasButtons() {
    return this.buttons && this.buttons.length > 0;
  }
  get hasError() {
    return this.sentError || this.deletedError;
  }
  get voice() {
    return this.type === "voice" && this.attachments[0];
  }
  get hasText() {
    return !Ae.isEmpty(this.text);
  }
  get isMessageFromSystemMember() {
    var e;
    return ((e = this.author) == null ? void 0 : e.isSystem) ?? !1;
  }
  init(e) {
    this.author || (this.author = e.memberMap.get(this.authorId)), this.reply && !this.reply.author && (this.reply.author = e.memberMap.get(this.reply.authorId));
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new To({
      ...e,
      author: e.author ? Bo.fromJson(e.author) : void 0,
      reply: e.reply ? To.fromJson(e.reply) : null,
      createdDate: L(e.createdDate),
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      attachments: e.attachments ? e.attachments.map($1.fromJson) : [],
      buttons: e.buttons ? e.buttons.map(Va.fromJson) : []
    });
  }
}
class LM extends n0 {
  constructor(e) {
    super();
    z(this, "title");
    z(this, "lastMessage");
    z(this, "lastActivityDate");
    z(this, "creatorLastActivityDate");
    z(this, "channelColor");
    z(this, "lastSeenMessageIndex");
    z(this, "targetLastSeenMessageIndex");
    z(this, "membersTypingMap");
    z(this, "members");
    z(this, "type");
    z(this, "target");
    z(this, "isDraft");
    z(this, "readonly");
    z(this, "creatorUnsubscribed");
    z(this, "creatorUnsubscribedReason");
    // TODO ??
    // messageSettings: ChatConversationMessageSettings;
    z(this, "state");
    z(this, "creatorUserId");
    e && this.update(e), this.membersTypingMap = /* @__PURE__ */ new Map();
  }
  // TODO remove
  // creatorUserExternalId: string; 
  get scrollToIndex() {
    var e;
    return this.lastSeenMessageIndex ?? ((e = this.lastMessage) == null ? void 0 : e.index) ?? 0;
  }
  // get hasUserNameOrId(): boolean {
  //     return !isEmpty(this.target?.userName) || !isEmpty(this.creatorUserExternalId);
  // }
  get userName() {
    var e;
    return (e = this.target) == null ? void 0 : e.userName;
  }
  // @computed get userChannelId() {
  //     switch (this.channelType) {
  //         case ChannelType.WA:
  //             return this.creatorUserExternalId && `+${this.creatorUserExternalId}`;
  //         default:
  //             return this.creatorUserExternalId;
  //     }
  // }
  get memberMapByUserId() {
    return this.members.toMap((e) => e.userId);
  }
  get memberMap() {
    return this.members.toMap((e) => e.id);
  }
  get memberTyping() {
    return Array.from(this.membersTypingMap.keys()).map((e) => this.memberMap.get(e));
  }
  // @computed get isResponseTimeLimitExceeded() {
  //     const settings = this.messageSettings;
  //     if (!settings.responseTimeLimit) return false;
  //     if (this.creatorLastActivityDate) {
  //         const diff = moment().diff(this.creatorLastActivityDate, 'milliseconds');
  //         return diff > settings.responseTimeLimit.milliseconds;
  //     }
  //     else {
  //         return true;
  //     }
  // }
  get name() {
    var e, o, b;
    return ((e = this.target) == null ? void 0 : e.fullName) ?? ((o = this.target) == null ? void 0 : o.phone) ?? ((b = this.target) == null ? void 0 : b.userName);
  }
  get unreadMessageCount() {
    return this.lastMessage ? this.lastSeenMessageIndex == null ? this.lastMessage.index + 1 : this.lastMessage.index - this.lastSeenMessageIndex : 0;
  }
  addTypingMember(e) {
    if (this.memberMap.has(e))
      return this.membersTypingMap.has(e) && clearTimeout(this.membersTypingMap.get(e)), this.membersTypingMap.set(e, setTimeout(() => this.removeTypingMember(e), 2e3)), !0;
  }
  removeTypingMember(e) {
    this.membersTypingMap.delete(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new LM({
      ...e,
      lastMessage: e.lastMessage ? To.fromJson(e.lastMessage) : null,
      lastActivityDate: e.lastActivityDate ? L(e.lastActivityDate) : null,
      creatorLastActivityDate: e.creatorLastActivityDate ? L(e.creatorLastActivityDate) : null,
      channelColor: e.channelColor ?? "#ffffff",
      members: e.members ? e.members.map(Bo.fromJson) : [],
      target: e.target ? Bo.fromJson(e.target) : void 0,
      creatorUnsubscribed: e.creatorUnsubscribed ?? !1
      // messageSettings: json.messageSettings ? ChatConversationMessageSettings.fromJson(json.messageSettings) : undefined,
    });
  }
}
var B2 = /* @__PURE__ */ ((p) => (p.ConversationCreated = "conversationCreated", p.ConversationUpdated = "conversationUpdated", p.ConversationDeleted = "conversationDeleted", p.ConversationSynced = "conversationSynced", p.MessageSent = "messageCreated", p.MessageUpdated = "messageUpdated", p.MessageDeleted = "messageDeleted", p.MemberAdded = "memberCreated", p.MemberDeleted = "memberDeleted", p.MemberUpdated = "memberUpdated", p.MemberTyping = "memberTyping", p))(B2 || {});
class bT extends ye {
  constructor(e) {
    super();
    z(this, "type");
    z(this, "payload");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Ya extends ye {
  constructor(e) {
    super();
    z(this, "conversation");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Ya({
      conversation: LM.fromJson(e)
    });
  }
}
class Ga extends ye {
  constructor(e) {
    super();
    z(this, "id");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Ga({ id: e.id });
  }
  update(e) {
    super.update(e);
  }
}
class Ka extends ye {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "lastSeenMessageIndex");
    z(this, "targetLastSeenMessageIndex");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Ka(e);
  }
  update(e) {
    super.update(e);
  }
}
class Qa extends ye {
  constructor(e) {
    super();
    z(this, "conversation");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Qa({
      conversation: LM.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class Za extends ye {
  constructor(e) {
    super();
    z(this, "member");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Za({
      member: Bo.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class ja extends ye {
  constructor(e) {
    super();
    z(this, "id");
    e && this.update(e);
  }
  static fromJson(e) {
    return new ja({
      id: e.id
    });
  }
  update(e) {
    super.update(e);
  }
}
class eO extends ye {
  constructor(e) {
    super();
    z(this, "memberId");
    e && this.update(e);
  }
  static fromJson(e) {
    return new eO({
      memberId: e.memberId
    });
  }
  update(e) {
    super.update(e);
  }
}
class tO extends ye {
  constructor(e) {
    super();
    z(this, "id");
    z(this, "isActive");
    z(this, "lastSeenMessageIndex");
    e && this.update(e);
  }
  static fromJson(e) {
    return new tO({
      id: e.id,
      isActive: e.isActive,
      lastSeenMessageIndex: e.lastSeenMessageIndex
    });
  }
  update(e) {
    super.update(e);
  }
}
class pO extends ye {
  constructor(e) {
    super();
    z(this, "index");
    e && this.update(e);
  }
  static fromJson(e) {
    return new pO({
      index: e.index
    });
  }
  update(e) {
    super.update(e);
  }
}
class oO extends ye {
  constructor(e) {
    super();
    z(this, "member");
    z(this, "messages");
    e && this.update(e);
  }
  static fromJson(e) {
    return new oO({
      member: Bo.fromJson(e.member),
      messages: e.messages.map(To.fromJson)
    });
  }
  update(e) {
    super.update(e);
  }
}
class MO extends ye {
  constructor(e) {
    super();
    z(this, "message");
    e && this.update(e);
  }
  static fromJson(e) {
    return new MO({
      message: To.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class nT {
  static create(t, e) {
    switch (t) {
      // conversations
      case B2.ConversationCreated:
        e = Ya.fromJson(e);
        break;
      case B2.ConversationUpdated:
        e = Qa.fromJson(e);
        break;
      case B2.ConversationDeleted:
        e = Ga.fromJson(e);
        break;
      case B2.ConversationSynced:
        e = Ka.fromJson(e);
        break;
      // conversation
      case B2.MessageSent:
        e = oO.fromJson(e);
        break;
      case B2.MessageUpdated:
        e = MO.fromJson(e);
        break;
      case B2.MessageDeleted:
        e = pO.fromJson(e);
        break;
      case B2.MemberTyping:
        e = eO.fromJson(e);
        break;
      case B2.MemberAdded:
        e = Za.fromJson(e);
        break;
      case B2.MemberDeleted:
        e = ja.fromJson(e);
        break;
      case B2.MemberUpdated:
        e = tO.fromJson(e);
        break;
      default:
        console.error(`[ChatActionFactory] '${t}' not found`);
        break;
    }
    return new bT({ type: t, payload: e });
  }
}
class yb extends n0 {
  constructor(e) {
    super();
    z(this, "firstName");
    z(this, "lastName");
    z(this, "middleName");
    z(this, "phone");
    z(this, "email");
    z(this, "avatar");
    z(this, "adminId");
    z(this, "studentId");
    z(this, "lastSeenDate");
    z(this, "post");
    z(this, "userName");
    z(this, "roles");
    e && this.update(e);
  }
  update(e, o) {
    super.update(e, o);
  }
  static fromJson(e) {
    return new yb({
      ...e,
      avatar: e.avatar ? $1.fromJson(e.avatar) : null,
      lastSeenDate: e.lastSeenDate ? L(e.lastSeenDate) : void 0
    });
  }
}
class zT {
  constructor(t) {
    z(this, "init", () => this.client.invoke("Init", [], (t) => ({
      user: yb.fromJson(t.user),
      conversationId: t.conversationId
    })));
    z(this, "conversation", {
      fetch: (t) => this.client.invoke("GetConversation", [t], LM.fromJson),
      sync: (t, e) => this.client.invoke("SyncConversation", [t, e]),
      typing: (t, e) => this.client.invoke("MemberTyping", [t, e]),
      updated: (t) => new q1(this.client, `Conversation ${t}`, (e) => nT.create(e.type, e.payload))
    });
    z(this, "message", {
      fetch: (t, e, o) => this.client.invoke("GetMessages", [{ conversationId: t, skip: e, take: o }], (b) => b.items.map(To.fromJson)),
      send: (t, e, o) => this.client.invoke("SendMessage", [t, e, o]),
      clickButton: (t) => this.client.invoke("ButtonClick", [t]),
      delete: (t) => this.client.invoke("DeleteMessage", [{ id: t }]),
      update: (t) => this.client.invoke("UpdateMessage", [t])
    });
    // TODO delete?
    z(this, "user", {
      fetchInfo: (t) => this.client.invoke("GetUserInfo", [t], (e) => ({
        user: new yb({
          id: e.id,
          email: e.email,
          phone: e.phone,
          firstName: e.firstName,
          lastName: e.lastName,
          post: e.post,
          userName: e.userName
        }),
        onlineStatus: e.onlineStatus,
        contact: e.contact ? yb.fromJson(e.contact) : null,
        chats: e.chats.map(LM.fromJson)
      }))
    });
    this.client = t;
  }
}
var rT = Object.defineProperty, cT = Object.getOwnPropertyDescriptor, bO = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? cT(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && rT(t, e, b), b;
};
class tn extends Kb {
  constructor(e, o) {
    super();
    z(this, "inited", !1);
    z(this, "connection");
    z(this, "connectionError", null);
    z(this, "state", C0.Disconnected);
    z(this, "connectionId", null);
    z(this, "handleTokenChanged", async (e) => {
      if (e != null) {
        this.state == C0.Connected && await this.disconnect(), await this.connect();
        return;
      }
      await this.disconnect();
    });
    this.settings = e, this.sdk = o, i0(this), this.toDispose($3(() => this.state, (r) => {
      this.connectionId = this.connection.connectionId, this.sdk.dispatcher.emit("hub.state.changed", { client: this, state: r, connectionId: this.connectionId });
    }));
    const b = async () => {
      var r;
      return (r = await this.sdk.tokenStorage.getTokens()) == null ? void 0 : r.accessToken;
    };
    this.connection = new oT().withUrl(this.settings.host, {
      accessTokenFactory: b,
      transport: Q1.WebSockets
    }).withAutomaticReconnect([2e3, 3e3, 5e3, 1e4, 6e4]).build(), this.toDispose(() => this.connection.stop());
  }
  async init() {
    if (this.inited)
      throw new Error("[HubClient] Already inited");
    this.connection.onclose((e) => this.setState(C0.Disconnected, e)), this.connection.onreconnecting((e) => this.setState(C0.Reconnecting, e)), this.connection.onreconnected((e) => this.setState(C0.Connected)), this.sdk.dispatcher.on("auth.token.changed", this.handleTokenChanged), this.toDispose(() => this.sdk.dispatcher.off("auth.token.changed", this.handleTokenChanged)), this.settings.autoConnect !== !1 && this.handleTokenChanged(await this.sdk.tokenStorage.getTokens()), this.inited = !0;
  }
  async connect() {
    if (this.state != C0.Connected)
      try {
        this.setState(C0.Connecting), await this.connection.start(), this.setState(C0.Connected);
      } catch (e) {
        this.setState(C0.Reconnecting, e), setTimeout(() => this.connect(), 5e3);
      }
  }
  async disconnect() {
    if (this.state != C0.Disconnected)
      try {
        this.setState(C0.Disconnecting), await this.connection.stop(), this.setState(C0.Disconnected);
      } catch {
        this.setState(C0.Disconnected);
      }
  }
  on(e, o) {
    return this.connection.on(e, o), () => {
      this.connection.off(e, o);
    };
  }
  async invoke(e, o, b) {
    let r = await this.safeInvoke(e, o, b);
    return !r.success && this.connection.state != C0.Connected && await this.waitForConnection() ? await this.safeInvoke(e, o, b) : r;
  }
  async safeInvoke(e, o, b) {
    try {
      const r = await this.connection.invoke(e, o), i = b ? b(r) : r;
      return { success: !0, errors: [], body: i };
    } catch {
      return { success: !1, errors: [], body: null };
    }
  }
  setState(e, o = null) {
    this.connectionError = o, this.state = e;
  }
  /**
   * wait for reconnection or timeout
   * @param durationMs
   */
  waitForConnection() {
    return new Promise((e) => {
      const o = setTimeout(() => {
        b(), e(!1);
      }, this.settings.invokeTimeoutMs), b = $3(() => this.state, (r) => {
        r == C0.Connected && (clearTimeout(o), b(), e(!0));
      });
    });
  }
}
bO([
  a
], tn.prototype, "state", 2);
bO([
  a
], tn.prototype, "connectionId", 2);
bO([
  C
], tn.prototype, "setState", 1);
class iT extends Kb {
  constructor(e) {
    super();
    z(this, "inited", !1);
    z(this, "hub");
    z(this, "hubClient");
    this.sdk = e, this.hubClient = "client" in e.config.chat ? e.config.chat.client : new tn(e.config.chat.clientConfig, e), this.hub = new zT(this.hubClient);
  }
  async init() {
    this.inited || (this.sdk.dispatcher.on("hub.state.changed", this.handleStateChanged.bind(this)), this.toDispose(() => this.sdk.dispatcher.off("hub.state.changed", this.handleStateChanged)), await this.hubClient.init(), this.toDispose(this.hubClient), this.inited = !0);
  }
  async sync() {
    const e = await this.hub.init();
    if (!e.success || !e.body.conversationId)
      throw new Error("Failed to init chat: " + e.errors.map((b) => b.message).join(", "));
    const o = await this.hub.conversation.fetch(e.body.conversationId);
    if (!o.success)
      throw new Error("Failed to fetch conversation: " + o.errors.map((b) => b.message).join(", "));
    this.toDispose(this.hub.conversation.updated(e.body.conversationId).subscribe(this.handleConversationUpdated.bind(this))), this.sdk.dispatcher.emit("chat.inited", { conversation: o.body, user: e.body.user });
  }
  async handleStateChanged(e) {
    e.client == this.hubClient && e.state == C0.Connected && await this.sync();
  }
  handleConversationUpdated(e) {
    this.sdk.dispatcher.emit("chat.conversation.updated", e.payload);
  }
  disconnect() {
    this.hubClient.disconnect();
  }
}
var aT = Object.defineProperty, OT = Object.getOwnPropertyDescriptor, It = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? OT(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && aT(t, e, b), b;
};
class qt {
  constructor(t) {
    z(this, "breadcrumbs", []);
    z(this, "threads", []);
    z(this, "topics", []);
    z(this, "thread", null);
    z(this, "canModerate", !1);
    z(this, "fetched", !1);
    z(this, "banStatus", null);
    this.sdk = t, i0(this);
  }
  get canCreateTopic() {
    return this.thread != null && this.thread.canStudentCreateTopics && this.banStatus == null;
  }
  canDeleteTopic(t) {
    var e;
    return this.canModerate ? !0 : t.contact.id == ((e = this.sdk.account.user) == null ? void 0 : e.id) && t.commentCount == 0 ? L().diff(t.createdDate, "minutes") < 10 : !1;
  }
  async fetch(t) {
    return this.fetched = !1, await this.sdk.api.forum.thread.fetchThread(t);
  }
  async deleteTopic(t) {
    const e = await this.sdk.api.forum.topic.deleteTopic(t);
    return e.success && s0(() => {
      this.topics = this.topics.filter((o) => o.id != t);
    }), e;
  }
}
It([
  a
], qt.prototype, "breadcrumbs", 2);
It([
  a
], qt.prototype, "threads", 2);
It([
  a
], qt.prototype, "topics", 2);
It([
  a
], qt.prototype, "thread", 2);
It([
  a
], qt.prototype, "canModerate", 2);
It([
  a
], qt.prototype, "fetched", 2);
It([
  a
], qt.prototype, "banStatus", 2);
It([
  $
], qt.prototype, "canCreateTopic", 1);
It([
  C
], qt.prototype, "fetch", 1);
It([
  C
], qt.prototype, "deleteTopic", 1);
var sT = Object.defineProperty, AT = Object.getOwnPropertyDescriptor, N1 = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? AT(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && sT(t, e, b), b;
};
class h1 extends Kb {
  constructor(e, o) {
    super();
    z(this, "breadcrumbs", []);
    z(this, "topic");
    z(this, "canModerate", !1);
    z(this, "fetched", !1);
    z(this, "replyTo", null);
    z(this, "banStatus", null);
    z(this, "fetchComments", async (e, o) => {
      const b = new _l({ take: o, page: e, topicId: this.topic.id });
      return await this.sdk.api.forum.comment.fetchTopicComments(b);
    });
    this.sdk = e, this.hub = o, i0(this);
  }
  subscribeTopicComment(e) {
    this.toDispose(
      this.hub.forum.topic.comment(this.topic.id).subscribe((o, b) => {
        s0(() => e(o));
      })
    );
  }
  subscribeTopicReaction(e) {
    this.toDispose(
      this.hub.forum.topic.reaction(this.topic.id).subscribe((o, b) => {
        s0(() => e(o, b));
      })
    );
  }
  subscribeTopicForumReaction() {
    this.toDispose(
      this.hub.forum.topic.topic(this.topic.id).subscribe(({ event: e, topic: o }, b) => {
        s0(() => {
          switch (e) {
            case "modified":
              this.topic.update({
                title: o.title,
                text: o.text,
                updatedDate: o.updatedDate,
                files: o.files,
                commentCount: o.commentCount,
                lastActivityDate: o.lastActivityDate
              });
              break;
          }
        });
      })
    );
  }
  get canDeleteTopic() {
    return this.canModerate ? !0 : this.canModifyTopic && this.topic.commentCount == 0;
  }
  get canModifyTopic() {
    var e;
    return this.canModerate ? !0 : this.topic.contact.id == ((e = this.sdk.account.user) == null ? void 0 : e.id) ? L().diff(this.topic.createdDate, "minutes") < 10 : !1;
  }
  canModifyComment(e) {
    var o;
    return this.canModerate ? !0 : e.contact.id == ((o = this.sdk.account.user) == null ? void 0 : o.id) ? L().diff(e.createdDate, "minutes") < 10 : !1;
  }
  async fetchTopic(e) {
    this.fetched = !1;
    const o = await this.sdk.api.forum.topic.fetchTopic(e);
    return o.success && s0(() => {
      this.breadcrumbs = o.body.breadcrumbs, this.topic = o.body.topic, this.canModerate = o.body.canModerate, this.banStatus = o.body.banStatus, this.fetched = !0;
    }), o;
  }
  async updateTopic(e, o) {
    return await this.sdk.api.forum.topic.updateTopic(
      this.topic.id,
      e,
      o.map((r) => r.id)
    );
  }
  async deleteTopic() {
    return await this.sdk.api.forum.topic.deleteTopic(this.topic.id);
  }
  async sendComment(e, o) {
    var r;
    const b = await this.sdk.api.forum.comment.createTopicComment(
      this.topic.id,
      e,
      ((r = this.replyTo) == null ? void 0 : r.id) ?? null,
      o.map((i) => i.id)
    );
    return b.success && s0(() => {
      this.replyTo = null;
    }), b;
  }
  async updateComment(e, o, b, r) {
    var s;
    return await this.sdk.api.forum.comment.updateTopicComment(
      e.id,
      o,
      b.map((d) => d.id),
      r || (s = e.reply) == null ? void 0 : s.id
    );
  }
  async deleteComment(e) {
    return await this.sdk.api.forum.comment.deleteTopicComment(e);
  }
  setReplyTo(e) {
    this.replyTo = e;
  }
  async fetchCommentPosition(e) {
    const o = await this.sdk.api.forum.comment.fetchTopicCommentPosition(this.topic.id, e);
    if (o.success) return o.body.position;
    throw new Error("Couldn't fetch comment position");
  }
  setBanStatus(e) {
    this.banStatus = e, e != null && (this.canModerate = !1);
  }
  async createCommentReaction(e, o) {
    return await this.sdk.api.forum.reaction.create(
      this.topic.id,
      e.id,
      o
    );
  }
  async updateCommentReaction(e, o) {
    return await this.sdk.api.forum.reaction.update(
      o,
      e
    );
  }
  async deleteCommentReaction(e) {
    return await this.sdk.api.forum.reaction.delete(e);
  }
  async createTopicReaction(e) {
    return await this.sdk.api.forum.reaction.create(
      this.topic.id,
      null,
      e
    );
  }
  async updateTopicReaction(e, o) {
    return await this.sdk.api.forum.reaction.update(
      o,
      e
    );
  }
  async deleteTopicReaction(e) {
    return await this.sdk.api.forum.reaction.delete(e);
  }
}
N1([
  a
], h1.prototype, "breadcrumbs", 2);
N1([
  a
], h1.prototype, "topic", 2);
N1([
  a
], h1.prototype, "canModerate", 2);
N1([
  a
], h1.prototype, "fetched", 2);
N1([
  a
], h1.prototype, "replyTo", 2);
N1([
  a
], h1.prototype, "banStatus", 2);
N1([
  $
], h1.prototype, "canDeleteTopic", 1);
N1([
  $
], h1.prototype, "canModifyTopic", 1);
N1([
  C
], h1.prototype, "fetchTopic", 1);
N1([
  C
], h1.prototype, "updateTopic", 1);
N1([
  C
], h1.prototype, "deleteTopic", 1);
N1([
  C
], h1.prototype, "sendComment", 1);
N1([
  C
], h1.prototype, "updateComment", 1);
N1([
  C
], h1.prototype, "deleteComment", 1);
N1([
  C
], h1.prototype, "setReplyTo", 1);
N1([
  C
], h1.prototype, "fetchCommentPosition", 1);
N1([
  C
], h1.prototype, "fetchComments", 2);
N1([
  C
], h1.prototype, "setBanStatus", 1);
N1([
  C
], h1.prototype, "createCommentReaction", 1);
N1([
  C
], h1.prototype, "updateCommentReaction", 1);
N1([
  C
], h1.prototype, "deleteCommentReaction", 1);
N1([
  C
], h1.prototype, "createTopicReaction", 1);
N1([
  C
], h1.prototype, "updateTopicReaction", 1);
N1([
  C
], h1.prototype, "deleteTopicReaction", 1);
class uT {
  constructor(t) {
    z(this, "thread");
    z(this, "topic");
    this.sdk = t, this.thread = new qt(this.sdk), this.topic = new h1(this.sdk, this.sdk.hub);
  }
}
class dT extends S1 {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  fetchItems(t) {
    return this.sdk.api.gamification.fetchLeaders(t ?? this.filter);
  }
  createFilter(t) {
    return new Ll(t);
  }
}
class lT extends v1 {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.gamification.product;
  }
}
class qT extends v1 {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.gamification.transaction;
  }
}
class fT {
  constructor(t) {
    z(this, "leader");
    z(this, "product");
    z(this, "transaction");
    this.sdk = t, this.leader = new dT(this.sdk), this.product = new lT(this.sdk), this.transaction = new qT(this.sdk);
  }
}
class WT {
  constructor(t) {
    this.sdk = t;
  }
  async fetch() {
    return this.sdk.api.announcement.fetch();
  }
  async close(t) {
    return this.sdk.api.announcement.close(t);
  }
}
var hT = Object.defineProperty, mT = Object.getOwnPropertyDescriptor, Ze = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? mT(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && hT(t, e, b), b;
};
class qe extends Kb {
  constructor() {
    super();
    z(this, "course");
    z(this, "studentCourse");
    z(this, "items", []);
    z(this, "currentItem");
    z(this, "itemFetching", !1);
    z(this, "itemFetchingId");
    z(this, "filteredItems", []);
    z(this, "itemsMap", /* @__PURE__ */ new Map());
    z(this, "courseFetched", !1);
    z(this, "courseItemsFetched", !1);
    z(this, "searchTerms", []);
    z(this, "isSearching", !1);
    i0(this);
  }
  get inited() {
    return this.courseFetched && this.courseItemsFetched;
  }
  filterItems(e, o = this.items) {
    if (Ae.isEmpty(e)) {
      this.filteredItems = o, this.searchTerms = [], this.isSearching = !1;
      return;
    }
    s0(() => {
      this.isSearching = !0, this.searchTerms = e.toLowerCase().trim().split(" ");
    }), s0(() => {
      this.filteredItems = o.map((b) => this.filterSteps(b)).filter((b) => b !== null);
    });
  }
  filterSteps(e, o = []) {
    const b = [...o, e.title].filter(Boolean).join(" ").toLowerCase();
    if (e.title && this.searchTerms.every((r) => b.includes(r)))
      return e;
    if (e.children.length > 0) {
      const r = e.children.map((i) => this.filterSteps(i, [...o, e.title])).filter((i) => i !== null);
      if (r.length > 0)
        return new Lo({ ...e, children: r });
    }
    return null;
  }
  clearSearch() {
    s0(() => {
      this.searchTerms = [], this.filteredItems = this.items;
    });
  }
  //#endregion
  buildTree(e, o, b = null, r = 1) {
    const i = e.filter((d) => d.parentItemId == (b == null ? void 0 : b.id)).sort((d, q) => d.position - q.position), s = [];
    for (const d of i)
      d.course = this.course, d.parent = b, d.level = r, d.schoolTimezone = o, s.push(d), d.type == Z1.Section && (d.children = this.buildTree(e, o, d, r + 1)), this.itemsMap.set(d.id, d);
    return s;
  }
  processTree(e, o = null, b = null, r = 1) {
    let i = null, s = null, d = 1;
    for (const q of e)
      if (q.studentCourse = this.studentCourse, q.course = this.course, q.parent = o, q.position = d++, q.previousItem = s ?? b, q.type == Z1.Step)
        q.globalPosition = r++, i || (i = q), s && (s.nextItem = q), s = q;
      else {
        const f = this.processTree(q.children, q, s ?? b, r);
        f.firstStepItem && (q.nextItem = f.firstStepItem, s ? s.nextItem = f.firstStepItem : b && (b.nextItem = f.firstStepItem), i || (i = f.firstStepItem)), f.lastStepItem && (s = f.lastStepItem), r = f.globalPosition;
      }
    return { firstStepItem: i, lastStepItem: s, globalPosition: r };
  }
}
Ze([
  a
], qe.prototype, "course", 2);
Ze([
  a
], qe.prototype, "studentCourse", 2);
Ze([
  a
], qe.prototype, "items", 2);
Ze([
  a
], qe.prototype, "currentItem", 2);
Ze([
  a
], qe.prototype, "itemFetching", 2);
Ze([
  a
], qe.prototype, "itemFetchingId", 2);
Ze([
  a
], qe.prototype, "filteredItems", 2);
Ze([
  a
], qe.prototype, "courseFetched", 2);
Ze([
  a
], qe.prototype, "courseItemsFetched", 2);
Ze([
  $
], qe.prototype, "inited", 1);
Ze([
  a
], qe.prototype, "searchTerms", 2);
Ze([
  a
], qe.prototype, "isSearching", 2);
Ze([
  C
], qe.prototype, "filterItems", 1);
Ze([
  C
], qe.prototype, "clearSearch", 1);
var RT = Object.defineProperty, yT = Object.getOwnPropertyDescriptor, lp = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? yT(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && RT(t, e, b), b;
};
class Pt extends qe {
  constructor(e, o) {
    super();
    z(this, "plan");
    this.sdk = e, this.hub = o, i0(this);
  }
  get initialItem() {
    return Array.from(this.itemsMap.values()).find((e) => e.type === Z1.Step);
  }
  async init(e, o, b) {
    return await this.fetchCourse(e) ? (await this.fetchCourseItems(o, b), !0) : !1;
  }
  async setPlan(e) {
    s0(() => {
      this.plan = e;
    }), await this.fetchCourseItems(void 0, void 0, e == null ? void 0 : e.id);
  }
  async selectCourseItem(e) {
    return await this.fetchCourseItem(e) ? (s0(() => {
      this.currentItem = e;
    }), !0) : !1;
  }
  async selectCourseItemById(e, o) {
    const b = this.itemsMap.get(e);
    if (b)
      return o != null && (b.tab = o), this.selectCourseItem(b);
    throw new Error("Course item not found: " + e);
  }
  async fetchCourse(e) {
    this.courseFetched = !1;
    const o = await this.sdk.api.coursePreview.fetchCourse(e);
    return o.success && s0(() => {
      this.course = o.body.course;
    }), s0(() => {
      this.courseFetched = !0;
    }), o.success;
  }
  async fetchCourseItems(e, o, b) {
    this.courseItemsFetched = !1;
    const r = await this.sdk.api.coursePreview.fetchCourseItems(this.course.id, b);
    return r.success && s0(() => {
      const i = this.buildTree(r.body.items, this.sdk.school.timezone);
      this.processTree(i), this.course.update({ totalItemCount: r.body.items.filter((s) => s.type == Z1.Step).length }), this.items = i, e != null ? this.selectCourseItemById(e, o) : this.initialItem != null && this.selectCourseItem(this.initialItem);
    }), s0(() => {
      this.courseItemsFetched = !0;
    }), r;
  }
  async fetchCourseItem(e) {
    this.itemFetching = !0;
    const o = await this.sdk.api.coursePreview.fetchCourseItem(this.course.id, e.id);
    return o.success && s0(() => {
      e.update({
        ...o.body.courseItem,
        tab: e.tab
      });
    }), s0(() => {
      this.itemFetching = !1;
    }), o.success;
  }
}
lp([
  a
], Pt.prototype, "plan", 2);
lp([
  $
], Pt.prototype, "initialItem", 1);
lp([
  C
], Pt.prototype, "init", 1);
lp([
  C
], Pt.prototype, "setPlan", 1);
lp([
  C
], Pt.prototype, "selectCourseItem", 1);
lp([
  C
], Pt.prototype, "selectCourseItemById", 1);
lp([
  C
], Pt.prototype, "fetchCourse", 1);
lp([
  C
], Pt.prototype, "fetchCourseItems", 1);
lp([
  C
], Pt.prototype, "fetchCourseItem", 1);
var gT = Object.defineProperty, LT = Object.getOwnPropertyDescriptor, Gp = (p, t, e, o) => {
  for (var b = LT(t, e), r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && gT(t, e, b), b;
};
class qp extends qe {
  constructor(t, e) {
    super(), this.sdk = t, this.hub = e, i0(this);
  }
  get initialItem() {
    return this.itemsMap.get(this.studentCourse.initialCourseItemId);
  }
  get canLeaveFeedback() {
    return this.studentCourse.state == "ended" && this.studentCourse.hasFeedback == !1 && this.studentCourse.course.dontAskFeedback == !1;
  }
  async init(t, e) {
    const o = await this.sdk.api.education.studentCourse.fetchItem(t);
    if (!o.success)
      return o;
    s0(() => {
      this.course = o.body.studentCourse.course, this.studentCourse = o.body.studentCourse, this.courseFetched = !0;
    });
    const b = await this.fetchCourseItems(
      o.body.hasItemAccess ? t : this.studentCourse.currentCourseItem.id,
      o.body.hasItemAccess ? e : void 0
    );
    return b.success ? (this.toDispose(
      this.hub.education.course.itemChanged(this.studentCourse.id).subscribe((r) => {
        s0(() => {
          const i = this.itemsMap.get(r.item.id);
          i && i.update(r.item);
        });
      })
    ), this.toDispose(
      this.hub.education.course.progress(this.studentCourse.id).subscribe((r) => {
        s0(() => {
          this.updateProgress(r);
        });
      })
    ), o) : b;
  }
  async selectCourseItem(t) {
    if (!t.courseItemAvailability.result)
      throw new Error("Course item is not available");
    const e = await this.fetchCourseItem(t);
    return e.success && (s0(() => this.currentItem = t), this.sdk.dispatcher.emit("learn.currentItem.updated", { item: t })), e;
  }
  async selectCourseItemById(t, e) {
    var b;
    if (((b = this.currentItem) == null ? void 0 : b.id) === t) return !0;
    const o = this.itemsMap.get(t);
    if (o)
      return e != null ? o.tab = e : o.tab = o.firstAvailableTab, this.selectCourseItem(o);
    throw new Error("Course item not found " + t);
  }
  updateProgress(t) {
    this.studentCourse.update(t.contactCourse);
    const e = this.itemsMap.get(t.courseItemId);
    e != null && (e.progress == null ? e.progress = t.courseItemProgress : e.progress.update(t.courseItemProgress), this.sdk.dispatcher.emit("learn.studentCourse.updated", { studentCourse: this.studentCourse }), this.sdk.dispatcher.emit("learn.currentItem.updated", { item: e }));
  }
  async fetchCourseItems(t, e) {
    this.courseItemsFetched = !1;
    const o = new X_({
      studentCourseId: this.studentCourse.id,
      courseItemId: t
    }), b = await this.sdk.api.education.studentCourse.item.fetch(o);
    if (b.success) {
      const r = this.buildTree(b.body, this.sdk.school.timezone);
      this.processTree(r), this.studentCourse.update({ totalItemCount: b.body.count((i) => i.type == Z1.Step) }), s0(() => this.items = r), t != null ? this.selectCourseItemById(t, e) : this.selectCourseItem(this.initialItem);
    }
    return s0(() => {
      this.courseItemsFetched = !0;
    }), b;
  }
  async fetchCourseItem(t) {
    this.itemFetching = !0, t.update({ fetching: !0 });
    const e = await this.sdk.api.education.studentCourse.item.fetchItem(this.studentCourse.id, t.id);
    return e.success && t.update({
      ...e.body,
      tab: t.tab
    }), t.update({ fetching: !1 }), s0(() => {
      this.itemFetching = !1;
    }), { success: e.success, errors: e.errors, courseItem: t };
  }
}
Gp([
  $
], qp.prototype, "initialItem");
Gp([
  $
], qp.prototype, "canLeaveFeedback");
Gp([
  C
], qp.prototype, "init");
Gp([
  C
], qp.prototype, "selectCourseItem");
Gp([
  C
], qp.prototype, "selectCourseItemById");
Gp([
  C
], qp.prototype, "updateProgress");
Gp([
  C
], qp.prototype, "fetchCourseItems");
Gp([
  C
], qp.prototype, "fetchCourseItem");
var vT = Object.defineProperty, _T = Object.getOwnPropertyDescriptor, te = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? _T(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && vT(t, e, b), b;
};
class Y1 extends Kb {
  constructor(e) {
    super();
    z(this, "library");
    z(this, "items", []);
    z(this, "currentItem");
    z(this, "itemFetching", !1);
    z(this, "openedSections", []);
    z(this, "filteredItems", []);
    z(this, "searchTerms", []);
    z(this, "libraryFetched", !1);
    z(this, "libraryItemsFetched", !1);
    this.sdk = e, i0(this);
  }
  filterItems(e, o = this.items) {
    if (y1(e)) {
      this.filteredItems = o, this.searchTerms = [];
      return;
    }
    this.searchTerms = e.toLowerCase().trim().split(" ");
    const b = (r) => {
      if (r.title && r.type === lb.Article && this.searchTerms.every((i) => r.title.toLowerCase().includes(i)))
        return r;
      if (r.children.length > 0) {
        const i = r.children.map(b).filter((s) => s !== null);
        if (i.length > 0)
          return new Db({ ...r, children: i });
      }
      return null;
    };
    this.filteredItems = o.map(b).filter((r) => r !== null);
  }
  get initialItem() {
    return this.findInitialItem();
  }
  get inited() {
    return this.libraryFetched && this.libraryItemsFetched;
  }
  async init(e, o, b = []) {
    this.openedSections = b;
    const r = await this.fetchLibrary(e);
    return r.success ? await this.fetchLibraryItems(o) : r;
  }
  async selectLibraryItem(e) {
    if (!e.availability.result)
      throw new Error("Library item access denied");
    const o = await this.fetchLibraryItem(e);
    return o.success && s0(() => this.currentItem = e), o;
  }
  async selectItemById(e) {
    let o = this.findItem(e);
    if (o)
      return await this.selectLibraryItem(o);
    throw new Error("Library item not found " + e);
  }
  async fetchLibrary(e) {
    this.libraryFetched = !1;
    const o = await this.sdk.api.education.studentLibrary.fetchLibrary(e);
    return o.success && s0(() => {
      this.library = o.body.library;
    }), s0(() => {
      this.libraryFetched = !0;
    }), o;
  }
  async fetchLibraryItems(e) {
    this.libraryItemsFetched = !1;
    const o = await this.sdk.api.education.studentLibrary.fetchLibraryItems(this.library.id);
    if (o.success) {
      const b = o.body.items;
      for (const r of b)
        r.update({ flowBeginDate: this.library.flowBeginDate });
      s0(() => this.items = this.buildItemTree(b, null)), this.processItemTree(this.items), e != null ? await this.selectItemById(e) : this.initialItem != null && await this.selectLibraryItem(this.initialItem);
    }
    return s0(() => {
      this.libraryItemsFetched = !0;
    }), o;
  }
  async fetchLibraryItem(e) {
    this.itemFetching = !0;
    const o = await this.sdk.api.education.studentLibrary.fetchLibraryItem(this.library.id, e.id);
    return o.success && s0(() => e.update({ ...o.body.item })), s0(() => {
      this.itemFetching = !1;
    }), o;
  }
  // simplify with map instead of tree
  findItem(e, o = this.items) {
    for (const b of o) {
      if (b.id == e) return b;
      if (b.type == lb.Section) {
        const r = this.findItem(e, b.children);
        if (r != null)
          return r;
      }
    }
    return null;
  }
  findInitialItem(e = this.items) {
    for (const o of e) {
      if (o.type == lb.Article)
        return o;
      {
        const b = this.findInitialItem(o.children);
        if (b != null)
          return b;
      }
    }
    return console.warn("Couldn't find initial item"), null;
  }
  buildItemTree(e, o) {
    const b = e.filter((r) => {
      var i;
      return ((i = r.parentItem) == null ? void 0 : i.id) == o;
    }).orderBy((r) => r.position);
    for (const r of b)
      r.children = this.buildItemTree(e, r.id);
    return b;
  }
  processItemTree(e, o = null, b = null) {
    let r = b, i = 1;
    for (const s of e)
      if (s.position = i++, s.section = o, s.library = new Co({ id: this.library.id }), s.type == lb.Article)
        s.previousItem = r, r != null && (r.nextItem = s), r = s;
      else {
        this.processItemTree(s.children, s, r);
        const d = s.lastChild;
        d != null && (r = d);
      }
  }
}
te([
  a
], Y1.prototype, "library", 2);
te([
  a
], Y1.prototype, "items", 2);
te([
  a
], Y1.prototype, "currentItem", 2);
te([
  a
], Y1.prototype, "itemFetching", 2);
te([
  a
], Y1.prototype, "openedSections", 2);
te([
  a
], Y1.prototype, "filteredItems", 2);
te([
  a
], Y1.prototype, "searchTerms", 2);
te([
  C
], Y1.prototype, "filterItems", 1);
te([
  $
], Y1.prototype, "initialItem", 1);
te([
  a
], Y1.prototype, "libraryFetched", 2);
te([
  a
], Y1.prototype, "libraryItemsFetched", 2);
te([
  $
], Y1.prototype, "inited", 1);
te([
  C
], Y1.prototype, "init", 1);
te([
  C
], Y1.prototype, "selectLibraryItem", 1);
te([
  C
], Y1.prototype, "selectItemById", 1);
te([
  C
], Y1.prototype, "fetchLibrary", 1);
te([
  C
], Y1.prototype, "fetchLibraryItems", 1);
te([
  C
], Y1.prototype, "fetchLibraryItem", 1);
te([
  C
], Y1.prototype, "buildItemTree", 1);
te([
  C
], Y1.prototype, "processItemTree", 1);
var NT = Object.defineProperty, BT = Object.getOwnPropertyDescriptor, G2 = (p, t, e, o) => {
  for (var b = BT(t, e), r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = i(t, e, b) || b);
  return b && NT(t, e, b), b;
};
class f2 extends qe {
  constructor(t, e) {
    super(), this.sdk = t, this.hub = e, i0(this);
  }
  get initialItem() {
    return this.itemsMap.get(this.studentCourse.initialCourseItemId);
  }
  async init(t, e, o) {
    return !await this.fetchCourse(t) || !await this.fetchCourseItems(e, o) ? !1 : (this.toDispose(
      this.hub.education.course.itemChanged(this.studentCourse.id).subscribe((i) => {
        s0(() => {
          const s = this.itemsMap.get(i.item.id);
          s && s.update(i.item);
        });
      })
    ), this.toDispose(
      this.hub.education.course.progress(this.studentCourse.id).subscribe((i) => {
        s0(() => {
          this.updateProgress(i);
        });
      })
    ), !0);
  }
  async selectCourseItem(t) {
    if (!t.courseItemAvailability.result) return !1;
    const e = await this.fetchCourseItem(t);
    return e.success && s0(() => {
      this.currentItem = t;
    }), e;
  }
  async selectCourseItemById(t, e) {
    const o = this.itemsMap.get(t);
    return o ? (e != null && (o.tab = e), await this.selectCourseItem(o)) : (console.error("Course item not found", t), !1);
  }
  async completeCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.completeStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const o of e.body.progresses)
        this.updateProgress(o);
    return e;
  }
  async resetCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.resetStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const o of e.body.progresses)
        this.updateProgress(o);
    return e;
  }
  async blockCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.blockStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const o of e.body.progresses)
        this.updateProgress(o);
    return e;
  }
  async unblockCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.unblockStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const o of e.body.progresses)
        this.updateProgress(o);
    return e;
  }
  updateProgress(t) {
    this.studentCourse.update(t.contactCourse);
    const e = this.itemsMap.get(t.courseItemId);
    e && (e.progress == null ? e.progress = t.courseItemProgress : e.progress.update(t.courseItemProgress));
  }
  async fetchCourse(t) {
    this.courseFetched = !1;
    const e = await this.sdk.api.studentCoursePreview.fetchStudentCourse(t);
    return e.success && s0(() => {
      this.studentCourse = e.body.studentCourse, this.course = this.studentCourse.course;
    }), s0(() => {
      this.courseFetched = !0;
    }), e.success;
  }
  async fetchCourseItems(t, e) {
    this.courseItemsFetched = !1;
    const o = await this.sdk.api.studentCoursePreview.fetchStudentCourseItems(this.studentCourse.id);
    return o.success && s0(() => {
      const b = this.buildTree(o.body.items, this.sdk.school.timezone);
      this.processTree(b), this.studentCourse.update({ totalItemCount: o.body.items.filter((r) => r.type === Z1.Step).length }), this.items = b, t != null ? this.selectCourseItemById(t, e) : this.initialItem != null && this.selectCourseItem(this.initialItem);
    }), s0(() => {
      this.courseItemsFetched = !0;
    }), o.success;
  }
  async fetchCourseItem(t) {
    this.itemFetching = !0;
    const e = await this.sdk.api.studentCoursePreview.fetchStudentCourseItem(this.studentCourse.id, t.id);
    return e.success && s0(() => {
      t.update({
        ...e.body.studentCourseItem,
        tab: t.tab
      });
    }), s0(() => {
      this.itemFetching = !1;
    }), e;
  }
}
G2([
  $
], f2.prototype, "initialItem");
G2([
  C
], f2.prototype, "init");
G2([
  C
], f2.prototype, "selectCourseItem");
G2([
  C
], f2.prototype, "selectCourseItemById");
G2([
  C
], f2.prototype, "completeCourseItem");
G2([
  C
], f2.prototype, "resetCourseItem");
G2([
  C
], f2.prototype, "blockCourseItem");
G2([
  C
], f2.prototype, "unblockCourseItem");
G2([
  C
], f2.prototype, "updateProgress");
G2([
  C
], f2.prototype, "fetchCourse");
G2([
  C
], f2.prototype, "fetchCourseItems");
G2([
  C
], f2.prototype, "fetchCourseItem");
class TT {
  constructor(t) {
    z(this, "learn");
    z(this, "library");
    // preview for courses
    z(this, "coursePreview");
    z(this, "studentCoursePreview");
    this.sdk = t, this.learn = new qp(this.sdk, this.sdk.hub), this.library = new Y1(this.sdk), this.coursePreview = new Pt(this.sdk, this.sdk.hub), this.studentCoursePreview = new f2(this.sdk, this.sdk.hub);
  }
}
var wT = Object.defineProperty, ST = Object.getOwnPropertyDescriptor, Uo = (p, t, e, o) => {
  for (var b = o > 1 ? void 0 : o ? ST(t, e) : t, r = p.length - 1, i; r >= 0; r--)
    (i = p[r]) && (b = (o ? i(t, e, b) : i(b)) || b);
  return o && b && wT(t, e, b), b;
};
class Kp {
  constructor(t) {
    z(this, "ready", !1);
    z(this, "words", {});
    z(this, "excludedLangs", []);
    z(this, "lang");
    z(this, "timestamp");
    this.sdk = t, i0(this);
  }
  get langs() {
    return Object.keys(hz).filter((t) => !this.excludedLangs.includes(t)).map((t) => t);
  }
  async init(t) {
    this.ready || (this.clear(), await this.fetchWords(t));
  }
  async fetchWords(t) {
    const e = await this.sdk.api.loc.fetch(t, this.timestamp);
    e.success && (e.body.needSync && this.setData(t, e.body.words, e.body.timestamp, e.body.excludedLangs), s0(() => this.ready = !0));
  }
  async setData(t, e, o, b = []) {
    this.lang = t, this.words = e, this.timestamp = o, this.excludedLangs = b;
  }
  clear() {
    this.words = {}, this.timestamp = void 0, this.ready = !1, this.excludedLangs = [];
  }
}
Uo([
  a
], Kp.prototype, "ready", 2);
Uo([
  a
], Kp.prototype, "words", 2);
Uo([
  a
], Kp.prototype, "excludedLangs", 2);
Uo([
  $
], Kp.prototype, "langs", 1);
Uo([
  C
], Kp.prototype, "fetchWords", 1);
Uo([
  C
], Kp.prototype, "setData", 1);
Uo([
  C
], Kp.prototype, "clear", 1);
var Dc, AA;
function xM() {
  return AA || (AA = 1, Dc = TypeError), Dc;
}
const DT = {}, XT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DT
}, Symbol.toStringTag, { value: "Module" })), CT = /* @__PURE__ */ Zd(XT);
var Xc, uA;
function cr() {
  if (uA) return Xc;
  uA = 1;
  var p = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && p ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, e = p && t && typeof t.get == "function" ? t.get : null, o = p && Map.prototype.forEach, b = typeof Set == "function" && Set.prototype, r = Object.getOwnPropertyDescriptor && b ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = b && r && typeof r.get == "function" ? r.get : null, s = b && Set.prototype.forEach, d = typeof WeakMap == "function" && WeakMap.prototype, q = d ? WeakMap.prototype.has : null, f = typeof WeakSet == "function" && WeakSet.prototype, h = f ? WeakSet.prototype.has : null, g = typeof WeakRef == "function" && WeakRef.prototype, y = g ? WeakRef.prototype.deref : null, w = Boolean.prototype.valueOf, U = Object.prototype.toString, N = Function.prototype.toString, S = String.prototype.match, D = String.prototype.slice, V = String.prototype.replace, H = String.prototype.toUpperCase, Y = String.prototype.toLowerCase, t0 = RegExp.prototype.test, j = Array.prototype.concat, b0 = Array.prototype.join, y0 = Array.prototype.slice, m0 = Math.floor, V0 = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, O0 = Object.getOwnPropertySymbols, m1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Z0 = typeof Symbol == "function" && typeof Symbol.iterator == "object", ze = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Z0 || !0) ? Symbol.toStringTag : null, I1 = Object.prototype.propertyIsEnumerable, pe = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(B) {
    return B.__proto__;
  } : null);
  function W0(B, T) {
    if (B === 1 / 0 || B === -1 / 0 || B !== B || B && B > -1e3 && B < 1e3 || t0.call(/e/, T))
      return T;
    var Y0 = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof B == "number") {
      var M1 = B < 0 ? -m0(-B) : m0(B);
      if (M1 !== B) {
        var z1 = String(M1), w0 = D.call(T, z1.length + 1);
        return V.call(z1, Y0, "$&_") + "." + V.call(V.call(w0, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return V.call(T, Y0, "$&_");
  }
  var re = CT, fe = re.custom, G1 = I(fe) ? fe : null, W2 = {
    __proto__: null,
    double: '"',
    single: "'"
  }, h2 = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Xc = function B(T, Y0, M1, z1) {
    var w0 = Y0 || {};
    if (z0(w0, "quoteStyle") && !z0(W2, w0.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (z0(w0, "maxStringLength") && (typeof w0.maxStringLength == "number" ? w0.maxStringLength < 0 && w0.maxStringLength !== 1 / 0 : w0.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Q2 = z0(w0, "customInspect") ? w0.customInspect : !0;
    if (typeof Q2 != "boolean" && Q2 !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (z0(w0, "indent") && w0.indent !== null && w0.indent !== "	" && !(parseInt(w0.indent, 10) === w0.indent && w0.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (z0(w0, "numericSeparator") && typeof w0.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var kt = w0.numericSeparator;
    if (typeof T > "u")
      return "undefined";
    if (T === null)
      return "null";
    if (typeof T == "boolean")
      return T ? "true" : "false";
    if (typeof T == "string")
      return Wp(T, w0);
    if (typeof T == "number") {
      if (T === 0)
        return 1 / 0 / T > 0 ? "0" : "-0";
      var Ne = String(T);
      return kt ? W0(T, Ne) : Ne;
    }
    if (typeof T == "bigint") {
      var ft = String(T) + "n";
      return kt ? W0(T, ft) : ft;
    }
    var HM = typeof w0.depth > "u" ? 5 : w0.depth;
    if (typeof M1 > "u" && (M1 = 0), M1 >= HM && HM > 0 && typeof T == "object")
      return x0(T) ? "[Array]" : "[Object]";
    var xt = UM(w0, M1);
    if (typeof z1 > "u")
      z1 = [];
    else if (_0(z1, T) >= 0)
      return "[Circular]";
    function e2(Rp, Vo, sr) {
      if (Vo && (z1 = y0.call(z1), z1.push(Vo)), sr) {
        var zn = {
          depth: w0.depth
        };
        return z0(w0, "quoteStyle") && (zn.quoteStyle = w0.quoteStyle), B(Rp, zn, M1 + 1, z1);
      }
      return B(Rp, w0, M1 + 1, z1);
    }
    if (typeof T == "function" && !a1(T)) {
      var pn = t1(T), on = mp(T, e2);
      return "[Function" + (pn ? ": " + pn : " (anonymous)") + "]" + (on.length > 0 ? " { " + b0.call(on, ", ") + " }" : "");
    }
    if (I(T)) {
      var Jo = Z0 ? V.call(String(T), /^(Symbol\(.*\))_[^)]*$/, "$1") : m1.call(T);
      return typeof T == "object" && !Z0 ? Et(Jo) : Jo;
    }
    if (ar(T)) {
      for (var eo = "<" + Y.call(String(T.nodeName)), to = T.attributes || [], $o = 0; $o < to.length; $o++)
        eo += " " + to[$o].name + "=" + ke(K1(to[$o].value), "double", w0);
      return eo += ">", T.childNodes && T.childNodes.length && (eo += "..."), eo += "</" + Y.call(String(T.nodeName)) + ">", eo;
    }
    if (x0(T)) {
      if (T.length === 0)
        return "[]";
      var JM = mp(T, e2);
      return xt && !FM(JM) ? "[" + jp(JM, xt) + "]" : "[ " + b0.call(JM, ", ") + " ]";
    }
    if (P0(T)) {
      var $M = mp(T, e2);
      return !("cause" in Error.prototype) && "cause" in T && !I1.call(T, "cause") ? "{ [" + String(T) + "] " + b0.call(j.call("[cause]: " + e2(T.cause), $M), ", ") + " }" : $M.length === 0 ? "[" + String(T) + "]" : "{ [" + String(T) + "] " + b0.call($M, ", ") + " }";
    }
    if (typeof T == "object" && Q2) {
      if (G1 && typeof T[G1] == "function" && re)
        return re(T, { depth: HM - M1 });
      if (Q2 !== "symbol" && typeof T.inspect == "function")
        return T.inspect();
    }
    if (g0(T)) {
      var Mn = [];
      return o && o.call(T, function(Rp, Vo) {
        Mn.push(e2(Vo, T, !0) + " => " + e2(Rp, T));
      }), Ho("Map", e.call(T), Mn, xt);
    }
    if (fp(T)) {
      var bn = [];
      return s && s.call(T, function(Rp) {
        bn.push(e2(Rp, T));
      }), Ho("Set", i.call(T), bn, xt);
    }
    if (je(T))
      return Zp("WeakMap");
    if (Qp(T))
      return Zp("WeakSet");
    if (K2(T))
      return Zp("WeakRef");
    if (E0(T))
      return Et(e2(Number(T)));
    if (E(T))
      return Et(e2(V0.call(T)));
    if (m(T))
      return Et(w.call(T));
    if (o1(T))
      return Et(e2(String(T)));
    if (typeof window < "u" && T === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && T === globalThis || typeof lM < "u" && T === lM)
      return "{ [object globalThis] }";
    if (!i1(T) && !a1(T)) {
      var VM = mp(T, e2), nn = pe ? pe(T) === Object.prototype : T instanceof Object || T.constructor === Object, YM = T instanceof Object ? "" : "null prototype", GM = !nn && ze && Object(T) === T && ze in T ? D.call(h0(T), 8, -1) : YM ? "Object" : "", Or = nn || typeof T.constructor != "function" ? "" : T.constructor.name ? T.constructor.name + " " : "", KM = Or + (GM || YM ? "[" + b0.call(j.call([], GM || [], YM || []), ": ") + "] " : "");
      return VM.length === 0 ? KM + "{}" : xt ? KM + "{" + jp(VM, xt) + "}" : KM + "{ " + b0.call(VM, ", ") + " }";
    }
    return String(T);
  };
  function ke(B, T, Y0) {
    var M1 = Y0.quoteStyle || T, z1 = W2[M1];
    return z1 + B + z1;
  }
  function K1(B) {
    return V.call(String(B), /"/g, "&quot;");
  }
  function d1(B) {
    return !ze || !(typeof B == "object" && (ze in B || typeof B[ze] < "u"));
  }
  function x0(B) {
    return h0(B) === "[object Array]" && d1(B);
  }
  function i1(B) {
    return h0(B) === "[object Date]" && d1(B);
  }
  function a1(B) {
    return h0(B) === "[object RegExp]" && d1(B);
  }
  function P0(B) {
    return h0(B) === "[object Error]" && d1(B);
  }
  function o1(B) {
    return h0(B) === "[object String]" && d1(B);
  }
  function E0(B) {
    return h0(B) === "[object Number]" && d1(B);
  }
  function m(B) {
    return h0(B) === "[object Boolean]" && d1(B);
  }
  function I(B) {
    if (Z0)
      return B && typeof B == "object" && B instanceof Symbol;
    if (typeof B == "symbol")
      return !0;
    if (!B || typeof B != "object" || !m1)
      return !1;
    try {
      return m1.call(B), !0;
    } catch {
    }
    return !1;
  }
  function E(B) {
    if (!B || typeof B != "object" || !V0)
      return !1;
    try {
      return V0.call(B), !0;
    } catch {
    }
    return !1;
  }
  var G = Object.prototype.hasOwnProperty || function(B) {
    return B in this;
  };
  function z0(B, T) {
    return G.call(B, T);
  }
  function h0(B) {
    return U.call(B);
  }
  function t1(B) {
    if (B.name)
      return B.name;
    var T = S.call(N.call(B), /^function\s*([\w$]+)/);
    return T ? T[1] : null;
  }
  function _0(B, T) {
    if (B.indexOf)
      return B.indexOf(T);
    for (var Y0 = 0, M1 = B.length; Y0 < M1; Y0++)
      if (B[Y0] === T)
        return Y0;
    return -1;
  }
  function g0(B) {
    if (!e || !B || typeof B != "object")
      return !1;
    try {
      e.call(B);
      try {
        i.call(B);
      } catch {
        return !0;
      }
      return B instanceof Map;
    } catch {
    }
    return !1;
  }
  function je(B) {
    if (!q || !B || typeof B != "object")
      return !1;
    try {
      q.call(B, q);
      try {
        h.call(B, h);
      } catch {
        return !0;
      }
      return B instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function K2(B) {
    if (!y || !B || typeof B != "object")
      return !1;
    try {
      return y.call(B), !0;
    } catch {
    }
    return !1;
  }
  function fp(B) {
    if (!i || !B || typeof B != "object")
      return !1;
    try {
      i.call(B);
      try {
        e.call(B);
      } catch {
        return !0;
      }
      return B instanceof Set;
    } catch {
    }
    return !1;
  }
  function Qp(B) {
    if (!h || !B || typeof B != "object")
      return !1;
    try {
      h.call(B, h);
      try {
        q.call(B, q);
      } catch {
        return !0;
      }
      return B instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function ar(B) {
    return !B || typeof B != "object" ? !1 : typeof HTMLElement < "u" && B instanceof HTMLElement ? !0 : typeof B.nodeName == "string" && typeof B.getAttribute == "function";
  }
  function Wp(B, T) {
    if (B.length > T.maxStringLength) {
      var Y0 = B.length - T.maxStringLength, M1 = "... " + Y0 + " more character" + (Y0 > 1 ? "s" : "");
      return Wp(D.call(B, 0, T.maxStringLength), T) + M1;
    }
    var z1 = h2[T.quoteStyle || "single"];
    z1.lastIndex = 0;
    var w0 = V.call(V.call(B, z1, "\\$1"), /[\x00-\x1f]/g, hp);
    return ke(w0, "single", T);
  }
  function hp(B) {
    var T = B.charCodeAt(0), Y0 = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[T];
    return Y0 ? "\\" + Y0 : "\\x" + (T < 16 ? "0" : "") + H.call(T.toString(16));
  }
  function Et(B) {
    return "Object(" + B + ")";
  }
  function Zp(B) {
    return B + " { ? }";
  }
  function Ho(B, T, Y0, M1) {
    var z1 = M1 ? jp(Y0, M1) : b0.call(Y0, ", ");
    return B + " (" + T + ") {" + z1 + "}";
  }
  function FM(B) {
    for (var T = 0; T < B.length; T++)
      if (_0(B[T], `
`) >= 0)
        return !1;
    return !0;
  }
  function UM(B, T) {
    var Y0;
    if (B.indent === "	")
      Y0 = "	";
    else if (typeof B.indent == "number" && B.indent > 0)
      Y0 = b0.call(Array(B.indent + 1), " ");
    else
      return null;
    return {
      base: Y0,
      prev: b0.call(Array(T + 1), Y0)
    };
  }
  function jp(B, T) {
    if (B.length === 0)
      return "";
    var Y0 = `
` + T.prev + T.base;
    return Y0 + b0.call(B, "," + Y0) + `
` + T.prev;
  }
  function mp(B, T) {
    var Y0 = x0(B), M1 = [];
    if (Y0) {
      M1.length = B.length;
      for (var z1 = 0; z1 < B.length; z1++)
        M1[z1] = z0(B, z1) ? T(B[z1], B) : "";
    }
    var w0 = typeof O0 == "function" ? O0(B) : [], Q2;
    if (Z0) {
      Q2 = {};
      for (var kt = 0; kt < w0.length; kt++)
        Q2["$" + w0[kt]] = w0[kt];
    }
    for (var Ne in B)
      z0(B, Ne) && (Y0 && String(Number(Ne)) === Ne && Ne < B.length || Z0 && Q2["$" + Ne] instanceof Symbol || (t0.call(/[^\w$]/, Ne) ? M1.push(T(Ne, B) + ": " + T(B[Ne], B)) : M1.push(Ne + ": " + T(B[Ne], B))));
    if (typeof O0 == "function")
      for (var ft = 0; ft < w0.length; ft++)
        I1.call(B, w0[ft]) && M1.push("[" + T(w0[ft]) + "]: " + T(B[w0[ft]], B));
    return M1;
  }
  return Xc;
}
var Cc, dA;
function IT() {
  if (dA) return Cc;
  dA = 1;
  var p = /* @__PURE__ */ cr(), t = /* @__PURE__ */ xM(), e = function(s, d, q) {
    for (var f = s, h; (h = f.next) != null; f = h)
      if (h.key === d)
        return f.next = h.next, q || (h.next = /** @type {NonNullable<typeof list.next>} */
        s.next, s.next = h), h;
  }, o = function(s, d) {
    if (s) {
      var q = e(s, d);
      return q && q.value;
    }
  }, b = function(s, d, q) {
    var f = e(s, d);
    f ? f.value = q : s.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: d,
      next: s.next,
      value: q
    };
  }, r = function(s, d) {
    return s ? !!e(s, d) : !1;
  }, i = function(s, d) {
    if (s)
      return e(s, d, !0);
  };
  return Cc = function() {
    var d, q = {
      assert: function(f) {
        if (!q.has(f))
          throw new t("Side channel does not contain " + p(f));
      },
      delete: function(f) {
        var h = d && d.next, g = i(d, f);
        return g && h && h === g && (d = void 0), !!g;
      },
      get: function(f) {
        return o(d, f);
      },
      has: function(f) {
        return r(d, f);
      },
      set: function(f, h) {
        d || (d = {
          next: void 0
        }), b(
          /** @type {NonNullable<typeof $o>} */
          d,
          f,
          h
        );
      }
    };
    return q;
  }, Cc;
}
var Ic, lA;
function Yl() {
  return lA || (lA = 1, Ic = Object), Ic;
}
var Pc, qA;
function PT() {
  return qA || (qA = 1, Pc = Error), Pc;
}
var Ec, fA;
function ET() {
  return fA || (fA = 1, Ec = EvalError), Ec;
}
var kc, WA;
function kT() {
  return WA || (WA = 1, kc = RangeError), kc;
}
var xc, hA;
function xT() {
  return hA || (hA = 1, xc = ReferenceError), xc;
}
var Fc, mA;
function FT() {
  return mA || (mA = 1, Fc = SyntaxError), Fc;
}
var Uc, RA;
function UT() {
  return RA || (RA = 1, Uc = URIError), Uc;
}
var Hc, yA;
function HT() {
  return yA || (yA = 1, Hc = Math.abs), Hc;
}
var Jc, gA;
function JT() {
  return gA || (gA = 1, Jc = Math.floor), Jc;
}
var $c, LA;
function $T() {
  return LA || (LA = 1, $c = Math.max), $c;
}
var Vc, vA;
function VT() {
  return vA || (vA = 1, Vc = Math.min), Vc;
}
var Yc, _A;
function YT() {
  return _A || (_A = 1, Yc = Math.pow), Yc;
}
var Gc, NA;
function GT() {
  return NA || (NA = 1, Gc = Math.round), Gc;
}
var Kc, BA;
function KT() {
  return BA || (BA = 1, Kc = Number.isNaN || function(t) {
    return t !== t;
  }), Kc;
}
var Qc, TA;
function QT() {
  if (TA) return Qc;
  TA = 1;
  var p = /* @__PURE__ */ KT();
  return Qc = function(e) {
    return p(e) || e === 0 ? e : e < 0 ? -1 : 1;
  }, Qc;
}
var Zc, wA;
function ZT() {
  return wA || (wA = 1, Zc = Object.getOwnPropertyDescriptor), Zc;
}
var jc, SA;
function Gl() {
  if (SA) return jc;
  SA = 1;
  var p = /* @__PURE__ */ ZT();
  if (p)
    try {
      p([], "length");
    } catch {
      p = null;
    }
  return jc = p, jc;
}
var ei, DA;
function jT() {
  if (DA) return ei;
  DA = 1;
  var p = Object.defineProperty || !1;
  if (p)
    try {
      p({}, "a", { value: 1 });
    } catch {
      p = !1;
    }
  return ei = p, ei;
}
var ti, XA;
function ew() {
  return XA || (XA = 1, ti = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = Symbol("test"), o = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var b = 42;
    t[e] = b;
    for (var r in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var i = Object.getOwnPropertySymbols(t);
    if (i.length !== 1 || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (s.value !== b || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), ti;
}
var pi, CA;
function tw() {
  if (CA) return pi;
  CA = 1;
  var p = typeof Symbol < "u" && Symbol, t = ew();
  return pi = function() {
    return typeof p != "function" || typeof Symbol != "function" || typeof p("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, pi;
}
var oi, IA;
function Kl() {
  return IA || (IA = 1, oi = typeof Reflect < "u" && Reflect.getPrototypeOf || null), oi;
}
var Mi, PA;
function Ql() {
  if (PA) return Mi;
  PA = 1;
  var p = /* @__PURE__ */ Yl();
  return Mi = p.getPrototypeOf || null, Mi;
}
var bi, EA;
function pw() {
  if (EA) return bi;
  EA = 1;
  var p = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, e = Math.max, o = "[object Function]", b = function(d, q) {
    for (var f = [], h = 0; h < d.length; h += 1)
      f[h] = d[h];
    for (var g = 0; g < q.length; g += 1)
      f[g + d.length] = q[g];
    return f;
  }, r = function(d, q) {
    for (var f = [], h = q, g = 0; h < d.length; h += 1, g += 1)
      f[g] = d[h];
    return f;
  }, i = function(s, d) {
    for (var q = "", f = 0; f < s.length; f += 1)
      q += s[f], f + 1 < s.length && (q += d);
    return q;
  };
  return bi = function(d) {
    var q = this;
    if (typeof q != "function" || t.apply(q) !== o)
      throw new TypeError(p + q);
    for (var f = r(arguments, 1), h, g = function() {
      if (this instanceof h) {
        var S = q.apply(
          this,
          b(f, arguments)
        );
        return Object(S) === S ? S : this;
      }
      return q.apply(
        d,
        b(f, arguments)
      );
    }, y = e(0, q.length - f.length), w = [], U = 0; U < y; U++)
      w[U] = "$" + U;
    if (h = Function("binder", "return function (" + i(w, ",") + "){ return binder.apply(this,arguments); }")(g), q.prototype) {
      var N = function() {
      };
      N.prototype = q.prototype, h.prototype = new N(), N.prototype = null;
    }
    return h;
  }, bi;
}
var ni, kA;
function ir() {
  if (kA) return ni;
  kA = 1;
  var p = pw();
  return ni = Function.prototype.bind || p, ni;
}
var zi, xA;
function nO() {
  return xA || (xA = 1, zi = Function.prototype.call), zi;
}
var ri, FA;
function Zl() {
  return FA || (FA = 1, ri = Function.prototype.apply), ri;
}
var ci, UA;
function ow() {
  return UA || (UA = 1, ci = typeof Reflect < "u" && Reflect && Reflect.apply), ci;
}
var ii, HA;
function Mw() {
  if (HA) return ii;
  HA = 1;
  var p = ir(), t = Zl(), e = nO(), o = ow();
  return ii = o || p.call(e, t), ii;
}
var ai, JA;
function jl() {
  if (JA) return ai;
  JA = 1;
  var p = ir(), t = /* @__PURE__ */ xM(), e = nO(), o = Mw();
  return ai = function(r) {
    if (r.length < 1 || typeof r[0] != "function")
      throw new t("a function is required");
    return o(p, e, r);
  }, ai;
}
var Oi, $A;
function bw() {
  if ($A) return Oi;
  $A = 1;
  var p = jl(), t = /* @__PURE__ */ Gl(), e;
  try {
    e = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var o = !!e && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), b = Object, r = b.getPrototypeOf;
  return Oi = o && typeof o.get == "function" ? p([o.get]) : typeof r == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return r(s == null ? s : b(s));
    }
  ) : !1, Oi;
}
var si, VA;
function nw() {
  if (VA) return si;
  VA = 1;
  var p = Kl(), t = Ql(), e = /* @__PURE__ */ bw();
  return si = p ? function(b) {
    return p(b);
  } : t ? function(b) {
    if (!b || typeof b != "object" && typeof b != "function")
      throw new TypeError("getProto: not an object");
    return t(b);
  } : e ? function(b) {
    return e(b);
  } : null, si;
}
var Ai, YA;
function zw() {
  if (YA) return Ai;
  YA = 1;
  var p = Function.prototype.call, t = Object.prototype.hasOwnProperty, e = ir();
  return Ai = e.call(p, t), Ai;
}
var ui, GA;
function zO() {
  if (GA) return ui;
  GA = 1;
  var p, t = /* @__PURE__ */ Yl(), e = /* @__PURE__ */ PT(), o = /* @__PURE__ */ ET(), b = /* @__PURE__ */ kT(), r = /* @__PURE__ */ xT(), i = /* @__PURE__ */ FT(), s = /* @__PURE__ */ xM(), d = /* @__PURE__ */ UT(), q = /* @__PURE__ */ HT(), f = /* @__PURE__ */ JT(), h = /* @__PURE__ */ $T(), g = /* @__PURE__ */ VT(), y = /* @__PURE__ */ YT(), w = /* @__PURE__ */ GT(), U = /* @__PURE__ */ QT(), N = Function, S = function(a1) {
    try {
      return N('"use strict"; return (' + a1 + ").constructor;")();
    } catch {
    }
  }, D = /* @__PURE__ */ Gl(), V = /* @__PURE__ */ jT(), H = function() {
    throw new s();
  }, Y = D ? (function() {
    try {
      return arguments.callee, H;
    } catch {
      try {
        return D(arguments, "callee").get;
      } catch {
        return H;
      }
    }
  })() : H, t0 = tw()(), j = nw(), b0 = Ql(), y0 = Kl(), m0 = Zl(), V0 = nO(), O0 = {}, m1 = typeof Uint8Array > "u" || !j ? p : j(Uint8Array), Z0 = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? p : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? p : ArrayBuffer,
    "%ArrayIteratorPrototype%": t0 && j ? j([][Symbol.iterator]()) : p,
    "%AsyncFromSyncIteratorPrototype%": p,
    "%AsyncFunction%": O0,
    "%AsyncGenerator%": O0,
    "%AsyncGeneratorFunction%": O0,
    "%AsyncIteratorPrototype%": O0,
    "%Atomics%": typeof Atomics > "u" ? p : Atomics,
    "%BigInt%": typeof BigInt > "u" ? p : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? p : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? p : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? p : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": o,
    "%Float16Array%": typeof Float16Array > "u" ? p : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? p : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? p : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? p : FinalizationRegistry,
    "%Function%": N,
    "%GeneratorFunction%": O0,
    "%Int8Array%": typeof Int8Array > "u" ? p : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? p : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? p : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": t0 && j ? j(j([][Symbol.iterator]())) : p,
    "%JSON%": typeof JSON == "object" ? JSON : p,
    "%Map%": typeof Map > "u" ? p : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !t0 || !j ? p : j((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": D,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? p : Promise,
    "%Proxy%": typeof Proxy > "u" ? p : Proxy,
    "%RangeError%": b,
    "%ReferenceError%": r,
    "%Reflect%": typeof Reflect > "u" ? p : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? p : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !t0 || !j ? p : j((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? p : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": t0 && j ? j(""[Symbol.iterator]()) : p,
    "%Symbol%": t0 ? Symbol : p,
    "%SyntaxError%": i,
    "%ThrowTypeError%": Y,
    "%TypedArray%": m1,
    "%TypeError%": s,
    "%Uint8Array%": typeof Uint8Array > "u" ? p : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? p : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? p : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? p : Uint32Array,
    "%URIError%": d,
    "%WeakMap%": typeof WeakMap > "u" ? p : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? p : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? p : WeakSet,
    "%Function.prototype.call%": V0,
    "%Function.prototype.apply%": m0,
    "%Object.defineProperty%": V,
    "%Object.getPrototypeOf%": b0,
    "%Math.abs%": q,
    "%Math.floor%": f,
    "%Math.max%": h,
    "%Math.min%": g,
    "%Math.pow%": y,
    "%Math.round%": w,
    "%Math.sign%": U,
    "%Reflect.getPrototypeOf%": y0
  };
  if (j)
    try {
      null.error;
    } catch (a1) {
      var ze = j(j(a1));
      Z0["%Error.prototype%"] = ze;
    }
  var I1 = function a1(P0) {
    var o1;
    if (P0 === "%AsyncFunction%")
      o1 = S("async function () {}");
    else if (P0 === "%GeneratorFunction%")
      o1 = S("function* () {}");
    else if (P0 === "%AsyncGeneratorFunction%")
      o1 = S("async function* () {}");
    else if (P0 === "%AsyncGenerator%") {
      var E0 = a1("%AsyncGeneratorFunction%");
      E0 && (o1 = E0.prototype);
    } else if (P0 === "%AsyncIteratorPrototype%") {
      var m = a1("%AsyncGenerator%");
      m && j && (o1 = j(m.prototype));
    }
    return Z0[P0] = o1, o1;
  }, pe = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, W0 = ir(), re = /* @__PURE__ */ zw(), fe = W0.call(V0, Array.prototype.concat), G1 = W0.call(m0, Array.prototype.splice), W2 = W0.call(V0, String.prototype.replace), h2 = W0.call(V0, String.prototype.slice), ke = W0.call(V0, RegExp.prototype.exec), K1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, d1 = /\\(\\)?/g, x0 = function(P0) {
    var o1 = h2(P0, 0, 1), E0 = h2(P0, -1);
    if (o1 === "%" && E0 !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (E0 === "%" && o1 !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var m = [];
    return W2(P0, K1, function(I, E, G, z0) {
      m[m.length] = G ? W2(z0, d1, "$1") : E || I;
    }), m;
  }, i1 = function(P0, o1) {
    var E0 = P0, m;
    if (re(pe, E0) && (m = pe[E0], E0 = "%" + m[0] + "%"), re(Z0, E0)) {
      var I = Z0[E0];
      if (I === O0 && (I = I1(E0)), typeof I > "u" && !o1)
        throw new s("intrinsic " + P0 + " exists, but is not available. Please file an issue!");
      return {
        alias: m,
        name: E0,
        value: I
      };
    }
    throw new i("intrinsic " + P0 + " does not exist!");
  };
  return ui = function(P0, o1) {
    if (typeof P0 != "string" || P0.length === 0)
      throw new s("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof o1 != "boolean")
      throw new s('"allowMissing" argument must be a boolean');
    if (ke(/^%?[^%]*%?$/, P0) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var E0 = x0(P0), m = E0.length > 0 ? E0[0] : "", I = i1("%" + m + "%", o1), E = I.name, G = I.value, z0 = !1, h0 = I.alias;
    h0 && (m = h0[0], G1(E0, fe([0, 1], h0)));
    for (var t1 = 1, _0 = !0; t1 < E0.length; t1 += 1) {
      var g0 = E0[t1], je = h2(g0, 0, 1), K2 = h2(g0, -1);
      if ((je === '"' || je === "'" || je === "`" || K2 === '"' || K2 === "'" || K2 === "`") && je !== K2)
        throw new i("property names with quotes must have matching quotes");
      if ((g0 === "constructor" || !_0) && (z0 = !0), m += "." + g0, E = "%" + m + "%", re(Z0, E))
        G = Z0[E];
      else if (G != null) {
        if (!(g0 in G)) {
          if (!o1)
            throw new s("base intrinsic for " + P0 + " exists, but the property is not available.");
          return;
        }
        if (D && t1 + 1 >= E0.length) {
          var fp = D(G, g0);
          _0 = !!fp, _0 && "get" in fp && !("originalValue" in fp.get) ? G = fp.get : G = G[g0];
        } else
          _0 = re(G, g0), G = G[g0];
        _0 && !z0 && (Z0[E] = G);
      }
    }
    return G;
  }, ui;
}
var di, KA;
function e4() {
  if (KA) return di;
  KA = 1;
  var p = /* @__PURE__ */ zO(), t = jl(), e = t([p("%String.prototype.indexOf%")]);
  return di = function(b, r) {
    var i = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      p(b, !!r)
    );
    return typeof i == "function" && e(b, ".prototype.") > -1 ? t(
      /** @type {const} */
      [i]
    ) : i;
  }, di;
}
var li, QA;
function t4() {
  if (QA) return li;
  QA = 1;
  var p = /* @__PURE__ */ zO(), t = /* @__PURE__ */ e4(), e = /* @__PURE__ */ cr(), o = /* @__PURE__ */ xM(), b = p("%Map%", !0), r = t("Map.prototype.get", !0), i = t("Map.prototype.set", !0), s = t("Map.prototype.has", !0), d = t("Map.prototype.delete", !0), q = t("Map.prototype.size", !0);
  return li = !!b && /** @type {Exclude<import('.'), false>} */
  function() {
    var h, g = {
      assert: function(y) {
        if (!g.has(y))
          throw new o("Side channel does not contain " + e(y));
      },
      delete: function(y) {
        if (h) {
          var w = d(h, y);
          return q(h) === 0 && (h = void 0), w;
        }
        return !1;
      },
      get: function(y) {
        if (h)
          return r(h, y);
      },
      has: function(y) {
        return h ? s(h, y) : !1;
      },
      set: function(y, w) {
        h || (h = new b()), i(h, y, w);
      }
    };
    return g;
  }, li;
}
var qi, ZA;
function rw() {
  if (ZA) return qi;
  ZA = 1;
  var p = /* @__PURE__ */ zO(), t = /* @__PURE__ */ e4(), e = /* @__PURE__ */ cr(), o = t4(), b = /* @__PURE__ */ xM(), r = p("%WeakMap%", !0), i = t("WeakMap.prototype.get", !0), s = t("WeakMap.prototype.set", !0), d = t("WeakMap.prototype.has", !0), q = t("WeakMap.prototype.delete", !0);
  return qi = r ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var h, g, y = {
        assert: function(w) {
          if (!y.has(w))
            throw new b("Side channel does not contain " + e(w));
        },
        delete: function(w) {
          if (r && w && (typeof w == "object" || typeof w == "function")) {
            if (h)
              return q(h, w);
          } else if (o && g)
            return g.delete(w);
          return !1;
        },
        get: function(w) {
          return r && w && (typeof w == "object" || typeof w == "function") && h ? i(h, w) : g && g.get(w);
        },
        has: function(w) {
          return r && w && (typeof w == "object" || typeof w == "function") && h ? d(h, w) : !!g && g.has(w);
        },
        set: function(w, U) {
          r && w && (typeof w == "object" || typeof w == "function") ? (h || (h = new r()), s(h, w, U)) : o && (g || (g = o()), g.set(w, U));
        }
      };
      return y;
    }
  ) : o, qi;
}
var fi, jA;
function cw() {
  if (jA) return fi;
  jA = 1;
  var p = /* @__PURE__ */ xM(), t = /* @__PURE__ */ cr(), e = IT(), o = t4(), b = rw(), r = b || o || e;
  return fi = function() {
    var s, d = {
      assert: function(q) {
        if (!d.has(q))
          throw new p("Side channel does not contain " + t(q));
      },
      delete: function(q) {
        return !!s && s.delete(q);
      },
      get: function(q) {
        return s && s.get(q);
      },
      has: function(q) {
        return !!s && s.has(q);
      },
      set: function(q, f) {
        s || (s = r()), s.set(q, f);
      }
    };
    return d;
  }, fi;
}
var Wi, eu;
function rO() {
  if (eu) return Wi;
  eu = 1;
  var p = String.prototype.replace, t = /%20/g, e = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Wi = {
    default: e.RFC3986,
    formatters: {
      RFC1738: function(o) {
        return p.call(o, t, "+");
      },
      RFC3986: function(o) {
        return String(o);
      }
    },
    RFC1738: e.RFC1738,
    RFC3986: e.RFC3986
  }, Wi;
}
var hi, tu;
function p4() {
  if (tu) return hi;
  tu = 1;
  var p = /* @__PURE__ */ rO(), t = Object.prototype.hasOwnProperty, e = Array.isArray, o = (function() {
    for (var N = [], S = 0; S < 256; ++S)
      N.push("%" + ((S < 16 ? "0" : "") + S.toString(16)).toUpperCase());
    return N;
  })(), b = function(S) {
    for (; S.length > 1; ) {
      var D = S.pop(), V = D.obj[D.prop];
      if (e(V)) {
        for (var H = [], Y = 0; Y < V.length; ++Y)
          typeof V[Y] < "u" && H.push(V[Y]);
        D.obj[D.prop] = H;
      }
    }
  }, r = function(S, D) {
    for (var V = D && D.plainObjects ? { __proto__: null } : {}, H = 0; H < S.length; ++H)
      typeof S[H] < "u" && (V[H] = S[H]);
    return V;
  }, i = function N(S, D, V) {
    if (!D)
      return S;
    if (typeof D != "object" && typeof D != "function") {
      if (e(S))
        S.push(D);
      else if (S && typeof S == "object")
        (V && (V.plainObjects || V.allowPrototypes) || !t.call(Object.prototype, D)) && (S[D] = !0);
      else
        return [S, D];
      return S;
    }
    if (!S || typeof S != "object")
      return [S].concat(D);
    var H = S;
    return e(S) && !e(D) && (H = r(S, V)), e(S) && e(D) ? (D.forEach(function(Y, t0) {
      if (t.call(S, t0)) {
        var j = S[t0];
        j && typeof j == "object" && Y && typeof Y == "object" ? S[t0] = N(j, Y, V) : S.push(Y);
      } else
        S[t0] = Y;
    }), S) : Object.keys(D).reduce(function(Y, t0) {
      var j = D[t0];
      return t.call(Y, t0) ? Y[t0] = N(Y[t0], j, V) : Y[t0] = j, Y;
    }, H);
  }, s = function(S, D) {
    return Object.keys(D).reduce(function(V, H) {
      return V[H] = D[H], V;
    }, S);
  }, d = function(N, S, D) {
    var V = N.replace(/\+/g, " ");
    if (D === "iso-8859-1")
      return V.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(V);
    } catch {
      return V;
    }
  }, q = 1024, f = function(S, D, V, H, Y) {
    if (S.length === 0)
      return S;
    var t0 = S;
    if (typeof S == "symbol" ? t0 = Symbol.prototype.toString.call(S) : typeof S != "string" && (t0 = String(S)), V === "iso-8859-1")
      return escape(t0).replace(/%u[0-9a-f]{4}/gi, function(m1) {
        return "%26%23" + parseInt(m1.slice(2), 16) + "%3B";
      });
    for (var j = "", b0 = 0; b0 < t0.length; b0 += q) {
      for (var y0 = t0.length >= q ? t0.slice(b0, b0 + q) : t0, m0 = [], V0 = 0; V0 < y0.length; ++V0) {
        var O0 = y0.charCodeAt(V0);
        if (O0 === 45 || O0 === 46 || O0 === 95 || O0 === 126 || O0 >= 48 && O0 <= 57 || O0 >= 65 && O0 <= 90 || O0 >= 97 && O0 <= 122 || Y === p.RFC1738 && (O0 === 40 || O0 === 41)) {
          m0[m0.length] = y0.charAt(V0);
          continue;
        }
        if (O0 < 128) {
          m0[m0.length] = o[O0];
          continue;
        }
        if (O0 < 2048) {
          m0[m0.length] = o[192 | O0 >> 6] + o[128 | O0 & 63];
          continue;
        }
        if (O0 < 55296 || O0 >= 57344) {
          m0[m0.length] = o[224 | O0 >> 12] + o[128 | O0 >> 6 & 63] + o[128 | O0 & 63];
          continue;
        }
        V0 += 1, O0 = 65536 + ((O0 & 1023) << 10 | y0.charCodeAt(V0) & 1023), m0[m0.length] = o[240 | O0 >> 18] + o[128 | O0 >> 12 & 63] + o[128 | O0 >> 6 & 63] + o[128 | O0 & 63];
      }
      j += m0.join("");
    }
    return j;
  }, h = function(S) {
    for (var D = [{ obj: { o: S }, prop: "o" }], V = [], H = 0; H < D.length; ++H)
      for (var Y = D[H], t0 = Y.obj[Y.prop], j = Object.keys(t0), b0 = 0; b0 < j.length; ++b0) {
        var y0 = j[b0], m0 = t0[y0];
        typeof m0 == "object" && m0 !== null && V.indexOf(m0) === -1 && (D.push({ obj: t0, prop: y0 }), V.push(m0));
      }
    return b(D), S;
  }, g = function(S) {
    return Object.prototype.toString.call(S) === "[object RegExp]";
  }, y = function(S) {
    return !S || typeof S != "object" ? !1 : !!(S.constructor && S.constructor.isBuffer && S.constructor.isBuffer(S));
  }, w = function(S, D) {
    return [].concat(S, D);
  }, U = function(S, D) {
    if (e(S)) {
      for (var V = [], H = 0; H < S.length; H += 1)
        V.push(D(S[H]));
      return V;
    }
    return D(S);
  };
  return hi = {
    arrayToObject: r,
    assign: s,
    combine: w,
    compact: h,
    decode: d,
    encode: f,
    isBuffer: y,
    isRegExp: g,
    maybeMap: U,
    merge: i
  }, hi;
}
var mi, pu;
function iw() {
  if (pu) return mi;
  pu = 1;
  var p = cw(), t = /* @__PURE__ */ p4(), e = /* @__PURE__ */ rO(), o = Object.prototype.hasOwnProperty, b = {
    brackets: function(N) {
      return N + "[]";
    },
    comma: "comma",
    indices: function(N, S) {
      return N + "[" + S + "]";
    },
    repeat: function(N) {
      return N;
    }
  }, r = Array.isArray, i = Array.prototype.push, s = function(U, N) {
    i.apply(U, r(N) ? N : [N]);
  }, d = Date.prototype.toISOString, q = e.default, f = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: q,
    formatter: e.formatters[q],
    // deprecated
    indices: !1,
    serializeDate: function(N) {
      return d.call(N);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, h = function(N) {
    return typeof N == "string" || typeof N == "number" || typeof N == "boolean" || typeof N == "symbol" || typeof N == "bigint";
  }, g = {}, y = function U(N, S, D, V, H, Y, t0, j, b0, y0, m0, V0, O0, m1, Z0, ze, I1, pe) {
    for (var W0 = N, re = pe, fe = 0, G1 = !1; (re = re.get(g)) !== void 0 && !G1; ) {
      var W2 = re.get(N);
      if (fe += 1, typeof W2 < "u") {
        if (W2 === fe)
          throw new RangeError("Cyclic object value");
        G1 = !0;
      }
      typeof re.get(g) > "u" && (fe = 0);
    }
    if (typeof y0 == "function" ? W0 = y0(S, W0) : W0 instanceof Date ? W0 = O0(W0) : D === "comma" && r(W0) && (W0 = t.maybeMap(W0, function(E) {
      return E instanceof Date ? O0(E) : E;
    })), W0 === null) {
      if (Y)
        return b0 && !ze ? b0(S, f.encoder, I1, "key", m1) : S;
      W0 = "";
    }
    if (h(W0) || t.isBuffer(W0)) {
      if (b0) {
        var h2 = ze ? S : b0(S, f.encoder, I1, "key", m1);
        return [Z0(h2) + "=" + Z0(b0(W0, f.encoder, I1, "value", m1))];
      }
      return [Z0(S) + "=" + Z0(String(W0))];
    }
    var ke = [];
    if (typeof W0 > "u")
      return ke;
    var K1;
    if (D === "comma" && r(W0))
      ze && b0 && (W0 = t.maybeMap(W0, b0)), K1 = [{ value: W0.length > 0 ? W0.join(",") || null : void 0 }];
    else if (r(y0))
      K1 = y0;
    else {
      var d1 = Object.keys(W0);
      K1 = m0 ? d1.sort(m0) : d1;
    }
    var x0 = j ? String(S).replace(/\./g, "%2E") : String(S), i1 = V && r(W0) && W0.length === 1 ? x0 + "[]" : x0;
    if (H && r(W0) && W0.length === 0)
      return i1 + "[]";
    for (var a1 = 0; a1 < K1.length; ++a1) {
      var P0 = K1[a1], o1 = typeof P0 == "object" && P0 && typeof P0.value < "u" ? P0.value : W0[P0];
      if (!(t0 && o1 === null)) {
        var E0 = V0 && j ? String(P0).replace(/\./g, "%2E") : String(P0), m = r(W0) ? typeof D == "function" ? D(i1, E0) : i1 : i1 + (V0 ? "." + E0 : "[" + E0 + "]");
        pe.set(N, fe);
        var I = p();
        I.set(g, pe), s(ke, U(
          o1,
          m,
          D,
          V,
          H,
          Y,
          t0,
          j,
          D === "comma" && ze && r(W0) ? null : b0,
          y0,
          m0,
          V0,
          O0,
          m1,
          Z0,
          ze,
          I1,
          I
        ));
      }
    }
    return ke;
  }, w = function(N) {
    if (!N)
      return f;
    if (typeof N.allowEmptyArrays < "u" && typeof N.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof N.encodeDotInKeys < "u" && typeof N.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (N.encoder !== null && typeof N.encoder < "u" && typeof N.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var S = N.charset || f.charset;
    if (typeof N.charset < "u" && N.charset !== "utf-8" && N.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var D = e.default;
    if (typeof N.format < "u") {
      if (!o.call(e.formatters, N.format))
        throw new TypeError("Unknown format option provided.");
      D = N.format;
    }
    var V = e.formatters[D], H = f.filter;
    (typeof N.filter == "function" || r(N.filter)) && (H = N.filter);
    var Y;
    if (N.arrayFormat in b ? Y = N.arrayFormat : "indices" in N ? Y = N.indices ? "indices" : "repeat" : Y = f.arrayFormat, "commaRoundTrip" in N && typeof N.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var t0 = typeof N.allowDots > "u" ? N.encodeDotInKeys === !0 ? !0 : f.allowDots : !!N.allowDots;
    return {
      addQueryPrefix: typeof N.addQueryPrefix == "boolean" ? N.addQueryPrefix : f.addQueryPrefix,
      allowDots: t0,
      allowEmptyArrays: typeof N.allowEmptyArrays == "boolean" ? !!N.allowEmptyArrays : f.allowEmptyArrays,
      arrayFormat: Y,
      charset: S,
      charsetSentinel: typeof N.charsetSentinel == "boolean" ? N.charsetSentinel : f.charsetSentinel,
      commaRoundTrip: !!N.commaRoundTrip,
      delimiter: typeof N.delimiter > "u" ? f.delimiter : N.delimiter,
      encode: typeof N.encode == "boolean" ? N.encode : f.encode,
      encodeDotInKeys: typeof N.encodeDotInKeys == "boolean" ? N.encodeDotInKeys : f.encodeDotInKeys,
      encoder: typeof N.encoder == "function" ? N.encoder : f.encoder,
      encodeValuesOnly: typeof N.encodeValuesOnly == "boolean" ? N.encodeValuesOnly : f.encodeValuesOnly,
      filter: H,
      format: D,
      formatter: V,
      serializeDate: typeof N.serializeDate == "function" ? N.serializeDate : f.serializeDate,
      skipNulls: typeof N.skipNulls == "boolean" ? N.skipNulls : f.skipNulls,
      sort: typeof N.sort == "function" ? N.sort : null,
      strictNullHandling: typeof N.strictNullHandling == "boolean" ? N.strictNullHandling : f.strictNullHandling
    };
  };
  return mi = function(U, N) {
    var S = U, D = w(N), V, H;
    typeof D.filter == "function" ? (H = D.filter, S = H("", S)) : r(D.filter) && (H = D.filter, V = H);
    var Y = [];
    if (typeof S != "object" || S === null)
      return "";
    var t0 = b[D.arrayFormat], j = t0 === "comma" && D.commaRoundTrip;
    V || (V = Object.keys(S)), D.sort && V.sort(D.sort);
    for (var b0 = p(), y0 = 0; y0 < V.length; ++y0) {
      var m0 = V[y0], V0 = S[m0];
      D.skipNulls && V0 === null || s(Y, y(
        V0,
        m0,
        t0,
        j,
        D.allowEmptyArrays,
        D.strictNullHandling,
        D.skipNulls,
        D.encodeDotInKeys,
        D.encode ? D.encoder : null,
        D.filter,
        D.sort,
        D.allowDots,
        D.serializeDate,
        D.format,
        D.formatter,
        D.encodeValuesOnly,
        D.charset,
        b0
      ));
    }
    var O0 = Y.join(D.delimiter), m1 = D.addQueryPrefix === !0 ? "?" : "";
    return D.charsetSentinel && (D.charset === "iso-8859-1" ? m1 += "utf8=%26%2310003%3B&" : m1 += "utf8=%E2%9C%93&"), O0.length > 0 ? m1 + O0 : "";
  }, mi;
}
var Ri, ou;
function aw() {
  if (ou) return Ri;
  ou = 1;
  var p = /* @__PURE__ */ p4(), t = Object.prototype.hasOwnProperty, e = Array.isArray, o = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: p.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, b = function(g) {
    return g.replace(/&#(\d+);/g, function(y, w) {
      return String.fromCharCode(parseInt(w, 10));
    });
  }, r = function(g, y, w) {
    if (g && typeof g == "string" && y.comma && g.indexOf(",") > -1)
      return g.split(",");
    if (y.throwOnLimitExceeded && w >= y.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + y.arrayLimit + " element" + (y.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return g;
  }, i = "utf8=%26%2310003%3B", s = "utf8=%E2%9C%93", d = function(y, w) {
    var U = { __proto__: null }, N = w.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
    N = N.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var S = w.parameterLimit === 1 / 0 ? void 0 : w.parameterLimit, D = N.split(
      w.delimiter,
      w.throwOnLimitExceeded ? S + 1 : S
    );
    if (w.throwOnLimitExceeded && D.length > S)
      throw new RangeError("Parameter limit exceeded. Only " + S + " parameter" + (S === 1 ? "" : "s") + " allowed.");
    var V = -1, H, Y = w.charset;
    if (w.charsetSentinel)
      for (H = 0; H < D.length; ++H)
        D[H].indexOf("utf8=") === 0 && (D[H] === s ? Y = "utf-8" : D[H] === i && (Y = "iso-8859-1"), V = H, H = D.length);
    for (H = 0; H < D.length; ++H)
      if (H !== V) {
        var t0 = D[H], j = t0.indexOf("]="), b0 = j === -1 ? t0.indexOf("=") : j + 1, y0, m0;
        b0 === -1 ? (y0 = w.decoder(t0, o.decoder, Y, "key"), m0 = w.strictNullHandling ? null : "") : (y0 = w.decoder(t0.slice(0, b0), o.decoder, Y, "key"), m0 = p.maybeMap(
          r(
            t0.slice(b0 + 1),
            w,
            e(U[y0]) ? U[y0].length : 0
          ),
          function(O0) {
            return w.decoder(O0, o.decoder, Y, "value");
          }
        )), m0 && w.interpretNumericEntities && Y === "iso-8859-1" && (m0 = b(String(m0))), t0.indexOf("[]=") > -1 && (m0 = e(m0) ? [m0] : m0);
        var V0 = t.call(U, y0);
        V0 && w.duplicates === "combine" ? U[y0] = p.combine(U[y0], m0) : (!V0 || w.duplicates === "last") && (U[y0] = m0);
      }
    return U;
  }, q = function(g, y, w, U) {
    var N = 0;
    if (g.length > 0 && g[g.length - 1] === "[]") {
      var S = g.slice(0, -1).join("");
      N = Array.isArray(y) && y[S] ? y[S].length : 0;
    }
    for (var D = U ? y : r(y, w, N), V = g.length - 1; V >= 0; --V) {
      var H, Y = g[V];
      if (Y === "[]" && w.parseArrays)
        H = w.allowEmptyArrays && (D === "" || w.strictNullHandling && D === null) ? [] : p.combine([], D);
      else {
        H = w.plainObjects ? { __proto__: null } : {};
        var t0 = Y.charAt(0) === "[" && Y.charAt(Y.length - 1) === "]" ? Y.slice(1, -1) : Y, j = w.decodeDotInKeys ? t0.replace(/%2E/g, ".") : t0, b0 = parseInt(j, 10);
        !w.parseArrays && j === "" ? H = { 0: D } : !isNaN(b0) && Y !== j && String(b0) === j && b0 >= 0 && w.parseArrays && b0 <= w.arrayLimit ? (H = [], H[b0] = D) : j !== "__proto__" && (H[j] = D);
      }
      D = H;
    }
    return D;
  }, f = function(y, w, U, N) {
    if (y) {
      var S = U.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, D = /(\[[^[\]]*])/, V = /(\[[^[\]]*])/g, H = U.depth > 0 && D.exec(S), Y = H ? S.slice(0, H.index) : S, t0 = [];
      if (Y) {
        if (!U.plainObjects && t.call(Object.prototype, Y) && !U.allowPrototypes)
          return;
        t0.push(Y);
      }
      for (var j = 0; U.depth > 0 && (H = V.exec(S)) !== null && j < U.depth; ) {
        if (j += 1, !U.plainObjects && t.call(Object.prototype, H[1].slice(1, -1)) && !U.allowPrototypes)
          return;
        t0.push(H[1]);
      }
      if (H) {
        if (U.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + U.depth + " and strictDepth is true");
        t0.push("[" + S.slice(H.index) + "]");
      }
      return q(t0, w, U, N);
    }
  }, h = function(y) {
    if (!y)
      return o;
    if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof y.throwOnLimitExceeded < "u" && typeof y.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var w = typeof y.charset > "u" ? o.charset : y.charset, U = typeof y.duplicates > "u" ? o.duplicates : y.duplicates;
    if (U !== "combine" && U !== "first" && U !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var N = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : o.allowDots : !!y.allowDots;
    return {
      allowDots: N,
      allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : o.allowEmptyArrays,
      allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : o.allowPrototypes,
      allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : o.allowSparse,
      arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : o.arrayLimit,
      charset: w,
      charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : o.charsetSentinel,
      comma: typeof y.comma == "boolean" ? y.comma : o.comma,
      decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : o.decodeDotInKeys,
      decoder: typeof y.decoder == "function" ? y.decoder : o.decoder,
      delimiter: typeof y.delimiter == "string" || p.isRegExp(y.delimiter) ? y.delimiter : o.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : o.depth,
      duplicates: U,
      ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : o.interpretNumericEntities,
      parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : o.parameterLimit,
      parseArrays: y.parseArrays !== !1,
      plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : o.plainObjects,
      strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : o.strictDepth,
      strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : o.strictNullHandling,
      throwOnLimitExceeded: typeof y.throwOnLimitExceeded == "boolean" ? y.throwOnLimitExceeded : !1
    };
  };
  return Ri = function(g, y) {
    var w = h(y);
    if (g === "" || g === null || typeof g > "u")
      return w.plainObjects ? { __proto__: null } : {};
    for (var U = typeof g == "string" ? d(g, w) : g, N = w.plainObjects ? { __proto__: null } : {}, S = Object.keys(U), D = 0; D < S.length; ++D) {
      var V = S[D], H = f(V, U[V], w, typeof g == "string");
      N = p.merge(N, H, w);
    }
    return w.allowSparse === !0 ? N : p.compact(N);
  }, Ri;
}
var yi, Mu;
function Ow() {
  if (Mu) return yi;
  Mu = 1;
  var p = /* @__PURE__ */ iw(), t = /* @__PURE__ */ aw(), e = /* @__PURE__ */ rO();
  return yi = {
    formats: e,
    parse: t,
    stringify: p
  }, yi;
}
var sw = /* @__PURE__ */ Ow();
const Aw = /* @__PURE__ */ wa(sw);
class uw {
  constructor(t) {
    z(this, "axios");
    this.apiUrl = t, this.axios = Am.create();
  }
  async execute(t, e) {
    var o, b, r;
    try {
      const i = this.buildUrl(t);
      t.headers || (t.headers = {
        "Content-Type": "application/json"
      });
      let s;
      switch (t.method) {
        case "GET": {
          const d = ((o = t.fields) == null ? void 0 : o.replace(new RegExp(`\r?
| `, "g"), "")) ?? null;
          let q = { ...t.body, fields: d };
          s = await this.axios.get(i, {
            params: q,
            headers: t.headers,
            paramsSerializer: (f) => {
              const h = JSON.parse(JSON.stringify(f));
              return Aw.stringify(h);
            },
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "POST": {
          s = await this.axios.post(i, t.body, {
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "PUT": {
          s = await this.axios.put(i, t.body, {
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "DELETE": {
          s = await this.axios.delete(i, {
            params: t.body,
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
      }
      return await this.parseResponseData(t.responseType, s);
    } catch (i) {
      return (i.response == null || i.response.data == null) && console.error("Network error", i), {
        success: !1,
        errors: ((r = (b = i.response) == null ? void 0 : b.data) == null ? void 0 : r.errors) ?? [],
        body: void 0,
        resetToken: !1,
        raw: i
      };
    }
  }
  buildUrl(t) {
    return `${this.apiUrl}/v${t.v}${t.url}`;
  }
  async parseResponseData(t = "json", e) {
    const { data: o, headers: b } = e;
    switch (t) {
      case "blob":
        if (o.type === "application/json") {
          const i = await o.text(), s = JSON.parse(i);
          return {
            success: o.success,
            body: s,
            errors: [],
            resetToken: !1,
            raw: e
          };
        } else
          return b["X-Filename"], {
            success: o.success,
            body: o,
            errors: [],
            resetToken: !1,
            raw: e
          };
      default:
      case "json":
        return {
          success: o.success,
          body: o.body,
          errors: o.errors,
          resetToken: o.resetToken,
          raw: e
        };
    }
  }
}
class dw extends uw {
  constructor(e) {
    super(e.apiUrl);
    z(this, "MaxAttempts", 3);
    this.config = e;
  }
  buildHeaders(e, o) {
    const b = {
      "Content-Type": "application/json",
      "X-Timezone-Offset": (/* @__PURE__ */ new Date()).getTimezoneOffset(),
      ...e.headers
    };
    return e.authorized && (o && (b.Authorization = `Bearer ${o.accessToken}`), this.config.getConnectionId && (b.ConnectionId = this.config.getConnectionId())), b;
  }
  async execute(e, o, b = 1) {
    const r = await this.config.tokenStorage.getTokens();
    e.headers = this.buildHeaders(e, r);
    let i = await super.execute(e, o);
    if (e.authorized)
      if (i.raw.status == 401) {
        if (b == this.MaxAttempts || !await this.refreshTokens(o, r))
          return i;
        i = await this.execute(e, o, b + 1);
      } else i.resetToken && await this.refreshTokens(o, r);
    return i;
  }
  async refreshTokens(e, o) {
    if (!o)
      return !1;
    const b = await e.auth.refreshToken(o.refreshToken);
    return b.success && await this.config.tokenStorage.setTokens(b.body), b.success;
  }
}
class bu extends ye {
  constructor(e) {
    super();
    z(this, "type");
    z(this, "id");
    z(this, "createdDate");
    z(this, "updatedDate");
    z(this, "contact");
    this.update(e);
  }
  static fromJsonBase(e) {
    return {
      id: e.id,
      type: e.type,
      createdDate: L(e.createdDate),
      updatedDate: e.updatedDate ? L(e.updatedDate) : void 0,
      contact: e.student ? L1.fromJson(e.student) : void 0
    };
  }
}
class cO extends bu {
  constructor(e) {
    super(e);
    z(this, "achievement");
    e && this.update(e);
  }
  get key() {
    return "GamificationAchievementNotification";
  }
  static fromJson(e) {
    return new cO({
      achievement: ka.fromJson(e.achievement),
      ...bu.fromJsonBase(e)
    });
  }
}
const lw = {
  parse: (p) => {
    switch (p.type) {
      case "gamificationAchievement":
        return cO.fromJson(p);
      default:
        throw new Error("Invalid notification type");
    }
  }
};
class qw {
  constructor() {
    z(this, "type");
    z(this, "post");
  }
  static fromJson(t) {
    const e = t.type === "updated" ? jd(t.post, !0) : t.post;
    let o;
    switch (t.type) {
      case "updated":
        o = e, o.attachments && (o.attachments = o.attachments.map(Pl.fromJson)), o.updatedDate && (o.updatedDate = L(o.updatedDate)), o.pinDate && (o.pinDate = L(o.pinDate));
        break;
      case "created":
      case "deleted":
      default:
        o = zr.fromJson(e);
        break;
    }
    return {
      type: t.type,
      post: o
    };
  }
}
class fw {
  constructor() {
    z(this, "type");
    z(this, "comment");
  }
  static fromJson(t) {
    const e = t.type === "updated" ? jd(t.comment, !0) : t.comment;
    e.parentId && (e.parent = { id: e.parentId }), e.replyId && !e.reply && (e.reply = { id: e.replyId });
    let o;
    switch (t.type) {
      case "updated":
        o = e, o.files && (o.files = o.files.map(at.fromJson)), o.updatedDate && (o.updatedDate = L(o.updatedDate));
        break;
      case "created":
      case "deleted":
      default:
        o = Ua.fromJson(e);
        break;
    }
    return {
      type: t.type,
      comment: o
    };
  }
}
class Ww {
  constructor(t) {
    z(this, "gamification");
    z(this, "notification");
    z(this, "user");
    z(this, "forum");
    z(this, "community");
    z(this, "education");
    z(this, "school");
    this.client = t, this.gamification = {
      balance: new q1(this.client, "GamificationBalance", (e) => e.balance)
    }, this.notification = new q1(this.client, "Notification", lw.parse), this.user = {
      notification: {
        count: new q1(this.client, "UserNotificationCount", (e) => e.count),
        new: new q1(this.client, "UserNotification", (e) => br.fromJson(e.notification))
      },
      email: {
        confirmed: new q1(this.client, "EmailConfirmed"),
        confirm: () => this.client.invoke("EmailConfirm", [])
      }
    }, this.community = {
      post: (e) => new q1(this.client, e ? `CommunityPostEvent:${e}` : "CommunityPostEvent", (o) => qw.fromJson(o)),
      postComment: (e) => new q1(this.client, `CommunityPostCommentEvent:${e}`, (o) => fw.fromJson(o))
    }, this.education = {
      course: {
        itemChanged: (e) => new q1(this.client, `SchoolContentItem courseId:${e}`, (o) => o),
        comment: (e) => new q1(this.client, `SchoolContentItemComment courseId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        })),
        itemComment: (e) => new q1(this.client, `SchoolContentItemComment courseItemId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        })),
        progress: (e) => new q1(this.client, `SchoolContentProgress courseId:${e}`, (o) => $e.fromJson(o))
      },
      library: {
        itemChanged: (e) => new q1(this.client, `SchoolContentItem libraryId:${e}`, (o) => o.item),
        comment: (e) => new q1(this.client, `SchoolContentItemComment libraryId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        })),
        itemComment: (e) => new q1(this.client, `SchoolContentItemComment libraryItemId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        }))
      },
      rating: {
        itemComment: (e) => new q1(this.client, `SchoolContentItemComment ratingId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        }))
      },
      comment: {
        comment: (e) => new q1(this.client, `SchoolContentItemComment commentId:${e}`, (o) => ({
          ...o,
          comment: Cp.fromJson(o.comment)
        }))
      },
      task: {
        answer: (e) => new q1(this.client, `TaskAnswer ${e}`, (o) => ({
          progress: $e.fromJson(o.progress),
          answer: ql.fromJson(o.answer)
        })),
        comment: (e) => new q1(this.client, `TaskComment ${e}`, (o) => ({
          ...o,
          comment: Ca.fromJson(o.comment)
        })),
        commentTyping: (e) => new q1(this.client, `TaskCommentTyping ${e}`, (o) => ({
          commentId: o.commentId,
          event: o.event
        })),
        sendTyping: (e, o, b, r) => this.client.invoke("TaskCommentTyping", [e, o, b, r])
      }
    }, this.forum = {
      topic: {
        comment: (e) => new q1(this.client, `ForumTopicComment ${e}`, (o) => ({
          topicId: o.topicId,
          event: o.event,
          comment: _o.fromJson(o.comment)
        })),
        reaction: (e) => new q1(this.client, `ForumTopicReaction ${e}`, (o) => ({
          topicId: o.topicId,
          commentId: o.commentId,
          reaction: vo.fromJson(o.reaction),
          event: o.event
        })),
        topic: (e) => new q1(this.client, `ForumTopic ${e}`, (o) => ({
          topic: Zb.fromJson(o.topic),
          event: o.event
        }))
      }
    }, this.school = {
      supportChatEnabled: new q1(this.client, "SchoolSupportChatChanged", (e) => e.enabled),
      schoolMigration: new q1(this.client, "SchoolMigration", (e) => pr.fromJson(e))
    }, t.init();
  }
  get connectionId() {
    var t;
    return ((t = this.client) == null ? void 0 : t.connectionId) ?? null;
  }
}
//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc
var nu = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
  "_"
), hw = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), gi = [
  /^ene/i,
  /^feb/i,
  /^mar/i,
  /^abr/i,
  /^may/i,
  /^jun/i,
  /^jul/i,
  /^ago/i,
  /^sep/i,
  /^oct/i,
  /^nov/i,
  /^dic/i
], zu = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
L.defineLocale("es", {
  months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
    "_"
  ),
  monthsShort: function(p, t) {
    return p ? /-MMM-/.test(t) ? hw[p.month()] : nu[p.month()] : nu;
  },
  monthsRegex: zu,
  monthsShortRegex: zu,
  monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
  monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
  monthsParse: gi,
  longMonthsParse: gi,
  shortMonthsParse: gi,
  weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
  weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
  weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
  weekdaysParseExact: !0,
  longDateFormat: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY H:mm",
    LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
  },
  calendar: {
    sameDay: function() {
      return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    nextDay: function() {
      return "[mañana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    nextWeek: function() {
      return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    lastDay: function() {
      return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    lastWeek: function() {
      return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "en %s",
    past: "hace %s",
    s: "unos segundos",
    ss: "%d segundos",
    m: "un minuto",
    mm: "%d minutos",
    h: "una hora",
    hh: "%d horas",
    d: "un día",
    dd: "%d días",
    w: "una semana",
    ww: "%d semanas",
    M: "un mes",
    MM: "%d meses",
    y: "un año",
    yy: "%d años"
  },
  dayOfMonthOrdinalParse: /\d{1,2}º/,
  ordinal: "%dº",
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  },
  invalidDate: "Fecha inválida"
});
//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
L.defineLocale("id", {
  months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split(
    "_"
  ),
  monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
  weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
  weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
  weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
  longDateFormat: {
    LT: "HH.mm",
    LTS: "HH.mm.ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY [pukul] HH.mm",
    LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
  },
  meridiemParse: /pagi|siang|sore|malam/,
  meridiemHour: function(p, t) {
    if (p === 12 && (p = 0), t === "pagi")
      return p;
    if (t === "siang")
      return p >= 11 ? p : p + 12;
    if (t === "sore" || t === "malam")
      return p + 12;
  },
  meridiem: function(p, t, e) {
    return p < 11 ? "pagi" : p < 15 ? "siang" : p < 19 ? "sore" : "malam";
  },
  calendar: {
    sameDay: "[Hari ini pukul] LT",
    nextDay: "[Besok pukul] LT",
    nextWeek: "dddd [pukul] LT",
    lastDay: "[Kemarin pukul] LT",
    lastWeek: "dddd [lalu pukul] LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "dalam %s",
    past: "%s yang lalu",
    s: "beberapa detik",
    ss: "%d detik",
    m: "semenit",
    mm: "%d menit",
    h: "sejam",
    hh: "%d jam",
    d: "sehari",
    dd: "%d hari",
    M: "sebulan",
    MM: "%d bulan",
    y: "setahun",
    yy: "%d tahun"
  },
  week: {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6
    // The week that contains Jan 6th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair
function mw(p, t) {
  var e = p.split("_");
  return t % 10 === 1 && t % 100 !== 11 ? e[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? e[1] : e[2];
}
function Sp(p, t, e) {
  var o = {
    ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
    mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
    hh: "час_часа_часов",
    dd: "день_дня_дней",
    ww: "неделя_недели_недель",
    MM: "месяц_месяца_месяцев",
    yy: "год_года_лет"
  };
  return e === "m" ? t ? "минута" : "минуту" : p + " " + mw(o[e], +p);
}
var Li = [
  /^янв/i,
  /^фев/i,
  /^мар/i,
  /^апр/i,
  /^ма[йя]/i,
  /^июн/i,
  /^июл/i,
  /^авг/i,
  /^сен/i,
  /^окт/i,
  /^ноя/i,
  /^дек/i
];
L.defineLocale("ru", {
  months: {
    format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split(
      "_"
    ),
    standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split(
      "_"
    )
  },
  monthsShort: {
    // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
    format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split(
      "_"
    ),
    standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split(
      "_"
    )
  },
  weekdays: {
    standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split(
      "_"
    ),
    format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split(
      "_"
    ),
    isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
  },
  weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  monthsParse: Li,
  longMonthsParse: Li,
  shortMonthsParse: Li,
  // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
  monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // копия предыдущего
  monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // полные названия с падежами
  monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
  // Выражение, которое соответствует только сокращённым формам
  monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
  longDateFormat: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY г.",
    LLL: "D MMMM YYYY г., H:mm",
    LLLL: "dddd, D MMMM YYYY г., H:mm"
  },
  calendar: {
    sameDay: "[Сегодня, в] LT",
    nextDay: "[Завтра, в] LT",
    lastDay: "[Вчера, в] LT",
    nextWeek: function(p) {
      if (p.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В следующее] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В следующий] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В следующую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    lastWeek: function(p) {
      if (p.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В прошлое] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В прошлый] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В прошлую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "через %s",
    past: "%s назад",
    s: "несколько секунд",
    ss: Sp,
    m: Sp,
    mm: Sp,
    h: "час",
    hh: Sp,
    d: "день",
    dd: Sp,
    w: "неделя",
    ww: Sp,
    M: "месяц",
    MM: Sp,
    y: "год",
    yy: Sp
  },
  meridiemParse: /ночи|утра|дня|вечера/i,
  isPM: function(p) {
    return /^(дня|вечера)$/.test(p);
  },
  meridiem: function(p, t, e) {
    return p < 4 ? "ночи" : p < 12 ? "утра" : p < 17 ? "дня" : "вечера";
  },
  dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
  ordinal: function(p, t) {
    switch (t) {
      case "M":
      case "d":
      case "DDD":
        return p + "-й";
      case "D":
        return p + "-го";
      case "w":
      case "W":
        return p + "-я";
      default:
        return p;
    }
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire
function Rw(p, t) {
  var e = p.split("_");
  return t % 10 === 1 && t % 100 !== 11 ? e[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? e[1] : e[2];
}
function so(p, t, e) {
  var o = {
    ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
    mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
    hh: t ? "година_години_годин" : "годину_години_годин",
    dd: "день_дні_днів",
    MM: "місяць_місяці_місяців",
    yy: "рік_роки_років"
  };
  return e === "m" ? t ? "хвилина" : "хвилину" : e === "h" ? t ? "година" : "годину" : p + " " + Rw(o[e], +p);
}
function yw(p, t) {
  var e = {
    nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split(
      "_"
    ),
    accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split(
      "_"
    ),
    genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split(
      "_"
    )
  }, o;
  return p === !0 ? e.nominative.slice(1, 7).concat(e.nominative.slice(0, 1)) : p ? (o = /(\[[ВвУу]\]) ?dddd/.test(t) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? "genitive" : "nominative", e[o][p.day()]) : e.nominative;
}
function cM(p) {
  return function() {
    return p + "о" + (this.hours() === 11 ? "б" : "") + "] LT";
  };
}
L.defineLocale("uk", {
  months: {
    format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split(
      "_"
    ),
    standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split(
      "_"
    )
  },
  monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split(
    "_"
  ),
  weekdays: yw,
  weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
  weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY р.",
    LLL: "D MMMM YYYY р., HH:mm",
    LLLL: "dddd, D MMMM YYYY р., HH:mm"
  },
  calendar: {
    sameDay: cM("[Сьогодні "),
    nextDay: cM("[Завтра "),
    lastDay: cM("[Вчора "),
    nextWeek: cM("[У] dddd ["),
    lastWeek: function() {
      switch (this.day()) {
        case 0:
        case 3:
        case 5:
        case 6:
          return cM("[Минулої] dddd [").call(this);
        case 1:
        case 2:
        case 4:
          return cM("[Минулого] dddd [").call(this);
      }
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "за %s",
    past: "%s тому",
    s: "декілька секунд",
    ss: so,
    m: so,
    mm: so,
    h: "годину",
    hh: so,
    d: "день",
    dd: so,
    M: "місяць",
    MM: so,
    y: "рік",
    yy: so
  },
  // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
  meridiemParse: /ночі|ранку|дня|вечора/,
  isPM: function(p) {
    return /^(дня|вечора)$/.test(p);
  },
  meridiem: function(p, t, e) {
    return p < 4 ? "ночі" : p < 12 ? "ранку" : p < 17 ? "дня" : "вечора";
  },
  dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
  ordinal: function(p, t) {
    switch (t) {
      case "M":
      case "d":
      case "DDD":
      case "w":
      case "W":
        return p + "-й";
      case "D":
        return p + "-го";
      default:
        return p;
    }
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 7
    // The week that contains Jan 7th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109
L.defineLocale("zh-cn", {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
    "_"
  ),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日Ah点mm分",
    LLLL: "YYYY年M月D日ddddAh点mm分",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(p, t) {
    return p === 12 && (p = 0), t === "凌晨" || t === "早上" || t === "上午" ? p : t === "下午" || t === "晚上" ? p + 12 : p >= 11 ? p : p + 12;
  },
  meridiem: function(p, t, e) {
    var o = p * 100 + t;
    return o < 600 ? "凌晨" : o < 900 ? "早上" : o < 1130 ? "上午" : o < 1230 ? "中午" : o < 1800 ? "下午" : "晚上";
  },
  calendar: {
    sameDay: "[今天]LT",
    nextDay: "[明天]LT",
    nextWeek: function(p) {
      return p.week() !== this.week() ? "[下]dddLT" : "[本]dddLT";
    },
    lastDay: "[昨天]LT",
    lastWeek: function(p) {
      return this.week() !== p.week() ? "[上]dddLT" : "[本]dddLT";
    },
    sameElse: "L"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function(p, t) {
    switch (t) {
      case "d":
      case "D":
      case "DDD":
        return p + "日";
      case "M":
        return p + "月";
      case "w":
      case "W":
        return p + "周";
      default:
        return p;
    }
  },
  relativeTime: {
    future: "%s后",
    past: "%s前",
    s: "几秒",
    ss: "%d 秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    w: "1 周",
    ww: "%d 周",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
L.defineLocale("zh-tw", {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
    "_"
  ),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日 HH:mm",
    LLLL: "YYYY年M月D日dddd HH:mm",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(p, t) {
    if (p === 12 && (p = 0), t === "凌晨" || t === "早上" || t === "上午")
      return p;
    if (t === "中午")
      return p >= 11 ? p : p + 12;
    if (t === "下午" || t === "晚上")
      return p + 12;
  },
  meridiem: function(p, t, e) {
    var o = p * 100 + t;
    return o < 600 ? "凌晨" : o < 900 ? "早上" : o < 1130 ? "上午" : o < 1230 ? "中午" : o < 1800 ? "下午" : "晚上";
  },
  calendar: {
    sameDay: "[今天] LT",
    nextDay: "[明天] LT",
    nextWeek: "[下]dddd LT",
    lastDay: "[昨天] LT",
    lastWeek: "[上]dddd LT",
    sameElse: "L"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
  ordinal: function(p, t) {
    switch (t) {
      case "d":
      case "D":
      case "DDD":
        return p + "日";
      case "M":
        return p + "月";
      case "w":
      case "W":
        return p + "週";
      default:
        return p;
    }
  },
  relativeTime: {
    future: "%s後",
    past: "%s前",
    s: "幾秒",
    ss: "%d 秒",
    m: "1 分鐘",
    mm: "%d 分鐘",
    h: "1 小時",
    hh: "%d 小時",
    d: "1 天",
    dd: "%d 天",
    M: "1 個月",
    MM: "%d 個月",
    y: "1 年",
    yy: "%d 年"
  }
});
//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras
var gw = {
  ss: "sekundė_sekundžių_sekundes",
  m: "minutė_minutės_minutę",
  mm: "minutės_minučių_minutes",
  h: "valanda_valandos_valandą",
  hh: "valandos_valandų_valandas",
  d: "diena_dienos_dieną",
  dd: "dienos_dienų_dienas",
  M: "mėnuo_mėnesio_mėnesį",
  MM: "mėnesiai_mėnesių_mėnesius",
  y: "metai_metų_metus",
  yy: "metai_metų_metus"
};
function Lw(p, t, e, o) {
  return t ? "kelios sekundės" : o ? "kelių sekundžių" : "kelias sekundes";
}
function sM(p, t, e, o) {
  return t ? Ip(e)[0] : o ? Ip(e)[1] : Ip(e)[2];
}
function ru(p) {
  return p % 10 === 0 || p > 10 && p < 20;
}
function Ip(p) {
  return gw[p].split("_");
}
function iM(p, t, e, o) {
  var b = p + " ";
  return p === 1 ? b + sM(p, t, e[0], o) : t ? b + (ru(p) ? Ip(e)[1] : Ip(e)[0]) : o ? b + Ip(e)[1] : b + (ru(p) ? Ip(e)[1] : Ip(e)[2]);
}
L.defineLocale("lt", {
  months: {
    format: "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split(
      "_"
    ),
    standalone: "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split(
      "_"
    ),
    isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
  },
  monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
  weekdays: {
    format: "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split(
      "_"
    ),
    standalone: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split(
      "_"
    ),
    isFormat: /dddd HH:mm/
  },
  weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
  weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
  weekdaysParseExact: !0,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "YYYY [m.] MMMM D [d.]",
    LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
    LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
    l: "YYYY-MM-DD",
    ll: "YYYY [m.] MMMM D [d.]",
    lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
    llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
  },
  calendar: {
    sameDay: "[Šiandien] LT",
    nextDay: "[Rytoj] LT",
    nextWeek: "dddd LT",
    lastDay: "[Vakar] LT",
    lastWeek: "[Praėjusį] dddd LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "po %s",
    past: "prieš %s",
    s: Lw,
    ss: iM,
    m: sM,
    mm: iM,
    h: sM,
    hh: iM,
    d: sM,
    dd: iM,
    M: sM,
    MM: iM,
    y: sM,
    yy: iM
  },
  dayOfMonthOrdinalParse: /\d{1,2}-oji/,
  ordinal: function(p) {
    return p + "-oji";
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
class vw {
  constructor(t, e) {
    /**
     * cache tokens
     */
    z(this, "tokens", null);
    /**
     * original setTokens implementation
     */
    z(this, "setTokensImpl");
    this.storage = t, this.sdk = e, this.setTokensImpl = t.setTokens, t.setTokens = this.setTokens;
  }
  get hasTokens() {
    return this.tokens != null;
  }
  async init() {
    await this.getTokens();
  }
  async getTokens() {
    if (this.tokens) return this.tokens;
    const t = await this.storage.getTokens();
    return t && (this.tokens = t), this.tokens;
  }
  async setTokens(t, e = !0) {
    this.tokens = t, await this.setTokensImpl.bind(this.storage)(t), this.sdk.dispatcher.emit("auth.token.changed", t), e && await this.waitForUserChangeOnce();
  }
  waitForUserChangeOnce(t) {
    return new Promise((e, o) => {
      const b = setTimeout(() => {
        o(new Error("User loading timeout"));
      }, t || 1e4);
      this.sdk.dispatcher.once("auth.user.changed", () => {
        clearTimeout(b), e();
      });
    });
  }
}
class Fw {
  constructor(t, e) {
    z(this, "inited", !1);
    z(this, "school");
    z(this, "dispatcher");
    z(this, "tokenStorage");
    z(this, "api");
    z(this, "auth");
    z(this, "account");
    z(this, "content");
    z(this, "hub");
    z(this, "chat");
    z(this, "partnership");
    z(this, "community");
    z(this, "forum");
    z(this, "gamification");
    z(this, "announcement");
    // public notification: NotificationModule;
    z(this, "localization");
    /**
     * Education module contains logic for previewing courses
     */
    z(this, "education");
    this.config = e, this.dispatcher = new dL(), this.tokenStorage = new vw(t, this), this.hub = new Ww("client" in e.hub ? e.hub.client : new tn(e.hub.clientConfig, this)), this.api = new Z7(e.apiClient || new dw({
      apiUrl: this.config.schoolDomain + "/api",
      tokenStorage: this.tokenStorage,
      getConnectionId: () => this.hub.connectionId
    })), this.auth = new j7(this), this.account = new bB(this), this.content = {
      courses: new rA(this, { sectionType: "course" }),
      libraries: new rA(this, { sectionType: "library" })
    }, this.chat = new iT(this), this.partnership = new sB(this), this.community = new dp(this), this.forum = new uT(this), this.gamification = new fT(this), this.announcement = new WT(this), this.education = new TT(this), this.localization = new Kp(this), this.setupMoment(this.config.lang);
  }
  async init() {
    this.dispatcher.on("auth.logout", this.reset.bind(this)), await this.tokenStorage.init();
    const t = await this.api.school.fetch(this.config.schoolDomain);
    if (!t.success)
      throw new Error("Failed to fetch school settings");
    this.school = t.body, await this.tryAuthorize(), this.inited = !0, this.dispatcher.emit("sdk.inited", { school: this.school });
  }
  async tryAuthorize() {
    return this.tokenStorage.tokens ? (await this.account.fetchUser()).success : !1;
  }
  setupMoment(t) {
    switch (t) {
      case hz.zhtw:
        L.locale("zh-tw");
        break;
      case hz.zhcn:
        L.locale("zh-cn");
        break;
      default:
        L.locale(t);
        break;
    }
  }
  async reset() {
    this.community.reset();
  }
}
export {
  at as AccelFile,
  bB as AccountModule,
  Xa as Admin,
  xv as AdminPartnerStatus,
  kv as AdminType,
  Da as Announcement,
  WT as AnnouncementModule,
  Z7 as Api,
  j7 as AuthModule,
  MN as BonusTransactionDurationType,
  bN as BonusTransactionValidityType,
  v1 as CRUDListStore,
  iT as ChatModule,
  Iv as Community,
  wN as CommunityBadge,
  Pw as CommunityBadgeFilter,
  ko as CommunityMember,
  XN as CommunityMemberBadge,
  PN as CommunityMemberFilter,
  $N as CommunityMemberReport,
  VN as CommunityMemberReportFilter,
  WB as CommunityMemberReportStore,
  AB as CommunityMemberStore,
  dp as CommunityModule,
  zr as CommunityPost,
  Pl as CommunityPostAttachment,
  Ua as CommunityPostComment,
  nA as CommunityPostCommentFilter,
  Fo as CommunityPostCommentStore,
  xN as CommunityPostFilter,
  EM as CommunityPostStore,
  Cl as CommunitySpaceItem,
  vN as CommunitySpaceItemFilter,
  uB as CommunitySpaceItemStore,
  Xb as ContactLicense,
  Ea as ContactLicenseFilter,
  wt as Course,
  Qb as CourseItem,
  rz as CourseItemAvailability,
  e_ as CourseItemCommentState,
  ql as CourseItemTaskAnswer,
  Ca as CourseItemTaskAnswerComment,
  XM as CourseItemTaskAnswerCommentFilter,
  $i as CourseItemTaskAnswerStatus,
  ul as CourseItemTaskField,
  Hi as CourseItemTaskFieldType,
  Z1 as CourseItemType,
  DM as CoursePlan,
  Fv as CoursePlanFilter,
  Kb as Disposable,
  uv as DisposableStack,
  TT as EducationModule,
  n0 as Entity,
  wz as EventCalendarEvent,
  Q_ as EventCalendarEventFilter,
  dL as EventDispatcher,
  Q7 as FileApi,
  Rt as FileSize,
  QN as FileSource,
  Fl as FileType,
  J0 as Filter,
  Xp as FlowTimeDelayCondition,
  vl as ForumBan,
  Dw as ForumBanFilter,
  uT as ForumModule,
  vo as ForumReaction,
  qo as ForumThread,
  Xw as ForumThreadFilter,
  Zb as ForumTopic,
  Cw as ForumTopicFilter,
  Rl as Gamification,
  ka as GamificationAchievement,
  J_ as GamificationAchievementFilter,
  G_ as GamificationContactAchievement,
  K_ as GamificationLeader,
  xa as GamificationLeaderAchievement,
  Ll as GamificationLeaderFilter,
  fT as GamificationModule,
  yl as GamificationProduct,
  ww as GamificationProductFilter,
  Y_ as GamificationTransaction,
  $_ as GamificationTransactionDurationType,
  Sw as GamificationTransactionFilter,
  V_ as GamificationTransactionValidityType,
  dv as HoursPer,
  tn as HubClient,
  C0 as HubConnectionState,
  q1 as HubSubscriber,
  hz as Lang,
  Kv as LibraryItemProgress,
  Pa as LicenseSuspension,
  S1 as ListStore,
  Kp as LocalizationModule,
  i7 as MemberApi,
  fv as MillisecondsPer,
  lv as MinutesPer,
  a7 as OfferApi,
  Dl as PartnershipMember,
  WN as PartnershipMemberFilter,
  sB as PartnershipModule,
  dN as PartnershipOffer,
  lN as PartnershipOfferFilter,
  O7 as PartnershipOrderApi,
  Ew as PartnershipTotalsFilter,
  Nl as PartnershipTransaction,
  tN as PartnershipTransactionFilter,
  RN as PartnershipTransactionRequest,
  yN as PartnershipTransactionRequestFilter,
  Jl as PartnershipTransactionStore,
  IM as Product,
  F_ as ProductType,
  CM as PurchaseOrder,
  Ia as PurchaseOrderContent,
  x_ as PurchaseOrderFilter,
  k_ as PurchaseOrderStatus,
  Dp as RegularTimeDelayCondition,
  Fw as SDK,
  Sb as School,
  Rb as SchoolContentItem,
  Cp as SchoolContentItemComment,
  jv as SchoolContentItemCommentFilter,
  E_ as SchoolContentItemFilter,
  zl as SchoolContentItemProgressRating,
  rA as SchoolContentModule,
  eB as SchoolContentStore,
  P_ as SchoolCourse,
  pr as SchoolMigration,
  Tv as SchoolMigrationStatus,
  Vi as SchoolProfileSettings,
  Yi as SchoolSettings,
  qv as SecondsPer,
  L1 as Student,
  nN as StudentBonusTransaction,
  zN as StudentBonusTransactionFilter,
  or as StudentCourse,
  Lo as StudentCourseItem,
  Io as StudentCourseItemBaseProgress,
  X_ as StudentCourseItemFilter,
  il as StudentCourseItemProgress,
  Wl as StudentCourseItemTask,
  L_ as StudentCourseItemTaskAnswerField,
  Tw as StudentCourseItemTaskAnswerFieldFilter,
  l_ as StudentCourseItemTest,
  $e as StudentCourseProgress,
  rl as StudentCourseSectionProgress,
  Co as StudentLibrary,
  Bw as StudentLibraryFilter,
  Db as StudentLibraryItem,
  lb as StudentLibraryItemType,
  Sa as StudentSession,
  Wv as TicksPer,
  hv as TimeUnit,
  mv as TimeUnitUtils,
  hM as Timezone,
  vw as TokenStorageProxy,
  _o as TopicComment,
  _l as TopicCommentFilter,
  c7 as TransactionApi,
  s7 as TransactionRequestApi,
  ye as Updatable,
  br as UserNotification,
  iN as UserNotificationChannel,
  Iw as UserNotificationChannelFilter,
  Z_ as UserNotificationFilter,
  sN as UserNotificationSettings,
  Se as UserNotificationType,
  A7 as UtmTagApi,
  jd as cleanOptionalObject,
  Lv as fromOptional,
  y1 as isEmpty,
  C2 as toOptional,
  gv as toOptionalObject
};
//# sourceMappingURL=index.es.js.map
